import { Reading } from '../../types';

export const minorArcanaReadings: Reading[] = [
  {
    "reading_id": "ace_wands_two_wands",
    "reading_name": "Нова искра пред избор",
    "reading_cards": "Асо Жезли + Двойка Жезли",
    "reading_combination": ["ace_wands", "two_wands"],
    "reading_meaning": "Асо Жезли носи ново начало и вдъхновение, а Двойка Жезли – момента на избор и планиране. Заедно показват, че имате енергията да започнете нещо ново, но все още се колебаете в коя посока. Това е момент на потенциал – искрата е запалена, сега трябва да изберете накъде да я насочите.",
    "reading_description": "Нова идея или проект ви вълнува, но все още не сте сигурни как точно да го реализирате. Предстои важен избор, който ще определи пътя напред.",
    "reading_advice": "Не се страхувайте да изберете – всяка посока е по-добра от липсата на такава. Доверете се на първоначалния си ентусиазъм."
  },
   {
    "reading_id": "office_politics",
    "reading_name": "Офис политики",
    "reading_cards": "5 Жезли + 7 Мечове",
    "reading_combination": ["five_wands", "seven_swords"],
    "reading_meaning": "Интриги и клюки",
    "reading_description": "Интриги, клюки, борба за власт. Има скрити врагове.",
    "reading_advice": "Пази гърба си. Не се замесвай в клюки. Работи, мълчи и гледай."
  },
    {
    "reading_id": "ace_wands_three_wands",
    "reading_name": "Първи стъпки",
    "reading_cards": "Асо Жезли + 3 Жезли",
    "reading_combination": ["ace_wands", "three_wands"],
    "reading_meaning": "Старт и очакване",
    "reading_description": "Започваш нещо ново и веднага виждаш първите резултати. Успехът не идва веднага, но пътят е обещаващ.",
    "reading_advice": "Бъди търпелив. Добрите неща идват при тези, които чакат, докато работят."
  },
    {
    "reading_id": "home_celebration",
    "reading_name": "Семеен празник",
    "reading_cards": "3 Чаши + 4 Жезли",
    "reading_combination": ["three_cups", "four_wands"],
    "reading_meaning": "Празник у дома",
    "reading_description": "Рожден ден, годишнина, празник в семейството.",
    "reading_advice": "Събери всички. Тези моменти са безценни."
  },
  {
    "reading_id": "creative_project",
    "reading_name": "Творчески проект",
    "reading_cards": "Асо Жезли + 3 Чаши",
    "reading_combination": ["ace_wands", "three_cups"],
    "reading_meaning": "Творческа работа",
    "reading_description": "Работа, свързана с изкуство, музика, писане. Твориш с радост.",
    "reading_advice": "Пусни въображението си. Това, което създаваш сега, носи радост на другите."
  },
  {
    "reading_id": "burnout",
    "reading_name": "Прегаряне",
    "reading_cards": "10 Жезли + 4 Мечове",
    "reading_combination": ["ten_wands", "four_swords"],
    "reading_meaning": "Изтощение",
    "reading_description": "Работиш прекалено много – тялото иска почивка.",
    "reading_advice": "Спри! Болничният идва, ако не спреш доброволно. Почивката не е лукс, а нужда."
  },
  {
    "reading_id": "distance_relationship",
    "reading_name": "Дистанционна връзка",
    "reading_cards": "8 Чаши + 2 Чаши",
    "reading_combination": ["eight_cups", "two_cups"],
    "reading_meaning": "Физическа или емоционална дистанция",
    "reading_description": "Единият от двамата е далеч – физически или емоционално.",
    "reading_advice": "Любовта изисква присъствие. Ако единият е тръгнал, пусни го."
  },
 
  {
    "reading_id": "ace_wands_three_wands",
    "reading_name": "Начало и очакване",
    "reading_cards": "Асо Жезли + Тройка Жезли",
    "reading_combination": ["ace_wands", "three_wands"],
    "reading_meaning": "Асо Жезли символизира старта и вдъхновението, а Тройка Жезли – търпеливото очакване на плодовете. Посяли сте семето на нещо ново и сега трябва да изчакате то да покълне. Енергията ви е насочена правилно, но резултатите ще дойдат с времето.",
    "reading_description": "Започнали сте нов проект и сега чакате първите резултати. Нетърпението е голямо, но трябва да проявите търпение.",
    "reading_advice": "Бъдете търпеливи – добрите неща идват при тези, които умеят да чакат, докато продължават да работят."
  },
  {
    "reading_id": "ace_wands_four_wands",
    "reading_name": "Асо Жезли + Четворка Жезли",
    "reading_cards": "Асо Жезли + Четворка Жезли",
    "reading_combination": ["ace_wands", "four_wands"],
    "reading_meaning": "Ново начало с празник.Асо Жезли носи искрата на новото начало, а Четворка Жезли – празника и завръщането у дома. Заедно предвещават радостно събитие, свързано с нов старт – нова работа, преместване или важен етап. Ентусиазмът ви ще бъде споделен от близките.",
    "reading_description": "Предстои нещо ново, което носи радост и повод за празнуване. Очаквайте щастливи събития и подкрепа от семейството.",
    "reading_advice": "Празнувайте малките победи – те са стъпалата към големия успех. Споделете радостта си с близките."
  },
  {
    "reading_id": "ace_wands_five_wands",
    "reading_name": "Асо Жезли + Петица Жезли",
    "reading_cards": "Асо Жезли + Петица Жезли",
    "reading_combination": ["ace_wands", "five_wands"],
    "reading_meaning": "Конкурентно начало.Асо Жезли носи нова идея, а Петица Жезли – конфликт и съперничество. Още в началото срещате конкуренция или съпротива. Това може да ви обезкуражи, но е знак, че сте на прав път – значимите неща винаги предизвикват реакция.",
    "reading_description": "Новото ви начинание среща съпротива още в зародиш. Конкуренция, спорове или хора, които не подкрепят идеята ви.",
    "reading_advice": "Не се отказвайте при първото препятствие. Конкуренцията означава, че идеята ви има стойност."
  },
  {
    "reading_id": "ace_wands_six_wands",
    "reading_name": "Асо Жезли + Шестица Жезли",
    "reading_cards": "Асо Жезли + Шестица Жезли",
    "reading_combination": ["ace_wands", "six_wands"],
    "reading_meaning": "Победно начало.Асо Жезли символизира старта, а Шестица Жезли – победата и признанието. Новото ви начинание ще има успех още от самото начало. Вашият ентусиазъм и увереност ще бъдат забелязани и оценени.",
    "reading_description": "Новият ви проект получава признание и успех още в началото. Всички виждат вашия талант и енергия.",
    "reading_advice": "Наслаждавайте се на успеха, но не спирайте да работите. Първата победа е само началото."
  },
  {
    "reading_id": "ace_wands_seven_wands",
    "reading_name": "Асо Жезли + Седмица Жезли",
    "reading_cards": "Асо Жезли + Седмица Жезли",
    "reading_combination": ["ace_wands", "seven_wands"],
    "reading_meaning": "Защита на идеята.Асо Жезли носи вдъхновението, а Седмица Жезли – защитата на позицията. Още в началото трябва да отстоявате новата си идея пред критици. Това е изпитание на вашата увереност.",
    "reading_description": "Новата ви идея се сблъсква с критики и съпротива. Трябва да защитавате позицията си.",
    "reading_advice": "Не се огъвайте пред първата съпротива. Убедеността ви ще спечели."
  },
  {
    "reading_id": "ace_wands_eight_wands",
    "reading_name": "Асо Жезли + Осмица Жезли",
    "reading_cards": "Асо Жезли + Осмица Жезли",
    "reading_combination": ["ace_wands", "eight_wands"],
    "reading_meaning": "Бърз старт.Асо Жезли носи искрата, а Осмица Жезли – бързината и движението. Всичко се случва светкавично – идеята се ражда и веднага започва да се развива. Няма време за колебание.",
    "reading_description": "Новата ви идея или проект се развива с неочаквана скорост. Трябва да действате бързо, за да не изпуснете вълната.",
    "reading_advice": "Хванете вълната на скоростта. Действайте сега, без да се бавите."
  },
  {
    "reading_id": "ace_wands_nine_wands",
    "reading_name": "Асо Жезли + Деветка Жезли",
    "reading_cards": "Асо Жезли + Деветка Жезли",
    "reading_combination": ["ace_wands", "nine_wands"],
    "reading_meaning": "Упорито начало.Асо Жезли носи ентусиазма, а Деветка Жезли – устойчивостта и последната линия на отбрана. Началото е трудно и изисква много усилия. Чувствате се изтощени, но не се отказвайте – краят на усилията наближава.",
    "reading_description": "Стартът е труден и изисква много енергия. Чувствате се изтощени, но трябва да издържите.",
    "reading_advice": "Дръжте се още малко. Финалната права е точно зад ъгъла."
  },
  {
    "reading_id": "ace_wands_ten_wands",
    "reading_name": "Асо Жезли + Десетка Жезли",
    "reading_cards": "Асо Жезли + Десетка Жезли",
    "reading_combination": ["ace_wands", "ten_wands"],
    "reading_meaning": "Претоварен старт.Асо Жезли носи ентусиазъм, а Десетка Жезли – претоварване и бреме. Поемате твърде много отговорности твърде рано. Ентусиазмът ви води до прегаряне, ако не забавите темпото.",
    "reading_description": "Започвате с ентусиазъм, но бързо се претоварвате. Поемате твърде много отговорности.",
    "reading_advice": "Забавете темпото. Никой не може да носи всичко сам. Потърсете помощ."
  },
  {
    "reading_id": "ace_wands_page_wands",
    "reading_name": "Асо Жезли + Паж Жезли",
    "reading_cards": "Асо Жезли + Паж Жезли",
    "reading_combination": ["ace_wands", "page_wands"],
    "reading_meaning": "Свежа енергия и новини.Асо Жезли носи искрата на новото начало, а Паж Жезли – ентусиазма и свежите новини. Заедно предвещават вълнуващо послание, свързано с нов проект или идея. Вашата енергия е заразителна.",
    "reading_description": "Получавате вълнуваща новина, свързана с ново начало. Ентусиазмът ви е на върха.",
    "reading_advice": "Споделете ентусиазма си с другите. Вашата енергия е заразителна и може да привлече подкрепа."
  },
  {
    "reading_id": "ace_wands_knight_wands",
    "reading_name": "Асо Жезли + Рицар Жезли",
    "reading_cards": "Асо Жезли + Рицар Жезли",
    "reading_combination": ["ace_wands", "knight_wands"],
    "reading_meaning": "Стремителен старт.Асо Жезли носи новото начало, а Рицар Жезли – импулсивността и бързото действие. Заедно създават експлозивна комбинация – идеята се ражда и веднага се втурвате да я реализирате с пълна сила. Внимавайте да не прегазите другите.",
    "reading_description": "Новата идея ви кара да действате светкавично. Имате неудържима енергия и желание за движение.",
    "reading_advice": "Действайте бързо, но не забравяйте за хората около вас. Страстта е добра, но не трябва да прегазва."
  },
  {
    "reading_id": "ace_wands_queen_wands",
    "reading_name": "Асо Жезли + Царица Жезли",
    "reading_cards": "Асо Жезли + Царица Жезли",
    "reading_combination": ["ace_wands", "queen_wands"],
    "reading_meaning": "Уверен старт.Асо Жезли носи искрата, а Царица Жезли – увереността и харизмата. Започвате нещо ново с голяма самоувереност. Вашата топлина и увереност привличат хората към вас и вашата идея.",
    "reading_description": "Започвате нов проект с увереност и харизма. Хората се вдъхновяват от вашата енергия.",
    "reading_advice": "Бъдете себе си – топло и уверено. Вашата светлина вдъхновява другите да ви последват."
  },
  {
    "reading_id": "ace_wands_king_wands",
    "reading_name": "Асо Жезли + Цар Жезли",
    "reading_cards": "Асо Жезли + Цар Жезли",
    "reading_combination": ["ace_wands", "king_wands"],
    "reading_meaning": "Лидерски старт.Асо Жезли носи новото начало, а Цар Жезли – лидерството и визията. Започвате нещо ново с ясна визия и авторитет. Имате всички качества да поведете другите и да реализирате идеята си.",
    "reading_description": "Започвате нов проект с ясна визия и лидерска позиция. Имате авторитета да водите другите.",
    "reading_advice": "Поемете лидерството. Имате визията и силата да я осъществите. Водете с пример."
  },
  {
    "reading_id": "ace_wands_two_cups",
    "reading_name": "Асо Жезли + Двойка Чаши",
    "reading_cards": "Асо Жезли + Двойка Чаши",
    "reading_combination": ["ace_wands", "two_cups"],
    "reading_meaning": "Страст и любов.Асо Жезли носи страстта и енергията, а Двойка Чаши – любовта и взаимното привличане. Огън и вода се срещат – страстна и интензивна любовна връзка. Химията между вас е силна и неудържима.",
    "reading_description": "Нова любовна връзка с много страст и енергия. Химията между вас е неудържима.",
    "reading_advice": "Наслаждавайте се на страстта, но не забравяйте и за емоционалната връзка. Огънят се нуждае от вода, за да не изгори."
  },
  {
    "reading_id": "ace_wands_three_cups",
    "reading_name": "Асо Жезли + Тройка Чаши",
    "reading_cards": "Асо Жезли + Тройка Чаши",
    "reading_combination": ["ace_wands", "three_cups"],
    "reading_meaning": "Празнична страст.Асо Жезли носи енергията, а Тройка Чаши – празника и радостта. Нова страст или проект идва с много поводи за празнуване. Вашият ентусиазъм е заразителен и събира хора около вас.",
    "reading_description": "Нов проект или страст носи много радост и поводи за празнуване. Енергията ви е заразителна.",
    "reading_advice": "Празнувайте всеки успех, дори малкия. Радостта, споделена с други, е двойна радост."
  },
  {
    "reading_id": "ace_wands_four_cups",
    "reading_name": "Асо Жезли + Четворка Чаши",
    "reading_cards": "Асо Жезли + Четворка Чаши",
    "reading_combination": ["ace_wands", "four_cups"],
    "reading_meaning": "Пропусната възможност.Асо Жезли носи нова възможност, а Четворка Чаши – апатията и неудовлетворението. Нова възможност се появява, но вие сте твърде заети със себе си, за да я забележите. Рискувате да пропуснете нещо ценно.",
    "reading_description": "Нова възможност се появява, но вие не я забелязвате. Твърде сте заети със себе си.",
    "reading_advice": "Вдигнете поглед. Може да пропускате нещо важно, което е точно пред вас."
  },
  {
    "reading_id": "ace_wands_five_cups",
    "reading_name": "Асо Жезли + Петица Чаши",
    "reading_cards": "Асо Жезли + Петица Чаши",
    "reading_combination": ["ace_wands", "five_cups"],
    "reading_meaning": "Ново начало след загуба",
    "second_meaning": "Асо Жезли носи новото начало, а Петица Чаши – тъгата и загубата. След период на скръб или разочарование идва нова надежда. Светлината се появява след тъмнината.",
    "reading_description": "Нова страст или проект се появява след период на тъга и загуба. Светлина след мрак.",
    "reading_advice": "Дори в скръбта има място за ново начало. Позволете си да се отворите към надеждата."
  },
  {
    "reading_id": "ace_wands_six_cups",
    "reading_name": "Асо Жезли + Шестица Чаши",
    "reading_cards": "Асо Жезли + Шестица Чаши",
    "reading_combination": ["ace_wands", "six_cups"],
    "reading_meaning": "Носталгична страст",
    "second_meaning": "Асо Жезли носи новото, а Шестица Чаши – спомените и носталгията. Новият проект или страст ви напомня за нещо от миналото. Усещате позната топлина и вдъхновение от стари спомени.",
    "reading_description": "Нов проект или страст ви напомня за нещо от миналото. Носталгия и ново начало.",
    "reading_advice": "Използвайте миналото като вдъхновение, но не позволявайте то да ви държи в капан. Творете новото с опита на старото."
  },
  {
    "reading_id": "ace_wands_seven_cups",
    "reading_name": "Асо Жезли + Седмица Чаши",
    "reading_cards": "Асо Жезли + Седмица Чаши",
    "reading_combination": ["ace_wands", "seven_cups"],
    "reading_meaning": "Много възможности",
    "second_meaning": "Асо Жезли носи нова енергия, а Седмица Чаши – множество избори и илюзии. Имате много възможности, но не всички са реални. Трудно е да изберете накъде да насочите енергията си.",
    "reading_description": "Нова страст и много възможности едновременно. Трудно е да изберете посока.",
    "reading_advice": "Изберете една възможност и ѝ се посветете. Не се разпилявайте в илюзии."
  },
  {
    "reading_id": "ace_wands_eight_cups",
    "reading_name": "Асо Жезли + Осмица Чаши",
    "reading_cards": "Асо Жезли + Осмица Чаши",
    "reading_combination": ["ace_wands", "eight_cups"],
    "reading_meaning": "Тръгване с нов проект",
    "second_meaning": "Асо Жезли носи новото начало, а Осмица Чаши – тръгването и оставянето. Започвате нов проект, което означава да оставите нещо старо зад гърба си. Пътят към новото изисква освобождаване.",
    "reading_description": "Започвате нов проект и оставяте старото зад гърба си. Път към новото.",
    "reading_advice": "Тръгнете смело. Старото вече не ви служи. Новият път ви очаква."
  },
  {
    "reading_id": "ace_wands_nine_cups",
    "reading_name": "Асо Жезли + Деветка Чаши",
    "reading_cards": "Асо Жезли + Деветка Чаши",
    "reading_combination": ["ace_wands", "nine_cups"],
    "reading_meaning": "Сбъдната мечта",
    "second_meaning": "Асо Жезли носи енергията, а Деветка Чаши – сбъднатото желание. Новият ви проект носи изпълнение на дългогодишна мечта. Удовлетворение и радост от постигнатото.",
    "reading_description": "Новият ви проект носи сбъдване на дългогодишна мечта. Удовлетворение и радост.",
    "reading_advice": "Насладете се на момента. Ти го заслужи. Мечтата ви се сбъдва."
  },
  {
    "reading_id": "ace_wands_ten_cups",
    "reading_name": "Асо Жезли + Десетка Чаши",
    "reading_cards": "Асо Жезли + Десетка Чаши",
    "reading_combination": ["ace_wands", "ten_cups"],
    "reading_meaning": "Семеен успех",
    "second_meaning": "Асо Жезли носи новото начало, а Десетка Чаши – пълното семейно щастие. Новият ви проект или начинание носи радост на цялото семейство. Споделен успех и хармония в дома.",
    "reading_description": "Нов проект, който носи щастие на цялото семейство. Споделен успех.",
    "reading_advice": "Споделете успеха със семейството си. Щастието е по-голямо, когато е споделено."
  },
  {
    "reading_id": "ace_wands_page_cups",
    "reading_name": "Асо Жезли + Паж Чаши",
    "reading_cards": "Асо Жезли + Паж Чаши",
    "reading_combination": ["ace_wands", "page_cups"],
    "reading_meaning": "Нова страст и послание",
    "second_meaning": "Асо Жезли носи енергията, а Паж Чаши – емоционално послание. Очаквайте вълнуваща новина, свързана със сърдечни въпроси или нов творчески проект. Някой може да ви признае чувствата си.",
    "reading_description": "Получавате емоционално послание, свързано с нова страст или проект. Сърцето ви бие по-бързо.",
    "reading_advice": "Отворете сърцето си за посланието. То носи нещо важно за вас."
  },
  {
    "reading_id": "ace_wands_knight_cups",
    "reading_name": "Асо Жезли + Рицар Чаши",
    "reading_cards": "Асо Жезли + Рицар Чаши",
    "reading_combination": ["ace_wands", "knight_cups"],
    "reading_meaning": "Романтична страст",
    "second_meaning": "Асо Жезли носи страстта, а Рицар Чаши – романтиката и ухажването. Очаквайте романтичен жест или предложение, което идва с много страст. Някой идва при вас с отворено сърце.",
    "reading_description": "Нова романтична връзка или романтичен жест идва с много страст и емоция.",
    "reading_advice": "Кажете какво чувствате. Бъдете смели в любовта – сърцето ви знае пътя."
  },
  {
    "reading_id": "ace_wands_queen_cups",
    "reading_name": "Асо Жезли + Царица Чаши",
    "reading_cards": "Асо Жезли + Царица Чаши",
    "reading_combination": ["ace_wands", "queen_cups"],
    "reading_meaning": "Интуитивна страст",
    "second_meaning": "Асо Жезли носи енергията, а Царица Чаши – интуицията и дълбоката емоционалност. Новата ви страст е водена от силна интуиция. Сърцето ви знае какво иска, дори умът да се съмнява.",
    "reading_description": "Нова страст или проект, воден от интуиция и дълбоки чувства. Слушайте сърцето си.",
    "reading_advice": "Доверете се на вътрешния си глас. Интуицията ви води правилно."
  },
  {
    "reading_id": "ace_wands_king_cups",
    "reading_name": "Асо Жезли + Цар Чаши",
    "reading_cards": "Асо Жезли + Цар Чаши",
    "reading_combination": ["ace_wands", "king_cups"],
    "reading_meaning": "Контролирана страст",
    "second_meaning": "Асо Жезли носи страстта, а Цар Чаши – емоционалната зрялост и контрол. Новата ви страст е силна, но вие умеете да я контролирате. Баланс между огън и вода.",
    "reading_description": "Нова страст, която умеете да контролирате. Емоционална зрялост и баланс.",
    "reading_advice": "Управлявайте енергията си с мъдрост. Страстта е силна, но вие сте по-силни."
  },
  {
    "reading_id": "ace_wands_two_swords",
    "reading_name": "Асо Жезли + Двойка Мечове",
    "reading_cards": "Асо Жезли + Двойка Мечове",
    "reading_combination": ["ace_wands", "two_swords"],
    "reading_meaning": "Идея и съмнение",
    "second_meaning": "Асо Жезли носи нова идея, а Двойка Мечове – нерешителност и блокиране. Имате нова идея, но се съмнявате дали да я реализирате. Страхът от грешка ви парализира.",
    "reading_description": "Нова идея се ражда, но я съпътстват съмнения и нерешителност. Не знаете дали да действате.",
    "reading_advice": "Свалете превръзката от очите. Понякога трябва да изберете, дори да не виждате ясно."
  },
  {
    "reading_id": "ace_wands_three_swords",
    "reading_name": "Асо Жезли + Тройка Мечове",
    "reading_cards": "Асо Жезли + Тройка Мечове",
    "reading_combination": ["ace_wands", "three_swords"],
    "reading_meaning": "Страст и болка",
    "second_meaning": "Асо Жезли носи страст, а Тройка Мечове – болка и разбито сърце. Новата ви страст може да донесе разочарование или болка. Внимавайте с кого споделяте ентусиазма си.",
    "reading_description": "Нова страст или проект носи не само радост, но и риск от разочарование.",
    "reading_advice": "Бъдете внимателни с доверието си. Не всяка страст носи само радост."
  },
  {
    "reading_id": "ace_wands_four_swords",
    "reading_name": "Асо Жезли + Четворка Мечове",
    "reading_cards": "Асо Жезли + Четворка Мечове",
    "reading_combination": ["ace_wands", "four_swords"],
    "reading_meaning": "Почивка преди старт",
    "second_meaning": "Асо Жезли носи нова енергия, а Четворка Мечове – почивка и възстановяване. Имате идея, но сега не е моментът за действие. Първо починете и съберете сили.",
    "reading_description": "Имате нова идея, но сега е време за почивка, не за действие. Съберете сили.",
    "reading_advice": "Починете си преди да започнете. Добрата подготовка води до успех."
  },
  {
    "reading_id": "ace_wands_five_swords",
    "reading_name": "Асо Жезли + Петица Мечове",
    "reading_cards": "Асо Жезли + Петица Мечове",
    "reading_combination": ["ace_wands", "five_swords"],
    "reading_meaning": "Конфликтна идея",
    "second_meaning": "Асо Жезли носи нова идея, а Петица Мечове – конфликт и празна победа. Идеята ви може да предизвика спор или да се опитате да я наложите по неправилен начин. Помислете дали си струва.",
    "reading_description": "Новата ви идея предизвиква конфликт. Може да спечелите, но с цената на нечии чувства.",
    "reading_advice": "Помислете дали си струва да нараните другите, за да спечелите. Понякога е по-добре да отстъпите."
  },
  {
    "reading_id": "ace_wands_six_swords",
    "reading_name": "Асо Жезли + Шестица Мечове",
    "reading_cards": "Асо Жезли + Шестица Мечове",
    "reading_combination": ["ace_wands", "six_swords"],
    "reading_meaning": "Ново начало и път",
    "second_meaning": "Асо Жезли носи новото начало, а Шестица Мечове – пътуването и прехода. Новата ви идея или проект ще ви отведе на ново място – физически или метафорично. Очаквайте промяна на средата.",
    "reading_description": "Нов проект или идея ви отвежда на ново място. Пътуване или преместване ви очаква.",
    "reading_advice": "Тръгнете с увереност. Новите води носят нови възможности."
  },
  {
    "reading_id": "ace_wands_seven_swords",
    "reading_name": "Асо Жезли + Седмица Мечове",
    "reading_cards": "Асо Жезли + Седмица Мечове",
    "reading_combination": ["ace_wands", "seven_swords"],
    "reading_meaning": "Идея и измама",
    "second_meaning": "Асо Жезли носи нова идея, а Седмица Мечове – измама и хитрост. Внимавайте – някой може да се опита да присвои идеята ви или да ви измами. Пазите интелектуалната си собственост.",
    "reading_description": "Новата ви идея е ценна, но има риск някой да се опита да ви я открадне.",
    "reading_advice": "Бъдете внимателни с кого споделяте идеите си. Проверявайте два пъти."
  },
  {
    "reading_id": "ace_wands_eight_swords",
    "reading_name": "Асо Жезли + Осмица Мечове",
    "reading_cards": "Асо Жезли + Осмица Мечове",
    "reading_combination": ["ace_wands", "eight_swords"],
    "reading_meaning": "Блокирана идея",
    "second_meaning": "Асо Жезли носи нова идея, а Осмица Мечове – чувство на капан и ограничение. Имате страхотна идея, но се чувствате блокирани и без изход. Страхът ви пречи да действате.",
    "reading_description": "Имате нова идея, но се чувствате в капан. Страховете ви пречат да действате.",
    "reading_advice": "Оковите са в главата ви. Освободете се от страха и ще видите, че имате повече възможности, отколкото си мислите."
  },
  {
    "reading_id": "ace_wands_nine_swords",
    "reading_name": "Асо Жезли + Деветка Мечове",
    "reading_cards": "Асо Жезли + Деветка Мечове",
    "reading_combination": ["ace_wands", "nine_swords"],
    "reading_meaning": "Тревожна идея",
    "second_meaning": "Асо Жезли носи нова енергия, а Деветка Мечове – тревога и безсъние. Новата идея ви вълнува, но също така ви тревожи. Мислите ви се въртят около нея и не ви оставят да спите.",
    "reading_description": "Нова идея ви вълнува, но носи и тревоги. Безсъние и премисляне.",
    "reading_advice": "Спокойствие. Повечето неща, за които се тревожим, никога не се случват. Доверете се на процеса."
  },
  {
    "reading_id": "ace_wands_ten_swords",
    "reading_name": "Асо Жезли + Десетка Мечове",
    "reading_cards": "Асо Жезли + Десетка Мечове",
    "reading_combination": ["ace_wands", "ten_swords"],
    "reading_meaning": "Край и ново начало",
    "second_meaning": "Асо Жезли носи новото, а Десетка Мечове – края и дъното. Нещо старо приключва, за да може нещо ново да започне. Краят е болезнен, но носи освобождение и нов път.",
    "reading_description": "След тежък край идва ново начало. Феникс от пепелта.",
    "reading_advice": "Оставете старото да умре. Новото вече чука на вратата. Позволете му да влезе."
  },
  {
    "reading_id": "ace_wands_page_swords",
    "reading_name": "Асо Жезли + Паж Мечове",
    "reading_cards": "Асо Жезли + Паж Мечове",
    "reading_combination": ["ace_wands", "page_swords"],
    "reading_meaning": "Идея и истина",
    "second_meaning": "Асо Жезли носи нова идея, а Паж Мечове – търсене на истината и любопитство. Новата ви идея ви кара да търсите отговори и да задавате въпроси. Любопитството ви води към открития.",
    "reading_description": "Нова идея ви кара да търсите истината. Любопитство и открития.",
    "reading_advice": "Задавайте въпроси. Не приемайте нищо за дадено. Истината е някъде там – открийте я."
  },
  {
    "reading_id": "ace_wands_knight_swords",
    "reading_name": "Асо Жезли + Рицар Мечове",
    "reading_cards": "Асо Жезли + Рицар Мечове",
    "reading_combination": ["ace_wands", "knight_swords"],
    "reading_meaning": "Стремителна идея",
    "second_meaning": "Асо Жезли носи новата идея, а Рицар Мечове – бързината и прямотата. Идеята ви идва светкавично и веднага искате да я реализирате. Действате бързо и решително.",
    "reading_description": "Новата идея идва светкавично и ви кара да действате без колебание. Бързина и решителност.",
    "reading_advice": "Действайте бързо, но не безразсъдно. Устремът ви е сила, но не прегазвайте другите."
  },
  {
    "reading_id": "ace_wands_queen_swords",
    "reading_name": "Асо Жезли + Царица Мечове",
    "reading_cards": "Асо Жезли + Царица Мечове",
    "reading_combination": ["ace_wands", "queen_swords"],
    "reading_meaning": "Ясна идея",
    "second_meaning": "Асо Жезли носи новата идея, а Царица Мечове – яснота и независимост. Имате кристално ясна визия за новото си начинание. Никой не може да ви заблуди – виждате истината.",
    "reading_description": "Новата ви идея е кристално ясна. Знаете точно какво искате и как да го постигнете.",
    "reading_advice": "Бъдете честни със себе си и с другите. Вашата яснота вдъхновява доверие."
  },
  {
    "reading_id": "ace_wands_king_swords",
    "reading_name": "Асо Жезли + Цар Мечове",
    "reading_cards": "Асо Жезли + Цар Мечове",
    "reading_combination": ["ace_wands", "king_swords"],
    "reading_meaning": "Стратегическа идея",
    "second_meaning": "Асо Жезли носи новата идея, а Цар Мечове – интелект и стратегия. Новата ви идея е добре обмислена и стратегически издържана. Имате ясен план за реализация.",
    "reading_description": "Новата ви идея е подкрепена с ясен план и стратегия. Интелект и логика водят напред.",
    "reading_advice": "Вземете решение с ума си, но не забравяйте и сърцето. Стратегията е важна, но и емоциите имат значение."
  },
  {
    "reading_id": "ace_wands_two_pentacles",
    "reading_name": "Асо Жезли + Двойка Пентакли",
    "reading_cards": "Асо Жезли + Двойка Пентакли",
    "reading_combination": ["ace_wands", "two_pentacles"],
    "reading_meaning": "Нов проект и баланс",
    "second_meaning": "Асо Жезли носи новата енергия, а Двойка Пентакли – баланса и жонглирането с ресурси. Новият проект изисква да балансирате време, пари и енергия. Ще трябва да жонглирате.",
    "reading_description": "Нов проект изисква да балансирате ресурсите си. Време, пари, енергия – всичко трябва да е в хармония.",
    "reading_advice": "Жонглирайте, но не изпускайте топката. Балансът е ключът към успеха."
  },
  {
    "reading_id": "ace_wands_three_pentacles",
    "reading_name": "Асо Жезли + Тройка Пентакли",
    "reading_cards": "Асо Жезли + Тройка Пентакли",
    "reading_combination": ["ace_wands", "three_pentacles"],
    "reading_meaning": "Нов проект в екип",
    "second_meaning": "Асо Жезли носи новата идея, а Тройка Пентакли – екипната работа и сътрудничество. Новият ви проект изисква да работите с други хора. Заедно можете да постигнете повече.",
    "reading_description": "Нов проект, който изисква сътрудничество с други. Екипна работа и споделени умения.",
    "reading_advice": "Работете в екип. Учете се от по-опитните и споделяйте знанията си. Заедно сте по-силни."
  },
  {
    "reading_id": "ace_wands_four_pentacles",
    "reading_name": "Асо Жезли + Четворка Пентакли",
    "reading_cards": "Асо Жезли + Четворка Пентакли",
    "reading_combination": ["ace_wands", "four_pentacles"],
    "reading_meaning": "Нов проект и сигурност",
    "second_meaning": "Асо Жезли носи новата идея, а Четворка Пентакли – сигурността и задържането. Новият проект изисква да инвестирате ресурси, но се страхувате да ги пуснете. Стискането може да ви попречи.",
    "reading_description": "Нова идея, но се страхувате да инвестирате ресурси. Стискате и се колебаете.",
    "reading_advice": "Пуснете малко. Страхът от загуба може да ви попречи да спечелите нещо по-голямо."
  },
  {
    "reading_id": "ace_wands_five_pentacles",
    "reading_name": "Асо Жезли + Петица Пентакли",
    "reading_cards": "Асо Жезли + Петица Пентакли",
    "reading_combination": ["ace_wands", "five_pentacles"],
    "reading_meaning": "Нов проект и липса",
    "second_meaning": "Асо Жезли носи новата идея, а Петица Пентакли – финансови трудности и липса. Имате страхотна идея, но ви липсват ресурси за реализация. Търсете помощ.",
    "reading_description": "Имате нова идея, но финансовите ресурси са ограничени. Чувствате се изолирани.",
    "reading_advice": "Потърсете помощ. Не сте сами. Има хора, готови да ви подкрепят, ако поискате."
  },
  {
    "reading_id": "ace_wands_six_pentacles",
    "reading_name": "Асо Жезли + Шестица Пентакли",
    "reading_cards": "Асо Жезли + Шестица Пентакли",
    "reading_combination": ["ace_wands", "six_pentacles"],
    "reading_meaning": "Нов проект и подкрепа",
    "second_meaning": "Асо Жезли носи новата идея, а Шестица Пентакли – помощта и щедростта. Новият ви проект получава подкрепа – финансова или емоционална. Някой вярва във вас.",
    "reading_description": "Новата ви идея получава подкрепа. Някой протяга ръка да ви помогне.",
    "reading_advice": "Приемете помощта с благодарност. Някой ден ще имате възможност да върнете жеста."
  },
  {
    "reading_id": "ace_wands_seven_pentacles",
    "reading_name": "Асо Жезли + Седмица Пентакли",
    "reading_cards": "Асо Жезли + Седмица Пентакли",
    "reading_combination": ["ace_wands", "seven_pentacles"],
    "reading_meaning": "Нов проект и търпение",
    "second_meaning": "Асо Жезли носи новата енергия, а Седмица Пентакли – търпението и чакането на резултати. Започнали сте нещо ново, но резултатите няма да дойдат веднага. Трябва да изчакате.",
    "reading_description": "Започнали сте нов проект, но трябва да изчакате резултатите. Търпение и вяра.",
    "reading_advice": "Чакайте търпеливо. Добрите неща идват при тези, които умеят да чакат, докато продължават да работят."
  },
  {
    "reading_id": "ace_wands_eight_pentacles",
    "reading_name": "Асо Жезли + Осмица Пентакли",
    "reading_cards": "Асо Жезли + Осмица Пентакли",
    "reading_combination": ["ace_wands", "eight_pentacles"],
    "reading_meaning": "Нов занаят",
    "second_meaning": "Асо Жезли носи новата идея, а Осмица Пентакли – усърдието и ученето. Новият ви проект изисква да научите нови умения. Вложете време и усилия в усъвършенстването.",
    "reading_description": "Нов проект изисква да научите нови умения. Усърдие и постоянство.",
    "reading_advice": "Учете се с желание. Майсторството идва с практика. Не спирайте да се развивате."
  },
  {
    "reading_id": "ace_wands_nine_pentacles",
    "reading_name": "Асо Жезли + Деветка Пентакли",
    "reading_cards": "Асо Жезли + Деветка Пентакли",
    "reading_combination": ["ace_wands", "nine_pentacles"],
    "reading_meaning": "Нов проект и независимост",
    "second_meaning": "Асо Жезли носи новата идея, а Деветка Пентакли – самодостатъчността и успеха. Новият ви проект ви води към финансова независимост и свобода. Наслаждавайте се на плодовете.",
    "reading_description": "Новият проект ви води към независимост и успех. Наслаждавайте се на постигнатото.",
    "reading_advice": "Ти постигна самостоятелност. Наслади се на свободата, но не спирай да твориш."
  },
  {
    "reading_id": "ace_wands_ten_pentacles",
    "reading_name": "Асо Жезли + Десетка Пентакли",
    "reading_cards": "Асо Жезли + Десетка Пентакли",
    "reading_combination": ["ace_wands", "ten_pentacles"],
    "reading_meaning": "Нов проект и наследство",
    "second_meaning": "Асо Жезли носи новото начало, а Десетка Пентакли – семейното наследство и дългосрочната сигурност. Новият ви проект има потенциала да осигури бъдещето на семейството ви.",
    "reading_description": "Нов проект, който носи дългосрочна сигурност и полза за семейството.",
    "reading_advice": "Мислете за бъдещето. Това, което градите сега, ще остане след вас."
  },
  {
    "reading_id": "ace_wands_page_pentacles",
    "reading_name": "Асо Жезли + Паж Пентакли",
    "reading_cards": "Асо Жезли + Паж Пентакли",
    "reading_combination": ["ace_wands", "page_pentacles"],
    "reading_meaning": "Нова възможност и учене",
    "second_meaning": "Асо Жезли носи новата възможност, а Паж Пентакли – ученето и новото начало в материалната сфера. Получавате шанс да научите нещо ново, което ще ви донесе полза.",
    "reading_description": "Нова възможност за учене или старт в материалната сфера. Инвестиция в себе си.",
    "reading_advice": "Започнете да учите. Инвестирайте в себе си. Търпеливо градете, стъпка по стъпка."
  },
  {
    "reading_id": "ace_wands_knight_pentacles",
    "reading_name": "Асо Жезли + Рицар Пентакли",
    "reading_cards": "Асо Жезли + Рицар Пентакли",
    "reading_combination": ["ace_wands", "knight_pentacles"],
    "reading_meaning": "Нов проект и търпение",
    "second_meaning": "Асо Жезли носи ентусиазма, а Рицар Пентакли – бавния и сигурен напредък. Новият ви проект изисква търпение – не очаквайте бързи резултати. Бавно, но сигурно.",
    "reading_description": "Нов проект, който изисква търпение и постоянство. Бързите резултати не са реалистични.",
    "reading_advice": "Не бързайте. Работете търпеливо. Сигурният път е бавен, но води до целта."
  },
  {
    "reading_id": "ace_wands_queen_pentacles",
    "reading_name": "Асо Жезли + Царица Пентакли",
    "reading_cards": "Асо Жезли + Царица Пентакли",
    "reading_combination": ["ace_wands", "queen_pentacles"],
    "reading_meaning": "Нов проект и грижа",
    "second_meaning": "Асо Жезли носи новата енергия, а Царица Пентакли – грижата и дома. Новият ви проект е свързан с дома, семейството или създаване на уют. Вложете сърце в него.",
    "reading_description": "Нов проект, свързан с дома, семейството или материалния уют. Грижа и практичност.",
    "reading_advice": "Грижете се за проекта като за дом. Вложете любов и практичност – резултатът ще бъде прекрасен."
  },
  {
    "reading_id": "ace_wands_king_pentacles",
    "reading_name": "Асо Жезли + Цар Пентакли",
    "reading_cards": "Асо Жезли + Цар Пентакли",
    "reading_combination": ["ace_wands", "king_pentacles"],
    "reading_meaning": "Нов бизнес проект",
    "second_meaning": "Асо Жезли носи новата идея, а Цар Пентакли – бизнес успеха и стабилността. Новият ви проект има потенциала да се превърне в успешен бизнес. Имате всички качества да успеете.",
    "reading_description": "Нов бизнес проект с потенциал за успех и стабилност. Лидерски качества.",
    "reading_advice": "Поемете лидерството. Имате визията и практичността да успеете. Градете стабилно."
  },
  {
    "reading_id": "two_wands_three_wands",
    "reading_name": "Двойка Жезли + Тройка Жезли",
    "reading_cards": "Двойка Жезли + Тройка Жезли",
    "reading_combination": ["two_wands", "three_wands"],
    "reading_meaning": "Избор и очакване",
    "second_meaning": "Двойка Жезли носи избора и планирането, а Тройка Жезли – очакването и разширяването на хоризонтите. След като сте взели решение, сега чакате резултатите. Погледът ви е насочен напред, но трябва да проявите търпение.",
    "reading_description": "Взели сте важно решение и сега чакате то да даде плод. Гледате напред с надежда.",
    "reading_advice": "Търпението е добродетел. Резултатите идват при тези, които умеят да чакат, докато продължават да работят."
  },
  {
    "reading_id": "two_wands_four_wands",
    "reading_name": "Двойка Жезли + Четворка Жезли",
    "reading_cards": "Двойка Жезли + Четворка Жезли",
    "reading_combination": ["two_wands", "four_wands"],
    "reading_meaning": "Избор и празник",
    "second_meaning": "Двойка Жезли носи избора и планирането, а Четворка Жезли – празника и стабилността. След като сте направили правилния избор, идва момент на празнуване и радост. Завръщане у дома след пътуване.",
    "reading_description": "След важния избор идва момент на празник и радост. Връщате се у дома.",
    "reading_advice": "Празнувайте, но утре ви очакват нови решения. Насладете се на момента."
  },
  {
    "reading_id": "two_wands_five_wands",
    "reading_name": "Двойка Жезли + Петица Жезли",
    "reading_cards": "Двойка Жезли + Петица Жезли",
    "reading_combination": ["two_wands", "five_wands"],
    "reading_meaning": "Спорен избор",
    "second_meaning": "Двойка Жезли носи избора, а Петица Жезли – конфликта и съперничеството. Изборът, който сте направили, не се харесва на всички. Очаквайте спорове и защита на позицията.",
    "reading_description": "Изборът ви предизвиква конфликти и спорове. Трябва да защитавате решението си.",
    "reading_advice": "Бъдете твърди в решението си. Не можете да угодите на всички. Отстоявайте това, в което вярвате."
  },
  {
    "reading_id": "two_wands_six_wands",
    "reading_name": "Двойка Жезли + Шестица Жезли",
    "reading_cards": "Двойка Жезли + Шестица Жезли",
    "reading_combination": ["two_wands", "six_wands"],
    "reading_meaning": "Правилен избор",
    "second_meaning": "Двойка Жезли носи избора, а Шестица Жезли – победата и признанието. Изборът ви беше правилен и вече виждате първите успехи. Признание и удовлетворение.",
    "reading_description": "Изборът ви се оказва правилен. Успехът и признанието идват.",
    "reading_advice": "Доверете се на интуицията си. Тя ви води правилно. Насладете се на победата."
  },
  {
    "reading_id": "two_wands_seven_wands",
    "reading_name": "Двойка Жезли + Седмица Жезли",
    "reading_cards": "Двойка Жезли + Седмица Жезли",
    "reading_combination": ["two_wands", "seven_wands"],
    "reading_meaning": "Защита на избора",
    "second_meaning": "Двойка Жезли носи избора, а Седмица Жезли – защитата на позицията. Някой оспорва решението ви и трябва да го защитавате. Не отстъпвайте, ако сте убедени.",
    "reading_description": "Изборът ви се оспорва. Трябва да защитавате позицията си.",
    "reading_advice": "Имайте смелостта да отстоявате себе си. Не се огъвайте пред критиката."
  },
  {
    "reading_id": "two_wands_eight_wands",
    "reading_name": "Двойка Жезли + Осмица Жезли",
    "reading_cards": "Двойка Жезли + Осмица Жезли",
    "reading_combination": ["two_wands", "eight_wands"],
    "reading_meaning": "Бързи резултати",
    "second_meaning": "Двойка Жезли носи избора, а Осмица Жезли – бързината и движението. След като сте взели решение, нещата започват да се случват много бързо. Едва успявате да ги настигнете.",
    "reading_description": "След избора нещата се развиват с неочаквана скорост. Бъдете готови.",
    "reading_advice": "Останете фокусирани, но се наслаждавайте на скоростта. Яздете вълната на успеха."
  },
  {
    "reading_id": "two_wands_nine_wands",
    "reading_name": "Двойка Жезли + Деветка Жезли",
    "reading_cards": "Двойка Жезли + Деветка Жезли",
    "reading_combination": ["two_wands", "nine_wands"],
    "reading_meaning": "Упоритост след избора",
    "second_meaning": "Двойка Жезли носи избора, а Деветка Жезли – устойчивостта и последната линия на отбрана. Изборът беше труден и още по-трудно е да се придържате към него. Умора, но и решителност.",
    "reading_description": "Изборът беше труден и все още изисква много усилия. Чувствате умора, но продължавате.",
    "reading_advice": "Не се отказвайте точно сега. Ти си почти на финала. Още малко търпение."
  },
  {
    "reading_id": "two_wands_ten_wands",
    "reading_name": "Двойка Жезли + Десетка Жезли",
    "reading_cards": "Двойка Жезли + Десетка Жезли",
    "reading_combination": ["two_wands", "ten_wands"],
    "reading_meaning": "Тежест на избора",
    "second_meaning": "Двойка Жезли носи избора, а Десетка Жезли – претоварването и бремето. Решението, което сте взели, носи много отговорности. Чувствате се претоварени, но сте поели ангажимент.",
    "reading_description": "Изборът ви донесе много отговорности. Чувствате се претоварени.",
    "reading_advice": "Потърсете помощ. Не е нужно да носите всичко сам. Споделете бремето."
  },
  {
    "reading_id": "two_wands_page_wands",
    "reading_name": "Двойка Жезли + Паж Жезли",
    "reading_cards": "Двойка Жезли + Паж Жезли",
    "reading_combination": ["two_wands", "page_wands"],
    "reading_meaning": "Избор и новини",
    "second_meaning": "Двойка Жезли носи избора, а Паж Жезли – новините и ентусиазма. Очаквайте вълнуваща новина, свързана с решението ви. Някой носи добри вести.",
    "reading_description": "След важния избор идват добри новини. Ентусиазъм и вдъхновение.",
    "reading_advice": "Отворете се за новините. Те носят нещо ценно за вашето пътуване."
  },
  {
    "reading_id": "two_wands_knight_wands",
    "reading_name": "Двойка Жезли + Рицар Жезли",
    "reading_cards": "Двойка Жезли + Рицар Жезли",
    "reading_combination": ["two_wands", "knight_wands"],
    "reading_meaning": "Бързо следствие",
    "second_meaning": "Двойка Жезли носи избора, а Рицар Жезли – импулсивността и бързото действие. След като сте взели решение, веднага се втурвате да действате. Няма колебание – само напред.",
    "reading_description": "След избора действате светкавично. Няма време за съмнения.",
    "reading_advice": "Действайте с увереност, но внимавайте да не прегазите другите по пътя."
  },
  {
    "reading_id": "two_wands_queen_wands",
    "reading_name": "Двойка Жезли + Царица Жезли",
    "reading_cards": "Двойка Жезли + Царица Жезли",
    "reading_combination": ["two_wands", "queen_wands"],
    "reading_meaning": "Уверен избор",
    "second_meaning": "Двойка Жезли носи избора, а Царица Жезли – увереността и харизмата. Правите избора си с увереност и топлина. Хората се вдъхновяват от вашата решителност.",
    "reading_description": "Правите избора си с увереност и харизма. Вдъхновявате другите.",
    "reading_advice": "Бъдете себе си – уверено и топло. Вашата светлина води другите."
  },
  {
    "reading_id": "two_wands_king_wands",
    "reading_name": "Двойка Жезли + Цар Жезли",
    "reading_cards": "Двойка Жезли + Цар Жезли",
    "reading_combination": ["two_wands", "king_wands"],
    "reading_meaning": "Властен избор",
    "second_meaning": "Двойка Жезли носи избора, а Цар Жезли – лидерството и визията. Изборът ви е стратегически и ви поставя в позиция на лидер. Имате визията да поведете другите.",
    "reading_description": "Изборът ви носи лидерска позиция. Имате визия и авторитет.",
    "reading_advice": "Поемете лидерството. Вашата визия ще вдъхнови другите да ви последват."
  },
  {
    "reading_id": "two_wands_two_cups",
    "reading_name": "Двойка Жезли + Двойка Чаши",
    "reading_cards": "Двойка Жезли + Двойка Чаши",
    "reading_combination": ["two_wands", "two_cups"],
    "reading_meaning": "Избор в любовта",
    "second_meaning": "Двойка Жезли носи избора, а Двойка Чаши – любовта и връзката. Предстои ви избор, свързан със сърдечни въпроси. Две възможности, две посоки – слушайте сърцето си.",
    "reading_description": "Избор, свързан с любов или връзка. Две възможности, две посоки.",
    "reading_advice": "Изберете сърцето, но не забравяйте и главата. След като изберете, не се съмнявайте."
  },
  {
    "reading_id": "two_wands_three_cups",
    "reading_name": "Двойка Жезли + Тройка Чаши",
    "reading_cards": "Двойка Жезли + Тройка Чаши",
    "reading_combination": ["two_wands", "three_cups"],
    "reading_meaning": "Избор и радост",
    "second_meaning": "Двойка Жезли носи избора, а Тройка Чаши – празника и радостта. Решението, което ще вземете, ще донесе радост и повод за празнуване. Щастлив избор.",
    "reading_description": "Изборът ви носи радост и повод за празнуване. Щастливо решение.",
    "reading_advice": "Изберете това, което ви прави щастливи. Радостта е добър компас."
  },
  {
    "reading_id": "two_wands_four_cups",
    "reading_name": "Двойка Жезли + Четворка Чаши",
    "reading_cards": "Двойка Жезли + Четворка Чаши",
    "reading_combination": ["two_wands", "four_cups"],
    "reading_meaning": "Избор и неудовлетворение",
    "second_meaning": "Двойка Жезли носи избора, а Четворка Чаши – апатията и неудовлетворението. Изправени сте пред избор, но никоя от опциите не ви удовлетворява напълно. Чувствате се в застой.",
    "reading_description": "Избор, но нито една опция не ви радва. Неудовлетворение и апатия.",
    "reading_advice": "Понякога липсата на избор е най-добрият избор. Изчакайте, преди да решите."
  },
  {
    "reading_id": "two_wands_five_cups",
    "reading_name": "Двойка Жезли + Петица Чаши",
    "reading_cards": "Двойка Жезли + Петица Чаши",
    "reading_combination": ["two_wands", "five_cups"],
    "reading_meaning": "Труден избор",
    "second_meaning": "Двойка Жезли носи избора, а Петица Чаши – загубата и тъгата. Изборът, пред който сте изправен, ще донесе загуба или тъга, независимо какво изберете. Трудно решение.",
    "reading_description": "Избор, който носи загуба и тъга, каквото и да изберете. Трудно решение.",
    "reading_advice": "Изберете това, което носи по-малко болка. Позволете си да скърбите, после продължете."
  },
  {
    "reading_id": "two_wands_six_cups",
    "reading_name": "Двойка Жезли + Шестица Чаши",
    "reading_cards": "Двойка Жезли + Шестица Чаши",
    "reading_combination": ["two_wands", "six_cups"],
    "reading_meaning": "Избор от миналото",
    "second_meaning": "Двойка Жезли носи избора, а Шестица Чаши – спомените и носталгията. Изборът ви е свързан с миналото – завръщане на стар човек или ситуация. Носталгия и решение.",
    "reading_description": "Избор, свързан с миналото. Носталгия и спомени.",
    "reading_advice": "Миналото е учител, не водач. Вземете наученото, но гледайте напред."
  },
  {
    "reading_id": "two_wands_seven_cups",
    "reading_name": "Двойка Жезли + Седмица Чаши",
    "reading_cards": "Двойка Жезли + Седмица Чаши",
    "reading_combination": ["two_wands", "seven_cups"],
    "reading_meaning": "Избор сред илюзии",
    "second_meaning": "Двойка Жезли носи избора, а Седмица Чаши – илюзиите и многото възможности. Трудно различавате истината от фантазията. Много опции, но повечето са илюзорни.",
    "reading_description": "Много възможности, но повечето са илюзии. Трудно различавате истината.",
    "reading_advice": "Свалете розовите очила, преди да изберете. Реалността е по-ценна от фантазията."
  },
  {
    "reading_id": "two_wands_eight_cups",
    "reading_name": "Двойка Жезли + Осмица Чаши",
    "reading_cards": "Двойка Жезли + Осмица Чаши",
    "reading_combination": ["two_wands", "eight_cups"],
    "reading_meaning": "Избор и тръгване",
    "second_meaning": "Двойка Жезли носи избора, а Осмица Чаши – тръгването и оставянето. Изборът, който правите, ще ви отведе на ново място. Трябва да оставите нещо старо зад гърба си.",
    "reading_description": "Изборът ви кара да тръгнете и да оставите познатото. Нов път.",
    "reading_advice": "Тръгнете с увереност. Новият път ви очаква с отворени обятия."
  },
  {
    "reading_id": "two_wands_nine_cups",
    "reading_name": "Двойка Жезли + Деветка Чаши",
    "reading_cards": "Двойка Жезли + Деветка Чаши",
    "reading_combination": ["two_wands", "nine_cups"],
    "reading_meaning": "Желан избор",
    "second_meaning": "Двойка Жезли носи избора, а Деветка Чаши – сбъднатото желание. Изборът, пред който сте, ще ви помогне да сбъднете мечтата си. Изберете смело.",
    "reading_description": "Избор, който води към сбъдване на мечта. Желано решение.",
    "reading_advice": "Мечтите заслужават да бъдат избрани. Не се колебайте – следвайте сърцето си."
  },
  {
    "reading_id": "two_wands_ten_cups",
    "reading_name": "Двойка Жезли + Десетка Чаши",
    "reading_cards": "Двойка Жезли + Десетка Чаши",
    "reading_combination": ["two_wands", "ten_cups"],
    "reading_meaning": "Семеен избор",
    "second_meaning": "Двойка Жезли носи избора, а Десетка Чаши – семейното щастие и хармония. Решението, което вземате, засяга цялото семейство. Съветвайте се с близките си.",
    "reading_description": "Избор, който засяга цялото семейство. Семейна хармония.",
    "reading_advice": "Семейството е най-важното. Съветвайте се с тях и вземете решение заедно."
  },
  {
    "reading_id": "two_wands_page_cups",
    "reading_name": "Двойка Жезли + Паж Чаши",
    "reading_cards": "Двойка Жезли + Паж Чаши",
    "reading_combination": ["two_wands", "page_cups"],
    "reading_meaning": "Избор и послание",
    "second_meaning": "Двойка Жезли носи избора, а Паж Чаши – емоционално послание. Очаквайте вест, свързана със сърдечни въпроси, която ще ви помогне да вземете решение.",
    "reading_description": "Емоционално послание идва, за да ви помогне с избора. Слушайте сърцето си.",
    "reading_advice": "Отворете сърцето си за посланието. То носи отговора, който търсите."
  },
  {
    "reading_id": "two_wands_knight_cups",
    "reading_name": "Двойка Жезли + Рицар Чаши",
    "reading_cards": "Двойка Жезли + Рицар Чаши",
    "reading_combination": ["two_wands", "knight_cups"],
    "reading_meaning": "Избор и романтика",
    "second_meaning": "Двойка Жезли носи избора, а Рицар Чаши – романтиката и ухажването. Предстои ви романтичен избор – между двама души или между две посоки в любовта. Следвайте сърцето си.",
    "reading_description": "Романтичен избор пред вас. Сърцето ви знае пътя.",
    "reading_advice": "Изберете с любов. Рицарят на Чаши ви кани да последвате сърцето си."
  },
  {
    "reading_id": "two_wands_queen_cups",
    "reading_name": "Двойка Жезли + Царица Чаши",
    "reading_cards": "Двойка Жезли + Царица Чаши",
    "reading_combination": ["two_wands", "queen_cups"],
    "reading_meaning": "Интуитивен избор",
    "second_meaning": "Двойка Жезли носи избора, а Царица Чаши – интуицията и дълбоката емоционалност. Интуицията ви ще ви подскаже правилния избор. Слушайте вътрешния си глас.",
    "reading_description": "Интуицията ви води към правилния избор. Слушайте вътрешния си глас.",
    "reading_advice": "Доверете се на вътрешния си глас. Той знае повече, отколкото си мислите."
  },
  {
    "reading_id": "two_wands_king_cups",
    "reading_name": "Двойка Жезли + Цар Чаши",
    "reading_cards": "Двойка Жезли + Цар Чаши",
    "reading_combination": ["two_wands", "king_cups"],
    "reading_meaning": "Балансиран избор",
    "second_meaning": "Двойка Жезли носи избора, а Цар Чаши – емоционалната зрялост и баланс. Ще вземете решението си с мъдрост и спокойствие. Без крайности, без прибързване.",
    "reading_description": "Избор, направен с мъдрост и емоционален баланс. Зряло решение.",
    "reading_advice": "Вземете решението с ума и сърцето заедно. Балансът води към най-добрия избор."
  },
  {
    "reading_id": "two_wands_two_swords",
    "reading_name": "Двойка Жезли + Двойка Мечове",
    "reading_cards": "Двойка Жезли + Двойка Мечове",
    "reading_combination": ["two_wands", "two_swords"],
    "reading_meaning": "Избор и съмнение",
    "second_meaning": "Двойка Жезли носи избора, а Двойка Мечове – нерешителността и блокажа. Изправени сте пред избор, но се страхувате да вземете решение. Парализиращи съмнения.",
    "reading_description": "Избор, който ви парализира. Съмнения и страх от грешка.",
    "reading_advice": "Свалете превръзката от очите. Понякога трябва да изберете, дори да не виждате ясно."
  },
  {
    "reading_id": "two_wands_three_swords",
    "reading_name": "Двойка Жезли + Тройка Мечове",
    "reading_cards": "Двойка Жезли + Тройка Мечове",
    "reading_combination": ["two_wands", "three_swords"],
    "reading_meaning": "Избор и болка",
    "second_meaning": "Двойка Жезли носи избора, а Тройка Мечове – болката и разбитото сърце. Изборът, който правите, може да донесе болка или разочарование. Трудно решение.",
    "reading_description": "Избор, който носи риск от болка и разочарование.",
    "reading_advice": "Болката е част от живота. Изберете това, което в дългосрочен план носи повече мир."
  },
  {
    "reading_id": "two_wands_four_swords",
    "reading_name": "Двойка Жезли + Четворка Мечове",
    "reading_cards": "Двойка Жезли + Четворка Мечове",
    "reading_combination": ["two_wands", "four_swords"],
    "reading_meaning": "Избор и почивка",
    "second_meaning": "Двойка Жезли носи избора, а Четворка Мечове – почивката и възстановяването. Преди да вземете важно решение, имате нужда от почивка. Изчакайте, докато умът ви се избистри.",
    "reading_description": "Преди важния избор, имате нужда от почивка. Изчакайте яснота.",
    "reading_advice": "Починете си. Най-добрите решения идват, когато умът е спокоен."
  },
  {
    "reading_id": "two_wands_five_swords",
    "reading_name": "Двойка Жезли + Петица Мечове",
    "reading_cards": "Двойка Жезли + Петица Мечове",
    "reading_combination": ["two_wands", "five_swords"],
    "reading_meaning": "Спорен избор",
    "second_meaning": "Двойка Жезли носи избора, а Петица Мечове – конфликта и празната победа. Изборът ви може да предизвика конфликт. Дори да спечелите, цената може да е висока.",
    "reading_description": "Избор, който води до конфликт. Победата може да е празна.",
    "reading_advice": "Помислете дали си струва да нараните другите, за да спечелите. Понякога отстъплението е по-мъдро."
  },
  {
    "reading_id": "two_wands_six_swords",
    "reading_name": "Двойка Жезли + Шестица Мечове",
    "reading_cards": "Двойка Жезли + Шестица Мечове",
    "reading_combination": ["two_wands", "six_swords"],
    "reading_meaning": "Избор и път",
    "second_meaning": "Двойка Жезли носи избора, а Шестица Мечове – пътуването и прехода. Изборът, който правите, ще ви отведе на ново място. Пътуване или преместване ви очаква.",
    "reading_description": "Избор, който води към пътуване или преместване. Нови хоризонти.",
    "reading_advice": "Тръгнете с увереност. Новите води носят нови възможности."
  },
  {
    "reading_id": "two_wands_seven_swords",
    "reading_name": "Двойка Жезли + Седмица Мечове",
    "reading_cards": "Двойка Жезли + Седмица Мечове",
    "reading_combination": ["two_wands", "seven_swords"],
    "reading_meaning": "Избор и измама",
    "second_meaning": "Двойка Жезли носи избора, а Седмица Мечове – измамата и хитростта. Внимавайте – някой може да се опита да ви измами или да ви подведе в избора. Проверявайте фактите.",
    "reading_description": "Избор, в който има риск от измама. Бъдете внимателни.",
    "reading_advice": "Проверявайте два пъти. Доверието е хубаво, но проверката е по-добра."
  },
  {
    "reading_id": "two_wands_eight_swords",
    "reading_name": "Двойка Жезли + Осмица Мечове",
    "reading_cards": "Двойка Жезли + Осмица Мечове",
    "reading_combination": ["two_wands", "eight_swords"],
    "reading_meaning": "Блокиран избор",
    "second_meaning": "Двойка Жезли носи избора, а Осмица Мечове – чувството на капан и ограничение. Чувствате се блокирани и без изход. Страхът ви пречи да вземете решение.",
    "reading_description": "Чувствате се в капан, без да виждате изход. Страхът ви блокира.",
    "reading_advice": "Оковите са в главата ви. Освободете се от страха – имате повече възможности, отколкото си мислите."
  },
  {
    "reading_id": "two_wands_nine_swords",
    "reading_name": "Двойка Жезли + Деветка Мечове",
    "reading_cards": "Двойка Жезли + Деветка Мечове",
    "reading_combination": ["two_wands", "nine_swords"],
    "reading_meaning": "Тревожен избор",
    "second_meaning": "Двойка Жезли носи избора, а Деветка Мечове – тревогата и безсънието. Изборът ви тревожи и не ви оставя да спите. Мислите ви се въртят около него.",
    "reading_description": "Изборът ви тревожи и не ви оставя да спите. Безсъние и притеснения.",
    "reading_advice": "Спокойствие. Повечето неща, за които се тревожим, никога не се случват. Дишайте дълбоко."
  },
  {
    "reading_id": "two_wands_ten_swords",
    "reading_name": "Двойка Жезли + Десетка Мечове",
    "reading_cards": "Двойка Жезли + Десетка Мечове",
    "reading_combination": ["two_wands", "ten_swords"],
    "reading_meaning": "Край на избора",
    "second_meaning": "Двойка Жезли носи избора, а Десетка Мечове – края и дъното. Периодът на колебания и избори приключва. Краят носи освобождение, дори да е болезнен.",
    "reading_description": "Периодът на избори и колебания приключва. Край и ново начало.",
    "reading_advice": "Оставете избора зад гърба си. Това, което е свършило, вече не тежи."
  },
  {
    "reading_id": "two_wands_page_swords",
    "reading_name": "Двойка Жезли + Паж Мечове",
    "reading_cards": "Двойка Жезли + Паж Мечове",
    "reading_combination": ["two_wands", "page_swords"],
    "reading_meaning": "Избор и истина",
    "second_meaning": "Двойка Жезли носи избора, а Паж Мечове – търсенето на истината. За да вземете правилното решение, трябва да откриете истината. Търсете отговори.",
    "reading_description": "За да изберете, трябва да откриете истината. Любопитство и разследване.",
    "reading_advice": "Задавайте въпроси. Не приемайте нищо за дадено. Истината ще ви насочи."
  },
  {
    "reading_id": "two_wands_knight_swords",
    "reading_name": "Двойка Жезли + Рицар Мечове",
    "reading_cards": "Двойка Жезли + Рицар Мечове",
    "reading_combination": ["two_wands", "knight_swords"],
    "reading_meaning": "Бърз избор",
    "second_meaning": "Двойка Жезли носи избора, а Рицар Мечове – бързината и прямотата. Ще вземете решение светкавично, без много колебания. Действие и решителност.",
    "reading_description": "Вземате решение бързо и решително. Няма време за колебания.",
    "reading_advice": "Действайте бързо, но не безразсъдно. Устремът ви е сила, но внимавайте кого прегазвате."
  },
  {
    "reading_id": "two_wands_queen_swords",
    "reading_name": "Двойка Жезли + Царица Мечове",
    "reading_cards": "Двойка Жезли + Царица Мечове",
    "reading_combination": ["two_wands", "queen_swords"],
    "reading_meaning": "Ясен избор",
    "second_meaning": "Двойка Жезли носи избора, а Царица Мечове – яснотата и независимостта. Виждате избора си кристално ясно. Никой не може да ви заблуди.",
    "reading_description": "Изборът ви е кристално ясен. Виждате истината без илюзии.",
    "reading_advice": "Бъдете честни със себе си. Вашата яснота води към правилното решение."
  },
  {
    "reading_id": "two_wands_king_swords",
    "reading_name": "Двойка Жезли + Цар Мечове",
    "reading_cards": "Двойка Жезли + Цар Мечове",
    "reading_combination": ["two_wands", "king_swords"],
    "reading_meaning": "Стратегически избор",
    "second_meaning": "Двойка Жезли носи избора, а Цар Мечове – интелекта и стратегията. Ще вземете решението си с логика и анализ. Обективност и справедливост.",
    "reading_description": "Избор, направен с логика и стратегия. Обективно решение.",
    "reading_advice": "Вземете решението с ума си. Логиката и справедливостта водят към правилния път."
  },
  {
    "reading_id": "two_wands_two_pentacles",
    "reading_name": "Двойка Жезли + Двойка Пентакли",
    "reading_cards": "Двойка Жезли + Двойка Пентакли",
    "reading_combination": ["two_wands", "two_pentacles"],
    "reading_meaning": "Избор и баланс",
    "second_meaning": "Двойка Жезли носи избора, а Двойка Пентакли – баланса и жонглирането. Изборът ви изисква да балансирате ресурси – време, пари, енергия. Жонглирайте внимателно.",
    "reading_description": "Избор, който изисква баланс между различни ресурси. Жонглирайте внимателно.",
    "reading_advice": "Балансирайте, но не изпускайте топката. Финансовият и времеви баланс са ключови."
  },
  {
    "reading_id": "two_wands_three_pentacles",
    "reading_name": "Двойка Жезли + Тройка Пентакли",
    "reading_cards": "Двойка Жезли + Тройка Пентакли",
    "reading_combination": ["two_wands", "three_pentacles"],
    "reading_meaning": "Избор и екип",
    "second_meaning": "Двойка Жезли носи избора, а Тройка Пентакли – екипната работа и сътрудничеството. Изборът ви ще бъде по-лесен, ако се посъветвате с други. Екипна работа.",
    "reading_description": "Избор, който изисква съвет и сътрудничество. Не сте сами.",
    "reading_advice": "Посъветвайте се с други. Заедно можете да вземете по-добро решение."
  },
  {
    "reading_id": "two_wands_four_pentacles",
    "reading_name": "Двойка Жезли + Четворка Пентакли",
    "reading_cards": "Двойка Жезли + Четворка Пентакли",
    "reading_combination": ["two_wands", "four_pentacles"],
    "reading_meaning": "Избор и сигурност",
    "second_meaning": "Двойка Жезли носи избора, а Четворка Пентакли – сигурността и задържането. Страхът от загуба може да ви попречи да изберете. Не се вкопчвайте прекалено.",
    "reading_description": "Избор, блокиран от страх от загуба. Стискате прекалено силно.",
    "reading_advice": "Пуснете малко. Страхът от загуба може да ви попречи да спечелите нещо по-добро."
  },
  {
    "reading_id": "two_wands_five_pentacles",
    "reading_name": "Двойка Жезли + Петица Пентакли",
    "reading_cards": "Двойка Жезли + Петица Пентакли",
    "reading_combination": ["two_wands", "five_pentacles"],
    "reading_meaning": "Избор и липса",
    "second_meaning": "Двойка Жезли носи избора, а Петица Пентакли – финансовите трудности и липсата. Искате да изберете, но ресурсите са ограничени. Търсете помощ.",
    "reading_description": "Искате да изберете, но ресурсите са ограничени. Чувствате се изолирани.",
    "reading_advice": "Потърсете помощ. Не сте сами. Има хора, готови да ви подкрепят."
  },
  {
    "reading_id": "two_wands_six_pentacles",
    "reading_name": "Двойка Жезли + Шестица Пентакли",
    "reading_cards": "Двойка Жезли + Шестица Пентакли",
    "reading_combination": ["two_wands", "six_pentacles"],
    "reading_meaning": "Избор и помощ",
    "second_meaning": "Двойка Жезли носи избора, а Шестица Пентакли – помощта и щедростта. Някой ще ви помогне да вземете правилното решение. Приемете подкрепата.",
    "reading_description": "Помощ идва, за да ви помогне с избора. Приемете я с благодарност.",
    "reading_advice": "Приемете помощта. Някой ден ще имате възможност да върнете жеста."
  },
  {
    "reading_id": "two_wands_seven_pentacles",
    "reading_name": "Двойка Жезли + Седмица Пентакли",
    "reading_cards": "Двойка Жезли + Седмица Пентакли",
    "reading_combination": ["two_wands", "seven_pentacles"],
    "reading_meaning": "Избор и търпение",
    "second_meaning": "Двойка Жезли носи избора, а Седмица Пентакли – търпението и чакането. След като изберете, ще трябва да изчакате резултатите. Търпение и вяра.",
    "reading_description": "След избора идва време за търпение. Чакайте резултатите.",
    "reading_advice": "Чакайте търпеливо. Добрите неща идват при тези, които умеят да чакат."
  },
  {
    "reading_id": "two_wands_eight_pentacles",
    "reading_name": "Двойка Жезли + Осмица Пентакли",
    "reading_cards": "Двойка Жезли + Осмица Пентакли",
    "reading_combination": ["two_wands", "eight_pentacles"],
    "reading_meaning": "Избор и учене",
    "second_meaning": "Двойка Жезли носи избора, а Осмица Пентакли – усърдието и ученето. За да направите правилния избор, трябва да научите нови умения. Инвестирайте в себе си.",
    "reading_description": "За правилния избор трябва да научите нови умения. Учете се.",
    "reading_advice": "Инвестирайте в себе си. Знанието ще ви помогне да изберете правилно."
  },
  {
    "reading_id": "two_wands_nine_pentacles",
    "reading_name": "Двойка Жезли + Деветка Пентакли",
    "reading_cards": "Двойка Жезли + Деветка Пентакли",
    "reading_combination": ["two_wands", "nine_pentacles"],
    "reading_meaning": "Избор и независимост",
    "second_meaning": "Двойка Жезли носи избора, а Деветка Пентакли – самодостатъчността и успеха. Изборът ви ще ви доведе до независимост и свобода. Правилно решение.",
    "reading_description": "Избор, който води към независимост и успех. Свобода и удовлетворение.",
    "reading_advice": "Изберете смело. Този път води към свободата, която търсите."
  },
  {
    "reading_id": "two_wands_ten_pentacles",
    "reading_name": "Двойка Жезли + Десетка Пентакли",
    "reading_cards": "Двойка Жезли + Десетка Пентакли",
    "reading_combination": ["two_wands", "ten_pentacles"],
    "reading_meaning": "Семеен избор",
    "second_meaning": "Двойка Жезли носи избора, а Десетка Пентакли – семейното наследство и дългосрочната сигурност. Решението ви засяга семейството и бъдещите поколения.",
    "reading_description": "Избор, който засяга семейството и бъдещето. Мислете дългосрочно.",
    "reading_advice": "Мислете за семейството и за това, което оставяте след себе си."
  },
  {
    "reading_id": "two_wands_page_pentacles",
    "reading_name": "Двойка Жезли + Паж Пентакли",
    "reading_cards": "Двойка Жезли + Паж Пентакли",
    "reading_combination": ["two_wands", "page_pentacles"],
    "reading_meaning": "Избор и ново начало",
    "second_meaning": "Двойка Жезли носи избора, а Паж Пентакли – новото начало в материалната сфера. Изборът ви отваря врата към нова финансова възможност или кариерен път.",
    "reading_description": "Избор, който води към нова финансова възможност. Ново начало.",
    "reading_advice": "Хванете възможността. Тя носи ново начало и растеж."
  },
  {
    "reading_id": "two_wands_knight_pentacles",
    "reading_name": "Двойка Жезли + Рицар Пентакли",
    "reading_cards": "Двойка Жезли + Рицар Пентакли",
    "reading_combination": ["two_wands", "knight_pentacles"],
    "reading_meaning": "Бавно решение",
    "second_meaning": "Двойка Жезли носи избора, а Рицар Пентакли – бавния и сигурен напредък. Не бързайте с решението. Бавно, но сигурно – обмислете всички детайли.",
    "reading_description": "Избор, който изисква време. Не бързайте, обмислете добре.",
    "reading_advice": "Не бързайте. Сигурният път е бавен, но води до целта. Обмислете добре."
  },
  {
    "reading_id": "two_wands_queen_pentacles",
    "reading_name": "Двойка Жезли + Царица Пентакли",
    "reading_cards": "Двойка Жезли + Царица Пентакли",
    "reading_combination": ["two_wands", "queen_pentacles"],
    "reading_meaning": "Практичен избор",
    "second_meaning": "Двойка Жезли носи избора, а Царица Пентакли – практичността и грижата. Изборът ви трябва да е практичен и да носи полза за дома и семейството.",
    "reading_description": "Практичен избор, свързан с дома и семейството. Грижа и практичност.",
    "reading_advice": "Изберете практичното. Грижата за дома и близките води към правилното решение."
  },
  {
    "reading_id": "two_wands_king_pentacles",
    "reading_name": "Двойка Жезли + Цар Пентакли",
    "reading_cards": "Двойка Жезли + Цар Пентакли",
    "reading_combination": ["two_wands", "king_pentacles"],
    "reading_meaning": "Бизнес избор",
    "second_meaning": "Двойка Жезли носи избора, а Цар Пентакли – бизнес успеха и стабилността. Изборът ви е свързан с бизнес, финанси или дългосрочна инвестиция. Стратегическо решение.",
    "reading_description": "Бизнес или финансов избор пред вас. Стратегическо решение.",
    "reading_advice": "Изберете с мъдрост. Това решение носи дългосрочна стабилност и успех."
  },



 {
    "reading_id": "three_wands_four_wands",
    "reading_name": "Тройка Жезли + Четворка Жезли",
    "reading_cards": "Тройка Жезли + Четворка Жезли",
    "reading_combination": ["three_wands", "four_wands"],
    "reading_meaning": "Очакване и празник",
    "second_meaning": "Тройка Жезли носи очакването и търпението, а Четворка Жезли – празника и стабилността. Докато чакате резултатите, не забравяйте да се радвате на това, което вече имате. Радостта и надеждата вървят ръка за ръка.",
    "reading_description": "В очакване на резултати, намирате повод за празнуване. Радвате се на пътя, не само на дестинацията.",
    "reading_advice": "Радвай се на пътя, не само на дестинацията. Празнувай малките победи."
  },
  {
    "reading_id": "three_wands_five_wands",
    "reading_name": "Тройка Жезли + Петица Жезли",
    "reading_cards": "Тройка Жезли + Петица Жезли",
    "reading_combination": ["three_wands", "five_wands"],
    "reading_meaning": "Очакване и конфликт",
    "second_meaning": "Тройка Жезли носи очакването, а Петица Жезли – конфликта и съперничеството. Докато чакате резултати, около вас назрява напрежение. Не се замесвайте в драми – фокусът ви трябва да остане върху целите.",
    "reading_description": "В очакване на резултати се сблъсквате с конфликти и спорове. Трудно е да запазите спокойствие.",
    "reading_advice": "Не се замесвай в драми. Фокусирай се върху целите си и остави споровете настрана."
  },
  {
    "reading_id": "three_wands_six_wands",
    "reading_name": "Тройка Жезли + Шестица Жезли",
    "reading_cards": "Тройка Жезли + Шестица Жезли",
    "reading_combination": ["three_wands", "six_wands"],
    "reading_meaning": "Очакван успех",
    "second_meaning": "Тройка Жезли носи очакването, а Шестица Жезли – победата и признанието. Търпението ви се отплаща – резултатите, които очаквате, идват и носят успех. Насладете се на момента.",
    "reading_description": "Очакваните резултати най-после идват и ви водят към успех. Търпението се отплаща.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Търпението и вярата доведоха до този успех."
  },
  {
    "reading_id": "three_wands_seven_wands",
    "reading_name": "Тройка Жезли + Седмица Жезли",
    "reading_cards": "Тройка Жезли + Седмица Жезли",
    "reading_combination": ["three_wands", "seven_wands"],
    "reading_meaning": "Очакване и защита",
    "second_meaning": "Тройка Жезли носи очакването, а Седмица Жезли – защитата на позицията. Докато чакате, някой се опитва да ви попречи. Дръжте позицията си и не отстъпвайте.",
    "reading_description": "Докато чакате резултати, някой се опитва да ви попречи. Трябва да защитавате позицията си.",
    "reading_advice": "Бъди бдителен, но не позволявай на страха да те завладее. Дръж позицията си."
  },
  {
    "reading_id": "three_wands_eight_wands",
    "reading_name": "Тройка Жезли + Осмица Жезли",
    "reading_cards": "Тройка Жезли + Осмица Жезли",
    "reading_combination": ["three_wands", "eight_wands"],
    "reading_meaning": "Бързи резултати",
    "second_meaning": "Тройка Жезли носи очакването, а Осмица Жезли – бързината. Резултатите идват неочаквано бързо – почти не можете да ги настигнете. Бъдете готови да ги посрещнете.",
    "reading_description": "Това, което очаквате, пристига с неочаквана скорост. Готови ли сте да го приемете?",
    "reading_advice": "Приготви се. Нещата ще се случат по-бързо, отколкото си мислиш. Бъди отворен за бързината."
  },
  {
    "reading_id": "three_wands_nine_wands",
    "reading_name": "Тройка Жезли + Деветка Жезли",
    "reading_cards": "Тройка Жезли + Деветка Жезли",
    "reading_combination": ["three_wands", "nine_wands"],
    "reading_meaning": "Изтощително очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Деветка Жезли – устойчивостта и изтощението. Чакането се проточва и започва да ви изтощава. Умора, но надеждата, че скоро ще приключи, ви крепи.",
    "reading_description": "Очакването се проточва и ви изтощава. Умора, но и надежда, че краят е близо.",
    "reading_advice": "Дръж се още малко. Краят е близо. Последните усилия ще доведат до резултат."
  },
  {
    "reading_id": "three_wands_ten_wands",
    "reading_name": "Тройка Жезли + Десетка Жезли",
    "reading_cards": "Тройка Жезли + Десетка Жезли",
    "reading_combination": ["three_wands", "ten_wands"],
    "reading_meaning": "Тежко очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Десетка Жезли – претоварването и бремето. Докато чакате, носите и много други отговорности. Претоварване и умора, но не можете да спрете.",
    "reading_description": "В очакване на резултати носите и други тежки отговорности. Претоварване и стрес.",
    "reading_advice": "Потърси облекчение, преди да се сринеш. Не можеш да носиш всичко сам."
  },
  {
    "reading_id": "three_wands_page_wands",
    "reading_name": "Тройка Жезли + Паж Жезли",
    "reading_cards": "Тройка Жезли + Паж Жезли",
    "reading_combination": ["three_wands", "page_wands"],
    "reading_meaning": "Очакване и новини",
    "second_meaning": "Тройка Жезли носи очакването, а Паж Жезли – новините и ентусиазма. Очаквайте вълнуваща вест, свързана с проекта ви. Новината ще дойде скоро и ще ви зареди с енергия.",
    "reading_description": "Докато чакате, идват добри новини. Ентусиазъм и вдъхновение.",
    "reading_advice": "Отвори се за новините. Те носят енергията, от която имаш нужда, за да продължиш."
  },
  {
    "reading_id": "three_wands_knight_wands",
    "reading_name": "Тройка Жезли + Рицар Жезли",
    "reading_cards": "Тройка Жезли + Рицар Жезли",
    "reading_combination": ["three_wands", "knight_wands"],
    "reading_meaning": "Нетърпеливо очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Рицар Жезли – импулсивността и нетърпението. Трудно ви е да чакате – искате резултати веднага. Но скоростта не винаги е най-добрият път.",
    "reading_description": "Очакването ви изпълва с нетърпение. Искате всичко да се случи веднага.",
    "reading_advice": "Забави малко. Скоростта не винаги е най-важното. Понякога бавното и сигурно води до по-добър резултат."
  },
  {
    "reading_id": "three_wands_queen_wands",
    "reading_name": "Тройка Жезли + Царица Жезли",
    "reading_cards": "Тройка Жезли + Царица Жезли",
    "reading_combination": ["three_wands", "queen_wands"],
    "reading_meaning": "Уверено очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Царица Жезли – увереността и харизмата. Чакате с вътрешна увереност, че всичко ще се нареди. Вашата топлина и вяра вдъхновяват и другите.",
    "reading_description": "Чакате с увереност и спокойствие. Знаете, че резултатите ще дойдат.",
    "reading_advice": "Вярвай в себе си и в процеса. Увереността ти е заразителна – носи я със себе си."
  },
  {
    "reading_id": "three_wands_king_wands",
    "reading_name": "Тройка Жезли + Цар Жезли",
    "reading_cards": "Тройка Жезли + Цар Жезли",
    "reading_combination": ["three_wands", "king_wands"],
    "reading_meaning": "Стратегическо очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Цар Жезли – лидерството и визията. Чакането ви не е пасивно – вие планирате следващите стъпки. Визията ви ще ви води напред.",
    "reading_description": "Докато чакате, планирате и строите визия за бъдещето. Стратегическо очакване.",
    "reading_advice": "Използвай времето на чакане, за да планираш. Визията ти ще те води напред."
  },
  {
    "reading_id": "three_wands_two_cups",
    "reading_name": "Тройка Жезли + Двойка Чаши",
    "reading_cards": "Тройка Жезли + Двойка Чаши",
    "reading_combination": ["three_wands", "two_cups"],
    "reading_meaning": "Очакване на любов",
    "second_meaning": "Тройка Жезли носи очакването, а Двойка Чаши – любовта и връзката. Очаквате нова любов или задълбочаване на съществуваща връзка. Търпението ще бъде възнаградено.",
    "reading_description": "Чакате нова любов или развитие в съществуваща връзка. Търпение и надежда.",
    "reading_advice": "Любовта идва, когато не я чакаш. Бъди отворен, но не прибързвай."
  },
  {
    "reading_id": "three_wands_three_cups",
    "reading_name": "Тройка Жезли + Тройка Чаши",
    "reading_cards": "Тройка Жезли + Тройка Чаши",
    "reading_combination": ["three_wands", "three_cups"],
    "reading_meaning": "Очакване на празник",
    "second_meaning": "Тройка Жезли носи очакването, а Тройка Чаши – празника и радостта. Очаквате повод за празнуване – събитие, среща или радостна вест. Подготвяйте се.",
    "reading_description": "Очаквате повод за радост и празнуване. Скоро ще имате причина да се радвате.",
    "reading_advice": "Подготвяй се за празника. Радостта идва – отвори сърцето си за нея."
  },
  {
    "reading_id": "three_wands_four_cups",
    "reading_name": "Тройка Жезли + Четворка Чаши",
    "reading_cards": "Тройка Жезли + Четворка Чаши",
    "reading_combination": ["three_wands", "four_cups"],
    "reading_meaning": "Очакване и неудовлетворение",
    "second_meaning": "Тройка Жезли носи очакването, а Четворка Чаши – апатията и неудовлетворението. Чакате нещо, но дори когато дойде, може да не ви удовлетвори. Преосмислете очакванията си.",
    "reading_description": "Очаквате нещо, но се съмнявате дали ще ви донесе радост. Неудовлетворение.",
    "reading_advice": "Провери дали това, което очакваш, наистина е това, което искаш. Понякога очакванията ни не съвпадат с истинските ни нужди."
  },
  {
    "reading_id": "three_wands_five_cups",
    "reading_name": "Тройка Жезли + Петица Чаши",
    "reading_cards": "Тройка Жезли + Петица Чаши",
    "reading_combination": ["three_wands", "five_cups"],
    "reading_meaning": "Очакване на загуба",
    "second_meaning": "Тройка Жезли носи очакването, а Петица Чаши – загубата и тъгата. Усещате, че предстои разочарование или загуба. Страх и несигурност в очакването.",
    "reading_description": "Усещате, че предстои загуба или разочарование. Страх и несигурност.",
    "reading_advice": "Каквото дойде, приеми го. Ще се справиш. Позволи си да скърбиш, после продължи."
  },
  {
    "reading_id": "three_wands_six_cups",
    "reading_name": "Тройка Жезли + Шестица Чаши",
    "reading_cards": "Тройка Жезли + Шестица Чаши",
    "reading_combination": ["three_wands", "six_cups"],
    "reading_meaning": "Носталгично очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Шестица Чаши – спомените и носталгията. Очаквате завръщане на някого или нещо от миналото. Спомени и надежда.",
    "reading_description": "Очаквате някой от миналото да се появи или нещо старо да се завърне.",
    "reading_advice": "Бъди готов да посрещнеш миналото, но не спирай да живееш в настоящето. Спомените са хубави, но не бива да те държат в капан."
  },
  {
    "reading_id": "three_wands_seven_cups",
    "reading_name": "Тройка Жезли + Седмица Чаши",
    "reading_cards": "Тройка Жезли + Седмица Чаши",
    "reading_combination": ["three_wands", "seven_cups"],
    "reading_meaning": "Очакване на илюзии",
    "second_meaning": "Тройка Жезли носи очакването, а Седмица Чаши – илюзиите и фантазиите. Очаквате нещо, което вероятно не е реално. Свали розовите очила.",
    "reading_description": "Очаквате нещо, което може да е илюзия или фантазия. Реалността може да е различна.",
    "reading_advice": "Слез на земята. Това, което очакваш, може да не е истина. Бъди реалист."
  },
  {
    "reading_id": "three_wands_eight_cups",
    "reading_name": "Тройка Жезли + Осмица Чаши",
    "reading_cards": "Тройка Жезли + Осмица Чаши",
    "reading_combination": ["three_wands", "eight_cups"],
    "reading_meaning": "Очакване на тръгване",
    "second_meaning": "Тройка Жезли носи очакването, а Осмица Чаши – тръгването и оставянето. Чакате момента да напуснете и да започнете нов път. Подготовка за заминаване.",
    "reading_description": "Чакате да дойде моментът да тръгнете. Подготовка за нов път.",
    "reading_advice": "Готов ли си за път? Скоро ще тръгнеш. Подготви се емоционално и логистично."
  },
  {
    "reading_id": "three_wands_nine_cups",
    "reading_name": "Тройка Жезли + Деветка Чаши",
    "reading_cards": "Тройка Жезли + Деветка Чаши",
    "reading_combination": ["three_wands", "nine_cups"],
    "reading_meaning": "Очакване на мечта",
    "second_meaning": "Тройка Жезли носи очакването, а Деветка Чаши – сбъднатото желание. Очаквате с нетърпение сбъдването на дългогодишна мечта. Скоро ще се случи.",
    "reading_description": "Очаквате с нетърпение сбъдването на дългогодишна мечта. Скоро ще се случи.",
    "reading_advice": "Търпение. Мечтите се сбъдват, когато е време. Вярвай, че скоро ще дойде твоят ред."
  },
  {
    "reading_id": "three_wands_ten_cups",
    "reading_name": "Тройка Жезли + Десетка Чаши",
    "reading_cards": "Тройка Жезли + Десетка Чаши",
    "reading_combination": ["three_wands", "ten_cups"],
    "reading_meaning": "Семейно очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Десетка Чаши – семейното щастие и хармония. Очаквате семейно събитие – сватба, раждане, събиране. Радостно очакване.",
    "reading_description": "Очаквате семейно събитие – сватба, раждане, събиране. Радост и вълнение.",
    "reading_advice": "Семейството те очаква. Бъди там с цялото си сърце. Тези моменти са безценни."
  },
  {
    "reading_id": "three_wands_page_cups",
    "reading_name": "Тройка Жезли + Паж Чаши",
    "reading_cards": "Тройка Жезли + Паж Чаши",
    "reading_combination": ["three_wands", "page_cups"],
    "reading_meaning": "Очакване на послание",
    "second_meaning": "Тройка Жезли носи очакването, а Паж Чаши – емоционално послание. Очаквайте вест, която ще докосне сърцето ви. Някой иска да ви каже нещо важно.",
    "reading_description": "Очаквате емоционално послание, което ще докосне сърцето ви.",
    "reading_advice": "Отвори сърцето си за посланието. То носи нещо ценно за теб."
  },
  {
    "reading_id": "three_wands_knight_cups",
    "reading_name": "Тройка Жезли + Рицар Чаши",
    "reading_cards": "Тройка Жезли + Рицар Чаши",
    "reading_combination": ["three_wands", "knight_cups"],
    "reading_meaning": "Очакване на романтика",
    "second_meaning": "Тройка Жезли носи очакването, а Рицар Чаши – романтиката и ухажването. Очаквайте романтичен жест или предложение. Някой идва при вас с отворено сърце.",
    "reading_description": "Очаквате романтичен жест или предложение. Любовта идва при вас.",
    "reading_advice": "Бъди отворен за любовта. Тя идва, когато най-малко я очакваш."
  },
  {
    "reading_id": "three_wands_queen_cups",
    "reading_name": "Тройка Жезли + Царица Чаши",
    "reading_cards": "Тройка Жезли + Царица Чаши",
    "reading_combination": ["three_wands", "queen_cups"],
    "reading_meaning": "Интуитивно очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Царица Чаши – интуицията и дълбоката емоционалност. Интуицията ви подсказва, че всичко ще бъде наред. Доверете ѝ се.",
    "reading_description": "Чакате с вътрешна увереност, водени от интуицията си. Знаете, че всичко ще се нареди.",
    "reading_advice": "Довери се на вътрешния си глас. Интуицията ти знае повече, отколкото ти осъзнаваш."
  },
  {
    "reading_id": "three_wands_king_cups",
    "reading_name": "Тройка Жезли + Цар Чаши",
    "reading_cards": "Тройка Жезли + Цар Чаши",
    "reading_combination": ["three_wands", "king_cups"],
    "reading_meaning": "Балансирано очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Цар Чаши – емоционалната зрялост и баланс. Чакате със спокойствие и мъдрост. Без тревога, без нетърпение.",
    "reading_description": "Чакате с емоционален баланс и мъдрост. Спокойствие и търпение.",
    "reading_advice": "Чакай с мир в сърцето. Емоционалната зрялост води до най-добрите решения."
  },
  {
    "reading_id": "three_wands_two_swords",
    "reading_name": "Тройка Жезли + Двойка Мечове",
    "reading_cards": "Тройка Жезли + Двойка Мечове",
    "reading_combination": ["three_wands", "two_swords"],
    "reading_meaning": "Очакване и съмнение",
    "second_meaning": "Тройка Жезли носи очакването, а Двойка Мечове – нерешителността и съмнението. Чакате, но се съмнявате какво ще се случи. Страхът замъглява перспективата.",
    "reading_description": "Очаквате, но се съмнявате какво ще донесе бъдещето. Нерешителност и страх.",
    "reading_advice": "Свали превръзката от очите. Понякога трябва да чакаш, дори когато не виждаш ясно."
  },
  {
    "reading_id": "three_wands_three_swords",
    "reading_name": "Тройка Жезли + Тройка Мечове",
    "reading_cards": "Тройка Жезли + Тройка Мечове",
    "reading_combination": ["three_wands", "three_swords"],
    "reading_meaning": "Очакване на болка",
    "second_meaning": "Тройка Жезли носи очакването, а Тройка Мечове – болката и разбитото сърце. Страхувате се, че очакваното ще донесе болка. Тревога и напрежение.",
    "reading_description": "Страхувате се, че това, което очаквате, ще донесе болка и разочарование.",
    "reading_advice": "Страхът от болка често е по-лош от самата болка. Бъди смел – каквото дойде, ще се справиш."
  },
  {
    "reading_id": "three_wands_four_swords",
    "reading_name": "Тройка Жезли + Четворка Мечове",
    "reading_cards": "Тройка Жезли + Четворка Мечове",
    "reading_combination": ["three_wands", "four_swords"],
    "reading_meaning": "Очакване и почивка",
    "second_meaning": "Тройка Жезли носи очакването, а Четворка Мечове – почивката и възстановяването. Докато чакате, имате нужда от почивка. Не изтощавайте силите си в нетърпение.",
    "reading_description": "Докато чакате, имате нужда от почивка. Съберете сили.",
    "reading_advice": "Почини си. Най-добрите неща идват, когато умът и тялото са спокойни."
  },
  {
    "reading_id": "three_wands_five_swords",
    "reading_name": "Тройка Жезли + Петица Мечове",
    "reading_cards": "Тройка Жезли + Петица Мечове",
    "reading_combination": ["three_wands", "five_swords"],
    "reading_meaning": "Очакване на конфликт",
    "second_meaning": "Тройка Жезли носи очакването, а Петица Мечове – конфликта и празната победа. Усещате, че предстои спор или битка. Помислете дали си струва да влизате.",
    "reading_description": "Усещате, че предстои конфликт. Възможна битка, която може да ви остави сам.",
    "reading_advice": "Понякога най-добрата победа е да не влизаш в битка. Избери битките си мъдро."
  },
  {
    "reading_id": "three_wands_six_swords",
    "reading_name": "Тройка Жезли + Шестица Мечове",
    "reading_cards": "Тройка Жезли + Шестица Мечове",
    "reading_combination": ["three_wands", "six_swords"],
    "reading_meaning": "Очакване на път",
    "second_meaning": "Тройка Жезли носи очакването, а Шестица Мечове – пътуването и прехода. Очаквате пътуване или промяна на средата. Нови хоризонти ви очакват.",
    "reading_description": "Очаквате пътуване или преместване. Нови хоризонти.",
    "reading_advice": "Готви се за път. Новите води носят нови възможности. Бъди отворен за тях."
  },
  {
    "reading_id": "three_wands_seven_swords",
    "reading_name": "Тройка Жезли + Седмица Мечове",
    "reading_cards": "Тройка Жезли + Седмица Мечове",
    "reading_combination": ["three_wands", "seven_swords"],
    "reading_meaning": "Очакване на измама",
    "second_meaning": "Тройка Жезли носи очакването, а Седмица Мечове – измамата и хитростта. Внимавайте – някой може да се опита да ви измами, докато чакате. Проверявайте информацията.",
    "reading_description": "Докато чакате, има риск някой да се опита да ви измами. Бъдете внимателни.",
    "reading_advice": "Проверявай два пъти. Доверието е хубаво, но проверката е по-добра."
  },
  {
    "reading_id": "three_wands_eight_swords",
    "reading_name": "Тройка Жезли + Осмица Мечове",
    "reading_cards": "Тройка Жезли + Осмица Мечове",
    "reading_combination": ["three_wands", "eight_swords"],
    "reading_meaning": "Очакване в капан",
    "second_meaning": "Тройка Жезли носи очакването, а Осмица Мечове – чувството на капан и ограничение. Чувствате се блокирани в очакването си. Страхът ви държи в застой.",
    "reading_description": "Чувствате се в капан, докато чакате. Страхът ви парализира.",
    "reading_advice": "Оковите са в главата ти. Освободи се от страха – имаш повече възможности, отколкото си мислиш."
  },
  {
    "reading_id": "three_wands_nine_swords",
    "reading_name": "Тройка Жезли + Деветка Мечове",
    "reading_cards": "Тройка Жезли + Деветка Мечове",
    "reading_combination": ["three_wands", "nine_swords"],
    "reading_meaning": "Тревожно очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Деветка Мечове – тревогата и безсънието. Чакането ви изпълва с тревога и не ви оставя да спите. Мислите ви се въртят.",
    "reading_description": "Чакането ви тревожи и не ви оставя да спите. Безсъние и притеснения.",
    "reading_advice": "Спокойствие. Повечето неща, за които се тревожим, никога не се случват. Дишай дълбоко."
  },
  {
    "reading_id": "three_wands_ten_swords",
    "reading_name": "Тройка Жезли + Десетка Мечове",
    "reading_cards": "Тройка Жезли + Десетка Мечове",
    "reading_combination": ["three_wands", "ten_swords"],
    "reading_meaning": "Край на очакването",
    "second_meaning": "Тройка Жезли носи очакването, а Десетка Мечове – края и дъното. Периодът на чакане приключва. Краят носи облекчение, дори да е труден.",
    "reading_description": "Периодът на чакане приключва. Край и ново начало.",
    "reading_advice": "Остави очакването зад гърба си. Това, което свърши, вече не тежи. Гледай напред."
  },
  {
    "reading_id": "three_wands_page_swords",
    "reading_name": "Тройка Жезли + Паж Мечове",
    "reading_cards": "Тройка Жезли + Паж Мечове",
    "reading_combination": ["three_wands", "page_swords"],
    "reading_meaning": "Очакване на истина",
    "second_meaning": "Тройка Жезли носи очакването, а Паж Мечове – търсенето на истината. Докато чакате, търсете отговори. Истината ще ви освободи.",
    "reading_description": "Докато чакате, търсите истината. Любопитство и открития.",
    "reading_advice": "Задавай въпроси. Не приемай нищо за дадено. Истината ще ти помогне да разбереш."
  },
  {
    "reading_id": "three_wands_knight_swords",
    "reading_name": "Тройка Жезли + Рицар Мечове",
    "reading_cards": "Тройка Жезли + Рицар Мечове",
    "reading_combination": ["three_wands", "knight_swords"],
    "reading_meaning": "Нетърпеливо очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Рицар Мечове – бързината и нетърпението. Чакането ви изнервя – искате всичко да се случи веднага. Но скоростта не винаги е добра.",
    "reading_description": "Чакането ви изпълва с нетърпение и напрежение. Искате всичко сега.",
    "reading_advice": "Забави. Бързината не винаги води до по-добър резултат. Понякога трябва да изчакаш."
  },
  {
    "reading_id": "three_wands_queen_swords",
    "reading_name": "Тройка Жезли + Царица Мечове",
    "reading_cards": "Тройка Жезли + Царица Мечове",
    "reading_combination": ["three_wands", "queen_swords"],
    "reading_meaning": "Ясно очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Царица Мечове – яснотата и независимостта. Виждате бъдещето ясно, без илюзии. Знаете какво ви очаква.",
    "reading_description": "Очаквате с яснота и без илюзии. Виждате нещата такива, каквито са.",
    "reading_advice": "Бъди честен със себе си. Яснотата, колкото и да е сурова, води към правилния път."
  },
  {
    "reading_id": "three_wands_king_swords",
    "reading_name": "Тройка Жезли + Цар Мечове",
    "reading_cards": "Тройка Жезли + Цар Мечове",
    "reading_combination": ["three_wands", "king_swords"],
    "reading_meaning": "Стратегическо очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Цар Мечове – интелекта и стратегията. Докато чакате, анализирате и планирате. Обективност и логика.",
    "reading_description": "Докато чакате, анализирате и планирате. Стратегическо очакване.",
    "reading_advice": "Използвай времето на чакане за анализ и планиране. Логиката ще ти помогне да вземеш правилното решение."
  },
  {
    "reading_id": "three_wands_two_pentacles",
    "reading_name": "Тройка Жезли + Двойка Пентакли",
    "reading_cards": "Тройка Жезли + Двойка Пентакли",
    "reading_combination": ["three_wands", "two_pentacles"],
    "reading_meaning": "Очакване и баланс",
    "second_meaning": "Тройка Жезли носи очакването, а Двойка Пентакли – баланса и жонглирането. Докато чакате, трябва да балансирате ресурси – време, пари, енергия. Жонглирайте внимателно.",
    "reading_description": "Докато чакате, трябва да балансирате ресурсите си. Време, пари, енергия – всичко е важно.",
    "reading_advice": "Балансирай, но не изпускай топката. Финансовият и времеви баланс са ключови в този период."
  },
  {
    "reading_id": "three_wands_three_pentacles",
    "reading_name": "Тройка Жезли + Тройка Пентакли",
    "reading_cards": "Тройка Жезли + Тройка Пентакли",
    "reading_combination": ["three_wands", "three_pentacles"],
    "reading_meaning": "Очакване в екип",
    "second_meaning": "Тройка Жезли носи очакването, а Тройка Пентакли – екипната работа и сътрудничеството. Не сте сами в очакването си – споделете го с екипа или семейството.",
    "reading_description": "Очаквате резултати заедно с други. Екипна работа и сътрудничество.",
    "reading_advice": "Сподели очакването с другите. Заедно сте по-силни и чакането става по-леко."
  },
  {
    "reading_id": "three_wands_four_pentacles",
    "reading_name": "Тройка Жезли + Четворка Пентакли",
    "reading_cards": "Тройка Жезли + Четворка Пентакли",
    "reading_combination": ["three_wands", "four_pentacles"],
    "reading_meaning": "Очакване и стискане",
    "second_meaning": "Тройка Жезли носи очакването, а Четворка Пентакли – стискането и страха от загуба. Докато чакате, се вкопчвате в ресурсите си от страх. Пуснете малко.",
    "reading_description": "Докато чакате, се вкопчвате в ресурсите си от страх да не ги загубите.",
    "reading_advice": "Пусни малко. Страхът от загуба може да ти попречи да получиш нещо по-добро."
  },
  {
    "reading_id": "three_wands_five_pentacles",
    "reading_name": "Тройка Жезли + Петица Пентакли",
    "reading_cards": "Тройка Жезли + Петица Пентакли",
    "reading_combination": ["three_wands", "five_pentacles"],
    "reading_meaning": "Очакване и липса",
    "second_meaning": "Тройка Жезли носи очакването, а Петица Пентакли – финансовите трудности и липсата. Чакате, но ресурсите са ограничени. Чувствате се изолирани.",
    "reading_description": "Очаквате, но финансовите ресурси са ограничени. Чувствате се изоставени.",
    "reading_advice": "Потърси помощ. Не си сам. Има хора, готови да те подкрепят, ако поискаш."
  },
  {
    "reading_id": "three_wands_six_pentacles",
    "reading_name": "Тройка Жезли + Шестица Пентакли",
    "reading_cards": "Тройка Жезли + Шестица Пентакли",
    "reading_combination": ["three_wands", "six_pentacles"],
    "reading_meaning": "Очакване и помощ",
    "second_meaning": "Тройка Жезли носи очакването, а Шестица Пентакли – помощта и щедростта. Докато чакате, получавате подкрепа – финансова или емоционална. Благодарете.",
    "reading_description": "Докато чакате, получавате помощ и подкрепа. Някой протяга ръка.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "three_wands_seven_pentacles",
    "reading_name": "Тройка Жезли + Седмица Пентакли",
    "reading_cards": "Тройка Жезли + Седмица Пентакли",
    "reading_combination": ["three_wands", "seven_pentacles"],
    "reading_meaning": "Търпеливо очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Седмица Пентакли – търпението и чакането. Инвестирали сте време и усилия и сега чакате резултати. Търпение и вяра.",
    "reading_description": "Инвестирали сте време и усилия и сега чакате резултати. Търпение и постоянство.",
    "reading_advice": "Чакай търпеливо. Добрите неща идват при тези, които умеят да чакат, докато продължават да работят."
  },
  {
    "reading_id": "three_wands_eight_pentacles",
    "reading_name": "Тройка Жезли + Осмица Пентакли",
    "reading_cards": "Тройка Жезли + Осмица Пентакли",
    "reading_combination": ["three_wands", "eight_pentacles"],
    "reading_meaning": "Очакване и учене",
    "second_meaning": "Тройка Жезли носи очакването, а Осмица Пентакли – усърдието и ученето. Докато чакате, усъвършенствайте уменията си. Времето не е загубено, а инвестирано.",
    "reading_description": "Докато чакате, усъвършенствате уменията си. Учене и растеж.",
    "reading_advice": "Използвай времето на чакане, за да се учиш. Знанието, което придобиеш сега, ще ти потрябва после."
  },
  {
    "reading_id": "three_wands_nine_pentacles",
    "reading_name": "Тройка Жезли + Деветка Пентакли",
    "reading_cards": "Тройка Жезли + Деветка Пентакли",
    "reading_combination": ["three_wands", "nine_pentacles"],
    "reading_meaning": "Очакване на независимост",
    "second_meaning": "Тройка Жезли носи очакването, а Деветка Пентакли – самодостатъчността и успеха. Очаквате момент на независимост и свобода. Той наближава.",
    "reading_description": "Очаквате момент на независимост и свобода. Успехът идва.",
    "reading_advice": "Ти си близо до целта. Наслади се на пътя, но знай, че свободата те очаква."
  },
  {
    "reading_id": "three_wands_ten_pentacles",
    "reading_name": "Тройка Жезли + Десетка Пентакли",
    "reading_cards": "Тройка Жезли + Десетка Пентакли",
    "reading_combination": ["three_wands", "ten_pentacles"],
    "reading_meaning": "Семейно очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Десетка Пентакли – семейното наследство и дългосрочната сигурност. Очаквате нещо, което ще донесе полза на цялото семейство.",
    "reading_description": "Очаквате нещо, което ще донесе сигурност и полза на цялото семейство.",
    "reading_advice": "Мисли за семейството. Това, което идва, ще помогне на всички. Бъди търпелив."
  },
  {
    "reading_id": "three_wands_page_pentacles",
    "reading_name": "Тройка Жезли + Паж Пентакли",
    "reading_cards": "Тройка Жезли + Паж Пентакли",
    "reading_combination": ["three_wands", "page_pentacles"],
    "reading_meaning": "Очакване на нова възможност",
    "second_meaning": "Тройка Жезли носи очакването, а Паж Пентакли – новата финансова възможност. Очаквайте предложение или шанс за материален растеж.",
    "reading_description": "Очаквате нова финансова възможност или кариерен шанс. Ново начало.",
    "reading_advice": "Хвани възможността, когато дойде. Тя носи ново начало и растеж."
  },
  {
    "reading_id": "three_wands_knight_pentacles",
    "reading_name": "Тройка Жезли + Рицар Пентакли",
    "reading_cards": "Тройка Жезли + Рицар Пентакли",
    "reading_combination": ["three_wands", "knight_pentacles"],
    "reading_meaning": "Бавно очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Рицар Пентакли – бавния и сигурен напредък. Резултатите няма да дойдат бързо. Търпение и постоянство.",
    "reading_description": "Резултатите идват бавно, но сигурно. Търпение и постоянство.",
    "reading_advice": "Не бързай. Сигурният път е бавен, но води до целта. Продължавай да работиш."
  },
  {
    "reading_id": "three_wands_queen_pentacles",
    "reading_name": "Тройка Жезли + Царица Пентакли",
    "reading_cards": "Тройка Жезли + Царица Пентакли",
    "reading_combination": ["three_wands", "queen_pentacles"],
    "reading_meaning": "Практично очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Царица Пентакли – практичността и грижата. Докато чакате, се грижете за дома и семейството. Практичният подход ще донесе резултати.",
    "reading_description": "Докато чакате, се грижите за дома и близките. Практичност и топлина.",
    "reading_advice": "Грижи се за дома и семейството. Това, което правиш сега, създава основата за бъдещето."
  },
  {
    "reading_id": "three_wands_king_pentacles",
    "reading_name": "Тройка Жезли + Цар Пентакли",
    "reading_cards": "Тройка Жезли + Цар Пентакли",
    "reading_combination": ["three_wands", "king_pentacles"],
    "reading_meaning": "Стабилно очакване",
    "second_meaning": "Тройка Жезли носи очакването, а Цар Пентакли – стабилността и бизнес успеха. Чакате с увереност, че резултатите ще донесат дългосрочна сигурност.",
    "reading_description": "Очаквате с увереност, че резултатите ще донесат стабилност и успех.",
    "reading_advice": "Вярвай в процеса. Това, което идва, носи дългосрочна сигурност. Бъди търпелив."
  },
  {
    "reading_id": "four_wands_five_wands",
    "reading_name": "Четворка Жезли + Петица Жезли",
    "reading_cards": "Четворка Жезли + Петица Жезли",
    "reading_combination": ["four_wands", "five_wands"],
    "reading_meaning": "Празник и конфликт",
    "second_meaning": "Четворка Жезли носи празника и хармонията, а Петица Жезли – конфликта и съперничеството. Радостен момент е помрачен от спорове или напрежение. Някой не може да се радва с вас – не позволявайте това да развали празника ви.",
    "reading_description": "Празник или щастлив момент е помрачен от конфликт. Някой не може да се радва с теб.",
    "reading_advice": "Не позволявай на споровете да развалят щастието ти. Пази радостта си – не всеки я заслужава."
  },
  {
    "reading_id": "four_wands_six_wands",
    "reading_name": "Четворка Жезли + Шестица Жезли",
    "reading_cards": "Четворка Жезли + Шестица Жезли",
    "reading_combination": ["four_wands", "six_wands"],
    "reading_meaning": "Празник на победата",
    "second_meaning": "Четворка Жезли носи празника, а Шестица Жезли – победата и признанието. Успехът ви дава повод за празнуване. Радост, задоволство, споделяне на успеха с близките.",
    "reading_description": "Празнуваш успех и победа с близките си. Радост и удовлетворение.",
    "reading_advice": "Празнувай, но утре те чакат нови предизвикателства. Наслади се на момента."
  },
  {
    "reading_id": "four_wands_seven_wands",
    "reading_name": "Четворка Жезли + Седмица Жезли",
    "reading_cards": "Четворка Жезли + Седмица Жезли",
    "reading_combination": ["four_wands", "seven_wands"],
    "reading_meaning": "Празник и защита",
    "second_meaning": "Четворка Жезли носи празника, а Седмица Жезли – защитата на позицията. Дори в момента на радост някой се опитва да ви попречи или да ви нападне. Не позволявайте това да развали момента.",
    "reading_description": "Докато празнуваш, някой се опитва да ти попречи. Не позволявай това да развали радостта.",
    "reading_advice": "Пази радостта си. Не всеки я заслужава. Бъди бдителен, но не позволявай страхът да те завладее."
  },
  {
    "reading_id": "four_wands_eight_wands",
    "reading_name": "Четворка Жезли + Осмица Жезли",
    "reading_cards": "Четворка Жезли + Осмица Жезли",
    "reading_combination": ["four_wands", "eight_wands"],
    "reading_meaning": "Бърз празник",
    "second_meaning": "Четворка Жезли носи празника, а Осмица Жезли – бързината. Щастливо събитие настъпва неочаквано бързо. Празник, за който не сте имали време да се подготвите, но това не го прави по-малко радостен.",
    "reading_description": "Щастливо събитие настъпва неочаквано бързо. Празник, за който не си имал време да се подготвиш.",
    "reading_advice": "Приеми радостта такава, каквато идва – неподготвен, но щастлив. Някои от най-добрите моменти са спонтанни."
  },
  {
    "reading_id": "four_wands_nine_wands",
    "reading_name": "Четворка Жезли + Деветка Жезли",
    "reading_cards": "Четворка Жезли + Деветка Жезли",
    "reading_combination": ["four_wands", "nine_wands"],
    "reading_meaning": "Уморен празник",
    "second_meaning": "Четворка Жезли носи празника, а Деветка Жезли – устойчивостта и изтощението. Дори в момента на радост усещате умората от предишните битки. Празник със смесени чувства.",
    "reading_description": "Празнуваш, но си изтощен от предишните усилия. Радост и умора едновременно.",
    "reading_advice": "Позволи си да си починеш, дори когато празнуваш. Заслужил си този момент на радост – наслади му се."
  },
  {
    "reading_id": "four_wands_ten_wands",
    "reading_name": "Четворка Жезли + Десетка Жезли",
    "reading_cards": "Четворка Жезли + Десетка Жезли",
    "reading_combination": ["four_wands", "ten_wands"],
    "reading_meaning": "Тежък празник",
    "second_meaning": "Четворка Жезли носи празника, а Десетка Жезли – претоварването и бремето. Опитвате се да се радвате, но тежестта на отговорностите не ви позволява. Празник, който не е истински.",
    "reading_description": "Опитваш се да се радваш, но отговорностите те притискат. Празник под напрежение.",
    "reading_advice": "Освободи се от част от бремето, за да можеш истински да се радваш. Няма срам да потърсиш помощ."
  },
  {
    "reading_id": "four_wands_page_wands",
    "reading_name": "Четворка Жезли + Паж Жезли",
    "reading_cards": "Четворка Жезли + Паж Жезли",
    "reading_combination": ["four_wands", "page_wands"],
    "reading_meaning": "Празник и новини",
    "second_meaning": "Четворка Жезли носи празника, а Паж Жезли – новините и ентусиазма. Очаквайте вълнуваща вест, свързана с радостно събитие. Новината ще дойде скоро и ще добави още повече радост.",
    "reading_description": "По време на празник идват вълнуващи новини. Ентусиазъм и радост.",
    "reading_advice": "Отвори се за новините. Те носят още повече светлина в този радостен момент."
  },
  {
    "reading_id": "four_wands_knight_wands",
    "reading_name": "Четворка Жезли + Рицар Жезли",
    "reading_cards": "Четворка Жезли + Рицар Жезли",
    "reading_combination": ["four_wands", "knight_wands"],
    "reading_meaning": "Бърз празник",
    "second_meaning": "Четворка Жезли носи празника, а Рицар Жезли – импулсивността и бързината. Празникът идва внезапно и с много енергия. Всичко се случва бързо и интензивно.",
    "reading_description": "Празникът идва внезапно и с много енергия. Бързина и интензивност.",
    "reading_advice": "Наслаждавай се на скоростта, но не изпускай контрол. Язди вълната, докато е висока."
  },
  {
    "reading_id": "four_wands_queen_wands",
    "reading_name": "Четворка Жезли + Царица Жезли",
    "reading_cards": "Четворка Жезли + Царица Жезли",
    "reading_combination": ["four_wands", "queen_wands"],
    "reading_meaning": "Топъл празник",
    "second_meaning": "Четворка Жезли носи празника, а Царица Жезли – топлината и харизмата. Празникът е изпълнен с топлина и радост. Вие сте в центъра на вниманието и се справяте чудесно.",
    "reading_description": "Празник, изпълнен с топлина и радост. Ти си в центъра на вниманието.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина прави празника специален."
  },
  {
    "reading_id": "four_wands_king_wands",
    "reading_name": "Четворка Жезли + Цар Жезли",
    "reading_cards": "Четворка Жезли + Цар Жезли",
    "reading_combination": ["four_wands", "king_wands"],
    "reading_meaning": "Властен празник",
    "second_meaning": "Четворка Жезли носи празника, а Цар Жезли – лидерството и визията. Празникът е организиран с власт и размах. Вие сте този, който води и вдъхновява.",
    "reading_description": "Празник, организиран с власт и размах. Ти си лидерът, който води другите.",
    "reading_advice": "Води с пример, но не забравяй истинската радост. Властта е привилегия, но и отговорност."
  },
  {
    "reading_id": "four_wands_two_cups",
    "reading_name": "Четворка Жезли + Двойка Чаши",
    "reading_cards": "Четворка Жезли + Двойка Чаши",
    "reading_combination": ["four_wands", "two_cups"],
    "reading_meaning": "Сватбен празник",
    "second_meaning": "Четворка Жезли носи празника и дома, а Двойка Чаши – любовта и съюза. Комбинацията предвещава сватба, годеж или голям любовен празник. Щастие и хармония.",
    "reading_description": "Празнуваш любовна връзка – сватба, годеж, годишнина. Радост и щастие.",
    "reading_advice": "Любовта заслужава да бъде празнувана. Наслади се на този специален момент."
  },
  {
    "reading_id": "four_wands_three_cups",
    "reading_name": "Четворка Жезли + Тройка Чаши",
    "reading_cards": "Четворка Жезли + Тройка Чаши",
    "reading_combination": ["four_wands", "three_cups"],
    "reading_meaning": "Семеен празник",
    "second_meaning": "Четворка Жезли носи дома, а Тройка Чаши – празника и приятелството. Семейно събиране или празник с близки приятели. Радост, смях, споделени мигове.",
    "reading_description": "Празник със семейството и приятелите. Радост, смях, споделени мигове.",
    "reading_advice": "Семейството е най-големият празник. Бъди истински там – тези моменти няма да се повторят."
  },
  {
    "reading_id": "four_wands_four_cups",
    "reading_name": "Четворка Жезли + Четворка Чаши",
    "reading_cards": "Четворка Жезли + Четворка Чаши",
    "reading_combination": ["four_wands", "four_cups"],
    "reading_meaning": "Празник и апатия",
    "second_meaning": "Четворка Жезли носи празника, а Четворка Чаши – апатията и неудовлетворението. Около вас има празник, но вие не усещате радост. Сякаш нещо ви липсва.",
    "reading_description": "Около теб има празник, но ти не усещаш радост. Сякаш нещо липсва.",
    "reading_advice": "Потърси причината вътре в себе си, не вън от теб. Понякога най-големите празници са тихи."
  },
  {
    "reading_id": "four_wands_five_cups",
    "reading_name": "Четворка Жезли + Петица Чаши",
    "reading_cards": "Четворка Жезли + Петица Чаши",
    "reading_combination": ["four_wands", "five_cups"],
    "reading_meaning": "Празник през сълзи",
    "second_meaning": "Четворка Жезли носи празника, а Петица Чаши – загубата и тъгата. Празнувате, но в сърцето ви има тъга по някого или нещо, което липсва. Смесени чувства.",
    "reading_description": "Празнуваш, но в сърцето ти има тъга. Радост и болка едновременно.",
    "reading_advice": "Позволи си да чувстваш и двете. Нормално е. Тъгата не отрича радостта, а я прави по-дълбока."
  },
  {
    "reading_id": "four_wands_six_cups",
    "reading_name": "Четворка Жезли + Шестица Чаши",
    "reading_cards": "Четворка Жезли + Шестица Чаши",
    "reading_combination": ["four_wands", "six_cups"],
    "reading_meaning": "Празник със стари приятели",
    "second_meaning": "Четворка Жезли носи празника, а Шестица Чаши – спомените и носталгията. Събиране на стари приятели или семейство. Носталгия, спомени, топлина.",
    "reading_description": "Празник, на който се събират стари приятели или семейство. Носталгия и радост.",
    "reading_advice": "Цени тези моменти. Те са безценни. Старите приятели са като вино – с времето стават по-добри."
  },
  {
    "reading_id": "four_wands_seven_cups",
    "reading_name": "Четворка Жезли + Седмица Чаши",
    "reading_cards": "Четворка Жезли + Седмица Чаши",
    "reading_combination": ["four_wands", "seven_cups"],
    "reading_meaning": "Илюзорен празник",
    "second_meaning": "Четворка Жезли носи празника, а Седмица Чаши – илюзиите и фантазиите. Празнувате нещо, което може да е илюзия. Радост, която може да е временна.",
    "reading_description": "Празнуваш нещо, което може да е илюзия. Радост, която може да е временна.",
    "reading_advice": "Провери дали това, което празнуваш, е реално. Свали розовите очила, преди да е късно."
  },
  {
    "reading_id": "four_wands_eight_cups",
    "reading_name": "Четворка Жезли + Осмица Чаши",
    "reading_cards": "Четворка Жезли + Осмица Чаши",
    "reading_combination": ["four_wands", "eight_cups"],
    "reading_meaning": "Празник и раздяла",
    "second_meaning": "Четворка Жезли носи празника, а Осмица Чаши – тръгването и оставянето. Празнувате, но знаете, че скоро ще се разделите или ще напуснете. Тъжна радост.",
    "reading_description": "Празнуваш, но знаеш, че скоро ще се разделиш с тези хора. Тъжна радост.",
    "reading_advice": "Наслади се на момента. Той няма да се повтори. Бъди истински там, докато можеш."
  },
  {
    "reading_id": "four_wands_nine_cups",
    "reading_name": "Четворка Жезли + Деветка Чаши",
    "reading_cards": "Четворка Жезли + Деветка Чаши",
    "reading_combination": ["four_wands", "nine_cups"],
    "reading_meaning": "Празник на мечтите",
    "second_meaning": "Четворка Жезли носи празника, а Деветка Чаши – сбъднатото желание. Празнувате сбъдването на дългогодишна мечта. Щастие и удовлетворение.",
    "reading_description": "Празнуваш сбъдването на дългогодишна мечта. Щастие и удовлетворение.",
    "reading_advice": "Ти го постигна. Наслади се на момента. Заслужил си всяка минута от този празник."
  },
  {
    "reading_id": "four_wands_ten_cups",
    "reading_name": "Четворка Жезли + Десетка Чаши",
    "reading_cards": "Четворка Жезли + Десетка Чаши",
    "reading_combination": ["four_wands", "ten_cups"],
    "reading_meaning": "Семеен празник",
    "second_meaning": "Четворка Жезли носи дома, а Десетка Чаши – пълното семейно щастие. Празник, на който цялото семейство е заедно. Щастие и хармония.",
    "reading_description": "Празник, на който цялото семейство е заедно. Щастие и хармония.",
    "reading_advice": "Семейството е най-големият празник. Бъди благодарен за тези моменти – те са най-ценното."
  },
  {
    "reading_id": "four_wands_page_cups",
    "reading_name": "Четворка Жезли + Паж Чаши",
    "reading_cards": "Четворка Жезли + Паж Чаши",
    "reading_combination": ["four_wands", "page_cups"],
    "reading_meaning": "Празник и послание",
    "second_meaning": "Четворка Жезли носи празника, а Паж Чаши – емоционално послание. Очаквайте нежно признание или романтична изненада по време на празник. Сърдечно послание.",
    "reading_description": "По време на празник идва нежно емоционално послание. Романтика във въздуха.",
    "reading_advice": "Отвори сърцето си за посланието. То носи любов и топлина в този радостен момент."
  },
  {
    "reading_id": "four_wands_knight_cups",
    "reading_name": "Четворка Жезли + Рицар Чаши",
    "reading_cards": "Четворка Жезли + Рицар Чаши",
    "reading_combination": ["four_wands", "knight_cups"],
    "reading_meaning": "Романтичен празник",
    "second_meaning": "Четворка Жезли носи празника, а Рицар Чаши – романтиката и ухажването. Очаквайте романтичен жест по време на празник – предложение, изненада, признание.",
    "reading_description": "Романтичен жест или предложение по време на празник. Любовта във въздуха.",
    "reading_advice": "Кажи какво чувстваш. Бъди смел в любовта – този момент може да промени всичко."
  },
  {
    "reading_id": "four_wands_queen_cups",
    "reading_name": "Четворка Жезли + Царица Чаши",
    "reading_cards": "Четворка Жезли + Царица Чаши",
    "reading_combination": ["four_wands", "queen_cups"],
    "reading_meaning": "Емоционален празник",
    "second_meaning": "Четворка Жезли носи празника, а Царица Чаши – интуицията и дълбоката емоционалност. Празникът е изпълнен с дълбоки емоции и сърдечна топлина. Интуицията ви води.",
    "reading_description": "Празник, изпълнен с дълбоки емоции и сърдечна топлина. Слушай сърцето си.",
    "reading_advice": "Довери се на интуицията си. Тя знае какво е най-добро за теб и за близките ти."
  },
  {
    "reading_id": "four_wands_king_cups",
    "reading_name": "Четворка Жезли + Цар Чаши",
    "reading_cards": "Четворка Жезли + Цар Чаши",
    "reading_combination": ["four_wands", "king_cups"],
    "reading_meaning": "Спокоен празник",
    "second_meaning": "Четворка Жезли носи празника, а Цар Чаши – емоционалната зрялост и баланс. Празник, изпълнен със спокойна радост и хармония. Без драма, без крайности.",
    "reading_description": "Спокоен празник, изпълнен с хармония и зряла радост. Без драма, без крайности.",
    "reading_advice": "Цени спокойната радост. Тя е най-трайната. Пази този баланс – той е ключът към щастието."
  },
  {
    "reading_id": "four_wands_two_swords",
    "reading_name": "Четворка Жезли + Двойка Мечове",
    "reading_cards": "Четворка Жезли + Двойка Мечове",
    "reading_combination": ["four_wands", "two_swords"],
    "reading_meaning": "Празник и съмнение",
    "second_meaning": "Четворка Жезли носи празника, а Двойка Мечове – нерешителността и съмнението. Празнувате, но в сърцето ви има съмнения. Радост и несигурност.",
    "reading_description": "Празнуваш, но в сърцето ти има съмнения. Радост и несигурност.",
    "reading_advice": "Не позволявай на съмненията да развалят празника ти. Понякога трябва просто да се отпуснеш и да се радваш."
  },
  {
    "reading_id": "four_wands_three_swords",
    "reading_name": "Четворка Жезли + Тройка Мечове",
    "reading_cards": "Четворка Жезли + Тройка Мечове",
    "reading_combination": ["four_wands", "three_swords"],
    "reading_meaning": "Празник и болка",
    "second_meaning": "Четворка Жезли носи празника, а Тройка Мечове – болката и разбитото сърце. Празнувате, но носите болка в сърцето си. Смесени чувства.",
    "reading_description": "Празнуваш, но носиш болка в сърцето си. Радост и тъга заедно.",
    "reading_advice": "Позволи си да чувстваш и двете. Нормално е. Болката не отрича радостта – те могат да съществуват едновременно."
  },
  {
    "reading_id": "four_wands_four_swords",
    "reading_name": "Четворка Жезли + Четворка Мечове",
    "reading_cards": "Четворка Жезли + Четворка Мечове",
    "reading_combination": ["four_wands", "four_swords"],
    "reading_meaning": "Тих празник",
    "second_meaning": "Четворка Жезли носи празника, а Четворка Мечове – почивката и уединението. Празнувате тихо, в малък кръг или сами. Радост, която не се споделя шумно.",
    "reading_description": "Празнуваш тихо, в уединение. Радост, която не се споделя шумно.",
    "reading_advice": "Понякога най-добрият празник е сам със себе си. Наслади се на тишината и спокойствието."
  },
  {
    "reading_id": "four_wands_five_swords",
    "reading_name": "Четворка Жезли + Петица Мечове",
    "reading_cards": "Четворка Жезли + Петица Мечове",
    "reading_combination": ["four_wands", "five_swords"],
    "reading_meaning": "Празник и победа",
    "second_meaning": "Четворка Жезли носи празника, а Петица Мечове – конфликта и празната победа. Празнувате победа, но цената може да е била висока. Някой е наранен.",
    "reading_description": "Празнуваш победа, но може би цената е била твърде висока. Някой е наранен.",
    "reading_advice": "Празнувай победата, но помни победените. Понякога да спечелиш не означава да унищожиш другия."
  },
  {
    "reading_id": "four_wands_six_swords",
    "reading_name": "Четворка Жезли + Шестица Мечове",
    "reading_cards": "Четворка Жезли + Шестица Мечове",
    "reading_combination": ["four_wands", "six_swords"],
    "reading_meaning": "Празник на път",
    "second_meaning": "Четворка Жезли носи празника, а Шестица Мечове – пътуването и прехода. Празнувате по време на пътуване или преместване. Радост в движение.",
    "reading_description": "Празнуваш или се радваш по време на пътуване. Радост в движение.",
    "reading_advice": "Пътувай и се радвай едновременно. Животът е път – наслаждавай се на всяка спирка."
  },
  {
    "reading_id": "four_wands_seven_swords",
    "reading_name": "Четворка Жезли + Седмица Мечове",
    "reading_cards": "Четворка Жезли + Седмица Мечове",
    "reading_combination": ["four_wands", "seven_swords"],
    "reading_meaning": "Празник с тайна",
    "second_meaning": "Четворка Жезли носи празника, а Седмица Мечове – измамата и хитростта. Празнувате, но има тайна, която тежи. Радост с угризения.",
    "reading_description": "Празнуваш, но има тайна, която те тежи. Радост с угризения.",
    "reading_advice": "Истината ще излезе. По-добре сам да я кажеш, отколкото тя да излезе сама. Освободи се от тежестта."
  },
  {
    "reading_id": "four_wands_eight_swords",
    "reading_name": "Четворка Жезли + Осмица Мечове",
    "reading_cards": "Четворка Жезли + Осмица Мечове",
    "reading_combination": ["four_wands", "eight_swords"],
    "reading_meaning": "Празник в капан",
    "second_meaning": "Четворка Жезли носи празника, а Осмица Мечове – чувството на капан и ограничение. Празнувате, но се чувствате в капан от обстоятелствата. Нямате истинска свобода.",
    "reading_description": "Празнуваш, но се чувстваш в капан от обстоятелствата. Нямаш истинска свобода.",
    "reading_advice": "Истинската радост е свободна. Ако се чувстваш в капан, нещо не е наред. Потърси изход."
  },
  {
    "reading_id": "four_wands_nine_swords",
    "reading_name": "Четворка Жезли + Деветка Мечове",
    "reading_cards": "Четворка Жезли + Деветка Мечове",
    "reading_combination": ["four_wands", "nine_swords"],
    "reading_meaning": "Празник и тревога",
    "second_meaning": "Четворка Жезли носи празника, а Деветка Мечове – тревогата и безсънието. Празнувате, но не спите от тревоги. Радост и страх едновременно.",
    "reading_description": "Празнуваш, но не спиш от тревоги. Радост и страх едновременно.",
    "reading_advice": "Тревогите могат да развалят всеки празник. Освободи се от тях – дишай дълбоко и бъди в момента."
  },
  {
    "reading_id": "four_wands_ten_swords",
    "reading_name": "Четворка Жезли + Десетка Мечове",
    "reading_cards": "Четворка Жезли + Десетка Мечове",
    "reading_combination": ["four_wands", "ten_swords"],
    "reading_meaning": "Празник и край",
    "second_meaning": "Четворка Жезли носи празника, а Десетка Мечове – края и дъното. Празнувате, но знаете, че скоро всичко ще приключи. Тъжна радост.",
    "reading_description": "Празнуваш, но знаеш, че скоро всичко ще приключи. Тъжна радост.",
    "reading_advice": "Наслади се на момента. Той няма да се повтори. Краят не отрича красотата на преживяното."
  },
  {
    "reading_id": "four_wands_page_swords",
    "reading_name": "Четворка Жезли + Паж Мечове",
    "reading_cards": "Четворка Жезли + Паж Мечове",
    "reading_combination": ["four_wands", "page_swords"],
    "reading_meaning": "Празник и истина",
    "second_meaning": "Четворка Жезли носи празника, а Паж Мечове – търсенето на истината. По време на празник може да излезе истина, която досега е била скрита. Бъдете готови.",
    "reading_description": "По време на празник излиза истина, която досега е била скрита. Бъди готов.",
    "reading_advice": "Истината може да боли, но винаги лекува. Приеми я с отворено сърце."
  },
  {
    "reading_id": "four_wands_knight_swords",
    "reading_name": "Четворка Жезли + Рицар Мечове",
    "reading_cards": "Четворка Жезли + Рицар Мечове",
    "reading_combination": ["four_wands", "knight_swords"],
    "reading_meaning": "Бърз празник",
    "second_meaning": "Четворка Жезли носи празника, а Рицар Мечове – бързината и прямотата. Празникът идва и си отива бързо. Интензивност и скорост.",
    "reading_description": "Празникът идва и си отива бързо. Интензивност и скорост.",
    "reading_advice": "Наслади се на скоростта, но не забравяй да спреш и да дишаш. Някои неща са красиви точно защото са кратки."
  },
  {
    "reading_id": "four_wands_queen_swords",
    "reading_name": "Четворка Жезли + Царица Мечове",
    "reading_cards": "Четворка Жезли + Царица Мечове",
    "reading_combination": ["four_wands", "queen_swords"],
    "reading_meaning": "Ясен празник",
    "second_meaning": "Четворка Жезли носи празника, а Царица Мечове – яснотата и независимостта. Празнувате без илюзии – знаете какво празнувате и защо. Чиста радост.",
    "reading_description": "Празнуваш без илюзии – знаеш какво празнуваш и защо. Чиста радост.",
    "reading_advice": "Бъди честен със себе си. Яснотата прави радостта по-истинска и трайна."
  },
  {
    "reading_id": "four_wands_king_swords",
    "reading_name": "Четворка Жезли + Цар Мечове",
    "reading_cards": "Четворка Жезли + Цар Мечове",
    "reading_combination": ["four_wands", "king_swords"],
    "reading_meaning": "Справедлив празник",
    "second_meaning": "Четворка Жезли носи празника, а Цар Мечове – справедливостта и интелекта. Празнувате след справедливо решение или заслужен успех. Обективна радост.",
    "reading_description": "Празнуваш след справедливо решение или заслужен успех. Обективна радост.",
    "reading_advice": "Радвай се на справедливостта. Тя е рядка и ценна. Наслади се на момента, защото го заслужаваш."
  },
  {
    "reading_id": "four_wands_two_pentacles",
    "reading_name": "Четворка Жезли + Двойка Пентакли",
    "reading_cards": "Четворка Жезли + Двойка Пентакли",
    "reading_combination": ["four_wands", "two_pentacles"],
    "reading_meaning": "Празник и баланс",
    "second_meaning": "Четворка Жезли носи празника, а Двойка Пентакли – баланса и жонглирането. Празнувате, но трябва да балансирате разходите и удоволствията. Жонглирайте внимателно.",
    "reading_description": "Празнуваш, но трябва да балансираш разходите и удоволствията. Жонглирай внимателно.",
    "reading_advice": "Празнувай, но с мярка. Финансовият баланс е важен – не позволявай на радостта да те изкуши да прекалиш."
  },
  {
    "reading_id": "four_wands_three_pentacles",
    "reading_name": "Четворка Жезли + Тройка Пентакли",
    "reading_cards": "Четворка Жезли + Тройка Пентакли",
    "reading_combination": ["four_wands", "three_pentacles"],
    "reading_meaning": "Празник с екип",
    "second_meaning": "Четворка Жезли носи празника, а Тройка Пентакли – екипната работа и сътрудничеството. Празнувате успех, постигнат в екип. Споделена радост и признание.",
    "reading_description": "Празнуваш успех, постигнат в екип. Споделена радост и признание.",
    "reading_advice": "Благодари на екипа си. Успехът е по-сладък, когато е споделен. Празнувайте заедно."
  },
  {
    "reading_id": "four_wands_four_pentacles",
    "reading_name": "Четворка Жезли + Четворка Пентакли",
    "reading_cards": "Четворка Жезли + Четворка Пентакли",
    "reading_combination": ["four_wands", "four_pentacles"],
    "reading_meaning": "Празник и сигурност",
    "second_meaning": "Четворка Жезли носи празника, а Четворка Пентакли – сигурността и стискането. Празнувате, но се страхувате да похарчите. Не позволявайте на страха да ограничава радостта.",
    "reading_description": "Празнуваш, но се страхуваш да похарчиш. Не позволявай на страха да ограничава радостта.",
    "reading_advice": "Пусни малко. Парите са за живот, не животът за пари. Позволи си да се радваш."
  },
  {
    "reading_id": "four_wands_five_pentacles",
    "reading_name": "Четворка Жезли + Петица Пентакли",
    "reading_cards": "Четворка Жезли + Петица Пентакли",
    "reading_combination": ["four_wands", "five_pentacles"],
    "reading_meaning": "Празник и липса",
    "second_meaning": "Четворка Жезли носи празника, а Петица Пентакли – финансовите трудности и липсата. Искате да празнувате, но ресурсите са ограничени. Търсете прости, но искрени начини за радост.",
    "reading_description": "Искаш да празнуваш, но финансовите ресурси са ограничени. Търси прости начини за радост.",
    "reading_advice": "Истинската радост не изисква много пари. Бъди креативен – най-простите неща често носят най-голямо щастие."
  },
  {
    "reading_id": "four_wands_six_pentacles",
    "reading_name": "Четворка Жезли + Шестица Пентакли",
    "reading_cards": "Четворка Жезли + Шестица Пентакли",
    "reading_combination": ["four_wands", "six_pentacles"],
    "reading_meaning": "Празник и щедрост",
    "second_meaning": "Четворка Жезли носи празника, а Шестица Пентакли – щедростта и даването. Празнувате, като споделяте с другите. Даването носи повече радост от получаването.",
    "reading_description": "Празнуваш, като споделяш с другите. Даването носи повече радост от получаването.",
    "reading_advice": "Сподели радостта си. Колкото повече даваш, толкова повече получаваш. Бъди щедър."
  },
  {
    "reading_id": "four_wands_seven_pentacles",
    "reading_name": "Четворка Жезли + Седмица Пентакли",
    "reading_cards": "Четворка Жезли + Седмица Пентакли",
    "reading_combination": ["four_wands", "seven_pentacles"],
    "reading_meaning": "Празник и търпение",
    "second_meaning": "Четворка Жезли носи празника, а Седмица Пентакли – търпението и чакането. Празнувате, но знаете, че истинските резултати ще дойдат по-късно. Празник на надеждата.",
    "reading_description": "Празнуваш, но знаеш, че истинските резултати ще дойдат по-късно. Празник на надеждата.",
    "reading_advice": "Празнувай напредъка, но имай търпение за крайния резултат. Добрите неща идват с времето."
  },
  {
    "reading_id": "four_wands_eight_pentacles",
    "reading_name": "Четворка Жезли + Осмица Пентакли",
    "reading_cards": "Четворка Жезли + Осмица Пентакли",
    "reading_combination": ["four_wands", "eight_pentacles"],
    "reading_meaning": "Празник на труда",
    "second_meaning": "Четворка Жезли носи празника, а Осмица Пентакли – усърдието и ученето. Празнувате завършването на проект или усвояването на ново умение. Трудът се отплаща.",
    "reading_description": "Празнуваш завършването на проект или усвояването на ново умение. Трудът се отплаща.",
    "reading_advice": "Гордей се с труда си. Майсторството идва с постоянство. Празнувай всяка стъпка от пътя."
  },
  {
    "reading_id": "four_wands_nine_pentacles",
    "reading_name": "Четворка Жезли + Деветка Пентакли",
    "reading_cards": "Четворка Жезли + Деветка Пентакли",
    "reading_combination": ["four_wands", "nine_pentacles"],
    "reading_meaning": "Празник на независимостта",
    "second_meaning": "Четворка Жезли носи празника, а Деветка Пентакли – самодостатъчността и успеха. Празнувате постигната независимост. Свобода и удовлетворение.",
    "reading_description": "Празнуваш постигната независимост. Свобода и удовлетворение.",
    "reading_advice": "Ти постигна самостоятелност. Наслади се на свободата и не забравяй откъде идваш."
  },
  {
    "reading_id": "four_wands_ten_pentacles",
    "reading_name": "Четворка Жезли + Десетка Пентакли",
    "reading_cards": "Четворка Жезли + Десетка Пентакли",
    "reading_combination": ["four_wands", "ten_pentacles"],
    "reading_meaning": "Семеен празник",
    "second_meaning": "Четворка Жезли носи дома, а Десетка Пентакли – семейното наследство и богатство. Празнувате семейно събитие, което свързва поколенията. Традиция и приемственост.",
    "reading_description": "Празнуваш семейно събитие, което свързва поколенията. Традиция и приемственост.",
    "reading_advice": "Цени семейството и традициите. Това, което празнувате днес, ще остане като спомен за утрешните поколения."
  },
  {
    "reading_id": "four_wands_page_pentacles",
    "reading_name": "Четворка Жезли + Паж Пентакли",
    "reading_cards": "Четворка Жезли + Паж Пентакли",
    "reading_combination": ["four_wands", "page_pentacles"],
    "reading_meaning": "Празник и ново начало",
    "second_meaning": "Четворка Жезли носи празника, а Паж Пентакли – новото начало в материалната сфера. Празнувате нова финансова възможност или кариерен старт. Радост и надежда.",
    "reading_description": "Празнуваш нова финансова възможност или кариерен старт. Радост и надежда.",
    "reading_advice": "Хвани възможността. Това е ново начало, което носи радост и растеж. Празнувай го!"
  },
  {
    "reading_id": "four_wands_knight_pentacles",
    "reading_name": "Четворка Жезли + Рицар Пентакли",
    "reading_cards": "Четворка Жезли + Рицар Пентакли",
    "reading_combination": ["four_wands", "knight_pentacles"],
    "reading_meaning": "Бавна радост",
    "second_meaning": "Четворка Жезли носи празника, а Рицар Пентакли – бавния и сигурен напредък. Радостта идва бавно, но е стабилна. Наслаждавайте се на сигурния път.",
    "reading_description": "Радостта идва бавно, но е стабилна. Наслаждавай се на сигурния път.",
    "reading_advice": "Не бързай. Сигурният път е бавен, но води до истинска и трайна радост."
  },
  {
    "reading_id": "four_wands_queen_pentacles",
    "reading_name": "Четворка Жезли + Царица Пентакли",
    "reading_cards": "Четворка Жезли + Царица Пентакли",
    "reading_combination": ["four_wands", "queen_pentacles"],
    "reading_meaning": "Домашен празник",
    "second_meaning": "Четворка Жезли носи дома, а Царица Пентакли – грижата и изобилието. Празнувате у дома, с домашна храна и уют. Истинско семейно щастие.",
    "reading_description": "Празнуваш у дома, с домашна храна и уют. Истинско семейно щастие.",
    "reading_advice": "Грижи се за дома и семейството. Това е най-красивият празник – споделен с близките в топлината на дома."
  },
  {
    "reading_id": "four_wands_king_pentacles",
    "reading_name": "Четворка Жезли + Цар Пентакли",
    "reading_cards": "Четворка Жезли + Цар Пентакли",
    "reading_combination": ["four_wands", "king_pentacles"],
    "reading_meaning": "Сигурен празник",
    "second_meaning": "Четворка Жезли носи празника, а Цар Пентакли – стабилността и успеха. Празнувате с увереност, че имате солидна основа. Сигурност и благополучие.",
    "reading_description": "Празнуваш с увереност, че имаш солидна основа. Сигурност и благополучие.",
    "reading_advice": "Наслади се на сигурността, която си изградил. Ти си създал стабилна основа – сега е време да празнуваш."
  },
  {
    "reading_id": "five_wands_six_wands",
    "reading_name": "Петица Жезли + Шестица Жезли",
    "reading_cards": "Петица Жезли + Шестица Жезли",
    "reading_combination": ["five_wands", "six_wands"],
    "reading_meaning": "Конфликт и победа",
    "second_meaning": "Петица Жезли носи конфликта и съперничеството, а Шестица Жезли – победата и признанието. След като сте преминали през битки и спорове, идва успехът. Борбата си е заслужавала.",
    "reading_description": "След конфликти и спорове идва победата. Борбата си заслужаваше.",
    "reading_advice": "Гордей се с това, което постигна. Не беше лесно, но успя. Наслади се на успеха."
  },
  {
    "reading_id": "five_wands_seven_wands",
    "reading_name": "Петица Жезли + Седмица Жезли",
    "reading_cards": "Петица Жезли + Седмица Жезли",
    "reading_combination": ["five_wands", "seven_wands"],
    "reading_meaning": "Битка за позиция",
    "second_meaning": "Петица Жезли носи конфликта, а Седмица Жезли – защитата на позицията. В конфликтна ситуация трябва да защитавате мястото си. Не отстъпвайте, но и не нападайте пръв.",
    "reading_description": "В разгара на конфликт трябва да защитаваш позицията си. Не отстъпвай, но не нападай пръв.",
    "reading_advice": "Дръж позицията си, но избери битките си мъдро. Не всяка битка си струва да се води."
  },
  {
    "reading_id": "five_wands_eight_wands",
    "reading_name": "Петица Жезли + Осмица Жезли",
    "reading_cards": "Петица Жезли + Осмица Жезли",
    "reading_combination": ["five_wands", "eight_wands"],
    "reading_meaning": "Бърз конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Осмица Жезли – бързината. Спорът ескалира неочаквано бързо. От малко недоразумение до голям скандал за миг.",
    "reading_description": "Конфликтът се разраства неочаквано бързо. От малко недоразумение до голям скандал за миг.",
    "reading_advice": "Преди да реагираш, преброй до десет. Бързите реакции рядко са мъдри. Дай си време да обмислиш."
  },
  {
    "reading_id": "five_wands_nine_wands",
    "reading_name": "Петица Жезли + Деветка Жезли",
    "reading_cards": "Петица Жезли + Деветка Жезли",
    "reading_combination": ["five_wands", "nine_wands"],
    "reading_meaning": "Изтощителен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Деветка Жезли – устойчивостта и изтощението. Продължителният конфликт започва да ви изтощава. Умора, но не можете да се откажете.",
    "reading_description": "Продължителният конфликт започва да те изтощава. Умора, но не можеш да се откажеш.",
    "reading_advice": "Потърси начин за примирие, преди да си загубил последните си сили. Понякога мирът е по-ценен от правотата."
  },
  {
    "reading_id": "five_wands_ten_wands",
    "reading_name": "Петица Жезли + Десетка Жезли",
    "reading_cards": "Петица Жезли + Десетка Жезли",
    "reading_combination": ["five_wands", "ten_wands"],
    "reading_meaning": "Конфликт и бреме",
    "second_meaning": "Петица Жезли носи конфликта, а Десетка Жезли – претоварването и бремето. Споровете добавят тежест към и без това претоварения ви живот. Твърде много едновременно.",
    "reading_description": "Конфликтите добавят тежест към и без това претоварения ти живот. Твърде много едновременно.",
    "reading_advice": "Освободи се от ненужните битки. Не всяка битка си струва да се води. Избери кои конфликти са наистина важни."
  },
  {
    "reading_id": "five_wands_page_wands",
    "reading_name": "Петица Жезли + Паж Жезли",
    "reading_cards": "Петица Жезли + Паж Жезли",
    "reading_combination": ["five_wands", "page_wands"],
    "reading_meaning": "Конфликт и новини",
    "second_meaning": "Петица Жезли носи конфликта, а Паж Жезли – новините и ентусиазма. По време на спор идват новини, които могат да променят ситуацията. Бъдете внимателни.",
    "reading_description": "По време на конфликт идват новини, които могат да променят ситуацията. Бъди внимателен.",
    "reading_advice": "Изслушай новините, преди да реагираш. Те може да носят решение на спора."
  },
  {
    "reading_id": "five_wands_knight_wands",
    "reading_name": "Импулсивен конфликт",
    "reading_cards": "Петица Жезли + Рицар Жезли",
    "reading_combination": ["five_wands", "knight_wands"],
    "reading_meaning": "Петица Жезли носи конфликта, а Рицар Жезли – импулсивността и бързината. Влизате в спор без да мислите, водени от емоция. Риск от прибързани действия.",
    "reading_description": "Влизаш в спор без да мислиш, воден от емоция. Риск от прибързани действия.",
    "reading_advice": "Забави. Импулсивните решения рядко са добри. Преди да реагираш, дишай дълбоко."
  },
  {
    "reading_id": "five_wands_queen_wands",
    "reading_name": "Уверен конфликт",
    "reading_cards": "Петица Жезли + Царица Жезли",
    "reading_combination": ["five_wands", "queen_wands"],
    "reading_meaning": "Петица Жезли носи конфликта, а Царица Жезли – увереността и харизмата. Водите спора с увереност и достойнство. Хората ви уважават, дори да не са съгласни.",
    "reading_description": "Водиш спора с увереност и достойнство. Хората те уважават, дори да не са съгласни.",
    "reading_advice": "Бъди уверен, но не арогантен. Истинската сила е в способността да защитаваш позицията си, без да унижаваш другия."
  },
  {
    "reading_id": "five_wands_king_wands",
    "reading_name": "Властен конфликт",
    "reading_cards": "Петица Жезли + Цар Жезли",
    "reading_combination": ["five_wands", "king_wands"],
    "reading_meaning": "Петица Жезли носи конфликта, а Цар Жезли – лидерството и авторитета. Битката е за власт и надмощие. Кой ще спечели?",
    "reading_description": "Конфликт за власт и надмощие. Битка на лидери.",
    "reading_advice": "Истинската власт не се нуждае от битки, за да се докаже. Води с мъдрост, не със сила."
  },
  {
    "reading_id": "five_wands_two_cups",
    "reading_name": "Конфликт в любовта",
    "reading_cards": "Петица Жезли + Двойка Чаши",
    "reading_combination": ["five_wands", "two_cups"],
    "reading_meaning":"Петица Жезли носи конфликта, а Двойка Чаши – любовта и връзката. Спорове и борба за надмощие в любовната връзка. Кой ще спечели?",
    "reading_description": "Конфликти и спорове в любовната връзка. Борба за надмощие.",
    "reading_advice": "В любовта няма победители. Търсете разбирателство, не победа. Когато единият печели, връзката губи."
  },
  {
    "reading_id": "five_wands_three_cups",
    "reading_name": "Конфликт на празник",
    "reading_cards": "Петица Жезли + Тройка Чаши",
    "reading_combination": ["five_wands", "three_cups"],
    "reading_meaning":"Петица Жезли носи конфликта, а Тройка Чаши – празника и радостта. Спор или конфликт помрачава празничното настроение. Напрежение сред радост.",
    "reading_description": "Конфликт или спор помрачава празничното настроение. Напрежение сред радост.",
    "reading_advice": "Не позволявай на споровете да развалят празника ти. Понякога е по-добре да преглътнеш, отколкото да разрушиш щастието."
  },
  {
    "reading_id": "five_wands_four_cups",
    "reading_name": "Петица Жезли + Четворка Чаши",
    "reading_cards": "Петица Жезли + Четворка Чаши",
    "reading_combination": ["five_wands", "four_cups"],
    "reading_meaning": "Борба с апатия",
    "second_meaning": "Петица Жезли носи конфликта, а Четворка Чаши – апатията и неудовлетворението. Борите се с чувство на апатия и безразличие. Трудно намирате мотивация.",
    "reading_description": "Бориш се с чувство на апатия и безразличие. Трудно намираш мотивация.",
    "reading_advice": "Понякога трябва да спреш да се бориш и да си починеш. Апатията не се побеждава с насилие, а с грижа към себе си."
  },
  {
    "reading_id": "five_wands_five_cups",
    "reading_name": "Петица Жезли + Петица Чаши",
    "reading_cards": "Петица Жезли + Петица Чаши",
    "reading_combination": ["five_wands", "five_cups"],
    "reading_meaning": "Конфликт и загуба",
    "second_meaning": "Петица Жезли носи конфликта, а Петица Чаши – загубата и тъгата. Спорът води до загуба – на приятелство, доверие или възможност. Горчив край.",
    "reading_description": "Спорът води до загуба – на приятелство, доверие или възможност. Горчив край.",
    "reading_advice": "Понякога най-добрата победа е да не влизаш в битка. Загубата не винаги си струва цената."
  },
  
  {
    "reading_id": "seven_wands_page_swords",
    "reading_name": "Седмица Жезли + Паж Мечове",
    "reading_cards": "Седмица Жезли + Паж Мечове",
    "reading_combination": ["seven_wands", "page_swords"],
    "reading_meaning": "Защита и истина",
    "second_meaning": "Седмица Жезли носи защитата на позицията, а Паж Мечове – търсенето на истината. Защитавате своето, но също така търсите отговори. Истината може да ви помогне да отстоявате по-успешно позицията си.",
    "reading_description": "Защитавате позицията си, като същевременно търсите истината. Любопитството ви помага да сте по-силни.",
    "reading_advice": "Търси истината – тя ще укрепи позицията ти. Не се страхувай да задаваш въпроси."
  },
  {
    "reading_id": "page_wands_four_swords",
    "reading_name": "Паж Жезли + Четворка Мечове",
    "reading_cards": "Паж Жезли + Четворка Мечове",
    "reading_combination": ["page_wands", "four_swords"],
    "reading_meaning": "Ентусиазъм и почивка",
    "second_meaning": "Паж Жезли носи ентусиазъм и новини, а Четворка Мечове – почивка и възстановяване. Имате идея или новина, но сега не е моментът за действие. Първо починете и обмислете.",
    "reading_description": "Носиш нова идея, но сега е време за почивка и размисъл, не за действие.",
    "reading_advice": "Не бързай да действаш. Почини си и обмисли идеята – утре ще я видиш по-ясно."
  }, 
  {
    "reading_id": "five_wands_eight_cups",
    "reading_name": "Петица Жезли + Осмица Чаши",
    "reading_cards": "Петица Жезли + Осмица Чаши",
    "reading_combination": ["five_wands", "eight_cups"],
    "reading_meaning": "Битката кара да тръгнеш",
    "second_meaning": "Петица Жезли носи конфликта, а Осмица Чаши – тръгването и оставянето. Конфликтът е толкова голям, че ви кара да напуснете и да тръгнете на нов път.",
    "reading_description": "Конфликтът е толкова голям, че те кара да напуснеш и да тръгнеш на път.",
    "reading_advice": "Понякога тръгването е най-доброто решение. Някои битки не си струва да се водят."
  },
  {
    "reading_id": "five_wands_nine_cups",
    "reading_name": "Петица Жезли + Деветка Чаши",
    "reading_cards": "Петица Жезли + Деветка Чаши",
    "reading_combination": ["five_wands", "nine_cups"],
    "reading_meaning": "Борба за мечта",
    "second_meaning": "Петица Жезли носи конфликта, а Деветка Чаши – сбъднатото желание. Борите се за това, което искате. Мечтата си заслужава битката.",
    "reading_description": "Бориш се за това, което искаш. Мечтата си заслужава битката.",
    "reading_advice": "Бори се, но не губи себе си в битката. Мечтата е важна, но ти си по-важен."
  },
  {
    "reading_id": "five_wands_ten_cups",
    "reading_name": "Петица Жезли + Десетка Чаши",
    "reading_cards": "Петица Жезли + Десетка Чаши",
    "reading_combination": ["five_wands", "ten_cups"],
    "reading_meaning": "Семеен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Десетка Чаши – семейното щастие и хармония. Кавги и спорове в семейството. Напрежение, което разваля хармонията.",
    "reading_description": "Конфликти и спорове в семейството. Напрежение, което разваля хармонията.",
    "reading_advice": "Семейството е по-важно от правотата. Потърси мир. Вкъщи не трябва да има победители и победени."
  },
  {
    "reading_id": "five_wands_page_cups",
    "reading_name": "Петица Жезли + Паж Чаши",
    "reading_cards": "Петица Жезли + Паж Чаши",
    "reading_combination": ["five_wands", "page_cups"],
    "reading_meaning": "Конфликт и послание",
    "second_meaning": "Петица Жезли носи конфликта, а Паж Чаши – емоционално послание. По време на спор идва нежно послание, което може да успокои духовете. Отворете сърцето си.",
    "reading_description": "По време на конфликт идва нежно емоционално послание. Може да успокои духовете.",
    "reading_advice": "Изслушай посланието с отворено сърце. То може да донесе помирение."
  },
  {
    "reading_id": "five_wands_knight_cups",
    "reading_name": "Петица Жезли + Рицар Чаши",
    "reading_cards": "Петица Жезли + Рицар Чаши",
    "reading_combination": ["five_wands", "knight_cups"],
    "reading_meaning": "Конфликт и романтика",
    "second_meaning": "Петица Жезли носи конфликта, а Рицар Чаши – романтиката и ухажването. Спор в любовта, но с романтичен завършек. Кавга, която завършва с помирение.",
    "reading_description": "Спор в любовта, който може да завърши с романтично помирение.",
    "reading_advice": "След бурята идва спокойствие. Позволи си да се помириш с любов, а не с его."
  },
  {
    "reading_id": "five_wands_queen_cups",
    "reading_name": "Петица Жезли + Царица Чаши",
    "reading_cards": "Петица Жезли + Царица Чаши",
    "reading_combination": ["five_wands", "queen_cups"],
    "reading_meaning": "Интуитивен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Царица Чаши – интуицията и дълбоката емоционалност. Интуицията ви подсказва как да разрешите спора. Слушайте я.",
    "reading_description": "Интуицията ти подсказва как да разрешиш спора. Слушай вътрешния си глас.",
    "reading_advice": "Довери се на интуицията си. Тя знае кога да отстъпиш и кога да се защитиш."
  },
  {
    "reading_id": "five_wands_king_cups",
    "reading_name": "Петица Жезли + Цар Чаши",
    "reading_cards": "Петица Жезли + Цар Чаши",
    "reading_combination": ["five_wands", "king_cups"],
    "reading_meaning": "Балансиран конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Цар Чаши – емоционалната зрялост и баланс. Водите спора с мъдрост и спокойствие. Без крайности, без драма.",
    "reading_description": "Водиш спора с мъдрост и спокойствие. Без крайности, без драма.",
    "reading_advice": "Бъди спокоен в бурята. Емоционалната зрялост е най-доброто оръжие в конфликт."
  },
  {
    "reading_id": "five_wands_two_swords",
    "reading_name": "Петица Жезли + Двойка Мечове",
    "reading_cards": "Петица Жезли + Двойка Мечове",
    "reading_combination": ["five_wands", "two_swords"],
    "reading_meaning": "Блокиран конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Двойка Мечове – нерешителността и блокажа. Спорът е в застой. Никой не отстъпва, но никой и не печели.",
    "reading_description": "Спорът е в застой. Никой не отстъпва, но никой и не печели.",
    "reading_advice": "Понякога най-добрият начин да спечелиш е да излезеш от битката. Нерешителността е по-лоша от грешното решение."
  },
  {
    "reading_id": "five_wands_three_swords",
    "reading_name": "Петица Жезли + Тройка Мечове",
    "reading_cards": "Петица Жезли + Тройка Мечове",
    "reading_combination": ["five_wands", "three_swords"],
    "reading_meaning": "Болен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Тройка Мечове – болката и разбитото сърце. Спорът носи дълбока емоционална болка. Думи, които нараняват.",
    "reading_description": "Спорът носи дълбока емоционална болка. Думи, които нараняват.",
    "reading_advice": "Преди да кажеш нещо, помисли дали можеш да го понесеш, ако ти го кажат. Болката остава дълго след кавгата."
  },
  {
    "reading_id": "five_wands_four_swords",
    "reading_name": "Петица Жезли + Четворка Мечове",
    "reading_cards": "Петица Жезли + Четворка Мечове",
    "reading_combination": ["five_wands", "four_swords"],
    "reading_meaning": "Почивка след конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Четворка Мечове – почивката и възстановяването. След битката идва време за почивка. Съберете сили.",
    "reading_description": "След битката идва време за почивка. Събери сили.",
    "reading_advice": "Почини си. Не можеш да се биеш вечно. Възстановяването е част от победата."
  },
  {
    "reading_id": "five_wands_five_swords",
    "reading_name": "Петица Жезли + Петица Мечове",
    "reading_cards": "Петица Жезли + Петица Мечове",
    "reading_combination": ["five_wands", "five_swords"],
    "reading_meaning": "Празна победа",
    "second_meaning": "Петица Жезли носи конфликта, а Петица Мечове – празната победа и унижението на другия. Спечелили сте, но каква беше цената? Оставили сте другите в прахта.",
    "reading_description": "Спечелил си, но каква беше цената? Оставил си другите в прахта.",
    "reading_advice": "Помисли дали си струва да унищожиш другия, за да спечелиш. Победата може да те остави сам."
  },
  {
    "reading_id": "five_wands_six_swords",
    "reading_name": "Петица Жезли + Шестица Мечове",
    "reading_cards": "Петица Жезли + Шестица Мечове",
    "reading_combination": ["five_wands", "six_swords"],
    "reading_meaning": "Бягство от конфликта",
    "second_meaning": "Петица Жезли носи конфликта, а Шестица Мечове – пътуването и прехода. Решавате да излезете от конфликта, като тръгнете на път. Отдалечаване от проблема.",
    "reading_description": "Решаваш да излезеш от конфликта, като тръгнеш на път. Отдалечаване от проблема.",
    "reading_advice": "Понякога най-доброто решение е да се отдалечиш. Новите води носят нов мир."
  },
  {
    "reading_id": "five_wands_seven_swords",
    "reading_name": "Петица Жезли + Седмица Мечове",
    "reading_cards": "Петица Жезли + Седмица Мечове",
    "reading_combination": ["five_wands", "seven_swords"],
    "reading_meaning": "Нечестен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Седмица Мечове – измамата и хитростта. Някой не играе честно. Има скрити мотиви и манипулации.",
    "reading_description": "Някой не играе честно. Има скрити мотиви и манипулации.",
    "reading_advice": "Внимавай. Не всички играят честно. Пази гърба си и не разкривай всичките си карти."
  },
  {
    "reading_id": "five_wands_eight_swords",
    "reading_name": "Петица Жезли + Осмица Мечове",
    "reading_cards": "Петица Жезли + Осмица Мечове",
    "reading_combination": ["five_wands", "eight_swords"],
    "reading_meaning": "Конфликт в капан",
    "second_meaning": "Петица Жезли носи конфликта, а Осмица Мечове – чувството на капан и ограничение. Чувствате се в капан в конфликта, без видим изход. Парализа.",
    "reading_description": "Чувстваш се в капан в конфликта, без видим изход. Парализа.",
    "reading_advice": "Оковите са в главата ти. Има повече възможности, отколкото виждаш. Потърси нова перспектива."
  },
  {
    "reading_id": "five_wands_nine_swords",
    "reading_name": "Петица Жезли + Деветка Мечове",
    "reading_cards": "Петица Жезли + Деветка Мечове",
    "reading_combination": ["five_wands", "nine_swords"],
    "reading_meaning": "Тревожен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Деветка Мечове – тревогата и безсънието. Спорът ви тревожи и не ви оставя да спите. Мислите ви се въртят около него.",
    "reading_description": "Спорът те тревожи и не те оставя да спиш. Мислите ти се въртят около него.",
    "reading_advice": "Спокойствие. Повечето неща, за които се тревожим, никога не се случват. Дишай дълбоко."
  },
  {
    "reading_id": "five_wands_ten_swords",
    "reading_name": "Петица Жезли + Десетка Мечове",
    "reading_cards": "Петица Жезли + Десетка Мечове",
    "reading_combination": ["five_wands", "ten_swords"],
    "reading_meaning": "Край на конфликта",
    "second_meaning": "Петица Жезли носи конфликта, а Десетка Мечове – края и дъното. Конфликтът приключва – по един или друг начин. Краят носи облекчение, дори да е труден.",
    "reading_description": "Конфликтът приключва – по един или друг начин. Краят носи облекчение.",
    "reading_advice": "Остави битката зад гърба си. Това, което свърши, вече не тежи. Гледай напред."
  },
  {
    "reading_id": "five_wands_page_swords",
    "reading_name": "Петица Жезли + Паж Мечове",
    "reading_cards": "Петица Жезли + Паж Мечове",
    "reading_combination": ["five_wands", "page_swords"],
    "reading_meaning": "Конфликт и истина",
    "second_meaning": "Петица Жезли носи конфликта, а Паж Мечове – търсенето на истината. По време на спора излиза истина, която променя всичко. Бъдете готови.",
    "reading_description": "По време на спора излиза истина, която променя всичко. Бъди готов.",
    "reading_advice": "Истината може да боли, но винаги лекува. Приеми я с отворено сърце."
  },
  {
    "reading_id": "five_wands_knight_swords",
    "reading_name": "Петица Жезли + Рицар Мечове",
    "reading_cards": "Петица Жезли + Рицар Мечове",
    "reading_combination": ["five_wands", "knight_swords"],
    "reading_meaning": "Агресивен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Рицар Мечове – агресията и прямотата. Конфликтът ескалира до агресия. Думи или действия, които нараняват.",
    "reading_description": "Конфликтът ескалира до агресия. Думи или действия, които нараняват.",
    "reading_advice": "Забави. Агресията води до разрушение, което не може да бъде поправено. Понякога мълчанието е по-силно."
  },
  {
    "reading_id": "five_wands_queen_swords",
    "reading_name": "Петица Жезли + Царица Мечове",
    "reading_cards": "Петица Жезли + Царица Мечове",
    "reading_combination": ["five_wands", "queen_swords"],
    "reading_meaning": "Ясен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Царица Мечове – яснотата и независимостта. Виждате спора ясно, без илюзии. Знаете какво искате и как да го постигнете.",
    "reading_description": "Виждаш спора ясно, без илюзии. Знаеш какво искаш и как да го постигнеш.",
    "reading_advice": "Бъди честен със себе си. Яснотата е сила. Не позволявай на емоциите да замъглят истината."
  },
  {
    "reading_id": "five_wands_king_swords",
    "reading_name": "Петица Жезли + Цар Мечове",
    "reading_cards": "Петица Жезли + Цар Мечове",
    "reading_combination": ["five_wands", "king_swords"],
    "reading_meaning": "Справедлив конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Цар Мечове – справедливостта и интелекта. Водите спора с логика и обективност. Истината е на ваша страна.",
    "reading_description": "Водиш спора с логика и обективност. Истината е на твоя страна.",
    "reading_advice": "Води с разум, не с емоция. Справедливостта не е жестока – тя е точна. Бъди твърд, но справедлив."
  },
  {
    "reading_id": "five_wands_two_pentacles",
    "reading_name": "Петица Жезли + Двойка Пентакли",
    "reading_cards": "Петица Жезли + Двойка Пентакли",
    "reading_combination": ["five_wands", "two_pentacles"],
    "reading_meaning": "Конфликт и баланс",
    "second_meaning": "Петица Жезли носи конфликта, а Двойка Пентакли – баланса и жонглирането. Трябва да балансирате конфликта с другите си задължения. Жонглирайте внимателно.",
    "reading_description": "Трябва да балансираш конфликта с другите си задължения. Жонглирай внимателно.",
    "reading_advice": "Не позволявай на един конфликт да завладее целия ти живот. Балансирай, но не изпускай важните неща."
  },
  {
    "reading_id": "five_wands_three_pentacles",
    "reading_name": "Петица Жезли + Тройка Пентакли",
    "reading_cards": "Петица Жезли + Тройка Пентакли",
    "reading_combination": ["five_wands", "three_pentacles"],
    "reading_meaning": "Конфликт в екип",
    "second_meaning": "Петица Жезли носи конфликта, а Тройка Пентакли – екипната работа и сътрудничеството. Спорове в екипа или на работното място. Напрежение между колеги.",
    "reading_description": "Спорове в екипа или на работното място. Напрежение между колеги.",
    "reading_advice": "Търсете общата цел. В екипа няма място за его. Конфликтите само забавят напредъка."
  },
  {
    "reading_id": "five_wands_four_pentacles",
    "reading_name": "Петица Жезли + Четворка Пентакли",
    "reading_cards": "Петица Жезли + Четворка Пентакли",
    "reading_combination": ["five_wands", "four_pentacles"],
    "reading_meaning": "Конфликт и стискане",
    "second_meaning": "Петица Жезли носи конфликта, а Четворка Пентакли – стискането и страха от загуба. Спорът е свързан с пари или ресурси. Страхът от загуба води до конфликт.",
    "reading_description": "Спорът е свързан с пари или ресурси. Страхът от загуба води до конфликт.",
    "reading_advice": "Пусни малко. Колкото повече стискаш, толкова повече се изплъзва. Понякога трябва да дадеш, за да получиш."
  },
  {
    "reading_id": "five_wands_five_pentacles",
    "reading_name": "Петица Жезли + Петица Пентакли",
    "reading_cards": "Петица Жезли + Петица Пентакли",
    "reading_combination": ["five_wands", "five_pentacles"],
    "reading_meaning": "Конфликт и липса",
    "second_meaning": "Петица Жезли носи конфликта, а Петица Пентакли – финансовите трудности и липсата. Спор, породен от липса на ресурси. Нужда и борба.",
    "reading_description": "Спор, породен от липса на ресурси. Нужда и борба.",
    "reading_advice": "Потърси помощ. Не си сам. Конфликтите, породени от липса, се решават със сътрудничество, не с битка."
  },
  {
    "reading_id": "five_wands_six_pentacles",
    "reading_name": "Петица Жезли + Шестица Пентакли",
    "reading_cards": "Петица Жезли + Шестица Пентакли",
    "reading_combination": ["five_wands", "six_pentacles"],
    "reading_meaning": "Конфликт и помощ",
    "second_meaning": "Петица Жезли носи конфликта, а Шестица Пентакли – помощта и щедростта. Някой протяга ръка да помогне за разрешаване на спора. Приемете помощта.",
    "reading_description": "Някой протяга ръка да помогне за разрешаване на спора. Приеми помощта.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "five_wands_seven_pentacles",
    "reading_name": "Петица Жезли + Седмица Пентакли",
    "reading_cards": "Петица Жезли + Седмица Пентакли",
    "reading_combination": ["five_wands", "seven_pentacles"],
    "reading_meaning": "Конфликт и търпение",
    "second_meaning": "Петица Жезли носи конфликта, а Седмица Пентакли – търпението и чакането. Спорът изисква търпение. Не очаквайте бързо решение.",
    "reading_description": "Спорът изисква търпение. Не очаквай бързо решение.",
    "reading_advice": "Чакай търпеливо. Някои конфликти се разрешават с времето, не с битка."
  },
  {
    "reading_id": "five_wands_eight_pentacles",
    "reading_name": "Петица Жезли + Осмица Пентакли",
    "reading_cards": "Петица Жезли + Осмица Пентакли",
    "reading_combination": ["five_wands", "eight_pentacles"],
    "reading_meaning": "Конфликт и учене",
    "second_meaning": "Петица Жезли носи конфликта, а Осмица Пентакли – усърдието и ученето. Конфликтът ви учи на нещо важно. Урок, маскиран като спор.",
    "reading_description": "Конфликтът те учи на нещо важно. Урок, маскиран като спор.",
    "reading_advice": "Научи урока. Всяка битка носи знание, ако си отворен да го видиш."
  },
  {
    "reading_id": "five_wands_nine_pentacles",
    "reading_name": "Петица Жезли + Деветка Пентакли",
    "reading_cards": "Петица Жезли + Деветка Пентакли",
    "reading_combination": ["five_wands", "nine_pentacles"],
    "reading_meaning": "Конфликт и независимост",
    "second_meaning": "Петица Жезли носи конфликта, а Деветка Пентакли – самодостатъчността и успеха. След конфликта идва независимост. Освобождаване и свобода.",
    "reading_description": "След конфликта идва независимост. Освобождаване и свобода.",
    "reading_advice": "Понякога конфликтът е цената, която плащаме за свободата. Ти си свободен – наслади се."
  },
  {
    "reading_id": "five_wands_ten_pentacles",
    "reading_name": "Петица Жезли + Десетка Пентакли",
    "reading_cards": "Петица Жезли + Десетка Пентакли",
    "reading_combination": ["five_wands", "ten_pentacles"],
    "reading_meaning": "Семеен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Десетка Пентакли – семейното наследство и богатство. Спорове за наследство или семейни ресурси. Битка за това, което остава.",
    "reading_description": "Спорове за наследство или семейни ресурси. Битка за това, което остава.",
    "reading_advice": "Помни – парите идват и си отиват, а семейството остава. Потърси компромис, за да не загубиш и двете."
  },
  {
    "reading_id": "five_wands_page_pentacles",
    "reading_name": "Петица Жезли + Паж Пентакли",
    "reading_cards": "Петица Жезли + Паж Пентакли",
    "reading_combination": ["five_wands", "page_pentacles"],
    "reading_meaning": "Конфликт и ново начало",
    "second_meaning": "Петица Жезли носи конфликта, а Паж Пентакли – новото начало в материалната сфера. Спорът отваря врата за нова възможност. Урок и шанс.",
    "reading_description": "Спорът отваря врата за нова възможност. Урок и шанс.",
    "reading_advice": "Виж възможността зад конфликта. Понякога разрухата носи семената на новото."
  },
  {
    "reading_id": "five_wands_knight_pentacles",
    "reading_name": "Петица Жезли + Рицар Пентакли",
    "reading_cards": "Петица Жезли + Рицар Пентакли",
    "reading_combination": ["five_wands", "knight_pentacles"],
    "reading_meaning": "Упорит конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Рицар Пентакли – бавния и сигурен напредък. Конфликтът се проточва. Няма бързо решение – търпение и постоянство.",
    "reading_description": "Конфликтът се проточва. Няма бързо решение – търпение и постоянство.",
    "reading_advice": "Не очаквай бързо решение. Бъди упорит, но не твърдоглав. Бавно, но сигурно."
  },
  {
    "reading_id": "five_wands_queen_pentacles",
    "reading_name": "Петица Жезли + Царица Пентакли",
    "reading_cards": "Петица Жезли + Царица Пентакли",
    "reading_combination": ["five_wands", "queen_pentacles"],
    "reading_meaning": "Практичен конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Царица Пентакли – практичността и грижата. Спорът се решава с практичен подход. Грижа и практичност.",
    "reading_description": "Спорът се решава с практичен подход. Грижа и практичност.",
    "reading_advice": "Потърси практично решение. Грижата за дома и близките е по-важна от правотата."
  },
  {
    "reading_id": "five_wands_king_pentacles",
    "reading_name": "Петица Жезли + Цар Пентакли",
    "reading_cards": "Петица Жезли + Цар Пентакли",
    "reading_combination": ["five_wands", "king_pentacles"],
    "reading_meaning": "Бизнес конфликт",
    "second_meaning": "Петица Жезли носи конфликта, а Цар Пентакли – бизнес успеха и стабилността. Спор в бизнеса или за финанси. Кой ще спечели?",
    "reading_description": "Спор в бизнеса или за финанси. Кой ще спечели?",
    "reading_advice": "В бизнеса няма място за его. Търси решение, което носи полза и на двете страни. Дългосрочният успех е по-важен от моментната победа."
  },
  {
    "reading_id": "six_wands_seven_wands",
    "reading_name": "Шестица Жезли + Седмица Жезли",
    "reading_cards": "Шестица Жезли + Седмица Жезли",
    "reading_combination": ["six_wands", "seven_wands"],
    "reading_meaning": "Успех и защита",
    "second_meaning": "Шестица Жезли носи победата и признанието, а Седмица Жезли – защитата на позицията. След като сте постигнали успех, веднага трябва да го защитавате от нападки. Победата не ви носи мир, но сте готови.",
    "reading_description": "Постигнал си успех, но веднага трябва да го защитаваш от нападки. Победата не ти носи мир.",
    "reading_advice": "Не позволявай на другите да ти отнемат радостта от успеха. Бъди бдителен, но не позволявай на страха да те завладее."
  },
  {
    "reading_id": "six_wands_eight_wands",
    "reading_name": "Шестица Жезли + Осмица Жезли",
    "reading_cards": "Шестица Жезли + Осмица Жезли",
    "reading_combination": ["six_wands", "eight_wands"],
    "reading_meaning": "Бърз успех",
    "second_meaning": "Шестица Жезли носи победата, а Осмица Жезли – бързината. Успехът идва неочаквано бързо и леко. Почти не можете да повярвате, че се случва. Радвайте се и се наслаждавайте.",
    "reading_description": "Победата идва неочаквано бързо и леко. Почти не можеш да повярваш, че се случва.",
    "reading_advice": "Приеми успеха с благодарност и смирение. Наслади се на момента – той няма да се повтори скоро."
  },
  {
    "reading_id": "six_wands_nine_wands",
    "reading_name": "Шестица Жезли + Деветка Жезли",
    "reading_cards": "Шестица Жезли + Деветка Жезли",
    "reading_combination": ["six_wands", "nine_wands"],
    "reading_meaning": "Уморен победител",
    "second_meaning": "Шестица Жезли носи победата, а Деветка Жезли – устойчивостта и изтощението. Постигнали сте успех, но цената беше висока. Чувствате се повече изтощени, отколкото щастливи.",
    "reading_description": "Постигна успех, но цената беше висока. Чувстваш се повече изтощен, отколкото щастлив.",
    "reading_advice": "Почини си. Заслужил си го. Победата е сладка, но не когато си твърде уморен да я вкусиш."
  },
  {
    "reading_id": "six_wands_ten_wands",
    "reading_name": "Шестица Жезли + Десетка Жезли",
    "reading_cards": "Шестица Жезли + Десетка Жезли",
    "reading_combination": ["six_wands", "ten_wands"],
    "reading_meaning": "Успех под напрежение",
    "second_meaning": "Шестица Жезли носи победата, а Десетка Жезли – претоварването и бремето. Успели сте, но все още носите тежестта на отговорностите. Няма време за празнуване.",
    "reading_description": "Успя, но все още носиш тежестта на отговорностите. Няма време за празнуване.",
    "reading_advice": "Намери момент за себе си, дори и кратък. Дори победителите имат нужда от почивка."
  },
  {
    "reading_id": "six_wands_page_wands",
    "reading_name": "Шестица Жезли + Паж Жезли",
    "reading_cards": "Шестица Жезли + Паж Жезли",
    "reading_combination": ["six_wands", "page_wands"],
    "reading_meaning": "Успех и новини",
    "second_meaning": "Шестица Жезли носи победата, а Паж Жезли – новините и ентусиазма. След успеха идват вълнуващи новини. Някой носи добри вести, които допълват радостта.",
    "reading_description": "След успеха идват вълнуващи новини. Някой носи добри вести.",
    "reading_advice": "Отвори се за новините. Те носят още повече радост и вдъхновение."
  },
  {
    "reading_id": "six_wands_knight_wands",
    "reading_name": "Шестица Жезли + Рицар Жезли",
    "reading_cards": "Шестица Жезли + Рицар Жезли",
    "reading_combination": ["six_wands", "knight_wands"],
    "reading_meaning": "Стремителен успех",
    "second_meaning": "Шестица Жезли носи победата, а Рицар Жезли – импулсивността и бързината. Успехът идва светкавично и носи усещане за неудържимост. Яздете вълната, докато е висока.",
    "reading_description": "Успехът идва светкавично и носи усещане за неудържимост.",
    "reading_advice": "Язди вълната, докато е висока, но не забравяй да дишаш. Скоростта е вълнуваща, но и изтощителна."
  },
  {
    "reading_id": "six_wands_queen_wands",
    "reading_name": "Шестица Жезли + Царица Жезли",
    "reading_cards": "Шестица Жезли + Царица Жезли",
    "reading_combination": ["six_wands", "queen_wands"],
    "reading_meaning": "Уверен успех",
    "second_meaning": "Шестица Жезли носи победата, а Царица Жезли – увереността и харизмата. Успехът ви идва с лекота, защото сте уверени в себе си. Хората се вдъхновяват от вашата светлина.",
    "reading_description": "Успехът ти идва с лекота, защото си уверен в себе си. Хората се вдъхновяват от теб.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина води другите. Сподели успеха си."
  },
  {
    "reading_id": "six_wands_king_wands",
    "reading_name": "Шестица Жезли + Цар Жезли",
    "reading_cards": "Шестица Жезли + Цар Жезли",
    "reading_combination": ["six_wands", "king_wands"],
    "reading_meaning": "Властен успех",
    "second_meaning": "Шестица Жезли носи победата, а Цар Жезли – лидерството и визията. Успехът ви поставя в позиция на лидер. Имате визията и авторитета да водите другите.",
    "reading_description": "Успехът те поставя в позиция на лидер. Имаш визията и авторитета да водиш.",
    "reading_advice": "Поеми лидерството с мъдрост. Води с пример и вдъхновявай другите да те следват."
  },
  {
    "reading_id": "six_wands_two_cups",
    "reading_name": "Шестица Жезли + Двойка Чаши",
    "reading_cards": "Шестица Жезли + Двойка Чаши",
    "reading_combination": ["six_wands", "two_cups"],
    "reading_meaning": "Победа в любовта",
    "second_meaning": "Шестица Жезли носи победата, а Двойка Чаши – любовта и връзката. Успех в любовта – признание, годеж или заздравяване на връзката. Любовта тържествува.",
    "reading_description": "Успех в любовта – признание, годеж или заздравяване на връзката. Любовта тържествува.",
    "reading_advice": "Празнувайте любовта си заедно. Този успех е и ваш, и неин. Споделете радостта."
  },
  {
    "reading_id": "six_wands_three_cups",
    "reading_name": "Шестица Жезли + Тройка Чаши",
    "reading_cards": "Шестица Жезли + Тройка Чаши",
    "reading_combination": ["six_wands", "three_cups"],
    "reading_meaning": "Успешен празник",
    "second_meaning": "Шестица Жезли носи победата, а Тройка Чаши – празника и радостта. Празнувате успех с приятели и близки. Радост и споделено щастие.",
    "reading_description": "Празнуваш успех с приятели и близки. Радост и споделено щастие.",
    "reading_advice": "Сподели успеха си. Той става по-голям, когато го споделиш с тези, които обичаш."
  },
  {
    "reading_id": "six_wands_four_cups",
    "reading_name": "Шестица Жезли + Четворка Чаши",
    "reading_cards": "Шестица Жезли + Четворка Чаши",
    "reading_combination": ["six_wands", "four_cups"],
    "reading_meaning": "Успех без радост",
    "second_meaning": "Шестица Жезли носи победата, а Четворка Чаши – апатията и неудовлетворението. Постигате успех, но не усещате радост. Нещо ви липсва или сте прегорели.",
    "reading_description": "Постигаш успех, но не усещаш радост. Нещо ти липсва или си прегорял.",
    "reading_advice": "Попитай се какво наистина искаш. Понякога успехът, който преследваме, не е нашият истински успех."
  },
  {
    "reading_id": "six_wands_five_cups",
    "reading_name": "Шестица Жезли + Петица Чаши",
    "reading_cards": "Шестица Жезли + Петица Чаши",
    "reading_combination": ["six_wands", "five_cups"],
    "reading_meaning": "Победа със загуба",
    "second_meaning": "Шестица Жезли носи победата, а Петица Чаши – загубата и тъгата. Успех, но с цената на нещо важно. Смесени чувства – радост и тъга едновременно.",
    "reading_description": "Постигаш успех, но губиш нещо важно по пътя. Смесени чувства.",
    "reading_advice": "Понякога победата не си струва цената. Позволи си да скърбиш за загубата, дори да празнуваш успеха."
  },
  {
    "reading_id": "six_wands_six_cups",
    "reading_name": "Шестица Жезли + Шестица Чаши",
    "reading_cards": "Шестица Жезли + Шестица Чаши",
    "reading_combination": ["six_wands", "six_cups"],
    "reading_meaning": "Успех от миналото",
    "second_meaning": "Шестица Жезли носи победата, а Шестица Чаши – спомените и носталгията. Получавате признание за нещо, което сте направили в миналото. Закъснял, но заслужен успех.",
    "reading_description": "Получаваш признание за нещо, което си направил в миналото. Закъснял, но заслужен успех.",
    "reading_advice": "По-добре късно, отколкото никога. Приеми признанието с благодарност и продължи напред."
  },
  {
    "reading_id": "six_wands_seven_cups",
    "reading_name": "Шестица Жезли + Седмица Чаши",
    "reading_cards": "Шестица Жезли + Седмица Чаши",
    "reading_combination": ["six_wands", "seven_cups"],
    "reading_meaning": "Илюзорен успех",
    "second_meaning": "Шестица Жезли носи победата, а Седмица Чаши – илюзиите и фантазиите. Мислите, че сте успели, но може да е илюзия. Проверете реалността.",
    "reading_description": "Мислиш, че си успял, но може да е илюзия. Провери реалността.",
    "reading_advice": "Не се залъгвай. Истинският успех е реален. Свали розовите очила и виж нещата такива, каквито са."
  },
  {
    "reading_id": "six_wands_eight_cups",
    "reading_name": "Шестица Жезли + Осмица Чаши",
    "reading_cards": "Шестица Жезли + Осмица Чаши",
    "reading_combination": ["six_wands", "eight_cups"],
    "reading_meaning": "Победа и тръгване",
    "second_meaning": "Шестица Жезли носи победата, а Осмица Чаши – тръгването и оставянето. Постигате успех, но веднага след това трябва да тръгнете. Няма време за празнуване.",
    "reading_description": "Постигаш успех, но веднага след това трябва да тръгнеш. Няма време за празнуване.",
    "reading_advice": "Празнувай в движение, ако трябва. Новите пътища очакват тези, които не спират."
  },
  {
    "reading_id": "six_wands_nine_cups",
    "reading_name": "Шестица Жезли + Деветка Чаши",
    "reading_cards": "Шестица Жезли + Деветка Чаши",
    "reading_combination": ["six_wands", "nine_cups"],
    "reading_meaning": "Сбъднат успех",
    "second_meaning": "Шестица Жезли носи победата, а Деветка Чаши – сбъднатото желание. Постигате точно това, за което сте мечтали. Удовлетворение и пълна радост.",
    "reading_description": "Постигаш точно това, за което си мечтал. Удовлетворение и пълна радост.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Мечтата ти се сбъдна – бъди благодарен."
  },
  {
    "reading_id": "six_wands_ten_cups",
    "reading_name": "Шестица Жезли + Десетка Чаши",
    "reading_cards": "Шестица Жезли + Десетка Чаши",
    "reading_combination": ["six_wands", "ten_cups"],
    "reading_meaning": "Семеен успех",
    "second_meaning": "Шестица Жезли носи победата, а Десетка Чаши – семейното щастие и хармония. Успех, който носи радост на цялото семейство. Споделена победа.",
    "reading_description": "Успех, който носи радост на цялото семейство. Споделена победа.",
    "reading_advice": "Семейството ти се гордее с теб. Сподели радостта с тях – те са част от твоя успех."
  },
  {
    "reading_id": "six_wands_page_cups",
    "reading_name": "Шестица Жезли + Паж Чаши",
    "reading_cards": "Шестица Жезли + Паж Чаши",
    "reading_combination": ["six_wands", "page_cups"],
    "reading_meaning": "Успех и послание",
    "second_meaning": "Шестица Жезли носи победата, а Паж Чаши – емоционално послание. След успеха идва нежно признание или романтично послание. Сърцето ви се изпълва.",
    "reading_description": "След успеха идва нежно признание или романтично послание. Сърцето ти се изпълва.",
    "reading_advice": "Отвори сърцето си за посланието. То носи любов и топлина в този момент на успех."
  },
  {
    "reading_id": "six_wands_knight_cups",
    "reading_name": "Шестица Жезли + Рицар Чаши",
    "reading_cards": "Шестица Жезли + Рицар Чаши",
    "reading_combination": ["six_wands", "knight_cups"],
    "reading_meaning": "Романтична победа",
    "second_meaning": "Шестица Жезли носи победата, а Рицар Чаши – романтиката и ухажването. Победа в любовта – признание, предложение или романтичен жест. Любовта печели.",
    "reading_description": "Победа в любовта – признание, предложение или романтичен жест. Любовта печели.",
    "reading_advice": "Кажи 'да' на любовта. Този момент е специален – наслади му се с пълно сърце."
  },
  {
    "reading_id": "six_wands_queen_cups",
    "reading_name": "Шестица Жезли + Царица Чаши",
    "reading_cards": "Шестица Жезли + Царица Чаши",
    "reading_combination": ["six_wands", "queen_cups"],
    "reading_meaning": "Интуитивен успех",
    "second_meaning": "Шестица Жезли носи победата, а Царица Чаши – интуицията и дълбоката емоционалност. Успехът идва, защото сте слушали сърцето си. Интуицията ви води правилно.",
    "reading_description": "Успехът идва, защото си слушал сърцето си. Интуицията те води правилно.",
    "reading_advice": "Довери се на вътрешния си глас. Той знае пътя. Продължавай да слушаш сърцето си."
  },
  {
    "reading_id": "six_wands_king_cups",
    "reading_name": "Шестица Жезли + Цар Чаши",
    "reading_cards": "Шестица Жезли + Цар Чаши",
    "reading_combination": ["six_wands", "king_cups"],
    "reading_meaning": "Зрял успех",
    "second_meaning": "Шестица Жезли носи победата, а Цар Чаши – емоционалната зрялост и баланс. Успехът идва, защото сте действали с мъдрост и спокойствие. Зряла победа.",
    "reading_description": "Успехът идва, защото си действал с мъдрост и спокойствие. Зряла победа.",
    "reading_advice": "Наслади се на успеха с мъдростта, която си придобил. Ти заслужи този момент."
  },
  {
    "reading_id": "six_wands_two_swords",
    "reading_name": "Шестица Жезли + Двойка Мечове",
    "reading_cards": "Шестица Жезли + Двойка Мечове",
    "reading_combination": ["six_wands", "two_swords"],
    "reading_meaning": "Успех и съмнение",
    "second_meaning": "Шестица Жезли носи победата, а Двойка Мечове – нерешителността и съмнението. Успели сте, но се съмнявате дали заслужавате. Нерешителност и самокритика.",
    "reading_description": "Успя, но се съмняваш дали заслужаваш. Нерешителност и самокритика.",
    "reading_advice": "Приеми успеха. Заслужаваш го. Свали превръзката от очите и виж какво си постигнал."
  },
  {
    "reading_id": "six_wands_three_swords",
    "reading_name": "Шестица Жезли + Тройка Мечове",
    "reading_cards": "Шестица Жезли + Тройка Мечове",
    "reading_combination": ["six_wands", "three_swords"],
    "reading_meaning": "Успех и болка",
    "second_meaning": "Шестица Жезли носи победата, а Тройка Мечове – болката и разбитото сърце. Успех, но с цената на разбито сърце или загуба. Смесени чувства.",
    "reading_description": "Успех, но с цената на разбито сърце или загуба. Смесени чувства.",
    "reading_advice": "Позволи си да чувстваш и радостта, и болката. Те могат да съществуват едновременно."
  },
  {
    "reading_id": "six_wands_four_swords",
    "reading_name": "Шестица Жезли + Четворка Мечове",
    "reading_cards": "Шестица Жезли + Четворка Мечове",
    "reading_combination": ["six_wands", "four_swords"],
    "reading_meaning": "Почивка след успех",
    "second_meaning": "Шестица Жезли носи победата, а Четворка Мечове – почивката и възстановяването. След успеха идва време за почивка. Възстановете силите.",
    "reading_description": "След успеха идва време за почивка. Възстанови силите.",
    "reading_advice": "Почини си. Заслужил си го. Победата не бяга – можеш да си вземеш почивка."
  },
  {
    "reading_id": "six_wands_five_swords",
    "reading_name": "Шестица Жезли + Петица Мечове",
    "reading_cards": "Шестица Жезли + Петица Мечове",
    "reading_combination": ["six_wands", "five_swords"],
    "reading_meaning": "Празна победа",
    "second_meaning": "Шестица Жезли носи победата, а Петица Мечове – празната победа и унижението на другия. Спечелили сте, но оставили сте другите в прахта. Победата е горчива.",
    "reading_description": "Спечели, но остави другите в прахта. Победата е горчива.",
    "reading_advice": "Помисли дали си струваше. Понякога да оставиш другия да спечели е по-голяма победа."
  },
  {
    "reading_id": "six_wands_six_swords",
    "reading_name": "Шестица Жезли + Шестица Мечове",
    "reading_cards": "Шестица Жезли + Шестица Мечове",
    "reading_combination": ["six_wands", "six_swords"],
    "reading_meaning": "Успех и път",
    "second_meaning": "Шестица Жезли носи победата, а Шестица Мечове – пътуването и прехода. Успехът ви отвежда на ново място. Пътуване или преместване след победа.",
    "reading_description": "Успехът те отвежда на ново място. Пътуване или преместване след победа.",
    "reading_advice": "Тръгни с увереност. Новите води носят нови победи. Успехът те следва."
  },
  {
    "reading_id": "six_wands_seven_swords",
    "reading_name": "Шестица Жезли + Седмица Мечове",
    "reading_cards": "Шестица Жезли + Седмица Мечове",
    "reading_combination": ["six_wands", "seven_swords"],
    "reading_meaning": "Успех и измама",
    "second_meaning": "Шестица Жезли носи победата, а Седмица Мечове – измамата и хитростта. Успехът ви може да е постигнат по нечестен начин или някой се опитва да ви го отнеме. Внимавайте.",
    "reading_description": "Успехът ти може да е постигнат по нечестен начин или някой се опитва да ти го отнеме.",
    "reading_advice": "Провери как си постигнал успеха. Ако е с измама, рано или късно ще излезе. Бъди честен със себе си."
  },
  {
    "reading_id": "six_wands_eight_swords",
    "reading_name": "Шестица Жезли + Осмица Мечове",
    "reading_cards": "Шестица Жезли + Осмица Мечове",
    "reading_combination": ["six_wands", "eight_swords"],
    "reading_meaning": "Успех в капан",
    "second_meaning": "Шестица Жезли носи победата, а Осмица Мечове – чувството на капан и ограничение. Успели сте, но се чувствате в капан. Победата не носи свобода.",
    "reading_description": "Успя, но се чувстваш в капан. Победата не носи свобода.",
    "reading_advice": "Оковите са в главата ти. Истинската победа е свободата. Потърси изход от собствените си ограничения."
  },
  {
    "reading_id": "six_wands_nine_swords",
    "reading_name": "Шестица Жезли + Деветка Мечове",
    "reading_cards": "Шестица Жезли + Деветка Мечове",
    "reading_combination": ["six_wands", "nine_swords"],
    "reading_meaning": "Успех и тревога",
    "second_meaning": "Шестица Жезли носи победата, а Деветка Мечове – тревогата и безсънието. Успели сте, но тревогите не ви напускат. Страх да не загубите постигнатото.",
    "reading_description": "Успя, но тревогите не те напускат. Страх да не загубиш постигнатото.",
    "reading_advice": "Спокойствие. Страхът може да ти отнеме радостта от успеха. Довери се, че можеш да задържиш това, което си постигнал."
  },
  {
    "reading_id": "six_wands_ten_swords",
    "reading_name": "Шестица Жезли + Десетка Мечове",
    "reading_cards": "Шестица Жезли + Десетка Мечове",
    "reading_combination": ["six_wands", "ten_swords"],
    "reading_meaning": "Край на успеха",
    "second_meaning": "Шестица Жезли носи победата, а Десетка Мечове – края и дъното. Един цикъл на успех приключва. Краят носи ново начало.",
    "reading_description": "Един цикъл на успех приключва. Краят носи ново начало.",
    "reading_advice": "Остави успеха зад гърба си. Той е бил, но не е вечен. Гледай напред към новото начало."
  },
  {
    "reading_id": "six_wands_page_swords",
    "reading_name": "Шестица Жезли + Паж Мечове",
    "reading_cards": "Шестица Жезли + Паж Мечове",
    "reading_combination": ["six_wands", "page_swords"],
    "reading_meaning": "Успех и истина",
    "second_meaning": "Шестица Жезли носи победата, а Паж Мечове – търсенето на истината. След успеха идва прозрение. Виждате истината за пътя, който сте изминали.",
    "reading_description": "След успеха идва прозрение. Виждаш истината за пътя, който си изминал.",
    "reading_advice": "Благодари на уроците. Истината за пътя ти е ценна повече от самия успех."
  },
  {
    "reading_id": "six_wands_knight_swords",
    "reading_name": "Шестица Жезли + Рицар Мечове",
    "reading_cards": "Шестица Жезли + Рицар Мечове",
    "reading_combination": ["six_wands", "knight_swords"],
    "reading_meaning": "Бърза победа",
    "second_meaning": "Шестица Жезли носи победата, а Рицар Мечове – бързината и прямотата. Победата идва светкавично, благодарение на бързи действия и ясна мисъл.",
    "reading_description": "Победата идва светкавично, благодарение на бързи действия и ясна мисъл.",
    "reading_advice": "Действай бързо, но с яснота. Скоростта е сила, когато е съчетана с мъдрост."
  },
  {
    "reading_id": "six_wands_queen_swords",
    "reading_name": "Шестица Жезли + Царица Мечове",
    "reading_cards": "Шестица Жезли + Царица Мечове",
    "reading_combination": ["six_wands", "queen_swords"],
    "reading_meaning": "Ясна победа",
    "second_meaning": "Шестица Жезли носи победата, а Царица Мечове – яснотата и независимостта. Победата е кристално ясна – знаете защо сте успели и какво сте направили правилно.",
    "reading_description": "Победата е кристално ясна – знаеш защо си успял и какво си направил правилно.",
    "reading_advice": "Бъди честен със себе си. Яснотата е твоята сила. Използвай я, за да продължиш напред."
  },
  {
    "reading_id": "six_wands_king_swords",
    "reading_name": "Шестица Жезли + Цар Мечове",
    "reading_cards": "Шестица Жезли + Цар Мечове",
    "reading_combination": ["six_wands", "king_swords"],
    "reading_meaning": "Справедлива победа",
    "second_meaning": "Шестица Жезли носи победата, а Цар Мечове – справедливостта и интелекта. Победата е заслужена и справедлива. Истината възтържествува.",
    "reading_description": "Победата е заслужена и справедлива. Истината възтържествува.",
    "reading_advice": "Радвай се на справедливостта. Ти спечели честно – това е най-сладката победа."
  },
  {
    "reading_id": "six_wands_two_pentacles",
    "reading_name": "Шестица Жезли + Двойка Пентакли",
    "reading_cards": "Шестица Жезли + Двойка Пентакли",
    "reading_combination": ["six_wands", "two_pentacles"],
    "reading_meaning": "Успех и баланс",
    "second_meaning": "Шестица Жезли носи победата, а Двойка Пентакли – баланса и жонглирането. Успехът изисква да балансирате новите отговорности. Жонглирайте внимателно.",
    "reading_description": "Успехът изисква да балансираш новите отговорности. Жонглирай внимателно.",
    "reading_advice": "Балансирай, но не изпускай топката. Новите отговорности са знак, че си пораснал."
  },
  {
    "reading_id": "six_wands_three_pentacles",
    "reading_name": "Шестица Жезли + Тройка Пентакли",
    "reading_cards": "Шестица Жезли + Тройка Пентакли",
    "reading_combination": ["six_wands", "three_pentacles"],
    "reading_meaning": "Екипен успех",
    "second_meaning": "Шестица Жезли носи победата, а Тройка Пентакли – екипната работа и сътрудничеството. Успехът е резултат от екипна работа. Споделете признанието.",
    "reading_description": "Успехът е резултат от екипна работа. Споделете признанието.",
    "reading_advice": "Благодари на екипа си. Успехът е по-сладък, когато е споделен. Празнувайте заедно."
  },
  {
    "reading_id": "six_wands_four_pentacles",
    "reading_name": "Шестица Жезли + Четворка Пентакли",
    "reading_cards": "Шестица Жезли + Четворка Пентакли",
    "reading_combination": ["six_wands", "four_pentacles"],
    "reading_meaning": "Успех и стискане",
    "second_meaning": "Шестица Жезли носи победата, а Четворка Пентакли – стискането и страха от загуба. Успели сте, но се страхувате да загубите постигнатото. Стискате прекалено силно.",
    "reading_description": "Успя, но се страхуваш да загубиш постигнатото. Стискаш прекалено силно.",
    "reading_advice": "Пусни малко. Колкото повече стискаш, толкова повече се изплъзва. Довери се, че можеш да задържиш успеха и без страх."
  },
  {
    "reading_id": "six_wands_five_pentacles",
    "reading_name": "Шестица Жезли + Петица Пентакли",
    "reading_cards": "Шестица Жезли + Петица Пентакли",
    "reading_combination": ["six_wands", "five_pentacles"],
    "reading_meaning": "Успех и липса",
    "second_meaning": "Шестица Жезли носи победата, а Петица Пентакли – финансовите трудности и липсата. Успех, но все още има липса или трудности. Радост и притеснение.",
    "reading_description": "Успех, но все още има липса или трудности. Радост и притеснение.",
    "reading_advice": "Не позволявай на страха от липса да помрачи успеха. Ти си постигнал нещо – признай си го."
  },
  {
    "reading_id": "six_wands_six_pentacles",
    "reading_name": "Шестица Жезли + Шестица Пентакли",
    "reading_cards": "Шестица Жезли + Шестица Пентакли",
    "reading_combination": ["six_wands", "six_pentacles"],
    "reading_meaning": "Успех и щедрост",
    "second_meaning": "Шестица Жезли носи победата, а Шестица Пентакли – щедростта и даването. Успехът ви позволява да помагате на другите. Споделяйте щедро.",
    "reading_description": "Успехът ти позволява да помагаш на другите. Споделяй щедро.",
    "reading_advice": "Колкото повече даваш, толкова повече получаваш. Щедростта умножава успеха."
  },
  {
    "reading_id": "six_wands_seven_pentacles",
    "reading_name": "Шестица Жезли + Седмица Пентакли",
    "reading_cards": "Шестица Жезли + Седмица Пентакли",
    "reading_combination": ["six_wands", "seven_pentacles"],
    "reading_meaning": "Успех и търпение",
    "second_meaning": "Шестица Жезли носи победата, а Седмица Пентакли – търпението и чакането. Успехът идва, но истинските плодове ще дойдат по-късно. Търпение.",
    "reading_description": "Успехът идва, но истинските плодове ще дойдат по-късно. Търпение.",
    "reading_advice": "Чакай търпеливо. Най-доброто тепърва идва. Празнувай малките стъпки."
  },
  {
    "reading_id": "six_wands_eight_pentacles",
    "reading_name": "Шестица Жезли + Осмица Пентакли",
    "reading_cards": "Шестица Жезли + Осмица Пентакли",
    "reading_combination": ["six_wands", "eight_pentacles"],
    "reading_meaning": "Успех и майсторство",
    "second_meaning": "Шестица Жезли носи победата, а Осмица Пентакли – усърдието и ученето. Успехът идва, защото сте усъвършенствали занаята си. Майсторството се отплаща.",
    "reading_description": "Успехът идва, защото си усъвършенствал занаята си. Майсторството се отплаща.",
    "reading_advice": "Продължавай да учиш и да се развиваш. Майсторството няма край – то е път, не дестинация."
  },
  {
    "reading_id": "six_wands_nine_pentacles",
    "reading_name": "Шестица Жезли + Деветка Пентакли",
    "reading_cards": "Шестица Жезли + Деветка Пентакли",
    "reading_combination": ["six_wands", "nine_pentacles"],
    "reading_meaning": "Успех и независимост",
    "second_meaning": "Шестица Жезли носи победата, а Деветка Пентакли – самодостатъчността и успеха. Постигате финансова независимост и успех. Свобода и удовлетворение.",
    "reading_description": "Постигаш финансова независимост и успех. Свобода и удовлетворение.",
    "reading_advice": "Ти постигна независимост. Наслади се на свободата – ти я заслужи."
  },
  {
    "reading_id": "six_wands_ten_pentacles",
    "reading_name": "Шестица Жезли + Десетка Пентакли",
    "reading_cards": "Шестица Жезли + Десетка Пентакли",
    "reading_combination": ["six_wands", "ten_pentacles"],
    "reading_meaning": "Семеен успех",
    "second_meaning": "Шестица Жезли носи победата, а Десетка Пентакли – семейното наследство и богатство. Успех, който носи полза на цялото семейство. Наследство и традиция.",
    "reading_description": "Успех, който носи полза на цялото семейство. Наследство и традиция.",
    "reading_advice": "Гордей се с това, което си изградил. Твоят успех е успех на рода ти."
  },
  {
    "reading_id": "six_wands_page_pentacles",
    "reading_name": "Шестица Жезли + Паж Пентакли",
    "reading_cards": "Шестица Жезли + Паж Пентакли",
    "reading_combination": ["six_wands", "page_pentacles"],
    "reading_meaning": "Успех и ново начало",
    "second_meaning": "Шестица Жезли носи победата, а Паж Пентакли – новото начало в материалната сфера. След успеха идва нова възможност. Нов проект или начинание.",
    "reading_description": "След успеха идва нова възможност. Нов проект или начинание.",
    "reading_advice": "Хвани новата възможност. Тя носи следващата стъпка в твоето развитие."
  },
  {
    "reading_id": "six_wands_knight_pentacles",
    "reading_name": "Шестица Жезли + Рицар Пентакли",
    "reading_cards": "Шестица Жезли + Рицар Пентакли",
    "reading_combination": ["six_wands", "knight_pentacles"],
    "reading_meaning": "Бавна победа",
    "second_meaning": "Шестица Жезли носи победата, а Рицар Пентакли – бавния и сигурен напредък. Успехът идва бавно, но сигурно. Търпението се отплаща.",
    "reading_description": "Успехът идва бавно, но сигурно. Търпението се отплаща.",
    "reading_advice": "Не бързай. Сигурният път е бавен, но води до траен успех. Продължавай да работиш."
  },
  {
    "reading_id": "six_wands_queen_pentacles",
    "reading_name": "Шестица Жезли + Царица Пентакли",
    "reading_cards": "Шестица Жезли + Царица Пентакли",
    "reading_combination": ["six_wands", "queen_pentacles"],
    "reading_meaning": "Успех и грижа",
    "second_meaning": "Шестица Жезли носи победата, а Царица Пентакли – грижата и дома. Успехът ви позволява да се грижите по-добре за дома и семейството. Практична победа.",
    "reading_description": "Успехът ти позволява да се грижиш по-добре за дома и семейството. Практична победа.",
    "reading_advice": "Грижи се за дома и близките. Те са твоята основа. Сподели успеха с тях."
  },
  {
    "reading_id": "six_wands_king_pentacles",
    "reading_name": "Шестица Жезли + Цар Пентакли",
    "reading_cards": "Шестица Жезли + Цар Пентакли",
    "reading_combination": ["six_wands", "king_pentacles"],
    "reading_meaning": "Бизнес успех",
    "second_meaning": "Шестица Жезли носи победата, а Цар Пентакли – бизнес успеха и стабилността. Голям успех в бизнеса или финансите. Стабилност и признание.",
    "reading_description": "Голям успех в бизнеса или финансите. Стабилност и признание.",
    "reading_advice": "Наслади се на успеха. Ти си изградил нещо стабилно. Продължавай да градиш с мъдрост."
  },

  {
    "reading_id": "big_win",
    "reading_name": "Голяма печалба",
    "reading_cards": "Асо Пентакли + 10 Пентакли",
    "reading_combination": ["ace_pentacles", "ten_pentacles"],
    "reading_meaning": "Неочаквани пари",
    "reading_description": "Неочаквани пари, печалба от лотария, бонус.",
    "reading_advice": "Радвай се, но не харчи всичко наведнъж. Инвестирай разумно."
  },
  {
    "reading_id": "debt",
    "reading_name": "Дългове",
    "reading_cards": "5 Пентакли + 4 Пентакли",
    "reading_combination": ["five_pentacles", "four_pentacles"],
    "reading_meaning": "Финансови задължения",
    "reading_description": "Имаш задължения, дължиш пари, едва свързваш двата края.",
    "reading_advice": "Направи план. Приоритизирай. Малки стъпки – ще излезеш."
  },
  {
    "reading_id": "investment",
    "reading_name": "Дългосрочна инвестиция",
    "reading_cards": "7 Пентакли + 8 Пентакли",
    "reading_combination": ["seven_pentacles", "eight_pentacles"],
    "reading_meaning": "Инвестиция с изчакване",
    "reading_description": "Инвестираш в нещо, което ще даде резултати след време.",
    "reading_advice": "Търпение. Най-добрите плодове узряват бавно."
  },
  {
    "reading_id": "business_partner",
    "reading_name": "Бизнес партньорство",
    "reading_cards": "2 Пентакли + 3 Пентакли",
    "reading_combination": ["two_pentacles", "three_pentacles"],
    "reading_meaning": "Сътрудничество",
    "reading_description": "Работиш с партньор, споделяш печалбата.",
    "reading_advice": "Избери внимателно – доверието е всичко."
  },
  {
    "reading_id": "fraud",
    "reading_name": "Финансова измама",
    "reading_cards": "7 Мечове + 5 Пентакли",
    "reading_combination": ["seven_swords", "five_pentacles"],
    "reading_meaning": "Ограбване",
    "reading_description": "Някой те е ограбил или измамил с пари.",
    "reading_advice": "Потърси правата си. И урок: не вярвай сляпо."
  } ,
    {
    "reading_id": "knight_cups_king_pentacles",
    "reading_name": "Рицар Чаши + Цар Пентакли",
    "reading_cards": "Рицар Чаши + Цар Пентакли",
    "reading_combination": ["knight_cups", "king_pentacles"],
    "reading_meaning": "Романтика и стабилност",
    "second_meaning": "Рицар Чаши носи романтика и емоционални предложения, а Цар Пентакли – стабилност и сигурност. Комбинацията съчетава сърдечните импулси с практичността. Романтичен жест, който води до стабилна връзка или финансово обвързване.",
    "reading_description": "Романтично предложение или жест, който носи дългосрочна сигурност. Емоции и практичност заедно.",
    "reading_advice": "Следвай сърцето си, но не забравяй и главата. Най-добрите решения са тези, които съчетават любов и стабилност."
  },
  {
    "reading_id": "seven_swords_king_pentacles",
    "reading_name": "Седмица Мечове + Цар Пентакли",
    "reading_cards": "Седмица Мечове + Цар Пентакли",
    "reading_combination": ["seven_swords", "king_pentacles"],
    "reading_meaning": "Хитрост и сигурност",
    "second_meaning": "Седмица Мечове носи измама и хитрост, а Цар Пентакли – стабилност и сигурност. Внимавайте – някой може да се опита да заобиколи правилата, за да постигне финансова стабилност. Не всичко, което блести, е злато.",
    "reading_description": "Опит за измама или заобикаляне на правилата в името на печалбата. Проверявайте фактите.",
    "reading_advice": "Не вярвай сляпо. Провери два пъти всяка информация, особено когато става въпрос за пари."
  },
  {
    "reading_id": "knight_cups_seven_swords",
    "reading_name": "Рицар Чаши + Седмица Мечове",
    "reading_cards": "Рицар Чаши + Седмица Мечове",
    "reading_combination": ["knight_cups", "seven_swords"],
    "reading_meaning": "Романтична измама",
    "second_meaning": "Рицар Чаши носи романтични жестове, а Седмица Мечове – измама и хитрост. Внимавайте – някой може да се представя за нещо, което не е, за да спечели сърцето ви. Не всички рицари са искрени.",
    "reading_description": "Романтичен жест, който може да крие скрити намерения. Бъдете внимателни с новите запознанства.",
    "reading_advice": "Доверявай се, но проверявай. Истинската любов не се нуждае от маски и игри."
  },
  {
    "reading_id": "major_pair_hierophant_king_pentacles",
    "reading_name": "Йерофант + Цар Пентакли",
    "reading_cards": "Йерофант + Цар Пентакли",
    "reading_combination": ["hierophant", "king_pentacles"],
    "reading_meaning": "Традиция и богатство",
    "second_meaning": "Йерофант носи традицията, институциите и брака, а Цар Пентакли – стабилността и успеха. Заедно предвещават традиционен брак, семеен бизнес или наследство. Успех, който идва чрез следване на утвърдените пътища.",
    "reading_description": "Традиционен брак, семеен бизнес, наследство или успех чрез институциите.",
    "reading_advice": "Следвай традициите, но не позволявай те да те ограничават. Има мъдрост в това, което са изградили преди нас."
  },
  {
    "reading_id": "major_pair_hierophant_knight_cups",
    "reading_name": "Йерофант + Рицар Чаши",
    "reading_cards": "Йерофант + Рицар Чаши",
    "reading_combination": ["hierophant", "knight_cups"],
    "reading_meaning": "Традиционно ухажване",
    "second_meaning": "Йерофант носи традицията и институциите, а Рицар Чаши – романтиката и ухажването. Комбинацията предвещава традиционно ухажване, годеж или сватба. Любов, която следва установените ритуали и ценности.",
    "reading_description": "Традиционно ухажване, годеж или сватба. Любов, която следва установените пътища.",
    "reading_advice": "Позволи на любовта да следва естествения си ход. Традициите са създадени, за да пазят ценностите."
  },
  {
    "reading_id": "page_wands_four_swords",
    "reading_name": "Паж Жезли + Четворка Мечове",
    "reading_cards": "Паж Жезли + Четворка Мечове",
    "reading_combination": ["page_wands", "four_swords"],
    "reading_meaning": "Идея и почивка",
    "second_meaning": "Паж Жезли носи ентусиазъм и новини, а Четворка Мечове – почивка и възстановяване. Имате нова идея или вълнуваща новина, но сега не е моментът за действие. Първо починете и обмислете.",
    "reading_description": "Носиш нова идея, но сега е време за почивка и размисъл, не за действие.",
    "reading_advice": "Не бързай да действаш. Почини си и обмисли идеята – утре ще я видиш по-ясно."
  },
  {
    "reading_id": "nine_wands_nine_pentacles",
    "reading_name": "Деветка Жезли + Деветка Пентакли",
    "reading_cards": "Деветка Жезли + Деветка Пентакли",
    "reading_combination": ["nine_wands", "nine_pentacles"],
    "reading_meaning": "Упоритост и независимост",
    "second_meaning": "Деветка Жезли носи устойчивост и изтощение, а Деветка Пентакли – самодостатъчност и успех. Постигате успех, но цената беше висока. Чувствате се изтощени, но независими. Смесени чувства на гордост и умора.",
    "reading_description": "Постигаш успех след тежки усилия. Умора и независимост едновременно.",
    "reading_advice": "Почини си. Заслужил си този успех. Наслади се на независимостта, но не забравяй да се грижиш за себе си."
  },
  {
    "reading_id": "nine_cups_nine_pentacles",
    "reading_name": "Деветка Чаши + Деветка Пентакли",
    "reading_cards": "Деветка Чаши + Деветка Пентакли",
    "reading_combination": ["nine_cups", "nine_pentacles"],
    "reading_meaning": "Сбъдната мечта и успех",
    "second_meaning": "Деветка Чаши носи сбъднатото желание, а Деветка Пентакли – самодостатъчността и успеха. Две деветки заедно – пълно удовлетворение и независимост. Имате всичко, за което сте мечтали, и сте свободни да се наслаждавате.",
    "reading_description": "Сбъдване на мечта и пълна независимост. Удовлетворение и свобода.",
    "reading_advice": "Наслади се на момента. Ти постигна всичко, за което си мечтал. Бъди благодарен."
  },
  {
    "reading_id": "nine_swords_nine_pentacles",
    "reading_name": "Деветка Мечове + Деветка Пентакли",
    "reading_cards": "Деветка Мечове + Деветка Пентакли",
    "reading_combination": ["nine_swords", "nine_pentacles"],
    "reading_meaning": "Тревога и независимост",
    "second_meaning": "Деветка Мечове носи тревога и безсъние, а Деветка Пентакли – самодостатъчност и успех. Имате успех, но тревогите не ви оставят да се насладите. Страхът да не загубите постигнатото ви измъчва.",
    "reading_description": "Постигаш успех, но тревогите не те оставят. Страх да не загубиш.",
    "reading_advice": "Спокойствие. Успехът е твой – не се страхувай да го загубиш. Наслади му се."
  },
  {
    "reading_id": "nine_wands_nine_swords",
    "reading_name": "Деветка Жезли + Деветка Мечове",
    "reading_cards": "Деветка Жезли + Деветка Мечове",
    "reading_combination": ["nine_wands", "nine_swords"],
    "reading_meaning": "Изтощение и тревога",
    "second_meaning": "Деветка Жезли носи устойчивост и изтощение, а Деветка Мечове – тревога и безсъние. Умората и тревогата вървят ръка за ръка. Не можете да спите, защото се страхувате, а сте изтощени, защото не спите. Омагьосан кръг.",
    "reading_description": "Умора и тревога заедно. Не спиш, защото се страхуваш, и си изтощен, защото не спиш.",
    "reading_advice": "Спри за момент. Тревогите ти не са реалност. Потърси помощ, ако не можеш сам да се измъкнеш."
  },
  {
    "reading_id": "nine_cups_nine_swords",
    "reading_name": "Деветка Чаши + Деветка Мечове",
    "reading_cards": "Деветка Чаши + Деветка Мечове",
    "reading_combination": ["nine_cups", "nine_swords"],
    "reading_meaning": "Мечта и тревога",
    "second_meaning": "Деветка Чаши носи сбъднатото желание, а Деветка Мечове – тревога и безсъние. Постигате това, което искате, но не можете да се насладите. Страхът, че ще го загубите, ви измъчва. Радост и тревога заедно.",
    "reading_description": "Постигаш мечтата си, но тревогите не те оставят да се насладиш.",
    "reading_advice": "Позволи си да бъдеш щастлив. Страхът не ти служи. Наслади се на това, което си постигнал."
  },
    {
    "reading_id": "eight_wands_page_pentacles",
    "reading_name": "Осмица Жезли + Паж Пентакли",
    "reading_cards": "Осмица Жезли + Паж Пентакли",
    "reading_combination": ["eight_wands", "page_pentacles"],
    "reading_meaning": "Бърза възможност",
    "second_meaning": "Осмица Жезли носи бързина и движение, а Паж Пентакли – нова възможност и учене. Нова финансова или кариерна възможност идва неочаквано бързо. Трябва да действате светкавично, за да я хванете.",
    "reading_description": "Нова възможност идва бързо – трябва да действаш без колебание. Учене и растеж.",
    "reading_advice": "Хвани възможността, докато е гореща. Не се бави – бързината е твой съюзник."
  },
  {
    "reading_id": "nine_cups_page_pentacles",
    "reading_name": "Деветка Чаши + Паж Пентакли",
    "reading_cards": "Деветка Чаши + Паж Пентакли",
    "reading_combination": ["nine_cups", "page_pentacles"],
    "reading_meaning": "Мечта и нова възможност",
    "second_meaning": "Деветка Чаши носи сбъднатото желание, а Паж Пентакли – нова възможност и учене. След като сте постигнали една мечта, се отваря нова врата. Щастието води към нов растеж.",
    "reading_description": "След сбъдната мечта идва нова възможност. Радост и ново начало.",
    "reading_advice": "Не спирай да мечтаеш. Всяко постижение отваря врата към следващото. Хвани новата възможност."
  },
 
  {
    "reading_id": "two_wands_ace_cups",
    "reading_name": "Избор и любов",
    "reading_cards": "2 Жезли + Асо Чаши",
    "reading_combination": ["two_wands", "ace_cups"],
    "reading_meaning": "Избираш любовта",
    "reading_description": "Предстои ти избор, свързан с любов или нови чувства. Сърцето ще ти покаже пътя.",
    "reading_advice": "Избери това, което те кара да се чувстваш жив."
  },
  {
    "reading_id": "two_wands_three_cups",
    "reading_name": "Избор и празник",
    "reading_cards": "2 Жезли + 3 Чаши",
    "reading_combination": ["two_wands", "three_cups"],
    "reading_meaning": "Решението носи радост",
    "reading_description": "Изборът, който ще направиш, ще донесе радост и повод за празнуване.",
    "reading_advice": "Избери това, което те прави щастлив."
  },
  {
    "reading_id": "two_wands_four_cups",
    "reading_name": "Избор и неудовлетворение",
    "reading_cards": "2 Жезли + 4 Чаши",
    "reading_combination": ["two_wands", "four_cups"],
    "reading_meaning": "Решението не те радва",
    "reading_description": "Изправен си пред избор, но никоя от опциите не те удовлетворява напълно.",
    "reading_advice": "Понякога липсата на избор е най-добрият избор."
  },
  {
    "reading_id": "two_wands_five_cups",
    "reading_name": "Труден избор",
    "reading_cards": "2 Жезли + 5 Чаши",
    "reading_combination": ["two_wands", "five_cups"],
    "reading_meaning": "Избор, който носи тъга",
    "reading_description": "Изборът, пред който си изправен, ще донесе загуба или тъга, независимо какво избереш.",
    "reading_advice": "Избери това, което носи по-малко болка."
  },
  {
    "reading_id": "two_wands_six_cups",
    "reading_name": "Избор от миналото",
    "reading_cards": "2 Жезли + 6 Чаши",
    "reading_combination": ["two_wands", "six_cups"],
    "reading_meaning": "Решение, свързано с минало",
    "reading_description": "Избор, който те връща към миналото или към стари спомени. Носталгия и решение.",
    "reading_advice": "Миналото е учител, не водач."
  },
  {
    "reading_id": "two_wands_seven_cups",
    "reading_name": "Избор сред илюзии",
    "reading_cards": "2 Жезли + 7 Чаши",
    "reading_combination": ["two_wands", "seven_cups"],
    "reading_meaning": "Трудно е да избереш",
    "reading_description": "Много възможности, но повечето са илюзорни. Трудно различаваш истината от фантазията.",
    "reading_advice": "Свали розовите очила, преди да избереш."
  },
  {
    "reading_id": "two_wands_eight_cups",
    "reading_name": "Избор и тръгване",
    "reading_cards": "2 Жезли + 8 Чаши",
    "reading_combination": ["two_wands", "eight_cups"],
    "reading_meaning": "Решението те кара да тръгнеш",
    "reading_description": "Изборът, който правиш, ще те отведе на ново място, далеч от познатото.",
    "reading_advice": "Тръгни с увереност. Новият път те очаква."
  },
  {
    "reading_id": "two_wands_nine_cups",
    "reading_name": "Желан избор",
    "reading_cards": "2 Жезли + 9 Чаши",
    "reading_combination": ["two_wands", "nine_cups"],
    "reading_meaning": "Избираш мечтата си",
    "reading_description": "Изправен си пред избор, който ще ти помогне да сбъднеш мечтата си. Избери смело.",
    "reading_advice": "Мечтите заслужават да бъдат избрани."
  },
  {
    "reading_id": "two_wands_ten_cups",
    "reading_name": "Семеен избор",
    "reading_cards": "2 Жезли + 10 Чаши",
    "reading_combination": ["two_wands", "ten_cups"],
    "reading_meaning": "Решение за семейството",
    "reading_description": "Избор, който засяга цялото семейство. Вземи го с мисъл за всички.",
    "reading_advice": "Семейството е най-важното. Съветвай се с тях."
  },
  {
    "reading_id": "three_wands_ace_cups",
    "reading_name": "Очакване на любов",
    "reading_cards": "3 Жезли + Асо Чаши",
    "reading_combination": ["three_wands", "ace_cups"],
    "reading_meaning": "Чакаш нова любов",
    "reading_description": "Очакваш нова любов или нови чувства да се появят на хоризонта. Търпение.",
    "reading_advice": "Любовта идва, когато не я чакаш."
  },
  {
    "reading_id": "three_wands_three_cups",
    "reading_name": "Очакване на празник",
    "reading_cards": "3 Жезли + 3 Чаши",
    "reading_combination": ["three_wands", "three_cups"],
    "reading_meaning": "Чакаш повод за радост",
    "reading_description": "Очакваш събитие или повод за празнуване. Скоро ще имаш причина да се радваш.",
    "reading_advice": "Подготвяй се за празника."
  },
  {
    "reading_id": "three_wands_five_cups",
    "reading_name": "Очакване на тъга",
    "reading_cards": "3 Жезли + 5 Чаши",
    "reading_combination": ["three_wands", "five_cups"],
    "reading_meaning": "Чакаш загуба",
    "reading_description": "Усещаш, че предстои загуба или разочарование. Страх и несигурност в очакването.",
    "reading_advice": "Каквото дойде, приеми го. Ще се справиш."
  },
  {
    "reading_id": "three_wands_six_cups",
    "reading_name": "Носталгично очакване",
    "reading_cards": "3 Жезли + 6 Чаши",
    "reading_combination": ["three_wands", "six_cups"],
    "reading_meaning": "Чакаш завръщане от миналото",
    "reading_description": "Очакваш някой от миналото да се появи или нещо старо да се завърне.",
    "reading_advice": "Бъди готов да посрещнеш миналото, но не спирай да живееш в настоящето."
  },
  {
    "reading_id": "three_wands_seven_cups",
    "reading_name": "Очакване сред илюзии",
    "reading_cards": "3 Жезли + 7 Чаши",
    "reading_combination": ["three_wands", "seven_cups"],
    "reading_meaning": "Чакаш нещо нереално",
    "reading_description": "Очакваш нещо, което вероятно е илюзия или фантазия. Реалността ще е различна.",
    "reading_advice": "Слез на земята. Това, което очакваш, може да не е истина."
  },
  {
    "reading_id": "three_wands_eight_cups",
    "reading_name": "Очакване на тръгване",
    "reading_cards": "3 Жезли + 8 Чаши",
    "reading_combination": ["three_wands", "eight_cups"],
    "reading_meaning": "Чакаш да тръгнеш",
    "reading_description": "Очакваш момента да напуснеш и да започнеш нов път. Подготовка за заминаване.",
    "reading_advice": "Готов ли си за път? Скоро ще тръгнеш."
  },
  {
    "reading_id": "three_wands_nine_cups",
    "reading_name": "Очакване на мечта",
    "reading_cards": "3 Жезли + 9 Чаши",
    "reading_combination": ["three_wands", "nine_cups"],
    "reading_meaning": "Чакаш мечтата да се сбъдне",
    "reading_description": "Очакваш с нетърпение сбъдването на дългогодишна мечта. Скоро ще се случи.",
    "reading_advice": "Търпение. Мечтите се сбъдват, когато е време."
  },
  {
    "reading_id": "three_wands_ten_cups",
    "reading_name": "Семейно очакване",
    "reading_cards": "3 Жезли + 10 Чаши",
    "reading_combination": ["three_wands", "ten_cups"],
    "reading_meaning": "Чакаш семейно събитие",
    "reading_description": "Очакваш семейно събитие - сватба, раждане, събиране. Радостно очакване.",
    "reading_advice": "Семейството те очаква. Бъди там."
  },
  {
    "reading_id": "four_wands_ace_cups",
    "reading_name": "Празник на любовта",
    "reading_cards": "4 Жезли + Асо Чаши",
    "reading_combination": ["four_wands", "ace_cups"],
    "reading_meaning": "Празнуваш нова любов",
    "reading_description": "Празнуваш нова любов или нови чувства. Щастие и радост.",
    "reading_advice": "Празнувай любовта с пълно сърце."
  },
  {
    "reading_id": "four_wands_two_cups",
    "reading_name": "Сватбен празник",
    "reading_cards": "4 Жезли + 2 Чаши",
    "reading_combination": ["four_wands", "two_cups"],
    "reading_meaning": "Празнуваш връзка",
    "reading_description": "Празнуваш любовна връзка - сватба, годеж, годишнина. Радост и щастие.",
    "reading_advice": "Любовта заслужава да бъде празнувана."
  },
  {
    "reading_id": "four_wands_five_cups",
    "reading_name": "Празник през сълзи",
    "reading_cards": "4 Жезли + 5 Чаши",
    "reading_combination": ["four_wands", "five_cups"],
    "reading_meaning": "Радост, помрачена от тъга",
    "reading_description": "Празнуваш, но в сърцето ти има тъга. Смесени чувства на радост и болка.",
    "reading_advice": "Позволи си да чувстваш и двете. Нормално е."
  },
  {
    "reading_id": "four_wands_six_cups",
    "reading_name": "Празник със стари приятели",
    "reading_cards": "4 Жезли + 6 Чаши",
    "reading_combination": ["four_wands", "six_cups"],
    "reading_meaning": "Събиране на стари приятели",
    "reading_description": "Празник, на който се събират стари приятели или семейство. Носталгия и радост.",
    "reading_advice": "Цени тези моменти. Те са безценни."
  },
  {
    "reading_id": "four_wands_seven_cups",
    "reading_name": "Илюзорен празник",
    "reading_cards": "4 Жезли + 7 Чаши",
    "reading_combination": ["four_wands", "seven_cups"],
    "reading_meaning": "Празник, който не е реален",
    "reading_description": "Празнуваш нещо, което може да е илюзия. Радост, която може да е временна.",
    "reading_advice": "Провери дали това, което празнуваш, е реално."
  },
  {
    "reading_id": "four_wands_eight_cups",
    "reading_name": "Празник и раздяла",
    "reading_cards": "4 Жезли + 8 Чаши",
    "reading_combination": ["four_wands", "eight_cups"],
    "reading_meaning": "Празнуваш и после тръгваш",
    "reading_description": "Празнуваш нещо, но знаеш, че скоро ще напуснеш. Тъжна радост.",
    "reading_advice": "Наслади се на момента. Той няма да се повтори."
  },
  {
    "reading_id": "four_wands_nine_cups",
    "reading_name": "Празник на мечтите",
    "reading_cards": "4 Жезли + 9 Чаши",
    "reading_combination": ["four_wands", "nine_cups"],
    "reading_meaning": "Празнуваш сбъдната мечта",
    "reading_description": "Празнуваш сбъдването на дългогодишна мечта. Щастие и удовлетворение.",
    "reading_advice": "Ти го постигна. Наслади се на момента."
  },
  {
    "reading_id": "four_wands_ten_cups",
    "reading_name": "Семеен празник",
    "reading_cards": "4 Жезли + 10 Чаши",
    "reading_combination": ["four_wands", "ten_cups"],
    "reading_meaning": "Празник със семейството",
    "reading_description": "Празник, на който цялото семейство е заедно. Щастие и хармония.",
    "reading_advice": "Семейството е най-големият празник."
  },
  {
    "reading_id": "five_wands_ace_cups",
    "reading_name": "Борба за любов",
    "reading_cards": "5 Жезли + Асо Чаши",
    "reading_combination": ["five_wands", "ace_cups"],
    "reading_meaning": "Бориш се за нова любов",
    "reading_description": "Трябва да се бориш за новата любов или чувства. Не всичко идва лесно.",
    "reading_advice": "Бори се, ако наистина я искаш."
  },
  {
    "reading_id": "five_wands_two_cups",
    "reading_name": "Конфликт в любовта",
    "reading_cards": "5 Жезли + 2 Чаши",
    "reading_combination": ["five_wands", "two_cups"],
    "reading_meaning": "Спорове с любимия",
    "reading_description": "Конфликти и спорове в любовната връзка. Борба за надмощие.",
    "reading_advice": "В любовта няма победители. Търсете разбирателство."
  },
  {
    "reading_id": "five_wands_three_cups",
    "reading_name": "Конфликт на празник",
    "reading_cards": "5 Жезли + 3 Чаши",
    "reading_combination": ["five_wands", "three_cups"],
    "reading_meaning": "Спорове по време на празник",
    "reading_description": "Конфликт или спор, който помрачава празнично настроение. Напрежение сред радост.",
    "reading_advice": "Не позволявай на споровете да развалят празника ти."
  },
  {
    "reading_id": "five_wands_four_cups",
    "reading_name": "Борба с неудовлетворение",
    "reading_cards": "5 Жезли + 4 Чаши",
    "reading_combination": ["five_wands", "four_cups"],
    "reading_meaning": "Бориш се с апатия",
    "reading_description": "Бориш се с чувство на неудовлетворение и апатия. Трудно намираш мотивация.",
    "reading_advice": "Понякога трябва да спреш да се бориш и да си починеш."
  },
  {
    "reading_id": "five_wands_six_cups",
    "reading_name": "Конфликт от миналото",
    "reading_cards": "5 Жезли + 6 Чаши",
    "reading_combination": ["five_wands", "six_cups"],
    "reading_meaning": "Стар конфликт излиза",
    "reading_description": "Конфликт, който идва от миналото, излиза отново на повърхността. Стари сметки.",
    "reading_advice": "Остави миналото. То не заслужава нова битка."
  },
  {
    "reading_id": "five_wands_seven_cups",
    "reading_name": "Борба с илюзии",
    "reading_cards": "5 Жезли + 7 Чаши",
    "reading_combination": ["five_wands", "seven_cups"],
    "reading_meaning": "Бориш се с нереални неща",
    "reading_description": "Бориш се с илюзии или страхове, които съществуват само в главата ти.",
    "reading_advice": "Най-големите битки са в ума ни. Освободи се."
  },
  {
    "reading_id": "five_wands_eight_cups",
    "reading_name": "Конфликт и тръгване",
    "reading_cards": "5 Жезли + 8 Чаши",
    "reading_combination": ["five_wands", "eight_cups"],
    "reading_meaning": "Битката те кара да тръгнеш",
    "reading_description": "Конфликтът е толкова голям, че те кара да напуснеш и да тръгнеш на път.",
    "reading_advice": "Понякога тръгването е най-доброто решение."
  },
  {
    "reading_id": "five_wands_nine_cups",
    "reading_name": "Борба за мечта",
    "reading_cards": "5 Жезли + 9 Чаши",
    "reading_combination": ["five_wands", "nine_cups"],
    "reading_meaning": "Бориш се за желанието си",
    "reading_description": "Бориш се за това, което искаш. Мечтата си заслужава битката.",
    "reading_advice": "Бори се, но не губи себе си в битката."
  },
  {
    "reading_id": "five_wands_ten_cups",
    "reading_name": "Семеен конфликт",
    "reading_cards": "5 Жезли + 10 Чаши",
    "reading_combination": ["five_wands", "ten_cups"],
    "reading_meaning": "Кавги в семейството",
    "reading_description": "Конфликти и спорове в семейството. Напрежение, което разваля хармонията.",
    "reading_advice": "Семейството е по-важно от правотата. Потърси мир."
  },
  {
    "reading_id": "six_wands_ace_cups",
    "reading_name": "Успех в любовта",
    "reading_cards": "6 Жезли + Асо Чаши",
    "reading_combination": ["six_wands", "ace_cups"],
    "reading_meaning": "Победа за сърцето",
    "reading_description": "Успех в любовта или новите чувства. Победа, която носи радост.",
    "reading_advice": "Радвай се на успеха. Ти го заслужи."
  },
  {
    "reading_id": "six_wands_two_cups",
    "reading_name": "Победа в любовта",
    "reading_cards": "6 Жезли + 2 Чаши",
    "reading_combination": ["six_wands", "two_cups"],
    "reading_meaning": "Връзката тържествува",
    "reading_description": "Любовната връзка тържествува и получава признание. Щастие и гордост.",
    "reading_advice": "Празнувайте любовта си заедно."
  },
  {
    "reading_id": "six_wands_three_cups",
    "reading_name": "Успешен празник",
    "reading_cards": "6 Жезли + 3 Чаши",
    "reading_combination": ["six_wands", "three_cups"],
    "reading_meaning": "Празнуваш успех",
    "reading_description": "Празнуваш успех с приятели и близки. Радост и споделено щастие.",
    "reading_advice": "Сподели успеха си. Той става по-голям."
  },
  {
    "reading_id": "six_wands_four_cups",
    "reading_name": "Успех, който не радва",
    "reading_cards": "6 Жезли + 4 Чаши",
    "reading_combination": ["six_wands", "four_cups"],
    "reading_meaning": "Победа без радост",
    "reading_description": "Постигаш успех, но не усещаш радост. Нещо липсва или си прегорял.",
    "reading_advice": "Попитай се какво наистина искаш."
  },
  {
    "reading_id": "six_wands_five_cups",
    "reading_name": "Победа със загуба",
    "reading_cards": "6 Жезли + 5 Чаши",
    "reading_combination": ["six_wands", "five_cups"],
    "reading_meaning": "Успех, но с цена",
    "reading_description": "Постигаш успех, но губиш нещо важно по пътя. Смесени чувства.",
    "reading_advice": "Понякога победата не си струва цената."
  },
  {
    "reading_id": "six_wands_six_cups",
    "reading_name": "Успех от миналото",
    "reading_cards": "6 Жезли + 6 Чаши",
    "reading_combination": ["six_wands", "six_cups"],
    "reading_meaning": "Признание за старо",
    "reading_description": "Получаваш признание за нещо, което си направил в миналото. Закъснял успех.",
    "reading_advice": "По-добре късно, отколкото никога."
  },
  {
    "reading_id": "six_wands_seven_cups",
    "reading_name": "Илюзорен успех",
    "reading_cards": "6 Жезли + 7 Чаши",
    "reading_combination": ["six_wands", "seven_cups"],
    "reading_meaning": "Успех, който не е реален",
    "reading_description": "Мислиш, че си успял, но може да е илюзия. Провери реалността.",
    "reading_advice": "Не се залъгвай. Истинският успех е реален."
  },
  {
    "reading_id": "six_wands_eight_cups",
    "reading_name": "Победа и тръгване",
    "reading_cards": "6 Жезли + 8 Чаши",
    "reading_combination": ["six_wands", "eight_cups"],
    "reading_meaning": "Успех и после заминаване",
    "reading_description": "Постигаш успех, но веднага след това трябва да тръгнеш. Няма време за празнуване.",
    "reading_advice": "Празнувай в движение, ако трябва."
  },
  {
    "reading_id": "six_wands_nine_cups",
    "reading_name": "Сбъднат успех",
    "reading_cards": "6 Жезли + 9 Чаши",
    "reading_combination": ["six_wands", "nine_cups"],
    "reading_meaning": "Успехът е мечта",
    "reading_description": "Постигаш точно това, за което си мечтал. Удовлетворение и радост.",
    "reading_advice": "Наслади се на момента. Ти го заслужи."
  },
  {
    "reading_id": "six_wands_ten_cups",
    "reading_name": "Семеен успех",
    "reading_cards": "6 Жезли + 10 Чаши",
    "reading_combination": ["six_wands", "ten_cups"],
    "reading_meaning": "Успех за семейството",
    "reading_description": "Успех, който носи щастие на цялото семейство. Споделена радост.",
    "reading_advice": "Семейството ти се гордее с теб."
  },
  {
    "reading_id": "seven_wands_ace_cups",
    "reading_name": "Защитаваш любовта",
    "reading_cards": "7 Жезли + Асо Чаши",
    "reading_combination": ["seven_wands", "ace_cups"],
    "reading_meaning": "Пазиш новите чувства",
    "reading_description": "Защитаваш новата любов или чувства от външни заплахи. Дръж позиция.",
    "reading_advice": "Защитавай това, което обичаш."
  },
  {
    "reading_id": "seven_wands_two_cups",
    "reading_name": "Защитаваш връзката",
    "reading_cards": "7 Жезли + 2 Чаши",
    "reading_combination": ["seven_wands", "two_cups"],
    "reading_meaning": "Пазиш любовта си",
    "reading_description": "Защитаваш връзката си от външни заплахи или клюки. Дръж се.",
    "reading_advice": "Истинската любов издържа на всичко."
  },
  {
    "reading_id": "seven_wands_three_cups",
    "reading_name": "Защитаваш радостта",
    "reading_cards": "7 Жезли + 3 Чаши",
    "reading_combination": ["seven_wands", "three_cups"],
    "reading_meaning": "Пазиш щастието си",
    "reading_description": "Защитаваш правото си на радост и празник от хора, които искат да ти го отнемат.",
    "reading_advice": "Никой няма право да ти отнеме радостта."
  },
  {
    "reading_id": "seven_wands_four_cups",
    "reading_name": "Защитаваш се от апатия",
    "reading_cards": "7 Жезли + 4 Чаши",
    "reading_combination": ["seven_wands", "four_cups"],
    "reading_meaning": "Бориш се с безразличие",
    "reading_description": "Бориш се с чувство на апатия и безразличие, което идва към теб.",
    "reading_advice": "Не позволявай на скуката да те победи."
  },
  {
    "reading_id": "seven_wands_five_cups",
    "reading_name": "Защитаваш се от тъга",
    "reading_cards": "7 Жезли + 5 Чаши",
    "reading_combination": ["seven_wands", "five_cups"],
    "reading_meaning": "Бориш се с тъгата",
    "reading_description": "Опитваш се да се защитиш от нахлуваща тъга и разочарование. Трудна битка.",
    "reading_advice": "Понякога трябва да приемеш тъгата, за да я преодолееш."
  },
  {
    "reading_id": "seven_wands_six_cups",
    "reading_name": "Защитаваш миналото",
    "reading_cards": "7 Жезли + 6 Чаши",
    "reading_combination": ["seven_wands", "six_cups"],
    "reading_meaning": "Пазиш спомените си",
    "reading_description": "Защитаваш спомените и миналото си от хора, които искат да ги омаловажат.",
    "reading_advice": "Спомените са твои. Никой няма право да ти ги отнема."
  },
  {
    "reading_id": "seven_wands_seven_cups",
    "reading_name": "Защитаваш се от илюзии",
    "reading_cards": "7 Жезли + 7 Чаши",
    "reading_combination": ["seven_wands", "seven_cups"],
    "reading_meaning": "Бориш се с фантазии",
    "reading_description": "Опитваш се да се предпазиш от собствените си илюзии и фантазии.",
    "reading_advice": "Истината е най-добрата защита."
  },
  {
    "reading_id": "seven_wands_eight_cups",
    "reading_name": "Защитаваш се като тръгваш",
    "reading_cards": "7 Жезли + 8 Чаши",
    "reading_combination": ["seven_wands", "eight_cups"],
    "reading_meaning": "Бягаш, докато се защитаваш",
    "reading_description": "Защитаваш се, докато напускаш ситуацията. Едновременно битка и бягство.",
    "reading_advice": "Понякога най-добрата защита е да избягаш."
  },
  {
    "reading_id": "seven_wands_nine_cups",
    "reading_name": "Защитаваш мечтата",
    "reading_cards": "7 Жезли + 9 Чаши",
    "reading_combination": ["seven_wands", "nine_cups"],
    "reading_meaning": "Пазиш желанието си",
    "reading_description": "Защитаваш мечтата си от хора, които не вярват в нея. Не се предавай.",
    "reading_advice": "Мечтите ти заслужават да бъдат защитени."
  },
  {
    "reading_id": "seven_wands_ten_cups",
    "reading_name": "Защитаваш семейството",
    "reading_cards": "7 Жезли + 10 Чаши",
    "reading_combination": ["seven_wands", "ten_cups"],
    "reading_meaning": "Пазиш семейството си",
    "reading_description": "Защитаваш семейството и дома си от външни заплахи. Битка за семейството.",
    "reading_advice": "Семейството си заслужава всяка битка."
  },
  {
    "reading_id": "eight_wands_ace_cups",
    "reading_name": "Бърза любов",
    "reading_cards": "8 Жезли + Асо Чаши",
    "reading_combination": ["eight_wands", "ace_cups"],
    "reading_meaning": "Любов от пръв поглед",
    "reading_description": "Нова любов идва светкавично, без предупреждение. Сърцето ти бие бързо.",
    "reading_advice": "Наслаждавай се на момента, но не бързай."
  },
  {
    "reading_id": "eight_wands_two_cups",
    "reading_name": "Бърза връзка",
    "reading_cards": "8 Жезли + 2 Чаши",
    "reading_combination": ["eight_wands", "two_cups"],
    "reading_meaning": "Връзка, която се развива бързо",
    "reading_description": "Връзка, която се развива изключително бързо. От първа среща до обвързване за миг.",
    "reading_advice": "Наслаждавай се, но не изпускай контрол."
  },
  {
    "reading_id": "eight_wands_three_cups",
    "reading_name": "Бърз празник",
    "reading_cards": "8 Жезли + 3 Чаши",
    "reading_combination": ["eight_wands", "three_cups"],
    "reading_meaning": "Празник, който идва неочаквано",
    "reading_description": "Изненадващ празник или повод за радост, който идва светкавично.",
    "reading_advice": "Празнувай, докато можеш."
  },
  {
    "reading_id": "eight_wands_four_cups",
    "reading_name": "Бърза промяна на настроение",
    "reading_cards": "8 Жезли + 4 Чаши",
    "reading_combination": ["eight_wands", "four_cups"],
    "reading_meaning": "От скука към екшън",
    "reading_description": "Внезапен край на скуката и апатията. Нещо бързо раздвижва нещата.",
    "reading_advice": "Хвани вълната на промяната."
  },
  {
    "reading_id": "eight_wands_five_cups",
    "reading_name": "Бърза тъга",
    "reading_cards": "8 Жезли + 5 Чаши",
    "reading_combination": ["eight_wands", "five_cups"],
    "reading_meaning": "Тъга идва бързо",
    "reading_description": "Внезапна загуба или разочарование, което идва без предупреждение. Бърза болка.",
    "reading_advice": "Позволи си да скърбиш, но не оставай там."
  },
  {
    "reading_id": "eight_wands_six_cups",
    "reading_name": "Бърз спомен",
    "reading_cards": "8 Жезли + 6 Чаши",
    "reading_combination": ["eight_wands", "six_cups"],
    "reading_meaning": "Спомен идва внезапно",
    "reading_description": "Спомен от миналото идва внезапно и неочаквано. Носталгия, която връхлита.",
    "reading_advice": "Приеми спомена, после продължи напред."
  },
  {
    "reading_id": "eight_wands_seven_cups",
    "reading_name": "Бързи илюзии",
    "reading_cards": "8 Жезли + 7 Чаши",
    "reading_combination": ["eight_wands", "seven_cups"],
    "reading_meaning": "Илюзиите идват бързо",
    "reading_description": "Фантазии и илюзии, които те завладяват бързо. Внимавай да не изгубиш реалността.",
    "reading_advice": "Слез на земята, преди да е късно."
  },
  {
    "reading_id": "eight_wands_eight_cups",
    "reading_name": "Бързо тръгване",
    "reading_cards": "8 Жезли + 8 Чаши",
    "reading_combination": ["eight_wands", "eight_cups"],
    "reading_meaning": "Тръгваш светкавично",
    "reading_description": "Решаваш да тръгнеш и заминаваш веднага. Бързо решение, бързо действие.",
    "reading_advice": "Понякога най-добрите решения са бързите."
  },
  {
    "reading_id": "eight_wands_nine_cups",
    "reading_name": "Бързо сбъдване",
    "reading_cards": "8 Жезли + 9 Чаши",
    "reading_combination": ["eight_wands", "nine_cups"],
    "reading_meaning": "Мечтата се сбъдва бързо",
    "reading_description": "Това, за което си мечтал, се сбъдва неочаквано бързо. Радост и изненада.",
    "reading_advice": "Наслаждавай се на момента."
  },
  {
    "reading_id": "eight_wands_ten_cups",
    "reading_name": "Бързо семейно събитие",
    "reading_cards": "8 Жезли + 10 Чаши",
    "reading_combination": ["eight_wands", "ten_cups"],
    "reading_meaning": "Семейно събитие идва бързо",
    "reading_description": "Семейно събитие (сватба, раждане) се случва неочаквано бързо. Радост и изненада.",
    "reading_advice": "Прегърни бързата промяна."
  },
  {
    "reading_id": "nine_wands_ace_cups",
    "reading_name": "Последна защита за любов",
    "reading_cards": "9 Жезли + Асо Чаши",
    "reading_combination": ["nine_wands", "ace_cups"],
    "reading_meaning": "Изтощен, но защитаваш новото",
    "reading_description": "Изтощен си, но продължаваш да защитаваш новата любов или чувства. Упоритост.",
    "reading_advice": "Дръж се още малко. Скоро ще има мир."
  },
  {
    "reading_id": "nine_wands_two_cups",
    "reading_name": "Последна битка за връзката",
    "reading_cards": "9 Жезли + 2 Чаши",
    "reading_combination": ["nine_wands", "two_cups"],
    "reading_meaning": "Бориш се до края за любовта",
    "reading_description": "Бориш се за връзката си, въпреки че си изтощен. Последни сили.",
    "reading_advice": "Ако любовта си струва, бий се до край."
  },
  {
    "reading_id": "nine_wands_three_cups",
    "reading_name": "Уморен, но празнуваш",
    "reading_cards": "9 Жезли + 3 Чаши",
    "reading_combination": ["nine_wands", "three_cups"],
    "reading_meaning": "Празнуваш въпреки умората",
    "reading_description": "Изтощен си, но все пак намираш сили да се радваш и празнуваш.",
    "reading_advice": "Понякога радостта лекува умората."
  },
  {
    "reading_id": "nine_wands_four_cups",
    "reading_name": "Умора и скука",
    "reading_cards": "9 Жезли + 4 Чаши",
    "reading_combination": ["nine_wands", "four_cups"],
    "reading_meaning": "Изтощен и неудовлетворен",
    "reading_description": "Едновременно си изтощен от битки и неудовлетворен от резултата. Тежка комбинация.",
    "reading_advice": "Почини си и преосмисли приоритетите."
  },
  {
    "reading_id": "nine_wands_five_cups",
    "reading_name": "Умора и тъга",
    "reading_cards": "9 Жезли + 5 Чаши",
    "reading_combination": ["nine_wands", "five_cups"],
    "reading_meaning": "Изтощен и тъжен",
    "reading_description": "Умората от битките се смесва с тъга от загуби. Двойна тежест.",
    "reading_advice": "Позволи си да починеш и да скърбиш. После стани."
  },
  {
    "reading_id": "nine_wands_six_cups",
    "reading_name": "Уморен от спомени",
    "reading_cards": "9 Жезли + 6 Чаши",
    "reading_combination": ["nine_wands", "six_cups"],
    "reading_meaning": "Спомените те изтощават",
    "reading_description": "Носталгията и спомените те изтощават емоционално. Миналото тежи.",
    "reading_advice": "Остави миналото. То не заслужава енергията ти."
  },
  {
    "reading_id": "nine_wands_seven_cups",
    "reading_name": "Уморен от илюзии",
    "reading_cards": "9 Жезли + 7 Чаши",
    "reading_combination": ["nine_wands", "seven_cups"],
    "reading_meaning": "Фантазиите те изтощават",
    "reading_description": "Живеенето в илюзии те е изтощило. Време е да се сблъскаш с реалността.",
    "reading_advice": "Реалността може да е по-добра от фантазиите."
  },
  {
    "reading_id": "nine_wands_eight_cups",
    "reading_name": "Уморен тръгваш",
    "reading_cards": "9 Жезли + 8 Чаши",
    "reading_combination": ["nine_wands", "eight_cups"],
    "reading_meaning": "Изтощен и тръгваш",
    "reading_description": "Толкова си изтощен, че решаваш просто да тръгнеш и да оставиш всичко.",
    "reading_advice": "Понякога тръгването е единственият начин да си починеш."
  },
  {
    "reading_id": "nine_wands_nine_cups",
    "reading_name": "Умора и мечта",
    "reading_cards": "9 Жезли + 9 Чаши",
    "reading_combination": ["nine_wands", "nine_cups"],
    "reading_meaning": "Изтощен, но мечтаеш",
    "reading_description": "Въпреки изтощението, продължаваш да мечтаеш и да се надяваш. Упоритост.",
    "reading_advice": "Мечтите ти дават сила. Дръж се за тях."
  },
  {
    "reading_id": "nine_wands_ten_cups",
    "reading_name": "Умора и семейство",
    "reading_cards": "9 Жезли + 10 Чаши",
    "reading_combination": ["nine_wands", "ten_cups"],
    "reading_meaning": "Изтощен, но семейството те крепи",
    "reading_description": "Уморен си от битки, но семейството ти дава сили да продължиш. Опора.",
    "reading_advice": "Семейството е твоята сила. Цени го."
  },
  {
    "reading_id": "ten_wands_ace_cups",
    "reading_name": "Бреме и нова любов",
    "reading_cards": "10 Жезли + Асо Чаши",
    "reading_combination": ["ten_wands", "ace_cups"],
    "reading_meaning": "Носеш тежест и нови чувства",
    "reading_description": "Носиш тежко бреме, но нови чувства или любов се появяват. Светлина в мрака.",
    "reading_advice": "Новата любов може да облекчи бремето."
  },
  {
    "reading_id": "ten_wands_two_cups",
    "reading_name": "Тежест и любов",
    "reading_cards": "10 Жезли + 2 Чаши",
    "reading_combination": ["ten_wands", "two_cups"],
    "reading_meaning": "Носиш бреме във връзката",
    "reading_description": "Носиш тежестта на връзката или семейството. Любовта те крепи, но е трудно.",
    "reading_advice": "Сподели бремето с партньора си."
  },
  {
    "reading_id": "ten_wands_three_cups",
    "reading_name": "Тежест и празник",
    "reading_cards": "10 Жезли + 3 Чаши",
    "reading_combination": ["ten_wands", "three_cups"],
    "reading_meaning": "Празнуваш въпреки бремето",
    "reading_description": "Носиш тежко бреме, но все пак намираш сили да празнуваш и да се радваш.",
    "reading_advice": "Радостта лекува. Не спирай да празнуваш."
  },
  {
    "reading_id": "ten_wands_four_cups",
    "reading_name": "Бреме и неудовлетворение",
    "reading_cards": "10 Жезли + 4 Чаши",
    "reading_combination": ["ten_wands", "four_cups"],
    "reading_meaning": "Носиш тежест и си нещастен",
    "reading_description": "Носиш тежко бреме и не си доволен от живота. Двойна тежест.",
    "reading_advice": "Понякога трябва да пуснеш бремето, за да бъдеш щастлив."
  },
  {
    "reading_id": "ten_wands_five_cups",
    "reading_name": "Бреме и загуба",
    "reading_cards": "10 Жезли + 5 Чаши",
    "reading_combination": ["ten_wands", "five_cups"],
    "reading_meaning": "Тежест след загуба",
    "reading_description": "Носиш бремето на загубата. Тежък период на скръб и отговорности.",
    "reading_advice": "Позволи си да скърбиш, но не носи бремето сам."
  },
  {
    "reading_id": "ten_wands_six_cups",
    "reading_name": "Бреме и спомени",
    "reading_cards": "10 Жезли + 6 Чаши",
    "reading_combination": ["ten_wands", "six_cups"],
    "reading_meaning": "Носиш тежестта на миналото",
    "reading_description": "Носиш бремето на минали спомени и преживявания. Миналото тежи.",
    "reading_advice": "Остави миналото. То не трябва да тежи на раменете ти."
  },
  {
    "reading_id": "ten_wands_seven_cups",
    "reading_name": "Бреме и илюзии",
    "reading_cards": "10 Жезли + 7 Чаши",
    "reading_combination": ["ten_wands", "seven_cups"],
    "reading_meaning": "Тежест от фантазии",
    "reading_description": "Носиш бремето на нереалистични очаквания и илюзии. Освободи се.",
    "reading_advice": "Свали товара на нереалистичните мечти."
  },
  {
    "reading_id": "ten_wands_eight_cups",
    "reading_name": "Бреме и тръгване",
    "reading_cards": "10 Жезли + 8 Чаши",
    "reading_combination": ["ten_wands", "eight_cups"],
    "reading_meaning": "Носиш тежест и тръгваш",
    "reading_description": "Носиш тежко бреме, но решаваш да тръгнеш и да оставиш всичко. Освобождение.",
    "reading_advice": "Тръгни леко. Бремето остава зад теб."
  },
  {
    "reading_id": "ten_wands_nine_cups",
    "reading_name": "Бреме и мечта",
    "reading_cards": "10 Жезли + 9 Чаши",
    "reading_combination": ["ten_wands", "nine_cups"],
    "reading_meaning": "Носиш тежест, но имаш мечта",
    "reading_description": "Въпреки тежкото бреме, продължаваш да мечтаеш за по-добро. Надежда.",
    "reading_advice": "Мечтата ти е светлина в тунела. Дръж се за нея."
  },
  {
    "reading_id": "ten_wands_ten_cups",
    "reading_name": "Бреме и семейство",
    "reading_cards": "10 Жезли + 10 Чаши",
    "reading_combination": ["ten_wands", "ten_cups"],
    "reading_meaning": "Носиш тежестта на семейството",
    "reading_description": "Носиш тежкото бреме на семейните отговорности. Любов и тежест заедно.",
    "reading_advice": "Семейството си заслужава бремето. Но не го носи сам."
  },
  {
    "reading_id": "ace_cups_two_swords",
    "reading_name": "Любов и съмнение",
    "reading_cards": "Асо Чаши + 2 Мечове",
    "reading_combination": ["ace_cups", "two_swords"],
    "reading_meaning": "Нови чувства, но съмнения",
    "reading_description": "Нови чувства или любов се появяват, но ги съпътстват съмнения и нерешителност.",
    "reading_advice": "Сърцето знае повече от ума. Довери му се."
  },
  {
    "reading_id": "ace_cups_three_swords",
    "reading_name": "Любов и болка",
    "reading_cards": "Асо Чаши + 3 Мечове",
    "reading_combination": ["ace_cups", "three_swords"],
    "reading_meaning": "Нова любов носи болка",
    "reading_description": "Нова любов или чувства идват с болка и разочарование. Любов и страдание.",
    "reading_advice": "Не всяка любов носи само радост. Понякога боли."
  },
  {
    "reading_id": "ace_cups_four_swords",
    "reading_name": "Любов и почивка",
    "reading_cards": "Асо Чаши + 4 Мечове",
    "reading_combination": ["ace_cups", "four_swords"],
    "reading_meaning": "Нови чувства в покой",
    "reading_description": "Нови чувства или любов се появяват в период на почивка и спокойствие.",
    "reading_advice": "Наслади се на любовта в тишина."
  },
  {
    "reading_id": "ace_cups_five_swords",
    "reading_name": "Любов и победа",
    "reading_cards": "Асо Чаши + 5 Мечове",
    "reading_combination": ["ace_cups", "five_swords"],
    "reading_meaning": "Печелиш любов",
    "reading_description": "Печелиш любов или сърце, но с цената на нечия загуба. Пирова победа.",
    "reading_advice": "Понякога да спечелиш сърце означава да загубиш нещо друго."
  },
  {
    "reading_id": "ace_cups_six_swords",
    "reading_name": "Любов и път",
    "reading_cards": "Асо Чаши + 6 Мечове",
    "reading_combination": ["ace_cups", "six_swords"],
    "reading_meaning": "Любов по време на път",
    "reading_description": "Нова любов или чувства се появяват по време на пътуване или преместване.",
    "reading_advice": "Любовта може да те последва навсякъде."
  },
  {
    "reading_id": "ace_cups_seven_swords",
    "reading_name": "Любов и измама",
    "reading_cards": "Асо Чаши + 7 Мечове",
    "reading_combination": ["ace_cups", "seven_swords"],
    "reading_meaning": "Нови чувства, но скрити",
    "reading_description": "Нова любов, която е скрита или има тайни. Внимавай с доверието.",
    "reading_advice": "Любовта не трябва да се крие. Ако е скрита, нещо не е наред."
  },
  {
    "reading_id": "ace_cups_eight_swords",
    "reading_name": "Любов в капан",
    "reading_cards": "Асо Чаши + 8 Мечове",
    "reading_combination": ["ace_cups", "eight_swords"],
    "reading_meaning": "Чувства, които те ограничават",
    "reading_description": "Нови чувства, които те карат да се чувстваш в капан или ограничен.",
    "reading_advice": "Любовта трябва да освобождава, не да заробва."
  },
  {
    "reading_id": "ace_cups_nine_swords",
    "reading_name": "Любов и тревога",
    "reading_cards": "Асо Чаши + 9 Мечове",
    "reading_combination": ["ace_cups", "nine_swords"],
    "reading_meaning": "Нови чувства, които тревожат",
    "reading_description": "Нова любов, която носи не само радост, но и тревоги и безсъние.",
    "reading_advice": "Любовта не трябва да те лишава от сън. Преосмисли."
  },
  {
    "reading_id": "ace_cups_ten_swords",
    "reading_name": "Любов и край",
    "reading_cards": "Асо Чаши + 10 Мечове",
    "reading_combination": ["ace_cups", "ten_swords"],
    "reading_meaning": "Нови чувства след край",
    "reading_description": "Нова любов се появява след тежък край или загуба. Феникс от пепелта.",
    "reading_advice": "След края идва ново начало. Отвори сърцето си."
  },
  {
    "reading_id": "two_cups_two_swords",
    "reading_name": "Връзка и съмнение",
    "reading_cards": "2 Чаши + 2 Мечове",
    "reading_combination": ["two_cups", "two_swords"],
    "reading_meaning": "Любов със съмнения",
    "reading_description": "Връзка, в която има много любов, но и много съмнения. Нерешителност.",
    "reading_advice": "Понякога трябва да спреш да мислиш и просто да чувстваш."
  },
  {
    "reading_id": "two_cups_three_swords",
    "reading_name": "Любов и болка",
    "reading_cards": "2 Чаши + 3 Мечове",
    "reading_combination": ["two_cups", "three_swords"],
    "reading_meaning": "Връзка, която боли",
    "reading_description": "Любовна връзка, която носи повече болка, отколкото радост. Страдание.",
    "reading_advice": "Любовта не трябва да боли толкова. Преосмисли."
  },
  {
    "reading_id": "two_cups_four_swords",
    "reading_name": "Любов и почивка",
    "reading_cards": "2 Чаши + 4 Мечове",
    "reading_combination": ["two_cups", "four_swords"],
    "reading_meaning": "Спокойна любов",
    "reading_description": "Връзка, в която има мир и спокойствие. Любов без драма.",
    "reading_advice": "Цени спокойната любов. Тя е рядка."
  },
  {
    "reading_id": "two_cups_five_swords",
    "reading_name": "Любов и победа",
    "reading_cards": "2 Чаши + 5 Мечове",
    "reading_combination": ["two_cups", "five_swords"],
    "reading_meaning": "Връзка, която побеждава",
    "reading_description": "Връзка, която преодолява конфликти и излиза победител. Силна любов.",
    "reading_advice": "Заедно сте по-силни от всяка битка."
  },
  {
    "reading_id": "two_cups_six_swords",
    "reading_name": "Любов и път",
    "reading_cards": "2 Чаши + 6 Мечове",
    "reading_combination": ["two_cups", "six_swords"],
    "reading_meaning": "Връзка по време на път",
    "reading_description": "Връзка, която се развива по време на пътуване или преместване. Любов в движение.",
    "reading_advice": "Пътувайте заедно. Това ще ви сближи."
  },
  {
    "reading_id": "two_cups_seven_swords",
    "reading_name": "Любов и измама",
    "reading_cards": "2 Чаши + 7 Мечове",
    "reading_combination": ["two_cups", "seven_swords"],
    "reading_meaning": "Връзка с тайни",
    "reading_description": "Връзка, в която има тайни или измами. Някой не е честен.",
    "reading_advice": "Истината е единственият път към истинска любов."
  },
  {
    "reading_id": "two_cups_eight_swords",
    "reading_name": "Любов в капан",
    "reading_cards": "2 Чаши + 8 Мечове",
    "reading_combination": ["two_cups", "eight_swords"],
    "reading_meaning": "Връзка, която те ограничава",
    "reading_description": "Връзка, в която се чувстваш в капан или ограничен. Нямаш свобода.",
    "reading_advice": "Любовта трябва да освобождава. Ако те заробва, не е любов."
  },
  {
    "reading_id": "two_cups_nine_swords",
    "reading_name": "Любов и тревога",
    "reading_cards": "2 Чаши + 9 Мечове",
    "reading_combination": ["two_cups", "nine_swords"],
    "reading_meaning": "Връзка, която тревожи",
    "reading_description": "Връзка, която носи повече тревоги, отколкото радост. Безсъние и притеснения.",
    "reading_advice": "Любовта не трябва да те лишава от сън."
  },
  {
    "reading_id": "two_cups_ten_swords",
    "reading_name": "Край на любовта",
    "reading_cards": "2 Чаши + 10 Мечове",
    "reading_combination": ["two_cups", "ten_swords"],
    "reading_meaning": "Връзката приключва",
    "reading_description": "Любовна връзка стига до своя край. Болка и раздяла.",
    "reading_advice": "Краят е ново начало. Позволи си да скърбиш, после продължи."
  },
  {
    "reading_id": "three_cups_two_swords",
    "reading_name": "Празник и съмнение",
    "reading_cards": "3 Чаши + 2 Мечове",
    "reading_combination": ["three_cups", "two_swords"],
    "reading_meaning": "Радост със съмнения",
    "reading_description": "Празнуваш, но в сърцето ти има съмнения. Радост и несигурност.",
    "reading_advice": "Не позволявай на съмненията да развалят празника ти."
  },
  
  {
    "reading_id": "fated_love",
    "reading_name": "Съдбовна любов",
    "reading_cards": "Влюбените + 2 Чаши + Асо Чаши",
    "reading_combination": ["lovers", "two_cups", "ace_cups"],
    "reading_meaning": "Предопределена връзка",
    "reading_description": "Това не е просто връзка – това е среща, писана в звездите. Двама души, които са предназначени един за друг.",
    "reading_advice": "Не се страхувай да скочиш – съдбата ти подава ръка."
  },
 
 
  {
    "reading_id": "toxic_relationship",
    "reading_name": "Токсична връзка",
    "reading_cards": "Дявол + 7 Мечове + 3 Мечове",
    "reading_combination": ["devil", "seven_swords", "three_swords"],
    "reading_meaning": "Зависимост и лъжи",
    "reading_description": "Връзка, основана на зависимост, лъжи и изтощение. Единият (или и двамата) е в плен на илюзията.",
    "reading_advice": "Време е да разпознаеш веригите и да ги свалиш. Самотата е по-добра от ада за двама."
  },
 
  {
    "reading_id": "ex_back_happy",
    "reading_name": "Щастливо завръщане",
    "reading_cards": "6 Чаши + 2 Чаши + Слънце",
    "reading_combination": ["six_cups", "two_cups", "sun"],
    "reading_meaning": "Щастливо завръщане на бивш",
    "reading_description": "Бивш партньор се връща в живота ти, но този път нещата изглеждат по-различно. Истинско щастие.",
    "reading_advice": "Дай шанс – хората се променят, времето лекува."
  },
  {
    "reading_id": "pregnancy",
    "reading_name": "Бременност",
    "reading_cards": "Императрица + 3 Чаши + Слънце",
    "reading_combination": ["empress", "three_cups", "sun"],
    "reading_meaning": "Нов живот",
    "reading_description": "Раждане на дете, нов член в семейството. Нов живот идва.",
    "reading_advice": "Нов живот идва – благословия! Готви се за промяна."
  },
  {
    "reading_id": "new_job",
    "reading_name": "Нова работа",
    "reading_cards": "Асо Пентакли + 6 Жезли",
    "reading_combination": ["ace_pentacles", "six_wands"],
    "reading_meaning": "Успешен старт",
    "reading_description": "Нова работа, повишение, нова финансова възможност. Успехът идва.",
    "reading_advice": "Хвани възможността. Тя няма да чака вечно."
  },
  {
    "reading_id": "unemployment",
    "reading_name": "Уволнение",
    "reading_cards": "10 Мечове + 5 Пентакли",
    "reading_combination": ["ten_swords", "five_pentacles"],
    "reading_meaning": "Загуба на работа",
    "reading_description": "Уволнение, съкращение, фалит. Край на този етап.",
    "reading_advice": "Това е врата, която се затваря, за да се отвори друга. Почини си и започни наново."
  },
  {
    "reading_id": "financial_crisis",
    "reading_name": "Финансова криза",
    "reading_cards": "5 Пентакли + 10 Жезли + Луна",
    "reading_combination": ["five_pentacles", "ten_wands", "moon"],
    "reading_meaning": "Тежък период",
    "reading_description": "Тежък финансов период – загуба на работа, фалит, дългове. Не виждаш ясен изход.",
    "reading_advice": "Потърси помощ – има хора, готови да помогнат. Светлината идва, дори в най-тъмната нощ."
  },
  {
    "reading_id": "bankruptcy",
    "reading_name": "Фалит",
    "reading_cards": "Кула + 5 Пентакли",
    "reading_combination": ["tower", "five_pentacles"],
    "reading_meaning": "Финансов срив",
    "reading_description": "Бизнесът се срива. Загуба на всичко.",
    "reading_advice": "Трябваше да рухне, за да построиш нещо истинско. От пепелта става феникс."
  },
  {
    "reading_id": "moving",
    "reading_name": "Преместване",
    "reading_cards": "6 Мечове + 4 Жезли",
    "reading_combination": ["six_swords", "four_wands"],
    "reading_meaning": "Нов дом",
    "reading_description": "Смяна на дома, местене в друг град или държава.",
    "reading_advice": "Ново място, нов живот. Отваряй се за новото."
  },
  {
    "reading_id": "travel",
    "reading_name": "Пътуване",
    "reading_cards": "8 Жезли + 6 Мечове + Колесница",
    "reading_combination": ["eight_wands", "six_swords", "chariot"],
    "reading_meaning": "Бързо пътуване",
    "reading_description": "Пътуване в чужбина, бързо придвижване, полет.",
    "reading_advice": "Хвани вълната – пътуването носи нови възможности."
  },
  {
    "reading_id": "spiritual_awakening",
    "reading_name": "Духовно пробуждане",
    "reading_cards": "Върховна жрица + Луна + Звезда",
    "reading_combination": ["high_priestess", "moon", "star"],
    "reading_meaning": "Интуиция и прозрения",
    "reading_description": "Силна интуиция, психични преживявания, сънища, които се сбъдват. Връзка с подсъзнанието.",
    "reading_advice": "Записвай сънищата си. Медитирай. Воден си отгоре."
  },
  {
    "reading_id": "depression",
    "reading_name": "Депресия",
    "reading_cards": "9 Мечове + Отшелник + Луна",
    "reading_combination": ["nine_swords", "hermit", "moon"],
    "reading_meaning": "Тъмна нощ на душата",
    "reading_description": "Дълбока депресия, духовна криза, безсъние, тревоги. Чувстваш се сам и изгубен.",
    "reading_advice": "Това е преход – нощта е най-тъмна преди зазоряване. Отговорът идва отвътре."
  },
  {
    "reading_id": "insight",
    "reading_name": "Прозрение",
    "reading_cards": "Асо Мечове + Слънце + Магьосник",
    "reading_combination": ["ace_swords", "sun", "magician"],
    "reading_meaning": "Внезапна яснота",
    "reading_description": "Внезапно разбиране – виждаш истината с невероятна яснота. Това прозрение променя всичко.",
    "reading_advice": "Сега знаеш какво трябва да правиш. Действай с увереност."
  },
  {
    "reading_id": "betrayal",
    "reading_name": "Предателство",
    "reading_cards": "7 Мечове + 3 Мечове + Дявол",
    "reading_combination": ["seven_swords", "three_swords", "devil"],
    "reading_meaning": "Някой лъже",
    "reading_description": "Някой ти подготвя предателство. Има тайни, лъжи, измама. Мотивите са егоистични.",
    "reading_advice": "Пази гърба си. Не споделяй тайни. Провери фактите."
  },
  {
    "reading_id": "illness",
    "reading_name": "Болест",
    "reading_cards": "5 Пентакли + 4 Мечове",
    "reading_combination": ["five_pentacles", "four_swords"],
    "reading_meaning": "Здравословни проблеми",
    "reading_description": "Здравословни проблеми. Нужда от почивка и лечение.",
    "reading_advice": "Посети лекар! Не отлагай. Тялото ти крещи за внимание."
  },
   {
    "reading_id": "ace_pentacles_two_wands",
    "reading_name": "Асо Пентакли + Двойка Жезли",
    "reading_cards": "Асо Пентакли + Двойка Жезли",
    "reading_combination": ["ace_pentacles", "two_wands"],
    "reading_meaning": "Ново начало и избор",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Двойка Жезли – избор и планиране. Имате шанс за материален успех, но трябва да изберете правилната посока. Не се колебайте – възможността е реална.",
    "reading_description": "Нова финансова възможност пред вас, но трябва да изберете накъде да я насочите.",
    "reading_advice": "Избери внимателно – правилният избор ще донесе стабилност."
  },
  {
    "reading_id": "ace_pentacles_three_wands",
    "reading_name": "Асо Пентакли + Тройка Жезли",
    "reading_cards": "Асо Пентакли + Тройка Жезли",
    "reading_combination": ["ace_pentacles", "three_wands"],
    "reading_meaning": "Ново начало и очакване",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Тройка Жезли – очакване и разширяване. Инвестирали сте в нещо ново и сега чакате резултатите. Търпението ще бъде възнаградено.",
    "reading_description": "Нова финансова възможност, която изисква търпение. Резултатите идват с времето.",
    "reading_advice": "Чакай търпеливо – добрите неща идват при тези, които умеят да чакат."
  },
  {
    "reading_id": "ace_pentacles_four_wands",
    "reading_name": "Асо Пентакли + Четворка Жезли",
    "reading_cards": "Асо Пентакли + Четворка Жезли",
    "reading_combination": ["ace_pentacles", "four_wands"],
    "reading_meaning": "Ново начало и празник",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Четворка Жезли – празник и стабилност. Новият ви проект или инвестиция носи повод за празнуване и радост в дома.",
    "reading_description": "Финансов успех, който носи радост и повод за празник със семейството.",
    "reading_advice": "Празнувай успеха, но не спирай да работиш. Стабилността се гради стъпка по стъпка."
  },
  {
    "reading_id": "ace_pentacles_five_wands",
    "reading_name": "Асо Пентакли + Петица Жезли",
    "reading_cards": "Асо Пентакли + Петица Жезли",
    "reading_combination": ["ace_pentacles", "five_wands"],
    "reading_meaning": "Ново начало и конкуренция",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Петица Жезли – конфликт и съперничество. Новата ви идея или бизнес среща конкуренция още в началото. Не се отказвайте – значимите неща винаги предизвикват реакция.",
    "reading_description": "Нова финансова възможност, но трябва да се бориш за нея. Конкуренция и спорове.",
    "reading_advice": "Не се отказвай при първото препятствие. Конкуренцията означава, че идеята ти има стойност."
  },
  {
    "reading_id": "ace_pentacles_six_wands",
    "reading_name": "Асо Пентакли + Шестица Жезли",
    "reading_cards": "Асо Пентакли + Шестица Жезли",
    "reading_combination": ["ace_pentacles", "six_wands"],
    "reading_meaning": "Ново начало и победа",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Шестица Жезли – победа и признание. Новото ви начинание ще има успех още от самото начало. Вашият ентусиазъм и увереност ще бъдат забелязани и оценени.",
    "reading_description": "Нова финансова възможност, която носи успех и признание още в началото.",
    "reading_advice": "Наслаждавай се на успеха, но не спирай да работиш. Първата победа е само началото."
  },
  {
    "reading_id": "ace_pentacles_seven_wands",
    "reading_name": "Асо Пентакли + Седмица Жезли",
    "reading_cards": "Асо Пентакли + Седмица Жезли",
    "reading_combination": ["ace_pentacles", "seven_wands"],
    "reading_meaning": "Ново начало и защита",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Седмица Жезли – защита на позицията. Още в началото трябва да отстоявате новата си идея пред критици. Това е изпитание на вашата увереност.",
    "reading_description": "Нова финансова възможност, която среща съпротива и критики. Трябва да защитаваш позицията си.",
    "reading_advice": "Не се огъвай пред първата съпротива. Убедеността ти ще спечели."
  },
  {
    "reading_id": "ace_pentacles_eight_wands",
    "reading_name": "Асо Пентакли + Осмица Жезли",
    "reading_cards": "Асо Пентакли + Осмица Жезли",
    "reading_combination": ["ace_pentacles", "eight_wands"],
    "reading_meaning": "Бърза финансова възможност",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Осмица Жезли – бързина и движение. Всичко се случва светкавично – възможността се появява и трябва да действате веднага. Няма време за колебание.",
    "reading_description": "Нова финансова възможност идва бързо – трябва да действаш без колебание.",
    "reading_advice": "Хвани вълната на скоростта. Действай сега, без да се бавиш."
  },
  {
    "reading_id": "ace_pentacles_nine_wands",
    "reading_name": "Асо Пентакли + Деветка Жезли",
    "reading_cards": "Асо Пентакли + Деветка Жезли",
    "reading_combination": ["ace_pentacles", "nine_wands"],
    "reading_meaning": "Упорито начало",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Деветка Жезли – устойчивост и изтощение. Началото е трудно и изисква много усилия. Чувствате се изтощени, но не се отказвайте – краят на усилията наближава.",
    "reading_description": "Нова финансова възможност, която изисква много усилия и търпение. Умора, но не се предавай.",
    "reading_advice": "Дръж се още малко. Финалната права е точно зад ъгъла."
  },
  {
    "reading_id": "ace_pentacles_ten_wands",
    "reading_name": "Асо Пентакли + Десетка Жезли",
    "reading_cards": "Асо Пентакли + Десетка Жезли",
    "reading_combination": ["ace_pentacles", "ten_wands"],
    "reading_meaning": "Претоварен старт",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Десетка Жезли – претоварване и бреме. Поемате твърде много отговорности твърде рано. Ентусиазмът ви води до прегаряне, ако не забавите темпото.",
    "reading_description": "Нова финансова възможност, но поемаш твърде много отговорности. Риск от прегаряне.",
    "reading_advice": "Забави темпото. Никой не може да носи всичко сам. Потърси помощ."
  },
  {
    "reading_id": "ace_pentacles_page_wands",
    "reading_name": "Асо Пентакли + Паж Жезли",
    "reading_cards": "Асо Пентакли + Паж Жезли",
    "reading_combination": ["ace_pentacles", "page_wands"],
    "reading_meaning": "Нова възможност и новини",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Паж Жезли – новини и ентусиазъм. Очаквайте вълнуваща вест, свързана с нова финансова възможност или кариерен старт. Ентусиазъм и надежда.",
    "reading_description": "Нова финансова възможност идва с вълнуващи новини. Ентусиазъм и надежда.",
    "reading_advice": "Сподели ентусиазма си с другите. Твоята енергия може да привлече подкрепа."
  },
  {
    "reading_id": "ace_pentacles_knight_wands",
    "reading_name": "Асо Пентакли + Рицар Жезли",
    "reading_cards": "Асо Пентакли + Рицар Жезли",
    "reading_combination": ["ace_pentacles", "knight_wands"],
    "reading_meaning": "Стремителен старт",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Рицар Жезли – импулсивност и бързина. Възможността се появява и веднага се втурвате да я реализирате. Внимавайте да не прегазите другите.",
    "reading_description": "Нова финансова възможност те кара да действаш светкавично. Неудържима енергия.",
    "reading_advice": "Действай бързо, но не забравяй за хората около теб. Страстта е добра, но не трябва да прегазва."
  },
  {
    "reading_id": "ace_pentacles_queen_wands",
    "reading_name": "Асо Пентакли + Царица Жезли",
    "reading_cards": "Асо Пентакли + Царица Жезли",
    "reading_combination": ["ace_pentacles", "queen_wands"],
    "reading_meaning": "Уверен финансов старт",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Царица Жезли – увереност и харизма. Започвате нещо ново с голяма самоувереност. Вашата топлина и увереност привличат хората и инвестициите.",
    "reading_description": "Нова финансова възможност с увереност и харизма. Хората се вдъхновяват от теб.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина вдъхновява другите да те последват."
  },
  {
    "reading_id": "ace_pentacles_king_wands",
    "reading_name": "Асо Пентакли + Цар Жезли",
    "reading_cards": "Асо Пентакли + Цар Жезли",
    "reading_combination": ["ace_pentacles", "king_wands"],
    "reading_meaning": "Лидерски финансов старт",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Цар Жезли – лидерство и визия. Започвате нов бизнес или проект с ясна визия и авторитет. Имате всички качества да поведете другите.",
    "reading_description": "Нов бизнес проект с ясна визия и лидерска позиция. Имаш авторитета да водиш.",
    "reading_advice": "Поеми лидерството. Имаш визията и силата да я осъществиш. Води с пример."
  },
  {
    "reading_id": "ace_pentacles_ace_wands",
    "reading_name": "Асо Пентакли + Асо Жезли",
    "reading_cards": "Асо Пентакли + Асо Жезли",
    "reading_combination": ["ace_pentacles", "ace_wands"],
    "reading_meaning": "Ново начало и страст",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Асо Жезли – ново начало и страст. Две аса заедно – мощен старт за нов бизнес, проект или инвестиция. Енергия и ресурси в хармония.",
    "reading_description": "Нов бизнес или проект с огромен потенциал. Енергия и ресурси заедно.",
    "reading_advice": "Действай сега! Имаш всичко необходимо за успех. Вярвай в себе си."
  },
  {
    "reading_id": "ace_pentacles_two_cups",
    "reading_name": "Асо Пентакли + Двойка Чаши",
    "reading_cards": "Асо Пентакли + Двойка Чаши",
    "reading_combination": ["ace_pentacles", "two_cups"],
    "reading_meaning": "Нова любов и стабилност",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Двойка Чаши – любов и връзка. Нова любов или връзка, която носи и материална стабилност. Любов и сигурност заедно.",
    "reading_description": "Нова връзка, която носи не само любов, но и стабилност. Финансова сигурност.",
    "reading_advice": "Следвай сърцето си, но не забравяй и главата. Това може да е сериозна връзка."
  },
  {
    "reading_id": "ace_pentacles_three_cups",
    "reading_name": "Асо Пентакли + Тройка Чаши",
    "reading_cards": "Асо Пентакли + Тройка Чаши",
    "reading_combination": ["ace_pentacles", "three_cups"],
    "reading_meaning": "Финансов успех и празник",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Тройка Чаши – празник и радост. Финансовият успех идва с много поводи за празнуване. Споделете радостта с приятели и семейство.",
    "reading_description": "Финансов успех, който носи радост и поводи за празнуване. Споделено щастие.",
    "reading_advice": "Празнувай всеки успех, дори малкия. Радостта, споделена с други, е двойна радост."
  },
  {
    "reading_id": "ace_pentacles_four_cups",
    "reading_name": "Асо Пентакли + Четворка Чаши",
    "reading_cards": "Асо Пентакли + Четворка Чаши",
    "reading_combination": ["ace_pentacles", "four_cups"],
    "reading_meaning": "Пропусната финансова възможност",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Четворка Чаши – апатия и неудовлетворение. Възможност се появява, но вие сте твърде заети със себе си, за да я забележите. Рискувате да пропуснете нещо ценно.",
    "reading_description": "Нова финансова възможност се появява, но ти не я забелязваш. Твърде си зает със себе си.",
    "reading_advice": "Вдигни поглед. Може да пропускаш нещо важно, което е точно пред теб."
  },
  {
    "reading_id": "ace_pentacles_five_cups",
    "reading_name": "Асо Пентакли + Петица Чаши",
    "reading_cards": "Асо Пентакли + Петица Чаши",
    "reading_combination": ["ace_pentacles", "five_cups"],
    "reading_meaning": "Ново начало след загуба",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Петица Чаши – загуба и тъга. След период на финансови затруднения идва нова надежда. Светлина след тъмнина.",
    "reading_description": "Нова финансова възможност се появява след период на загуби и разочарования.",
    "reading_advice": "Дори в трудностите има място за ново начало. Позволи си да се отвориш към надеждата."
  },
  {
    "reading_id": "ace_pentacles_six_cups",
    "reading_name": "Асо Пентакли + Шестица Чаши",
    "reading_cards": "Асо Пентакли + Шестица Чаши",
    "reading_combination": ["ace_pentacles", "six_cups"],
    "reading_meaning": "Носталгична инвестиция",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Шестица Чаши – спомени и носталгия. Новата ви инвестиция или проект ви напомня за нещо от миналото. Носталгия и ново начало.",
    "reading_description": "Нова финансова възможност, която те връща към спомени от миналото.",
    "reading_advice": "Използвай миналото като вдъхновение, но не позволявай то да те държи в капан."
  },
  {
    "reading_id": "ace_pentacles_seven_cups",
    "reading_name": "Асо Пентакли + Седмица Чаши",
    "reading_cards": "Асо Пентакли + Седмица Чаши",
    "reading_combination": ["ace_pentacles", "seven_cups"],
    "reading_meaning": "Много финансови възможности",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Седмица Чаши – множество избори и илюзии. Имате много възможности, но не всички са реални. Трудно е да изберете накъде да насочите ресурсите си.",
    "reading_description": "Много финансови възможности, но не всички са реални. Труден избор.",
    "reading_advice": "Избери една възможност и ѝ се посвети. Не се разпилявай в илюзии."
  },
  {
    "reading_id": "ace_pentacles_eight_cups",
    "reading_name": "Асо Пентакли + Осмица Чаши",
    "reading_cards": "Асо Пентакли + Осмица Чаши",
    "reading_combination": ["ace_pentacles", "eight_cups"],
    "reading_meaning": "Тръгване с нов проект",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Осмица Чаши – тръгване и оставяне. Започвате нов проект, което означава да оставите нещо старо зад гърба си. Пътят към новото изисква освобождаване.",
    "reading_description": "Започваш нов финансов проект и оставяш старото зад гърба си.",
    "reading_advice": "Тръгни смело. Старото вече не ти служи. Новият път те очаква."
  },
  {
    "reading_id": "ace_pentacles_nine_cups",
    "reading_name": "Асо Пентакли + Деветка Чаши",
    "reading_cards": "Асо Пентакли + Деветка Чаши",
    "reading_combination": ["ace_pentacles", "nine_cups"],
    "reading_meaning": "Сбъдната финансова мечта",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Деветка Чаши – сбъднато желание. Новият ви проект носи изпълнение на дългогодишна финансова мечта. Удовлетворение и радост.",
    "reading_description": "Новият финансов проект носи сбъдване на дългогодишна мечта.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Мечтата ти се сбъдва."
  },
  {
    "reading_id": "ace_pentacles_ten_cups",
    "reading_name": "Асо Пентакли + Десетка Чаши",
    "reading_cards": "Асо Пентакли + Десетка Чаши",
    "reading_combination": ["ace_pentacles", "ten_cups"],
    "reading_meaning": "Семеен финансов успех",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Десетка Чаши – пълно семейно щастие. Новият ви проект носи радост на цялото семейство. Финансова стабилност и хармония в дома.",
    "reading_description": "Нов финансов проект, който носи щастие на цялото семейство.",
    "reading_advice": "Сподели успеха със семейството си. Щастието е по-голямо, когато е споделено."
  },
  {
    "reading_id": "ace_pentacles_page_cups",
    "reading_name": "Асо Пентакли + Паж Чаши",
    "reading_cards": "Асо Пентакли + Паж Чаши",
    "reading_combination": ["ace_pentacles", "page_cups"],
    "reading_meaning": "Финансова възможност и послание",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Паж Чаши – емоционално послание. Очаквайте вълнуваща новина, свързана с финанси или кариера. Някой може да ви направи предложение.",
    "reading_description": "Получаваш емоционално послание, свързано с нова финансова възможност.",
    "reading_advice": "Отвори сърцето си за посланието. То носи нещо важно за теб."
  },
  {
    "reading_id": "ace_pentacles_knight_cups",
    "reading_name": "Асо Пентакли + Рицар Чаши",
    "reading_cards": "Асо Пентакли + Рицар Чаши",
    "reading_combination": ["ace_pentacles", "knight_cups"],
    "reading_meaning": "Романтично предложение",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Рицар Чаши – романтика и ухажване. Очаквайте романтичен жест или предложение, което идва с материална сигурност. Любов и стабилност заедно.",
    "reading_description": "Романтично предложение или жест, който носи и финансова сигурност.",
    "reading_advice": "Кажи какво чувстваш. Бъди смел в любовта – сърцето ти знае пътя."
  },
  {
    "reading_id": "ace_pentacles_queen_cups",
    "reading_name": "Асо Пентакли + Царица Чаши",
    "reading_cards": "Асо Пентакли + Царица Чаши",
    "reading_combination": ["ace_pentacles", "queen_cups"],
    "reading_meaning": "Интуитивна инвестиция",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Царица Чаши – интуиция и дълбока емоционалност. Интуицията ви води към правилната финансова инвестиция. Слушайте вътрешния си глас.",
    "reading_description": "Нова финансова възможност, водена от интуиция и дълбоки чувства.",
    "reading_advice": "Довери се на вътрешния си глас. Интуицията ти води правилно."
  },
  {
    "reading_id": "ace_pentacles_king_cups",
    "reading_name": "Асо Пентакли + Цар Чаши",
    "reading_cards": "Асо Пентакли + Цар Чаши",
    "reading_combination": ["ace_pentacles", "king_cups"],
    "reading_meaning": "Контролирана инвестиция",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Цар Чаши – емоционална зрялост и контрол. Новата ви инвестиция е силна, но вие умеете да я контролирате. Баланс между емоции и разум.",
    "reading_description": "Нова финансова възможност, която умееш да контролираш. Емоционална зрялост и баланс.",
    "reading_advice": "Управлявай ресурсите си с мъдрост. Страстта е силна, но ти си по-силен."
  },
  {
    "reading_id": "ace_pentacles_two_swords",
    "reading_name": "Асо Пентакли + Двойка Мечове",
    "reading_cards": "Асо Пентакли + Двойка Мечове",
    "reading_combination": ["ace_pentacles", "two_swords"],
    "reading_meaning": "Финансова възможност и съмнение",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Двойка Мечове – нерешителност и блокиране. Имате нова финансова възможност, но се съмнявате дали да я реализирате. Страхът от грешка ви парализира.",
    "reading_description": "Нова финансова възможност, но съмненията те спират. Не знаеш дали да действаш.",
    "reading_advice": "Свали превръзката от очите. Понякога трябва да избереш, дори да не виждаш ясно."
  },
  {
    "reading_id": "ace_pentacles_three_swords",
    "reading_name": "Асо Пентакли + Тройка Мечове",
    "reading_cards": "Асо Пентакли + Тройка Мечове",
    "reading_combination": ["ace_pentacles", "three_swords"],
    "reading_meaning": "Финансова възможност и болка",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Тройка Мечове – болка и разбито сърце. Новата ви финансова възможност може да донесе разочарование или болка. Внимавайте с кого споделяте.",
    "reading_description": "Нова финансова възможност носи не само радост, но и риск от разочарование.",
    "reading_advice": "Бъди внимателен с доверието си. Не всяка възможност носи само печалба."
  },
  {
    "reading_id": "ace_pentacles_four_swords",
    "reading_name": "Асо Пентакли + Четворка Мечове",
    "reading_cards": "Асо Пентакли + Четворка Мечове",
    "reading_combination": ["ace_pentacles", "four_swords"],
    "reading_meaning": "Почивка преди инвестиция",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Четворка Мечове – почивка и възстановяване. Имате възможност, но сега не е моментът за действие. Първо починете и съберете сили.",
    "reading_description": "Имаш нова финансова възможност, но сега е време за почивка, не за действие.",
    "reading_advice": "Почини си преди да започнеш. Добрата подготовка води до успех."
  },
  {
    "reading_id": "ace_pentacles_five_swords",
    "reading_name": "Асо Пентакли + Петица Мечове",
    "reading_cards": "Асо Пентакли + Петица Мечове",
    "reading_combination": ["ace_pentacles", "five_swords"],
    "reading_meaning": "Конфликтна финансова възможност",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Петица Мечове – конфликт и празна победа. Възможността може да предизвика спор или да се опитате да я наложите по неправилен начин. Помислете дали си струва.",
    "reading_description": "Новата финансова възможност предизвиква конфликт. Може да спечелиш, но с цената на нечии чувства.",
    "reading_advice": "Помисли дали си струва да нараниш другите, за да спечелиш. Понякога е по-добре да отстъпиш."
  },
  {
    "reading_id": "ace_pentacles_six_swords",
    "reading_name": "Асо Пентакли + Шестица Мечове",
    "reading_cards": "Асо Пентакли + Шестица Мечове",
    "reading_combination": ["ace_pentacles", "six_swords"],
    "reading_meaning": "Ново финансово начало и път",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Шестица Мечове – пътуване и преход. Новата ви инвестиция или проект ще ви отведе на ново място – физически или метафорично. Очаквайте промяна на средата.",
    "reading_description": "Нов финансов проект те отвежда на ново място. Пътуване или преместване те очаква.",
    "reading_advice": "Тръгни с увереност. Новите води носят нови възможности."
  },
  {
    "reading_id": "ace_pentacles_seven_swords",
    "reading_name": "Асо Пентакли + Седмица Мечове",
    "reading_cards": "Асо Пентакли + Седмица Мечове",
    "reading_combination": ["ace_pentacles", "seven_swords"],
    "reading_meaning": "Финансова възможност и измама",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Седмица Мечове – измама и хитрост. Внимавайте – някой може да се опита да присвои идеята ви или да ви измами. Пазите интелектуалната си собственост.",
    "reading_description": "Новата ти финансова идея е ценна, но има риск някой да се опита да ти я открадне.",
    "reading_advice": "Бъди внимателен с кого споделяш идеите си. Проверявай два пъти."
  },
  {
    "reading_id": "ace_pentacles_eight_swords",
    "reading_name": "Асо Пентакли + Осмица Мечове",
    "reading_cards": "Асо Пентакли + Осмица Мечове",
    "reading_combination": ["ace_pentacles", "eight_swords"],
    "reading_meaning": "Блокирана финансова възможност",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Осмица Мечове – чувство на капан и ограничение. Имате страхотна възможност, но се чувствате блокирани и без изход. Страхът ви пречи да действате.",
    "reading_description": "Имаш нова финансова възможност, но се чувстваш в капан. Страховете ти пречат да действаш.",
    "reading_advice": "Оковите са в главата ти. Освободи се от страха и ще видиш, че имаш повече възможности."
  },
  {
    "reading_id": "ace_pentacles_nine_swords",
    "reading_name": "Асо Пентакли + Деветка Мечове",
    "reading_cards": "Асо Пентакли + Деветка Мечове",
    "reading_combination": ["ace_pentacles", "nine_swords"],
    "reading_meaning": "Тревожна финансова възможност",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Деветка Мечове – тревога и безсъние. Възможността ви вълнува, но също така ви тревожи. Мислите ви се въртят около нея и не ви оставят да спите.",
    "reading_description": "Нова финансова възможност те вълнува, но носи и тревоги. Безсъние и премисляне.",
    "reading_advice": "Спокойствие. Повечето неща, за които се тревожим, никога не се случват. Довери се на процеса."
  },
  {
    "reading_id": "ace_pentacles_ten_swords",
    "reading_name": "Асо Пентакли + Десетка Мечове",
    "reading_cards": "Асо Пентакли + Десетка Мечове",
    "reading_combination": ["ace_pentacles", "ten_swords"],
    "reading_meaning": "Край и ново финансово начало",
    "second_meaning": "Асо Пентакли носи ново финансово начало, а Десетка Мечове – край и дъно. Нещо старо приключва, за да може нещо ново да започне. Краят е болезнен, но носи освобождение и нов път.",
    "reading_description": "След тежък финансов край идва ново начало. Феникс от пепелта.",
    "reading_advice": "Остави старото да умре. Новото вече чука на вратата. Позволи му да влезе."
  },
  {
    "reading_id": "ace_pentacles_page_swords",
    "reading_name": "Асо Пентакли + Паж Мечове",
    "reading_cards": "Асо Пентакли + Паж Мечове",
    "reading_combination": ["ace_pentacles", "page_swords"],
    "reading_meaning": "Финансова възможност и истина",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Паж Мечове – търсене на истината. Новата ви финансова идея ви кара да търсите отговори и да задавате въпроси. Любопитството ви води към открития.",
    "reading_description": "Нова финансова възможност те кара да търсиш истината. Любопитство и открития.",
    "reading_advice": "Задавай въпроси. Не приемай нищо за дадено. Истината е някъде там – открий я."
  },
  {
    "reading_id": "ace_pentacles_knight_swords",
    "reading_name": "Асо Пентакли + Рицар Мечове",
    "reading_cards": "Асо Пентакли + Рицар Мечове",
    "reading_combination": ["ace_pentacles", "knight_swords"],
    "reading_meaning": "Стремителна финансова идея",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Рицар Мечове – бързина и прямота. Идеята идва светкавично и веднага искате да я реализирате. Действате бързо и решително.",
    "reading_description": "Новата финансова идея идва светкавично и те кара да действаш без колебание.",
    "reading_advice": "Действай бързо, но не безразсъдно. Устремът ти е сила, но не прегазвай другите."
  },
  {
    "reading_id": "ace_pentacles_queen_swords",
    "reading_name": "Асо Пентакли + Царица Мечове",
    "reading_cards": "Асо Пентакли + Царица Мечове",
    "reading_combination": ["ace_pentacles", "queen_swords"],
    "reading_meaning": "Ясна финансова идея",
    "second_meaning": "Асо Пентакли носи нова финансова възможност, а Царица Мечове – яснота и независимост. Имате кристално ясна визия за новата си финансова възможност. Никой не може да ви заблуди.",
    "reading_description": "Новата ти финансова идея е кристално ясна. Знаеш точно какво искаш и как да го постигнеш.",
    "reading_advice": "Бъди честен със себе си и с другите. Твоята яснота вдъхновява доверие."
  },
  {
    "reading_id": "ace_pentacles_king_swords",
    "reading_name": "Стратегическа финансова идея",
    "reading_cards": "Асо Пентакли + Цар Мечове",
    "reading_combination": ["ace_pentacles", "king_swords"],
     "reading_meaning": "Асо Пентакли носи нова финансова възможност, а Цар Мечове – интелект и стратегия. Новата ви финансова идея е добре обмислена и стратегически издържана. Имате ясен план за реализация.",
    "reading_description": "Новата ти финансова идея е подкрепена с ясен план и стратегия.",
    "reading_advice": "Вземи решение с ума си, но не забравяй и сърцето. Стратегията е важна, но и емоциите имат значение."
  },
    {
    "reading_id": "two_pentacles_two_wands",
    "reading_name": "Двойка Пентакли + Двойка Жезли",
    "reading_cards": "Двойка Пентакли + Двойка Жезли",
    "reading_combination": ["two_pentacles", "two_wands"],
    "reading_meaning": "Баланс и избор",
    "second_meaning": "Двойка Пентакли носи баланс и жонглиране с ресурси, а Двойка Жезли – избор и планиране. Трябва да балансирате финансите си, докато правите важен избор. Жонглирайте внимателно.",
    "reading_description": "Балансираш финансите и правиш важен избор. Жонглирай внимателно.",
    "reading_advice": "Балансирай, но не изпускай топката. Финансовият баланс е ключов."
  },
  {
    "reading_id": "two_pentacles_three_wands",
    "reading_name": "Двойка Пентакли + Тройка Жезли",
    "reading_cards": "Двойка Пентакли + Тройка Жезли",
    "reading_combination": ["two_pentacles", "three_wands"],
    "reading_meaning": "Баланс и очакване",
    "second_meaning": "Двойка Пентакли носи баланс, а Тройка Жезли – очакване и разширяване. Инвестирали сте ресурси и сега чакате резултати. Търпението и балансът ще бъдат възнаградени.",
    "reading_description": "Инвестирал си и сега чакаш резултати. Търпение и баланс.",
    "reading_advice": "Чакай търпеливо, докато поддържаш баланс. Добрите неща идват с времето."
  },
  {
    "reading_id": "two_pentacles_four_wands",
    "reading_name": "Двойка Пентакли + Четворка Жезли",
    "reading_cards": "Двойка Пентакли + Четворка Жезли",
    "reading_combination": ["two_pentacles", "four_wands"],
    "reading_meaning": "Баланс и празник",
    "second_meaning": "Двойка Пентакли носи баланс, а Четворка Жезли – празник и стабилност. Успявате да балансирате финансите си, което ви позволява да празнувате със семейството. Стабилност и радост.",
    "reading_description": "Балансираш финансите и празнуваш със семейството. Стабилност и радост.",
    "reading_advice": "Празнувай, но продължавай да балансираш. Стабилността се гради с мярка."
  },
  {
    "reading_id": "two_pentacles_five_wands",
    "reading_name": "Двойка Пентакли + Петица Жезли",
    "reading_cards": "Двойка Пентакли + Петица Жезли",
    "reading_combination": ["two_pentacles", "five_wands"],
    "reading_meaning": "Баланс и конфликт",
    "second_meaning": "Двойка Пентакли носи баланс, а Петица Жезли – конфликт и съперничество. Трудно е да запазите финансов баланс, когато около вас има спорове и конкуренция. Фокусирайте се върху приоритетите си.",
    "reading_description": "Трудно пазиш финансов баланс сред конфликти и спорове.",
    "reading_advice": "Не се замесвай в драми. Фокусирай се върху баланса и приоритетите си."
  },
  {
    "reading_id": "two_pentacles_six_wands",
    "reading_name": "Двойка Пентакли + Шестица Жезли",
    "reading_cards": "Двойка Пентакли + Шестица Жезли",
    "reading_combination": ["two_pentacles", "six_wands"],
    "reading_meaning": "Баланс и успех",
    "second_meaning": "Двойка Пентакли носи баланс, а Шестица Жезли – победа и признание. Успявате да балансирате ресурсите си и това води до успех. Признание за уменията ви да жонглирате.",
    "reading_description": "Балансираш ресурсите си и постигаш успех. Признание и стабилност.",
    "reading_advice": "Наслаждавай се на успеха, но не спирай да балансираш. Стабилността изисква постоянство."
  },
  {
    "reading_id": "two_pentacles_seven_wands",
    "reading_name": "Двойка Пентакли + Седмица Жезли",
    "reading_cards": "Двойка Пентакли + Седмица Жезли",
    "reading_combination": ["two_pentacles", "seven_wands"],
    "reading_meaning": "Баланс и защита",
    "second_meaning": "Двойка Пентакли носи баланс, а Седмица Жезли – защита на позицията. Трябва да защитавате финансовия си баланс от външни заплахи. Не позволявайте на другите да ви извадят от равновесие.",
    "reading_description": "Защитаваш финансовия си баланс от външни заплахи. Дръж се.",
    "reading_advice": "Пази баланса си. Не позволявай на другите да те извадят от равновесие."
  },
  {
    "reading_id": "two_pentacles_eight_wands",
    "reading_name": "Двойка Пентакли + Осмица Жезли",
    "reading_cards": "Двойка Пентакли + Осмица Жезли",
    "reading_combination": ["two_pentacles", "eight_wands"],
    "reading_meaning": "Бърз баланс",
    "second_meaning": "Двойка Пентакли носи баланс, а Осмица Жезли – бързина и движение. Трябва да балансирате финансите си бързо – нещата се движат с голяма скорост. Бъдете готови за бързи решения.",
    "reading_description": "Трябва да балансираш финансите си бързо – нещата се движат с голяма скорост.",
    "reading_advice": "Действай бързо, но с мярка. Балансът при скорост изисква фокус."
  },
  {
    "reading_id": "two_pentacles_nine_wands",
    "reading_name": "Двойка Пентакли + Деветка Жезли",
    "reading_cards": "Двойка Пентакли + Деветка Жезли",
    "reading_combination": ["two_pentacles", "nine_wands"],
    "reading_meaning": "Баланс и изтощение",
    "second_meaning": "Двойка Пентакли носи баланс, а Деветка Жезли – устойчивост и изтощение. Поддържането на баланс ви изтощава. Умора, но не се отказвайте – краят на усилията наближава.",
    "reading_description": "Поддържането на финансов баланс те изтощава. Умора, но не се предавай.",
    "reading_advice": "Дръж се още малко. Финалната права е точно зад ъгъла."
  },
  {
    "reading_id": "two_pentacles_ten_wands",
    "reading_name": "Двойка Пентакли + Десетка Жезли",
    "reading_cards": "Двойка Пентакли + Десетка Жезли",
    "reading_combination": ["two_pentacles", "ten_wands"],
    "reading_meaning": "Претоварен баланс",
    "second_meaning": "Двойка Пентакли носи баланс, а Десетка Жезли – претоварване и бреме. Опитвате се да балансирате, но носите твърде много отговорности. Риск от прегаряне.",
    "reading_description": "Опитваш се да балансираш, но носиш твърде много отговорности. Претоварване.",
    "reading_advice": "Потърси помощ. Не можеш да носиш всичко сам. Сподели бремето."
  },
  {
    "reading_id": "two_pentacles_page_wands",
    "reading_name": "Двойка Пентакли + Паж Жезли",
    "reading_cards": "Двойка Пентакли + Паж Жезли",
    "reading_combination": ["two_pentacles", "page_wands"],
    "reading_meaning": "Баланс и новини",
    "second_meaning": "Двойка Пентакли носи баланс, а Паж Жезли – новини и ентусиазъм. Очаквайте вълнуваща новина, свързана с финансите ви. Новината ще дойде в момент, когато сте в баланс.",
    "reading_description": "Вълнуваща финансова новина идва в момент на баланс.",
    "reading_advice": "Отвори се за новините. Те носят нещо ценно за финансовото ти бъдеще."
  },
  {
    "reading_id": "two_pentacles_knight_wands",
    "reading_name": "Двойка Пентакли + Рицар Жезли",
    "reading_cards": "Двойка Пентакли + Рицар Жезли",
    "reading_combination": ["two_pentacles", "knight_wands"],
    "reading_meaning": "Бърз финансов баланс",
    "second_meaning": "Двойка Пентакли носи баланс, а Рицар Жезли – импулсивност и бързина. Трябва да възстановите финансов баланс бързо. Действайте решително, но не импулсивно.",
    "reading_description": "Трябва да възстановиш финансов баланс бързо. Действай решително.",
    "reading_advice": "Действай бързо, но не безразсъдно. Балансът изисква и мисъл, не само скорост."
  },
  {
    "reading_id": "two_pentacles_queen_wands",
    "reading_name": "Двойка Пентакли + Царица Жезли",
    "reading_cards": "Двойка Пентакли + Царица Жезли",
    "reading_combination": ["two_pentacles", "queen_wands"],
    "reading_meaning": "Уверен баланс",
    "second_meaning": "Двойка Пентакли носи баланс, а Царица Жезли – увереност и харизма. Поддържате финансов баланс с увереност и топлина. Хората се вдъхновяват от вашата стабилност.",
    "reading_description": "Поддържаш финансов баланс с увереност и топлина. Вдъхновяваш другите.",
    "reading_advice": "Бъди себе си – уверено и топло. Твоят баланс вдъхновява доверие."
  },
  {
    "reading_id": "two_pentacles_king_wands",
    "reading_name": "Двойка Пентакли + Цар Жезли",
    "reading_cards": "Двойка Пентакли + Цар Жезли",
    "reading_combination": ["two_pentacles", "king_wands"],
    "reading_meaning": "Лидерски баланс",
    "second_meaning": "Двойка Пентакли носи баланс, а Цар Жезли – лидерство и визия. Вашият финансов баланс ви поставя в лидерска позиция. Имате визията да водите другите.",
    "reading_description": "Финансовият ти баланс те поставя в лидерска позиция. Имаш визия.",
    "reading_advice": "Поеми лидерството. Твоят баланс и визия ще вдъхновят другите."
  },
  {
    "reading_id": "two_pentacles_ace_wands",
    "reading_name": "Двойка Пентакли + Асо Жезли",
    "reading_cards": "Двойка Пентакли + Асо Жезли",
    "reading_combination": ["two_pentacles", "ace_wands"],
    "reading_meaning": "Баланс и ново начало",
    "second_meaning": "Двойка Пентакли носи баланс, а Асо Жезли – ново начало и вдъхновение. Нова възможност се появява в момент, когато сте във финансов баланс. Готови сте да я посрещнете.",
    "reading_description": "Нова финансова възможност идва, когато си в баланс. Готов си.",
    "reading_advice": "Хвани възможността. Балансът ти дава стабилна основа за нов старт."
  },
  {
    "reading_id": "two_pentacles_ace_cups",
    "reading_name": "Двойка Пентакли + Асо Чаши",
    "reading_cards": "Двойка Пентакли + Асо Чаши",
    "reading_combination": ["two_pentacles", "ace_cups"],
    "reading_meaning": "Баланс и нови чувства",
    "second_meaning": "Двойка Пентакли носи баланс, а Асо Чаши – нови чувства и любов. Нова любов или емоционално начало идва в период на финансов баланс. Емоции и стабилност заедно.",
    "reading_description": "Нова любов идва, когато си във финансов баланс. Стабилност и емоции.",
    "reading_advice": "Отвори сърцето си. Балансът ти позволява да приемеш любовта спокойно."
  },
  {
    "reading_id": "two_pentacles_two_cups",
    "reading_name": "Двойка Пентакли + Двойка Чаши",
    "reading_cards": "Двойка Пентакли + Двойка Чаши",
    "reading_combination": ["two_pentacles", "two_cups"],
    "reading_meaning": "Баланс и любов",
    "second_meaning": "Двойка Пентакли носи баланс, а Двойка Чаши – любов и връзка. Успявате да балансирате финансите и любовта си. Хармония между сърце и портфейл.",
    "reading_description": "Балансираш финансите и любовта. Хармония между сърце и портфейл.",
    "reading_advice": "Пази този баланс. Той е рядък и ценен. Любовта и стабилността могат да съществуват заедно."
  },
  {
    "reading_id": "two_pentacles_three_cups",
    "reading_name": "Двойка Пентакли + Тройка Чаши",
    "reading_cards": "Двойка Пентакли + Тройка Чаши",
    "reading_combination": ["two_pentacles", "three_cups"],
    "reading_meaning": "Баланс и празник",
    "second_meaning": "Двойка Пентакли носи баланс, а Тройка Чаши – празник и радост. Успявате да балансирате финансите си, което ви позволява да празнувате с приятели. Споделена радост.",
    "reading_description": "Балансираш финансите и празнуваш с приятели. Споделена радост.",
    "reading_advice": "Празнувай, но продължавай да балансираш. Радостта е по-голяма, когато има сигурност."
  },
  {
    "reading_id": "two_pentacles_four_cups",
    "reading_name": "Двойка Пентакли + Четворка Чаши",
    "reading_cards": "Двойка Пентакли + Четворка Чаши",
    "reading_combination": ["two_pentacles", "four_cups"],
    "reading_meaning": "Баланс и неудовлетворение",
    "second_meaning": "Двойка Пентакли носи баланс, а Четворка Чаши – апатия и неудовлетворение. Имате финансов баланс, но не сте щастливи. Нещо ви липсва. Търсете радостта не само в парите.",
    "reading_description": "Имаш финансов баланс, но не си щастлив. Нещо липсва.",
    "reading_advice": "Потърси радостта не само в парите. Истинското щастие идва отвътре."
  },
  {
    "reading_id": "two_pentacles_five_cups",
    "reading_name": "Двойка Пентакли + Петица Чаши",
    "reading_cards": "Двойка Пентакли + Петица Чаши",
    "reading_combination": ["two_pentacles", "five_cups"],
    "reading_meaning": "Баланс и загуба",
    "second_meaning": "Двойка Пентакли носи баланс, а Петица Чаши – загуба и тъга. Опитвате се да запазите финансов баланс след загуба. Трудно, но възможно. Позволете си да скърбите.",
    "reading_description": "Опитваш се да запазиш финансов баланс след загуба. Трудно, но възможно.",
    "reading_advice": "Позволи си да скърбиш, после продължи. Балансът ще се възстанови с времето."
  },
  {
    "reading_id": "two_pentacles_six_cups",
    "reading_name": "Двойка Пентакли + Шестица Чаши",
    "reading_cards": "Двойка Пентакли + Шестица Чаши",
    "reading_combination": ["two_pentacles", "six_cups"],
    "reading_meaning": "Баланс и носталгия",
    "second_meaning": "Двойка Пентакли носи баланс, а Шестица Чаши – спомени и носталгия. Финансовият ви баланс ви позволява да си позволите нещо, което ви напомня за миналото. Носталгична инвестиция.",
    "reading_description": "Финансовият ти баланс ти позволява да си позволиш нещо от миналото.",
    "reading_advice": "Използвай миналото като вдъхновение, но не позволявай то да те държи в капан."
  },
  {
    "reading_id": "two_pentacles_seven_cups",
    "reading_name": "Двойка Пентакли + Седмица Чаши",
    "reading_cards": "Двойка Пентакли + Седмица Чаши",
    "reading_combination": ["two_pentacles", "seven_cups"],
    "reading_meaning": "Баланс и илюзии",
    "second_meaning": "Двойка Пентакли носи баланс, а Седмица Чаши – илюзии и фантазии. Опитвате се да балансирате финансите си, но сте заобиколени от илюзорни възможности. Внимавайте да не се заблудите.",
    "reading_description": "Балансираш финансите сред илюзорни възможности. Внимавай да не се заблудиш.",
    "reading_advice": "Свали розовите очила. Реалността е по-ценна от фантазията, особено когато става въпрос за пари."
  },
  {
    "reading_id": "two_pentacles_eight_cups",
    "reading_name": "Двойка Пентакли + Осмица Чаши",
    "reading_cards": "Двойка Пентакли + Осмица Чаши",
    "reading_combination": ["two_pentacles", "eight_cups"],
    "reading_meaning": "Баланс и тръгване",
    "second_meaning": "Двойка Пентакли носи баланс, а Осмица Чаши – тръгване и оставяне. Напълно сте балансирали финансите си и вече можете да тръгнете на ново място. Освободени сте.",
    "reading_description": "Балансирал си финансите и можеш да тръгнеш на ново място. Свобода.",
    "reading_advice": "Тръгни с увереност. Балансът ти дава свобода да продължиш напред."
  },
  {
    "reading_id": "two_pentacles_nine_cups",
    "reading_name": "Двойка Пентакли + Деветка Чаши",
    "reading_cards": "Двойка Пентакли + Деветка Чаши",
    "reading_combination": ["two_pentacles", "nine_cups"],
    "reading_meaning": "Баланс и сбъдната мечта",
    "second_meaning": "Двойка Пентакли носи баланс, а Деветка Чаши – сбъднато желание. Финансовият ви баланс ви позволява да сбъднете дългогодишна мечта. Удовлетворение и радост.",
    "reading_description": "Финансовият ти баланс ти позволява да сбъднеш мечта. Удовлетворение.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Балансът доведе до мечтата."
  },
  {
    "reading_id": "two_pentacles_ten_cups",
    "reading_name": "Двойка Пентакли + Десетка Чаши",
    "reading_cards": "Двойка Пентакли + Десетка Чаши",
    "reading_combination": ["two_pentacles", "ten_cups"],
    "reading_meaning": "Баланс и семейно щастие",
    "second_meaning": "Двойка Пентакли носи баланс, а Десетка Чаши – семейно щастие. Финансовият ви баланс носи хармония в семейството. Споделена стабилност и радост.",
    "reading_description": "Финансовият ти баланс носи хармония в семейството. Споделена радост.",
    "reading_advice": "Семейството ти се радва на стабилността. Бъди благодарен и продължавай да балансираш."
  },
  {
    "reading_id": "two_pentacles_page_cups",
    "reading_name": "Двойка Пентакли + Паж Чаши",
    "reading_cards": "Двойка Пентакли + Паж Чаши",
    "reading_combination": ["two_pentacles", "page_cups"],
    "reading_meaning": "Баланс и послание",
    "second_meaning": "Двойка Пентакли носи баланс, а Паж Чаши – емоционално послание. В период на финансов баланс идва нежно послание от сърце. Отворете се за него.",
    "reading_description": "В период на финансов баланс идва нежно послание от сърце.",
    "reading_advice": "Отвори сърцето си за посланието. То носи нещо ценно."
  },
  {
    "reading_id": "two_pentacles_knight_cups",
    "reading_name": "Двойка Пентакли + Рицар Чаши",
    "reading_cards": "Двойка Пентакли + Рицар Чаши",
    "reading_combination": ["two_pentacles", "knight_cups"],
    "reading_meaning": "Баланс и романтика",
    "second_meaning": "Двойка Пентакли носи баланс, а Рицар Чаши – романтика и ухажване. Романтичен жест идва в момент на финансова стабилност. Любов и сигурност заедно.",
    "reading_description": "Романтичен жест идва в момент на финансова стабилност.",
    "reading_advice": "Кажи какво чувстваш. Балансът ти позволява да приемеш любовта спокойно."
  },
  {
    "reading_id": "two_pentacles_queen_cups",
    "reading_name": "Двойка Пентакли + Царица Чаши",
    "reading_cards": "Двойка Пентакли + Царица Чаши",
    "reading_combination": ["two_pentacles", "queen_cups"],
    "reading_meaning": "Интуитивен баланс",
    "second_meaning": "Двойка Пентакли носи баланс, а Царица Чаши – интуиция и дълбока емоционалност. Интуицията ви помага да поддържате финансов баланс. Доверете се на вътрешния си глас.",
    "reading_description": "Интуицията ти помага да поддържаш финансов баланс.",
    "reading_advice": "Довери се на вътрешния си глас. Той знае как да балансираш."
  },
  {
    "reading_id": "two_pentacles_king_cups",
    "reading_name": "Двойка Пентакли + Цар Чаши",
    "reading_cards": "Двойка Пентакли + Цар Чаши",
    "reading_combination": ["two_pentacles", "king_cups"],
    "reading_meaning": "Балансирана мъдрост",
    "second_meaning": "Двойка Пентакли носи баланс, а Цар Чаши – емоционална зрялост и баланс. Поддържате финансов баланс с мъдрост и спокойствие. Без крайности, без прибързване.",
    "reading_description": "Поддържаш финансов баланс с мъдрост и спокойствие.",
    "reading_advice": "Продължавай така. Балансът и мъдростта вървят ръка за ръка."
  },
    {
    "reading_id": "three_pentacles_two_wands",
    "reading_name": "Тройка Пентакли + Двойка Жезли",
    "reading_cards": "Тройка Пентакли + Двойка Жезли",
    "reading_combination": ["three_pentacles", "two_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа и сътрудничество, а Двойка Жезли – избор и планиране. Работите в екип и предстои важен избор. Съветвайте се с другите – заедно ще вземете правилното решение.",
    "reading_description": "Екипна работа и важен избор пред вас. Съветвайте се с колегите.",
    "reading_advice": "Посъветвай се с екипа. Заедно ще вземете по-добро решение."
  },
  {
    "reading_id": "three_pentacles_three_wands",
    "reading_name": "Тройка Пентакли + Тройка Жезли",
    "reading_cards": "Тройка Пентакли + Тройка Жезли",
    "reading_combination": ["three_pentacles", "three_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Тройка Жезли – очакване и разширяване. С екипа сте инвестирали време и усилия и сега чакате резултатите. Търпението ще бъде възнаградено.",
    "reading_description": "С екипа чакате резултати. Търпение и вяра.",
    "reading_advice": "Чакайте търпеливо заедно. Добрите неща идват при тези, които умеят да чакат."
  },
  {
    "reading_id": "three_pentacles_four_wands",
    "reading_name": "Тройка Пентакли + Четворка Жезли",
    "reading_cards": "Тройка Пентакли + Четворка Жезли",
    "reading_combination": ["three_pentacles", "four_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Четворка Жезли – празник и стабилност. Завършвате проект с екипа и това е повод за празнуване. Споделен успех и радост.",
    "reading_description": "Завършвате проект с екипа – повод за празник. Споделен успех.",
    "reading_advice": "Празнувайте заедно. Успехът е по-сладък, когато е споделен."
  },
  {
    "reading_id": "three_pentacles_five_wands",
    "reading_name": "Тройка Пентакли + Петица Жезли",
    "reading_cards": "Тройка Пентакли + Петица Жезли",
    "reading_combination": ["three_pentacles", "five_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Петица Жезли – конфликт и съперничество. В екипа има спорове и напрежение. Търсете обща цел, за да разрешите конфликта.",
    "reading_description": "Конфликти и спорове в екипа. Търсете обща цел.",
    "reading_advice": "Потърсете общата цел. В екипа сме заедно – конфликтите пречат на успеха."
  },
  {
    "reading_id": "three_pentacles_six_wands",
    "reading_name": "Тройка Пентакли + Шестица Жезли",
    "reading_cards": "Тройка Пентакли + Шестица Жезли",
    "reading_combination": ["three_pentacles", "six_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Шестица Жезли – победа и признание. Екипният ви труд получава признание. Успехът е споделен и всички се радват.",
    "reading_description": "Екипният ви труд получава признание. Споделен успех.",
    "reading_advice": "Споделете успеха с екипа. Благодарете им – без тях нямаше да го постигнете."
  },
  {
    "reading_id": "three_pentacles_seven_wands",
    "reading_name": "Тройка Пентакли + Седмица Жезли",
    "reading_cards": "Тройка Пентакли + Седмица Жезли",
    "reading_combination": ["three_pentacles", "seven_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Седмица Жезли – защита на позицията. Екипът ви е под атака – трябва да защитавате работата си. Дръжте се заедно.",
    "reading_description": "Екипът ви е под атака – дръжте се заедно и защитавайте работата си.",
    "reading_advice": "Дръжте се заедно. Екипът е по-силен от всеки отделен член."
  },
  {
    "reading_id": "three_pentacles_eight_wands",
    "reading_name": "Тройка Пентакли + Осмица Жезли",
    "reading_cards": "Тройка Пентакли + Осмица Жезли",
    "reading_combination": ["three_pentacles", "eight_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Осмица Жезли – бързина и движение. Проектът се движи бързо – екипът трябва да действа светкавично. Координацията е ключова.",
    "reading_description": "Проектът се движи бързо – екипът трябва да действа светкавично.",
    "reading_advice": "Координирайте се. Бързината изисква добра комуникация в екипа."
  },
  {
    "reading_id": "three_pentacles_nine_wands",
    "reading_name": "Тройка Пентакли + Деветка Жезли",
    "reading_cards": "Тройка Пентакли + Деветка Жезли",
    "reading_combination": ["three_pentacles", "nine_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Деветка Жезли – устойчивост и изтощение. Екипът е изтощен от усилията, но финалът наближава. Дръжте се още малко.",
    "reading_description": "Екипът е изтощен, но финалът наближава. Дръжте се заедно.",
    "reading_advice": "Дръжте се още малко. Финалната права е точно зад ъгъла."
  },
  {
    "reading_id": "three_pentacles_ten_wands",
    "reading_name": "Тройка Пентакли + Десетка Жезли",
    "reading_cards": "Тройка Пентакли + Десетка Жезли",
    "reading_combination": ["three_pentacles", "ten_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Десетка Жезли – претоварване и бреме. Екипът е претоварен с отговорности. Споделете задачите, за да не изгорите.",
    "reading_description": "Екипът е претоварен. Споделете задачите, за да не изгорите.",
    "reading_advice": "Споделете бремето. Никой не може да носи всичко сам."
  },
  {
    "reading_id": "three_pentacles_page_wands",
    "reading_name": "Тройка Пентакли + Паж Жезли",
    "reading_cards": "Тройка Пентакли + Паж Жезли",
    "reading_combination": ["three_pentacles", "page_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Паж Жезли – новини и ентусиазъм. В екипа идват вълнуващи новини. Ентусиазъм и вдъхновение за всички.",
    "reading_description": "Вълнуващи новини идват в екипа. Ентусиазъм и вдъхновение.",
    "reading_advice": "Споделете новините с екипа. Те носят енергия за напред."
  },
  {
    "reading_id": "three_pentacles_knight_wands",
    "reading_name": "Тройка Пентакли + Рицар Жезли",
    "reading_cards": "Тройка Пентакли + Рицар Жезли",
    "reading_combination": ["three_pentacles", "knight_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Рицар Жезли – импулсивност и бързина. Някой в екипа действа импулсивно. Забавете темпото, преди да сте направили грешка.",
    "reading_description": "Някой в екипа действа импулсивно. Забавете темпото.",
    "reading_advice": "Забавете. Импулсивните решения рядко са добри за екипа."
  },
  {
    "reading_id": "three_pentacles_queen_wands",
    "reading_name": "Тройка Пентакли + Царица Жезли",
    "reading_cards": "Тройка Пентакли + Царица Жезли",
    "reading_combination": ["three_pentacles", "queen_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Царица Жезли – увереност и харизма. Вие сте сърцето на екипа – вашата увереност вдъхновява всички. Водете с топлина.",
    "reading_description": "Ти си сърцето на екипа – увереността ти вдъхновява всички.",
    "reading_advice": "Бъди топъл и уверен. Твоята светлина води екипа напред."
  },
  {
    "reading_id": "three_pentacles_king_wands",
    "reading_name": "Тройка Пентакли + Цар Жезли",
    "reading_cards": "Тройка Пентакли + Цар Жезли",
    "reading_combination": ["three_pentacles", "king_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Цар Жезли – лидерство и визия. Вие сте лидерът на екипа – вашата визия води всички към успех. Водете с пример.",
    "reading_description": "Ти си лидерът на екипа – визията ти води всички към успех.",
    "reading_advice": "Поеми лидерството. Твоята визия ще вдъхнови екипа да те последва."
  },
  {
    "reading_id": "three_pentacles_ace_wands",
    "reading_name": "Тройка Пентакли + Асо Жезли",
    "reading_cards": "Тройка Пентакли + Асо Жезли",
    "reading_combination": ["three_pentacles", "ace_wands"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Асо Жезли – ново начало и вдъхновение. Екипът започва нов проект с много ентусиазъм. Искрата е запалена – сега работете заедно.",
    "reading_description": "Екипът започва нов проект с много ентусиазъм. Работете заедно.",
    "reading_advice": "Хванете искрата заедно. Екипният ентусиазъм води до успех."
  },
  {
    "reading_id": "three_pentacles_ace_cups",
    "reading_name": "Тройка Пентакли + Асо Чаши",
    "reading_cards": "Тройка Пентакли + Асо Чаши",
    "reading_combination": ["three_pentacles", "ace_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Асо Чаши – нови чувства и любов. В екипа се раждат нови чувства или приятелство. Емоционална връзка, която укрепва екипа.",
    "reading_description": "В екипа се раждат нови чувства. Емоционална връзка укрепва екипа.",
    "reading_advice": "Отвори сърцето си за екипа. Емоционалната връзка прави работата по-лека."
  },
  {
    "reading_id": "three_pentacles_two_cups",
    "reading_name": "Тройка Пентакли + Двойка Чаши",
    "reading_cards": "Тройка Пентакли + Двойка Чаши",
    "reading_combination": ["three_pentacles", "two_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Двойка Чаши – любов и връзка. В екипа има специална връзка – партньорство, което работи чудесно. Хармония и сътрудничество.",
    "reading_description": "В екипа има специална връзка – партньорство, което работи чудесно.",
    "reading_advice": "Ценете тази връзка. Хармонията в екипа е безценна."
  },
  {
    "reading_id": "three_pentacles_three_cups",
    "reading_name": "Тройка Пентакли + Тройка Чаши",
    "reading_cards": "Тройка Пентакли + Тройка Чаши",
    "reading_combination": ["three_pentacles", "three_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Тройка Чаши – празник и радост. Екипът празнува успех или събитие. Радост, споделена с колеги, е двойна радост.",
    "reading_description": "Екипът празнува успех. Радост, споделена с колеги, е двойна радост.",
    "reading_advice": "Празнувайте заедно. Тези моменти укрепват екипа."
  },
  {
    "reading_id": "three_pentacles_four_cups",
    "reading_name": "Тройка Пентакли + Четворка Чаши",
    "reading_cards": "Тройка Пентакли + Четворка Чаши",
    "reading_combination": ["three_pentacles", "four_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Четворка Чаши – апатия и неудовлетворение. В екипа има неудовлетворение и апатия. Някой не дава най-доброто от себе си. Потърсете причината.",
    "reading_description": "В екипа има неудовлетворение. Някой не дава най-доброто от себе си.",
    "reading_advice": "Потърсете причината. Понякога човек има нужда да бъде чут."
  },
  {
    "reading_id": "three_pentacles_five_cups",
    "reading_name": "Тройка Пентакли + Петица Чаши",
    "reading_cards": "Тройка Пентакли + Петица Чаши",
    "reading_combination": ["three_pentacles", "five_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Петица Чаши – загуба и тъга. Екипът преживява загуба – напускане на член, провален проект. Позволете си да скърбите заедно.",
    "reading_description": "Екипът преживява загуба – напускане на член, провален проект.",
    "reading_advice": "Позволете си да скърбите заедно. Това ще ви направи по-силни."
  },
  {
    "reading_id": "three_pentacles_six_cups",
    "reading_name": "Тройка Пентакли + Шестица Чаши",
    "reading_cards": "Тройка Пентакли + Шестица Чаши",
    "reading_combination": ["three_pentacles", "six_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Шестица Чаши – спомени и носталгия. Екипът се връща към стари проекти или спомени. Носталгия, която може да вдъхнови новото.",
    "reading_description": "Екипът се връща към стари проекти. Носталгия и вдъхновение.",
    "reading_advice": "Използвайте миналото като вдъхновение, но гледайте напред."
  },
  {
    "reading_id": "three_pentacles_seven_cups",
    "reading_name": "Тройка Пентакли + Седмица Чаши",
    "reading_cards": "Тройка Пентакли + Седмица Чаши",
    "reading_combination": ["three_pentacles", "seven_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Седмица Чаши – илюзии и фантазии. В екипа има нереалистични очаквания. Свалете розовите очила и погледнете реалността.",
    "reading_description": "В екипа има нереалистични очаквания. Погледнете реалността.",
    "reading_advice": "Свалете розовите очила. Реалността е по-ценна от фантазията."
  },
  {
    "reading_id": "three_pentacles_eight_cups",
    "reading_name": "Тройка Пентакли + Осмица Чаши",
    "reading_cards": "Тройка Пентакли + Осмица Чаши",
    "reading_combination": ["three_pentacles", "eight_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Осмица Чаши – тръгване и оставяне. Член на екипа напуска или вие решавате да тръгнете по нов път. Тръгвайте с мир.",
    "reading_description": "Член на екипа напуска или вие решавате да тръгнете по нов път.",
    "reading_advice": "Тръгвайте с мир. Пътищата се разделят, за да се срещнат отново."
  },
  {
    "reading_id": "three_pentacles_nine_cups",
    "reading_name": "Тройка Пентакли + Деветка Чаши",
    "reading_cards": "Тройка Пентакли + Деветка Чаши",
    "reading_combination": ["three_pentacles", "nine_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Деветка Чаши – сбъднато желание. Екипът постига това, за което е мечтал. Споделено удовлетворение и радост.",
    "reading_description": "Екипът постига това, за което е мечтал. Споделено удовлетворение.",
    "reading_advice": "Насладете се на момента заедно. Ти и екипът го заслужихте."
  },
  {
    "reading_id": "three_pentacles_ten_cups",
    "reading_name": "Тройка Пентакли + Десетка Чаши",
    "reading_cards": "Тройка Пентакли + Десетка Чаши",
    "reading_combination": ["three_pentacles", "ten_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Десетка Чаши – семейно щастие. Екипът става като семейство. Хармония, подкрепа и споделена радост.",
    "reading_description": "Екипът става като семейство. Хармония и споделена радост.",
    "reading_advice": "Ценете екипа си като семейство. Те са вашата опора."
  },
  {
    "reading_id": "three_pentacles_page_cups",
    "reading_name": "Тройка Пентакли + Паж Чаши",
    "reading_cards": "Тройка Пентакли + Паж Чаши",
    "reading_combination": ["three_pentacles", "page_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Паж Чаши – емоционално послание. В екипа идва нежно послание или предложение. Отворете сърцата си за него.",
    "reading_description": "В екипа идва нежно послание. Отворете сърцата си за него.",
    "reading_advice": "Слушайте с отворени сърца. Посланието носи нещо ценно за екипа."
  },
  {
    "reading_id": "three_pentacles_knight_cups",
    "reading_name": "Тройка Пентакли + Рицар Чаши",
    "reading_cards": "Тройка Пентакли + Рицар Чаши",
    "reading_combination": ["three_pentacles", "knight_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Рицар Чаши – романтика и ухажване. В екипа може да се роди любов или романтичен жест. Позволете на чувствата да текат.",
    "reading_description": "В екипа може да се роди любов. Позволете на чувствата да текат.",
    "reading_advice": "Позволи на чувствата да текат. Любовта в екипа може да е прекрасна."
  },
  {
    "reading_id": "three_pentacles_queen_cups",
    "reading_name": "Тройка Пентакли + Царица Чаши",
    "reading_cards": "Тройка Пентакли + Царица Чаши",
    "reading_combination": ["three_pentacles", "queen_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Царица Чаши – интуиция и емпатия. Вие сте емпатичната душа на екипа – вашата интуиция води всички. Слушайте я.",
    "reading_description": "Ти си емпатичната душа на екипа – интуицията ти води всички.",
    "reading_advice": "Довери се на интуицията си. Тя знае какво е най-добро за екипа."
  },
  {
    "reading_id": "three_pentacles_king_cups",
    "reading_name": "Тройка Пентакли + Цар Чаши",
    "reading_cards": "Тройка Пентакли + Цар Чаши",
    "reading_combination": ["three_pentacles", "king_cups"],
    "reading_meaning": "Тройка Пентакли носи екипна работа, а Цар Чаши – емоционална зрялост и баланс. Вие сте емоционалният стълб на екипа – вашият баланс държи всички заедно.",
    "reading_description": "Ти си емоционалният стълб на екипа – балансът ти държи всички.",
    "reading_advice": "Бъди спокоен и мъдър. Твоят баланс е опората на екипа."
  },
    {
    "reading_id": "four_pentacles_two_wands",
    "reading_name": "Четворка Пентакли + Двойка Жезли",
    "reading_cards": "Четворка Пентакли + Двойка Жезли",
    "reading_combination": ["four_pentacles", "two_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Двойка Жезли – избор и планиране. Държите здраво ресурсите си, но предстои избор. Страхът от загуба може да ви попречи да изберете най-доброто.",
    "reading_description": "Държиш здраво ресурсите си, но предстои избор. Страхът от загуба те спира.",
    "reading_advice": "Пусни малко. Страхът от загуба може да ти попречи да спечелиш нещо по-добро."
  },
  {
    "reading_id": "four_pentacles_three_wands",
    "reading_name": "Четворка Пентакли + Тройка Жезли",
    "reading_cards": "Четворка Пентакли + Тройка Жезли",
    "reading_combination": ["four_pentacles", "three_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Тройка Жезли – очакване и разширяване. Инвестирали сте и сега чакате, но стискате прекалено силно. Пуснете малко, за да могат плодовете да узреят.",
    "reading_description": "Инвестирал си и чакаш, но стискаш прекалено силно. Пусни малко.",
    "reading_advice": "Не стискай толкова силно. Дай време на инвестицията да узрее."
  },
  {
    "reading_id": "four_pentacles_four_wands",
    "reading_name": "Четворка Пентакли + Четворка Жезли",
    "reading_cards": "Четворка Пентакли + Четворка Жезли",
    "reading_combination": ["four_pentacles", "four_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Четворка Жезли – празник и стабилност. Имате стабилен дом и финанси, но се страхувате да празнувате. Позволете си да се насладите на постигнатото.",
    "reading_description": "Имаш стабилен дом и финанси, но се страхуваш да празнуваш.",
    "reading_advice": "Позволи си да се насладиш. Заслужил си този момент на радост."
  },
  {
    "reading_id": "four_pentacles_five_wands",
    "reading_name": "Четворка Пентакли + Петица Жезли",
    "reading_cards": "Четворка Пентакли + Петица Жезли",
    "reading_combination": ["four_pentacles", "five_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Петица Жезли – конфликт и съперничество. Спор за ресурси или пари. Някой се опитва да ви вземе това, което сте натрупали. Дръжте се твърдо.",
    "reading_description": "Спор за ресурси или пари. Някой се опитва да ти вземе това, което си натрупал.",
    "reading_advice": "Дръж се твърдо, но не стискай до болка. Търси компромис, ако е възможно."
  },
  {
    "reading_id": "four_pentacles_six_wands",
    "reading_name": "Четворка Пентакли + Шестица Жезли",
    "reading_cards": "Четворка Пентакли + Шестица Жезли",
    "reading_combination": ["four_pentacles", "six_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Шестица Жезли – победа и признание. Постигнали сте успех и го пазите. Гордейте се с постигнатото, но не позволявайте егото да ви заслепи.",
    "reading_description": "Постигнал си успех и го пазиш. Гордей се, но не позволявай егото да те заслепи.",
    "reading_advice": "Наслаждавай се на успеха, но не спирай да се развиваш."
  },
  {
    "reading_id": "four_pentacles_seven_wands",
    "reading_name": "Четворка Пентакли + Седмица Жезли",
    "reading_cards": "Четворка Пентакли + Седмица Жезли",
    "reading_combination": ["four_pentacles", "seven_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Седмица Жезли – защита на позицията. Трябва да защитавате това, което сте натрупали. Някой иска да ви го отнеме. Дръжте позицията си.",
    "reading_description": "Трябва да защитаваш това, което си натрупал. Някой иска да ти го отнеме.",
    "reading_advice": "Дръж позицията си. Това, което си изградил, си заслужава защита."
  },
  {
    "reading_id": "four_pentacles_eight_wands",
    "reading_name": "Четворка Пентакли + Осмица Жезли",
    "reading_cards": "Четворка Пентакли + Осмица Жезли",
    "reading_combination": ["four_pentacles", "eight_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Осмица Жезли – бързина и движение. Всичко се случва бързо, а вие се опитвате да задържите контрол. Пуснете малко – не можете да контролирате всичко.",
    "reading_description": "Всичко се случва бързо, а ти се опитваш да задържиш контрол.",
    "reading_advice": "Пусни малко. Не можеш да контролираш всичко. Довери се на процеса."
  },
  {
    "reading_id": "four_pentacles_nine_wands",
    "reading_name": "Четворка Пентакли + Деветка Жезли",
    "reading_cards": "Четворка Пентакли + Деветка Жезли",
    "reading_combination": ["four_pentacles", "nine_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Деветка Жезли – устойчивост и изтощение. Изтощени сте от защитата на това, което имате. Умора, но не се отказвайте – краят наближава.",
    "reading_description": "Изтощен си от защитата на това, което имаш. Умора, но не се отказвай.",
    "reading_advice": "Дръж се още малко. Финалната права е точно зад ъгъла."
  },
  {
    "reading_id": "four_pentacles_ten_wands",
    "reading_name": "Четворка Пентакли + Десетка Жезли",
    "reading_cards": "Четворка Пентакли + Десетка Жезли",
    "reading_combination": ["four_pentacles", "ten_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Десетка Жезли – претоварване и бреме. Носите твърде много отговорности и се вкопчвате в тях от страх. Освободете се от ненужното бреме.",
    "reading_description": "Носиш твърде много отговорности и се вкопчваш в тях от страх.",
    "reading_advice": "Освободи се от ненужното бреме. Не можеш да носиш всичко сам."
  },
  {
    "reading_id": "four_pentacles_page_wands",
    "reading_name": "Четворка Пентакли + Паж Жезли",
    "reading_cards": "Четворка Пентакли + Паж Жезли",
    "reading_combination": ["four_pentacles", "page_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Паж Жезли – новини и ентусиазъм. Вълнуваща новина идва, но вие се страхувате да я приемете. Отворете се за нея.",
    "reading_description": "Вълнуваща новина идва, но ти се страхуваш да я приемеш.",
    "reading_advice": "Отвори се за новините. Те носят нещо ценно за бъдещето ти."
  },
  {
    "reading_id": "four_pentacles_knight_wands",
    "reading_name": "Четворка Пентакли + Рицар Жезли",
    "reading_cards": "Четворка Пентакли + Рицар Жезли",
    "reading_combination": ["four_pentacles", "knight_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Рицар Жезли – импулсивност и бързина. Някой действа импулсивно и застрашава сигурността ви. Забавете и обмислете.",
    "reading_description": "Някой действа импулсивно и застрашава сигурността ти.",
    "reading_advice": "Забави. Импулсивните решения могат да разрушат това, което си изградил."
  },
  {
    "reading_id": "four_pentacles_queen_wands",
    "reading_name": "Четворка Пентакли + Царица Жезли",
    "reading_cards": "Четворка Пентакли + Царица Жезли",
    "reading_combination": ["four_pentacles", "queen_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Царица Жезли – увереност и харизма. Пазите сигурността си с увереност и топлина. Хората ви се доверяват, защото знаят, че сте стабилни.",
    "reading_description": "Пазиш сигурността си с увереност и топлина. Хората ти се доверяват.",
    "reading_advice": "Бъди топъл и уверен. Твоята стабилност вдъхновява доверие."
  },
  {
    "reading_id": "four_pentacles_king_wands",
    "reading_name": "Четворка Пентакли + Цар Жезли",
    "reading_cards": "Четворка Пентакли + Цар Жезли",
    "reading_combination": ["four_pentacles", "king_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Цар Жезли – лидерство и визия. Вие сте лидер, който пази ресурсите на екипа. Вашата стабилност е опора за всички.",
    "reading_description": "Ти си лидер, който пази ресурсите на екипа. Стабилността ти е опора.",
    "reading_advice": "Води с мъдрост. Твоята стабилност дава сигурност на другите."
  },
  {
    "reading_id": "four_pentacles_ace_wands",
    "reading_name": "Четворка Пентакли + Асо Жезли",
    "reading_cards": "Четворка Пентакли + Асо Жезли",
    "reading_combination": ["four_pentacles", "ace_wands"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Асо Жезли – ново начало и вдъхновение. Нова възможност се появява, но вие се страхувате да инвестирате. Пуснете малко – някои неща си струват риска.",
    "reading_description": "Нова възможност се появява, но ти се страхуваш да инвестираш.",
    "reading_advice": "Пусни малко. Някои неща си струват риска. Не позволявай на страха да те спре."
  },
  {
    "reading_id": "four_pentacles_ace_cups",
    "reading_name": "Четворка Пентакли + Асо Чаши",
    "reading_cards": "Четворка Пентакли + Асо Чаши",
    "reading_combination": ["four_pentacles", "ace_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Асо Чаши – нови чувства и любов. Нова любов идва, но вие се страхувате да отворите сърцето си. Стискането може да ви попречи да обичате.",
    "reading_description": "Нова любов идва, но ти се страхуваш да отвориш сърцето си.",
    "reading_advice": "Отвори сърцето си. Любовта не се стиска – тя се дава свободно."
  },
  {
    "reading_id": "four_pentacles_two_cups",
    "reading_name": "Четворка Пентакли + Двойка Чаши",
    "reading_cards": "Четворка Пентакли + Двойка Чаши",
    "reading_combination": ["four_pentacles", "two_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Двойка Чаши – любов и връзка. Връзката ви е стабилна, но може да имате нужда да се отпуснете повече. Не позволявайте на страха от загуба да ви прави студени.",
    "reading_description": "Връзката ти е стабилна, но може да си твърде стиснат с чувствата.",
    "reading_advice": "Отпусни се. Истинската любов не се страхува от загуба – тя се дава свободно."
  },
  {
    "reading_id": "four_pentacles_three_cups",
    "reading_name": "Четворка Пентакли + Тройка Чаши",
    "reading_cards": "Четворка Пентакли + Тройка Чаши",
    "reading_combination": ["four_pentacles", "three_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Тройка Чаши – празник и радост. Страхувате се да празнувате, защото не искате да харчите. Празникът не е само в парите – радостта е безценна.",
    "reading_description": "Страхуваш се да празнуваш, защото не искаш да харчиш.",
    "reading_advice": "Празникът не е само в парите. Радостта е безценна – позволи си я."
  },
  {
    "reading_id": "four_pentacles_four_cups",
    "reading_name": "Четворка Пентакли + Четворка Чаши",
    "reading_cards": "Четворка Пентакли + Четворка Чаши",
    "reading_combination": ["four_pentacles", "four_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Четворка Чаши – апатия и неудовлетворение. Имате сигурност, но не сте щастливи. Стискате толкова силно, че сте забравили да живеете.",
    "reading_description": "Имаш сигурност, но не си щастлив. Стискаш толкова силно, че си забравил да живееш.",
    "reading_advice": "Пусни малко. Сигурността не е в парите, а в способността да се радваш."
  },
  {
    "reading_id": "four_pentacles_five_cups",
    "reading_name": "Четворка Пентакли + Петица Чаши",
    "reading_cards": "Четворка Пентакли + Петица Чаши",
    "reading_combination": ["four_pentacles", "five_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Петица Чаши – загуба и тъга. Преживявате загуба и се вкопчвате в това, което ви е останало. Позволете си да скърбите, но не се вкопчвайте прекалено.",
    "reading_description": "Преживяваш загуба и се вкопчваш в това, което ти е останало.",
    "reading_advice": "Позволи си да скърбиш, но не се вкопчвай прекалено. Нови неща идват."
  },
  {
    "reading_id": "four_pentacles_six_cups",
    "reading_name": "Четворка Пентакли + Шестица Чаши",
    "reading_cards": "Четворка Пентакли + Шестица Чаши",
    "reading_combination": ["four_pentacles", "six_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Шестица Чаши – спомени и носталгия. Държите се за спомени и стари неща. Понякога трябва да пуснем, за да освободим място за новото.",
    "reading_description": "Държиш се за спомени и стари неща. Пусни, за да освободиш място за новото.",
    "reading_advice": "Пусни. Спомените са в сърцето, не в нещата."
  },
  {
    "reading_id": "four_pentacles_seven_cups",
    "reading_name": "Четворка Пентакли + Седмица Чаши",
    "reading_cards": "Четворка Пентакли + Седмица Чаши",
    "reading_combination": ["four_pentacles", "seven_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Седмица Чаши – илюзии и фантазии. Живеете в илюзия, че стискането ще ви донесе сигурност. Истинската сигурност идва отвътре.",
    "reading_description": "Живееш в илюзия, че стискането ще ти донесе сигурност.",
    "reading_advice": "Свали розовите очила. Истинската сигурност идва отвътре, не от това, което стискаш."
  },
  {
    "reading_id": "four_pentacles_eight_cups",
    "reading_name": "Четворка Пентакли + Осмица Чаши",
    "reading_cards": "Четворка Пентакли + Осмица Чаши",
    "reading_combination": ["four_pentacles", "eight_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Осмица Чаши – тръгване и оставяне. Тръгвате и оставяте сигурността зад гърба си. Страх, но и освобождение.",
    "reading_description": "Тръгваш и оставяш сигурността зад гърба си. Страх, но и освобождение.",
    "reading_advice": "Тръгни смело. Истинската свобода идва, когато спреш да се страхуваш да пуснеш."
  },
  {
    "reading_id": "four_pentacles_nine_cups",
    "reading_name": "Четворка Пентакли + Деветка Чаши",
    "reading_cards": "Четворка Пентакли + Деветка Чаши",
    "reading_combination": ["four_pentacles", "nine_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Деветка Чаши – сбъднато желание. Постигнали сте това, което искате, и го пазите. Насладете се на момента – заслужили сте го.",
    "reading_description": "Постигнал си това, което искаш, и го пазиш. Наслади се – заслужил си.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Но не спирай да се радваш."
  },
  {
    "reading_id": "four_pentacles_ten_cups",
    "reading_name": "Четворка Пентакли + Десетка Чаши",
    "reading_cards": "Четворка Пентакли + Десетка Чаши",
    "reading_combination": ["four_pentacles", "ten_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Десетка Чаши – семейно щастие. Имате стабилен дом и семейство. Не се страхувайте да споделяте – щастието расте, когато го споделяш.",
    "reading_description": "Имаш стабилен дом и семейство. Не се страхувай да споделяш.",
    "reading_advice": "Сподели щастието си със семейството. То става по-голямо, когато е споделено."
  },
  {
    "reading_id": "four_pentacles_page_cups",
    "reading_name": "Четворка Пентакли + Паж Чаши",
    "reading_cards": "Четворка Пентакли + Паж Чаши",
    "reading_combination": ["four_pentacles", "page_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Паж Чаши – емоционално послание. Нежно послание идва, но вие се страхувате да го приемете. Отворете сърцето си.",
    "reading_description": "Нежно послание идва, но ти се страхуваш да го приемеш.",
    "reading_advice": "Отвори сърцето си. Посланието носи нещо ценно – не го изпускай."
  },
  {
    "reading_id": "four_pentacles_knight_cups",
    "reading_name": "Четворка Пентакли + Рицар Чаши",
    "reading_cards": "Четворка Пентакли + Рицар Чаши",
    "reading_combination": ["four_pentacles", "knight_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Рицар Чаши – романтика и ухажване. Романтичен жест идва, но вие се страхувате да се отпуснете. Позволете на любовта да влезе.",
    "reading_description": "Романтичен жест идва, но ти се страхуваш да се отпуснеш.",
    "reading_advice": "Позволи на любовта да влезе. Истинската любов не те заплашва – тя те обогатява."
  },
  {
    "reading_id": "four_pentacles_queen_cups",
    "reading_name": "Четворка Пентакли + Царица Чаши",
    "reading_cards": "Четворка Пентакли + Царица Чаши",
    "reading_combination": ["four_pentacles", "queen_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Царица Чаши – интуиция и емпатия. Интуицията ви подсказва, че стискате прекалено. Слушайте сърцето си – то знае кога да пуснете.",
    "reading_description": "Интуицията ти подсказва, че стискаш прекалено. Слушай сърцето си.",
    "reading_advice": "Довери се на интуицията си. Тя знае кога да стискаш и кога да пуснеш."
  },
  {
    "reading_id": "four_pentacles_king_cups",
    "reading_name": "Четворка Пентакли + Цар Чаши",
    "reading_cards": "Четворка Пентакли + Цар Чаши",
    "reading_combination": ["four_pentacles", "king_cups"],
    "reading_meaning": "Четворка Пентакли носи сигурност и стискане, а Цар Чаши – емоционална зрялост и баланс. Стискате, но с мъдрост. Знаете кога да задържите и кога да пуснете. Баланс между сигурност и щедрост.",
    "reading_description": "Стискаш, но с мъдрост. Знаеш кога да задържиш и кога да пуснеш.",
    "reading_advice": "Продължавай така. Балансът между сигурност и щедрост е мъдрост."
  },
    {
    "reading_id": "five_pentacles_two_wands",
    "reading_name": "Петица Пентакли + Двойка Жезли",
    "reading_cards": "Петица Пентакли + Двойка Жезли",
    "reading_combination": ["five_pentacles", "two_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Двойка Жезли – избор и планиране. Имате ограничени ресурси и предстои важен избор. Търсете помощ и планирайте внимателно – всяко решение има значение.",
    "reading_description": "Ограничени ресурси и важен избор пред теб. Планирай внимателно.",
    "reading_advice": "Потърси помощ. Не си сам. Планирай внимателно – всяка стъпка има значение."
  },
  {
    "reading_id": "five_pentacles_three_wands",
    "reading_name": "Петица Пентакли + Тройка Жезли",
    "reading_cards": "Петица Пентакли + Тройка Жезли",
    "reading_combination": ["five_pentacles", "three_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Тройка Жезли – очакване и разширяване. Инвестирали сте последните си ресурси и сега чакате. Трудно очакване, но надеждата ви крепи.",
    "reading_description": "Инвестирал си последните си ресурси и сега чакаш. Трудно, но надеждата те крепи.",
    "reading_advice": "Чакай търпеливо. Надеждата е последното, което умира. Вярвай, че ще се получи."
  },
  {
    "reading_id": "five_pentacles_four_wands",
    "reading_name": "Петица Пентакли + Четворка Жезли",
    "reading_cards": "Петица Пентакли + Четворка Жезли",
    "reading_combination": ["five_pentacles", "four_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Четворка Жезли – празник и стабилност. Искате да празнувате, но ресурсите са ограничени. Истинският празник не е в парите – той е в сърцето.",
    "reading_description": "Искаш да празнуваш, но ресурсите са ограничени. Истинският празник не е в парите.",
    "reading_advice": "Празнувай с това, което имаш. Истинската радост не изисква много пари."
  },
  {
    "reading_id": "five_pentacles_five_wands",
    "reading_name": "Петица Пентакли + Петица Жезли",
    "reading_cards": "Петица Пентакли + Петица Жезли",
    "reading_combination": ["five_pentacles", "five_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Петица Жезли – конфликт и съперничество. Борите се за оскъдни ресурси. Конфликти и спорове около пари. Търсете мирно решение.",
    "reading_description": "Бориш се за оскъдни ресурси. Конфликти и спорове около пари.",
    "reading_advice": "Търси мирно решение. Борбата за оскъдни ресурси рядко носи победа."
  },
  {
    "reading_id": "five_pentacles_six_wands",
    "reading_name": "Петица Пентакли + Шестица Жезли",
    "reading_cards": "Петица Пентакли + Шестица Жезли",
    "reading_combination": ["five_pentacles", "six_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Шестица Жезли – победа и признание. Въпреки трудностите, идва успех. Победата е по-сладка, когато идва след тежък период.",
    "reading_description": "Въпреки трудностите, идва успех. Победата е по-сладка след тежък период.",
    "reading_advice": "Наслади се на победата. Ти я заслужи. Трудностите те направиха по-силен."
  },
  {
    "reading_id": "five_pentacles_seven_wands",
    "reading_name": "Петица Пентакли + Седмица Жезли",
    "reading_cards": "Петица Пентакли + Седмица Жезли",
    "reading_combination": ["five_pentacles", "seven_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Седмица Жезли – защита на позицията. Някой се опитва да ви отнеме малкото, което имате. Защитавайте се, но търсете и помощ.",
    "reading_description": "Някой се опитва да ти отнеме малкото, което имаш. Защитавай се.",
    "reading_advice": "Защитавай се, но не се затваряй. Потърси помощ – има хора, които искат да помогнат."
  },
  {
    "reading_id": "five_pentacles_eight_wands",
    "reading_name": "Петица Пентакли + Осмица Жезли",
    "reading_cards": "Петица Пентакли + Осмица Жезли",
    "reading_combination": ["five_pentacles", "eight_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Осмица Жезли – бързина и движение. Всичко се случва бързо – възможност или заплаха идва светкавично. Бъдете готови да реагирате.",
    "reading_description": "Всичко се случва бързо – възможност или заплаха идва светкавично.",
    "reading_advice": "Бъди готов да реагираш. Скоростта може да ти донесе решение."
  },
  {
    "reading_id": "five_pentacles_nine_wands",
    "reading_name": "Петица Пентакли + Деветка Жезли",
    "reading_cards": "Петица Пентакли + Деветка Жезли",
    "reading_combination": ["five_pentacles", "nine_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Деветка Жезли – устойчивост и изтощение. Борите се с трудностите и сте изтощени. Не се отказвайте – краят наближава.",
    "reading_description": "Бориш се с трудностите и си изтощен. Не се отказвай – краят наближава.",
    "reading_advice": "Дръж се още малко. Финалната права е точно зад ъгъла."
  },
  {
    "reading_id": "five_pentacles_ten_wands",
    "reading_name": "Петица Пентакли + Десетка Жезли",
    "reading_cards": "Петица Пентакли + Десетка Жезли",
    "reading_combination": ["five_pentacles", "ten_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Десетка Жезли – претоварване и бреме. Носите тежкото бреме на финансовите трудности. Претоварени сте. Потърсете облекчение.",
    "reading_description": "Носиш тежкото бреме на финансовите трудности. Претоварен си.",
    "reading_advice": "Потърси облекчение. Не можеш да носиш всичко сам. Има хора, готови да помогнат."
  },
  {
    "reading_id": "five_pentacles_page_wands",
    "reading_name": "Петица Пентакли + Паж Жезли",
    "reading_cards": "Петица Пентакли + Паж Жезли",
    "reading_combination": ["five_pentacles", "page_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Паж Жезли – новини и ентусиазъм. Вълнуваща новина идва – може би възможност за изход от трудностите. Отворете се за нея.",
    "reading_description": "Вълнуваща новина идва – може би възможност за изход от трудностите.",
    "reading_advice": "Отвори се за новините. Те могат да донесат изход от трудната ситуация."
  },
  {
    "reading_id": "five_pentacles_knight_wands",
    "reading_name": "Петица Пентакли + Рицар Жезли",
    "reading_cards": "Петица Пентакли + Рицар Жезли",
    "reading_combination": ["five_pentacles", "knight_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Рицар Жезли – импулсивност и бързина. Импулсивно решение може да влоши финансовото ви положение. Забавете и обмислете.",
    "reading_description": "Импулсивно решение може да влоши финансовото ти положение. Забави и обмисли.",
    "reading_advice": "Не взимай прибързани решения. Импулсивността може да влоши нещата."
  },
  {
    "reading_id": "five_pentacles_queen_wands",
    "reading_name": "Петица Пентакли + Царица Жезли",
    "reading_cards": "Петица Пентакли + Царица Жезли",
    "reading_combination": ["five_pentacles", "queen_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Царица Жезли – увереност и харизма. Въпреки трудностите, запазвате увереност и достойнство. Вашата топлина привлича помощ.",
    "reading_description": "Въпреки трудностите, запазваш увереност и достойнство. Топлината ти привлича помощ.",
    "reading_advice": "Бъди топъл и уверен. Твоята светлина привлича хора, които искат да помогнат."
  },
  {
    "reading_id": "five_pentacles_king_wands",
    "reading_name": "Петица Пентакли + Цар Жезли",
    "reading_cards": "Петица Пентакли + Цар Жезли",
    "reading_combination": ["five_pentacles", "king_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Цар Жезли – лидерство и визия. Вие сте лидер, който води през трудностите. Вашата визия вдъхновява надежда у другите.",
    "reading_description": "Ти си лидер, който води през трудностите. Визията ти вдъхновява надежда.",
    "reading_advice": "Води с визия и увереност. Твоето лидерство ще изведе екипа от трудностите."
  },
  {
    "reading_id": "five_pentacles_ace_wands",
    "reading_name": "Петица Пентакли + Асо Жезли",
    "reading_cards": "Петица Пентакли + Асо Жезли",
    "reading_combination": ["five_pentacles", "ace_wands"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Асо Жезли – ново начало и вдъхновение. Нова възможност се появява в момент на трудности. Това може да е изходът, който търсите.",
    "reading_description": "Нова възможност се появява в момент на трудности. Може да е изходът, който търсиш.",
    "reading_advice": "Хвани възможността. Тя може да е светлината в тунела."
  },
  {
    "reading_id": "five_pentacles_ace_cups",
    "reading_name": "Петица Пентакли + Асо Чаши",
    "reading_cards": "Петица Пентакли + Асо Чаши",
    "reading_combination": ["five_pentacles", "ace_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Асо Чаши – нови чувства и любов. Нова любов или приятелство идва в труден момент. Сърцето ви намира утеха.",
    "reading_description": "Нова любов или приятелство идва в труден момент. Сърцето ти намира утеха.",
    "reading_advice": "Отвори сърцето си. Любовта лекува дори най-тежките рани."
  },
  {
    "reading_id": "five_pentacles_two_cups",
    "reading_name": "Петица Пентакли + Двойка Чаши",
    "reading_cards": "Петица Пентакли + Двойка Чаши",
    "reading_combination": ["five_pentacles", "two_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Двойка Чаши – любов и връзка. Връзката ви е подложена на изпитание от финансови трудности. Дръжте се заедно – любовта е по-силна от парите.",
    "reading_description": "Връзката ви е подложена на изпитание от финансови трудности.",
    "reading_advice": "Дръжте се заедно. Любовта е по-силна от парите. Трудностите ще ви направят по-силни."
  },
  {
    "reading_id": "five_pentacles_three_cups",
    "reading_name": "Петица Пентакли + Тройка Чаши",
    "reading_cards": "Петица Пентакли + Тройка Чаши",
    "reading_combination": ["five_pentacles", "three_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Тройка Чаши – празник и радост. Дори в трудностите намирате повод за радост. Приятелите и семейството са вашата истинска подкрепа.",
    "reading_description": "Дори в трудностите намираш повод за радост. Приятелите и семейството са твоята подкрепа.",
    "reading_advice": "Празнувай малките неща. Радостта не зависи от парите."
  },
  {
    "reading_id": "five_pentacles_four_cups",
    "reading_name": "Петица Пентакли + Четворка Чаши",
    "reading_cards": "Петица Пентакли + Четворка Чаши",
    "reading_combination": ["five_pentacles", "four_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Четворка Чаши – апатия и неудовлетворение. Трудностите ви правят апатични и недоволни. Не затваряйте очи – помощ може да е точно пред вас.",
    "reading_description": "Трудностите те правят апатичен и недоволен. Помощ може да е точно пред теб.",
    "reading_advice": "Вдигни поглед. Помощта може да е точно пред теб, но ти не я виждаш."
  },
  {
    "reading_id": "five_pentacles_five_cups",
    "reading_name": "Петица Пентакли + Петица Чаши",
    "reading_cards": "Петица Пентакли + Петица Чаши",
    "reading_combination": ["five_pentacles", "five_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Петица Чаши – загуба и тъга. Двойна загуба – финансова и емоционална. Позволете си да скърбите, но не губете надежда.",
    "reading_description": "Двойна загуба – финансова и емоционална. Скърби, но не губи надежда.",
    "reading_advice": "Позволи си да скърбиш. Но помни – след дъжда идва слънце. Надеждата винаги е там."
  },
  {
    "reading_id": "five_pentacles_six_cups",
    "reading_name": "Петица Пентакли + Шестица Чаши",
    "reading_cards": "Петица Пентакли + Шестица Чаши",
    "reading_combination": ["five_pentacles", "six_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Шестица Чаши – спомени и носталгия. Спомените за по-добри времена ви крепят. Използвайте миналото като вдъхновение, но не живейте в него.",
    "reading_description": "Спомените за по-добри времена те крепят. Използвай ги като вдъхновение.",
    "reading_advice": "Спомените са утеха, но не живей в миналото. Гледай напред."
  },
  {
    "reading_id": "five_pentacles_seven_cups",
    "reading_name": "Петица Пентакли + Седмица Чаши",
    "reading_cards": "Петица Пентакли + Седмица Чаши",
    "reading_combination": ["five_pentacles", "seven_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Седмица Чаши – илюзии и фантазии. Бягате в илюзии, за да избегнете реалността. Свали розовите очила – само истината може да ви помогне.",
    "reading_description": "Бягаш в илюзии, за да избегнеш реалността. Свали розовите очила.",
    "reading_advice": "Погледни истината в очите. Само тя може да ти помогне да излезеш от трудностите."
  },
  {
    "reading_id": "five_pentacles_eight_cups",
    "reading_name": "Петица Пентакли + Осмица Чаши",
    "reading_cards": "Петица Пентакли + Осмица Чаши",
    "reading_combination": ["five_pentacles", "eight_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Осмица Чаши – тръгване и оставяне. Решавате да напуснете ситуацията на липса и да тръгнете към нещо ново. Смела стъпка.",
    "reading_description": "Решаваш да напуснеш ситуацията на липса и да тръгнеш към нещо ново.",
    "reading_advice": "Тръгни смело. Понякога трябва да оставиш, за да получиш нещо по-добро."
  },
  {
    "reading_id": "five_pentacles_nine_cups",
    "reading_name": "Петица Пентакли + Деветка Чаши",
    "reading_cards": "Петица Пентакли + Деветка Чаши",
    "reading_combination": ["five_pentacles", "nine_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Деветка Чаши – сбъднато желание. Въпреки трудностите, една мечта се сбъдва. Радост сред трудностите.",
    "reading_description": "Въпреки трудностите, една мечта се сбъдва. Радост сред трудностите.",
    "reading_advice": "Наслади се на тази радост. Тя е доказателство, че дори в трудности има място за щастие."
  },
  {
    "reading_id": "five_pentacles_ten_cups",
    "reading_name": "Петица Пентакли + Десетка Чаши",
    "reading_cards": "Петица Пентакли + Десетка Чаши",
    "reading_combination": ["five_pentacles", "ten_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Десетка Чаши – семейно щастие. Финансовите трудности не могат да разрушат семейната ви хармония. Любовта е по-силна от парите.",
    "reading_description": "Финансовите трудности не могат да разрушат семейната ви хармония.",
    "reading_advice": "Цени семейството си. То е истинското ви богатство. Заедно ще преодолеете всичко."
  },
  {
    "reading_id": "five_pentacles_page_cups",
    "reading_name": "Петица Пентакли + Паж Чаши",
    "reading_cards": "Петица Пентакли + Паж Чаши",
    "reading_combination": ["five_pentacles", "page_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Паж Чаши – емоционално послание. Нежно послание идва, носейки надежда в трудния момент. Отворете сърцето си.",
    "reading_description": "Нежно послание идва, носейки надежда в трудния момент.",
    "reading_advice": "Отвори сърцето си за посланието. То носи надежда и утеха."
  },
  {
    "reading_id": "five_pentacles_knight_cups",
    "reading_name": "Петица Пентакли + Рицар Чаши",
    "reading_cards": "Петица Пентакли + Рицар Чаши",
    "reading_combination": ["five_pentacles", "knight_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Рицар Чаши – романтика и ухажване. Романтичен жест идва в труден момент. Позволете на любовта да ви утеши.",
    "reading_description": "Романтичен жест идва в труден момент. Позволи на любовта да те утеши.",
    "reading_advice": "Позволи на любовта да влезе. Тя може да е точно това, от което имаш нужда сега."
  },
  {
    "reading_id": "five_pentacles_queen_cups",
    "reading_name": "Петица Пентакли + Царица Чаши",
    "reading_cards": "Петица Пентакли + Царица Чаши",
    "reading_combination": ["five_pentacles", "queen_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Царица Чаши – интуиция и емпатия. Интуицията ви подсказва как да излезете от трудностите. Слушайте сърцето си.",
    "reading_description": "Интуицията ти подсказва как да излезеш от трудностите. Слушай сърцето си.",
    "reading_advice": "Довери се на вътрешния си глас. Той знае пътя през трудностите."
  },
  {
    "reading_id": "five_pentacles_king_cups",
    "reading_name": "Петица Пентакли + Цар Чаши",
    "reading_cards": "Петица Пентакли + Цар Чаши",
    "reading_combination": ["five_pentacles", "king_cups"],
    "reading_meaning": "Петица Пентакли носи финансови трудности и липса, а Цар Чаши – емоционална зрялост и баланс. Запазвате емоционален баланс въпреки трудностите. Мъдростта ви помага да не се паникьосвате.",
    "reading_description": "Запазваш емоционален баланс въпреки трудностите. Мъдростта ти помага.",
    "reading_advice": "Бъди спокоен и мъдър. Емоционалният баланс е най-доброто оръжие срещу трудностите."
  },
    {
    "reading_id": "six_pentacles_two_wands",
    "reading_name": "Шестица Пентакли + Двойка Жезли",
    "reading_cards": "Шестица Пентакли + Двойка Жезли",
    "reading_combination": ["six_pentacles", "two_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Двойка Жезли – избор и планиране. Някой ви предлага помощ, но трябва да изберете дали да я приемете. Не се страхувайте да приемете подкрепа.",
    "reading_description": "Някой ти предлага помощ, но трябва да избереш дали да я приемеш.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "six_pentacles_three_wands",
    "reading_name": "Шестица Пентакли + Тройка Жезли",
    "reading_cards": "Шестица Пентакли + Тройка Жезли",
    "reading_combination": ["six_pentacles", "three_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Тройка Жезли – очакване и разширяване. Помощта, която сте получили, ще даде резултати. Чакайте търпеливо – плодовете идват.",
    "reading_description": "Помощта, която си получил, ще даде резултати. Чакай търпеливо.",
    "reading_advice": "Чакай търпеливо. Добрата инвестиция (и помощ) дава плодове с времето."
  },
  {
    "reading_id": "six_pentacles_four_wands",
    "reading_name": "Шестица Пентакли + Четворка Жезли",
    "reading_cards": "Шестица Пентакли + Четворка Жезли",
    "reading_combination": ["six_pentacles", "four_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Четворка Жезли – празник и стабилност. Споделяте успеха си с другите. Празнувате и дарявате – щедростта умножава радостта.",
    "reading_description": "Споделяш успеха си с другите. Щедростта умножава радостта.",
    "reading_advice": "Сподели щедро. Радостта се умножава, когато се споделя."
  },
  {
    "reading_id": "six_pentacles_five_wands",
    "reading_name": "Шестица Пентакли + Петица Жезли",
    "reading_cards": "Шестица Пентакли + Петица Жезли",
    "reading_combination": ["six_pentacles", "five_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Петица Жезли – конфликт и съперничество. Предлагате помощ, но срещате съпротива. Някой не иска да приеме помощ. Не настоявайте – уважете избора му.",
    "reading_description": "Предлагаш помощ, но срещаш съпротива. Някой не иска да приеме.",
    "reading_advice": "Уважи избора на другия. Не можеш да помогнеш на някой, който не иска помощ."
  },
  {
    "reading_id": "six_pentacles_six_wands",
    "reading_name": "Шестица Пентакли + Шестица Жезли",
    "reading_cards": "Шестица Пентакли + Шестица Жезли",
    "reading_combination": ["six_pentacles", "six_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Шестица Жезли – победа и признание. Вашата щедрост носи признание. Хората ви уважават и ценят за това, което давате.",
    "reading_description": "Твоята щедрост носи признание. Хората те уважават и ценят.",
    "reading_advice": "Продължавай да даваш. Щедростта ти се завръща многократно."
  },
  {
    "reading_id": "six_pentacles_seven_wands",
    "reading_name": "Шестица Пентакли + Седмица Жезли",
    "reading_cards": "Шестица Пентакли + Седмица Жезли",
    "reading_combination": ["six_pentacles", "seven_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Седмица Жезли – защита на позицията. Защитавате правото си да помагате или някой ви атакува, защото сте щедри. Дръжте се.",
    "reading_description": "Защитаваш правото си да помагаш. Някой те атакува за щедростта ти.",
    "reading_advice": "Дръж се. Щедростта не е слабост – тя е сила."
  },
  {
    "reading_id": "six_pentacles_eight_wands",
    "reading_name": "Шестица Пентакли + Осмица Жезли",
    "reading_cards": "Шестица Пентакли + Осмица Жезли",
    "reading_combination": ["six_pentacles", "eight_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Осмица Жезли – бързина и движение. Помощта идва бързо и неочаквано. Бъдете готови да я приемете или да я дадете светкавично.",
    "reading_description": "Помощта идва бързо и неочаквано. Бъди готов да я приемеш или дадеш.",
    "reading_advice": "Действай бързо. Някои възможности за помощ не чакат."
  },
  {
    "reading_id": "six_pentacles_nine_wands",
    "reading_name": "Шестица Пентакли + Деветка Жезли",
    "reading_cards": "Шестица Пентакли + Деветка Жезли",
    "reading_combination": ["six_pentacles", "nine_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Деветка Жезли – устойчивост и изтощение. Изтощени сте, но продължавате да помагате на другите. Грижете се и за себе си.",
    "reading_description": "Изтощен си, но продължаваш да помагаш на другите. Грижи се и за себе си.",
    "reading_advice": "Помощта започва от себе си. Не можеш да даваш от празно."
  },
  {
    "reading_id": "six_pentacles_ten_wands",
    "reading_name": "Шестица Пентакли + Десетка Жезли",
    "reading_cards": "Шестица Пентакли + Десетка Жезли",
    "reading_combination": ["six_pentacles", "ten_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Десетка Жезли – претоварване и бреме. Носите бремето на другите – помагате, но се претоварвате. Научете се да казвате \"не\".",
    "reading_description": "Носиш бремето на другите – помагаш, но се претоварваш.",
    "reading_advice": "Научи се да казваш \"не\". Не можеш да помагаш на всички, ако си претоварен."
  },
  {
    "reading_id": "six_pentacles_page_wands",
    "reading_name": "Шестица Пентакли + Паж Жезли",
    "reading_cards": "Шестица Пентакли + Паж Жезли",
    "reading_combination": ["six_pentacles", "page_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Паж Жезли – новини и ентусиазъм. Вълнуваща новина идва за помощ или дарение. Някой иска да ви помогне или вие ще помогнете на някого.",
    "reading_description": "Вълнуваща новина идва за помощ или дарение. Някой иска да ти помогне.",
    "reading_advice": "Отвори се за новината. Тя носи надежда и подкрепа."
  },
  {
    "reading_id": "six_pentacles_knight_wands",
    "reading_name": "Шестица Пентакли + Рицар Жезли",
    "reading_cards": "Шестица Пентакли + Рицар Жезли",
    "reading_combination": ["six_pentacles", "knight_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Рицар Жезли – импулсивност и бързина. Някой иска да помогне импулсивно, но може да не обмисли добре. Бъдете благодарни, но внимателни.",
    "reading_description": "Някой иска да помогне импулсивно. Бъди благодарен, но внимателен.",
    "reading_advice": "Приеми помощта, но проверѝ дали е добре обмислена. Импулсивната помощ може да донесе усложнения."
  },
  {
    "reading_id": "six_pentacles_queen_wands",
    "reading_name": "Шестица Пентакли + Царица Жезли",
    "reading_cards": "Шестица Пентакли + Царица Жезли",
    "reading_combination": ["six_pentacles", "queen_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Царица Жезли – увереност и харизма. Вие сте този, който помага с увереност и топлина. Вашата щедрост вдъхновява другите.",
    "reading_description": "Ти си този, който помага с увереност и топлина. Щедростта ти вдъхновява.",
    "reading_advice": "Продължавай да даваш с топлина. Твоята щедрост променя животи."
  },
  {
    "reading_id": "six_pentacles_king_wands",
    "reading_name": "Шестица Пентакли + Цар Жезли",
    "reading_cards": "Шестица Пентакли + Цар Жезли",
    "reading_combination": ["six_pentacles", "king_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Цар Жезли – лидерство и визия. Вие сте лидер, който помага и вдъхновява. Вашата щедрост и визия водят другите.",
    "reading_description": "Ти си лидер, който помага и вдъхновява. Щедростта и визията ти водят другите.",
    "reading_advice": "Води с пример. Твоята щедрост е лидерско качество, което вдъхновява."
  },
  {
    "reading_id": "six_pentacles_ace_wands",
    "reading_name": "Шестица Пентакли + Асо Жезли",
    "reading_cards": "Шестица Пентакли + Асо Жезли",
    "reading_combination": ["six_pentacles", "ace_wands"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Асо Жезли – ново начало и вдъхновение. Нова възможност идва чрез помощ, която получавате или давате. Искрата е запалена.",
    "reading_description": "Нова възможност идва чрез помощ, която получаваш или даваш.",
    "reading_advice": "Хвани искрата. Помощта, която идва сега, може да е начало на нещо голямо."
  },
  {
    "reading_id": "six_pentacles_ace_cups",
    "reading_name": "Шестица Пентакли + Асо Чаши",
    "reading_cards": "Шестица Пентакли + Асо Чаши",
    "reading_combination": ["six_pentacles", "ace_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Асо Чаши – нови чувства и любов. Нова любов или приятелство идва чрез помощ. Сърцето се отваря, когато получаваш или даваш.",
    "reading_description": "Нова любов или приятелство идва чрез помощ. Сърцето се отваря.",
    "reading_advice": "Отвори сърцето си. Даването и получаването на помощ може да роди любов."
  },
  {
    "reading_id": "six_pentacles_two_cups",
    "reading_name": "Шестица Пентакли + Двойка Чаши",
    "reading_cards": "Шестица Пентакли + Двойка Чаши",
    "reading_combination": ["six_pentacles", "two_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Двойка Чаши – любов и връзка. Връзка, основана на взаимна подкрепа и щедрост. Давате и получавате в баланс.",
    "reading_description": "Връзка, основана на взаимна подкрепа и щедрост. Даваш и получаваш в баланс.",
    "reading_advice": "Цени този баланс. Даването и получаването в любовта е ключът към хармонията."
  },
  {
    "reading_id": "six_pentacles_three_cups",
    "reading_name": "Шестица Пентакли + Тройка Чаши",
    "reading_cards": "Шестица Пентакли + Тройка Чаши",
    "reading_combination": ["six_pentacles", "three_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Тройка Чаши – празник и радост. Празнувате, като споделяте с другите. Щедростта прави празника по-радостен.",
    "reading_description": "Празнуваш, като споделяш с другите. Щедростта прави празника по-радостен.",
    "reading_advice": "Споделяй щедро. Колкото повече даваш, толкова повече радост получаваш."
  },
  {
    "reading_id": "six_pentacles_four_cups",
    "reading_name": "Шестица Пентакли + Четворка Чаши",
    "reading_cards": "Шестица Пентакли + Четворка Чаши",
    "reading_combination": ["six_pentacles", "four_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Четворка Чаши – апатия и неудовлетворение. Предлагат ви помощ, но вие не я забелязвате. Вдигнете поглед – помощта е точно пред вас.",
    "reading_description": "Предлагат ти помощ, но ти не я забелязваш. Вдигни поглед.",
    "reading_advice": "Свали превръзката от очите. Помощта може да е точно пред теб."
  },
  {
    "reading_id": "six_pentacles_five_cups",
    "reading_name": "Шестица Пентакли + Петица Чаши",
    "reading_cards": "Шестица Пентакли + Петица Чаши",
    "reading_combination": ["six_pentacles", "five_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Петица Чаши – загуба и тъга. Някой протяга ръка да ви помогне след загуба. Приемете помощта – не сте сами.",
    "reading_description": "Някой протяга ръка да ти помогне след загуба. Приеми – не си сам.",
    "reading_advice": "Приеми помощта. Няма срам да поискаш помощ, когато си в тъга."
  },
  {
    "reading_id": "six_pentacles_six_cups",
    "reading_name": "Шестица Пентакли + Шестица Чаши",
    "reading_cards": "Шестица Пентакли + Шестица Чаши",
    "reading_combination": ["six_pentacles", "six_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Шестица Чаши – спомени и носталгия. Някой от миналото идва да ви помогне. Стар приятел или роднина протяга ръка.",
    "reading_description": "Някой от миналото идва да ти помогне. Стар приятел протяга ръка.",
    "reading_advice": "Приеми помощта с благодарност. Някои връзки са вечни."
  },
  {
    "reading_id": "six_pentacles_seven_cups",
    "reading_name": "Шестица Пентакли + Седмица Чаши",
    "reading_cards": "Шестица Пентакли + Седмица Чаши",
    "reading_combination": ["six_pentacles", "seven_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Седмица Чаши – илюзии и фантазии. Някой предлага помощ, но може да не е искрен. Проверете намеренията, преди да приемете.",
    "reading_description": "Някой предлага помощ, но може да не е искрен. Провери намеренията.",
    "reading_advice": "Провери два пъти. Не всяка предложена помощ е искрена."
  },
  {
    "reading_id": "six_pentacles_eight_cups",
    "reading_name": "Шестица Пентакли + Осмица Чаши",
    "reading_cards": "Шестица Пентакли + Осмица Чаши",
    "reading_combination": ["six_pentacles", "eight_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Осмица Чаши – тръгване и оставяне. Тръгвате, но носите със себе си помощта, която сте получили. Благодарни сте и свободни.",
    "reading_description": "Тръгваш, но носиш със себе си помощта, която си получил. Благодарен и свободен.",
    "reading_advice": "Тръгни с благодарност. Помощта, която получи, те прави по-силен."
  },
  {
    "reading_id": "six_pentacles_nine_cups",
    "reading_name": "Шестица Пентакли + Деветка Чаши",
    "reading_cards": "Шестица Пентакли + Деветка Чаши",
    "reading_combination": ["six_pentacles", "nine_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Деветка Чаши – сбъднато желание. Мечтата ви се сбъдва с помощта на другите. Благодарност и удовлетворение.",
    "reading_description": "Мечтата ти се сбъдва с помощта на другите. Благодарност и удовлетворение.",
    "reading_advice": "Благодари на тези, които ти помогнаха. Сподели радостта с тях."
  },
  {
    "reading_id": "six_pentacles_ten_cups",
    "reading_name": "Шестица Пентакли + Десетка Чаши",
    "reading_cards": "Шестица Пентакли + Десетка Чаши",
    "reading_combination": ["six_pentacles", "ten_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Десетка Чаши – семейно щастие. Семейството ви помага или вие помагате на семейството. Споделена подкрепа и любов.",
    "reading_description": "Семейството ти помага или ти помагаш на семейството. Споделена подкрепа.",
    "reading_advice": "Цени семейството си. То е най-голямата ти подкрепа."
  },
  {
    "reading_id": "six_pentacles_page_cups",
    "reading_name": "Шестица Пентакли + Паж Чаши",
    "reading_cards": "Шестица Пентакли + Паж Чаши",
    "reading_combination": ["six_pentacles", "page_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Паж Чаши – емоционално послание. Нежно послание идва с предложение за помощ. Отворете сърцето си.",
    "reading_description": "Нежно послание идва с предложение за помощ. Отвори сърцето си.",
    "reading_advice": "Отвори се за посланието. То носи подкрепа и топлина."
  },
  {
    "reading_id": "six_pentacles_knight_cups",
    "reading_name": "Шестица Пентакли + Рицар Чаши",
    "reading_cards": "Шестица Пентакли + Рицар Чаши",
    "reading_combination": ["six_pentacles", "knight_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Рицар Чаши – романтика и ухажване. Романтичен жест идва с предложение за помощ. Любов и подкрепа заедно.",
    "reading_description": "Романтичен жест идва с предложение за помощ. Любов и подкрепа заедно.",
    "reading_advice": "Позволи на любовта и подкрепата да влязат в живота ти."
  },
  {
    "reading_id": "six_pentacles_queen_cups",
    "reading_name": "Шестица Пентакли + Царица Чаши",
    "reading_cards": "Шестица Пентакли + Царица Чаши",
    "reading_combination": ["six_pentacles", "queen_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Царица Чаши – интуиция и емпатия. Интуицията ви подсказва на кого да помогнете или от кого да приемете помощ. Слушайте сърцето си.",
    "reading_description": "Интуицията ти подсказва на кого да помогнеш или от кого да приемеш помощ.",
    "reading_advice": "Довери се на интуицията си. Тя знае кой наистина има нужда от помощ."
  },
  {
    "reading_id": "six_pentacles_king_cups",
    "reading_name": "Шестица Пентакли + Цар Чаши",
    "reading_cards": "Шестица Пентакли + Цар Чаши",
    "reading_combination": ["six_pentacles", "king_cups"],
    "reading_meaning": "Шестица Пентакли носи помощ и щедрост, а Цар Чаши – емоционална зрялост и баланс. Помагате с мъдрост и баланс. Знаете кога да дадете и кога да получите.",
    "reading_description": "Помагаш с мъдрост и баланс. Знаеш кога да дадеш и кога да получиш.",
    "reading_advice": "Продължавай така. Твоят баланс между даване и получаване е пример за другите."
  },
    {
    "reading_id": "seven_pentacles_two_wands",
    "reading_name": "Седмица Пентакли + Двойка Жезли",
    "reading_cards": "Седмица Пентакли + Двойка Жезли",
    "reading_combination": ["seven_pentacles", "two_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Двойка Жезли – избор и планиране. Инвестирали сте време и ресурси и сега чакате резултати. Предстои избор за следващата стъпка. Чакайте търпеливо, но планирайте.",
    "reading_description": "Инвестирал си време и ресурси и чакаш резултати. Чакай търпеливо, но планирай.",
    "reading_advice": "Чакай търпеливо, докато планираш следващите стъпки. Най-добрите неща идват с времето."
  },
  {
    "reading_id": "seven_pentacles_three_wands",
    "reading_name": "Седмица Пентакли + Тройка Жезли",
    "reading_cards": "Седмица Пентакли + Тройка Жезли",
    "reading_combination": ["seven_pentacles", "three_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Тройка Жезли – очакване и разширяване. Двойно очакване – инвестирали сте и гледате напред. Плодовете идват, но имайте търпение.",
    "reading_description": "Инвестирал си и гледаш напред. Плодовете идват, но имай търпение.",
    "reading_advice": "Гледай напред с надежда. Търпението ти ще бъде възнаградено."
  },
  {
    "reading_id": "seven_pentacles_four_wands",
    "reading_name": "Седмица Пентакли + Четворка Жезли",
    "reading_cards": "Седмица Пентакли + Четворка Жезли",
    "reading_combination": ["seven_pentacles", "four_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Четворка Жезли – празник и стабилност. Празнувате напредъка, докато чакате крайните резултати. Радвайте се на пътя, не само на дестинацията.",
    "reading_description": "Празнуваш напредъка, докато чакаш крайните резултати. Радвай се на пътя.",
    "reading_advice": "Празнувай малките победи. Те са стъпалата към големия успех."
  },
  {
    "reading_id": "seven_pentacles_five_wands",
    "reading_name": "Седмица Пентакли + Петица Жезли",
    "reading_cards": "Седмица Пентакли + Петица Жезли",
    "reading_combination": ["seven_pentacles", "five_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Петица Жезли – конфликт и съперничество. Докато чакате резултати, около вас има спорове и конкуренция. Не се замесвайте – фокусът ви е върху плодовете.",
    "reading_description": "Докато чакаш резултати, около теб има спорове. Не се замесвай.",
    "reading_advice": "Не се замесвай в драми. Фокусирай се върху това, което си посял."
  },
  {
    "reading_id": "seven_pentacles_six_wands",
    "reading_name": "Седмица Пентакли + Шестица Жезли",
    "reading_cards": "Седмица Пентакли + Шестица Жезли",
    "reading_combination": ["seven_pentacles", "six_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Шестица Жезли – победа и признание. Търпението ви се отплаща – резултатите идват и носят успех. Насладете се на момента.",
    "reading_description": "Търпението ти се отплаща – резултатите идват и носят успех.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Търпението и упоритостта дават плод."
  },
  {
    "reading_id": "seven_pentacles_seven_wands",
    "reading_name": "Седмица Пентакли + Седмица Жезли",
    "reading_cards": "Седмица Пентакли + Седмица Жезли",
    "reading_combination": ["seven_pentacles", "seven_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Седмица Жезли – защита на позицията. Докато чакате, някой се опитва да ви попречи. Дръжте позицията си и не отстъпвайте.",
    "reading_description": "Докато чакаш, някой се опитва да ти попречи. Дръж позицията си.",
    "reading_advice": "Бъди бдителен, но не позволявай на страха да те завладее. Дръж позицията си."
  },
  {
    "reading_id": "seven_pentacles_eight_wands",
    "reading_name": "Седмица Пентакли + Осмица Жезли",
    "reading_cards": "Седмица Пентакли + Осмица Жезли",
    "reading_combination": ["seven_pentacles", "eight_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Осмица Жезли – бързина и движение. Резултатите идват неочаквано бързо. Бъдете готови да ги посрещнете.",
    "reading_description": "Резултатите идват неочаквано бързо. Бъди готов да ги посрещнеш.",
    "reading_advice": "Приготви се. Нещата ще се случат по-бързо, отколкото очакваш."
  },
  {
    "reading_id": "seven_pentacles_nine_wands",
    "reading_name": "Седмица Пентакли + Деветка Жезли",
    "reading_cards": "Седмица Пентакли + Деветка Жезли",
    "reading_combination": ["seven_pentacles", "nine_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Деветка Жезли – устойчивост и изтощение. Чакането се проточва и започва да ви изтощава. Умора, но и надежда, че скоро ще приключи.",
    "reading_description": "Чакането се проточва и те изтощава. Умора, но надежда, че краят е близо.",
    "reading_advice": "Дръж се още малко. Финалната права е точно зад ъгъла."
  },
  {
    "reading_id": "seven_pentacles_ten_wands",
    "reading_name": "Седмица Пентакли + Десетка Жезли",
    "reading_cards": "Седмица Пентакли + Десетка Жезли",
    "reading_combination": ["seven_pentacles", "ten_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Десетка Жезли – претоварване и бреме. Докато чакате, носите и много други отговорности. Претоварване и умора, но не можете да спрете.",
    "reading_description": "Докато чакаш, носиш и много други отговорности. Претоварване и умора.",
    "reading_advice": "Потърси облекчение, преди да се сринеш. Не можеш да носиш всичко сам."
  },
  {
    "reading_id": "seven_pentacles_page_wands",
    "reading_name": "Седмица Пентакли + Паж Жезли",
    "reading_cards": "Седмица Пентакли + Паж Жезли",
    "reading_combination": ["seven_pentacles", "page_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Паж Жезли – новини и ентусиазъм. Очаквайте вълнуваща новина, свързана с проекта ви. Добри вести идват.",
    "reading_description": "Очаквай вълнуваща новина. Добри вести идват.",
    "reading_advice": "Отвори се за новините. Те носят вдъхновение и нова енергия."
  },
  {
    "reading_id": "seven_pentacles_knight_wands",
    "reading_name": "Седмица Пентакли + Рицар Жезли",
    "reading_cards": "Седмица Пентакли + Рицар Жезли",
    "reading_combination": ["seven_pentacles", "knight_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Рицар Жезли – импулсивност и бързина. Нетърпението ви расте – искате резултати веднага. Забавете – скоростта не винаги е добра.",
    "reading_description": "Нетърпението ти расте – искаш резултати веднага. Забави.",
    "reading_advice": "Забави малко. Скоростта не винаги е най-важното. Понякога бавното и сигурно води до по-добър резултат."
  },
  {
    "reading_id": "seven_pentacles_queen_wands",
    "reading_name": "Седмица Пентакли + Царица Жезли",
    "reading_cards": "Седмица Пентакли + Царица Жезли",
    "reading_combination": ["seven_pentacles", "queen_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Царица Жезли – увереност и харизма. Чакате с увереност, знаейки, че всичко ще се нареди. Вашата топлина и вяра вдъхновяват другите.",
    "reading_description": "Чакаш с увереност, знаейки, че всичко ще се нареди. Вярата ти вдъхновява.",
    "reading_advice": "Чакай с увереност. Твоята вяра и топлина ще привлекат положителни резултати."
  },
  {
    "reading_id": "seven_pentacles_king_wands",
    "reading_name": "Седмица Пентакли + Цар Жезли",
    "reading_cards": "Седмица Пентакли + Цар Жезли",
    "reading_combination": ["seven_pentacles", "king_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Цар Жезли – лидерство и визия. Чакате с визия за бъдещето. Вашето стратегическо мислене ще ви донесе успех.",
    "reading_description": "Чакаш с визия за бъдещето. Стратегическото ти мислене ще донесе успех.",
    "reading_advice": "Гледай напред с визия. Твоето лидерство води другите към успех."
  },
  {
    "reading_id": "seven_pentacles_ace_wands",
    "reading_name": "Седмица Пентакли + Асо Жезли",
    "reading_cards": "Седмица Пентакли + Асо Жезли",
    "reading_combination": ["seven_pentacles", "ace_wands"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Асо Жезли – ново начало и вдъхновение. Докато чакате плодовете на една инвестиция, се появява нова възможност. Готови ли сте да я хванете?",
    "reading_description": "Докато чакаш плодовете на една инвестиция, се появява нова възможност.",
    "reading_advice": "Хвани новата възможност. Тя може да е още по-голяма от тази, която чакаш."
  },
  {
    "reading_id": "seven_pentacles_ace_cups",
    "reading_name": "Седмица Пентакли + Асо Чаши",
    "reading_cards": "Седмица Пентакли + Асо Чаши",
    "reading_combination": ["seven_pentacles", "ace_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Асо Чаши – нови чувства и любов. Нова любов или приятелство се появява, докато чакате. Сърцето ви се отваря в периода на изчакване.",
    "reading_description": "Нова любов се появява, докато чакаш. Сърцето ти се отваря.",
    "reading_advice": "Отвори сърцето си. Любовта идва, когато не я чакаш."
  },
  {
    "reading_id": "seven_pentacles_two_cups",
    "reading_name": "Седмица Пентакли + Двойка Чаши",
    "reading_cards": "Седмица Пентакли + Двойка Чаши",
    "reading_combination": ["seven_pentacles", "two_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Двойка Чаши – любов и връзка. Връзката ви се развива бавно, но сигурно. Търпението в любовта носи дълбоки корени.",
    "reading_description": "Връзката ви се развива бавно, но сигурно. Търпението в любовта носи дълбоки корени.",
    "reading_advice": "Чакай търпеливо. Истинската любов не бърза – тя узрява с времето."
  },
  {
    "reading_id": "seven_pentacles_three_cups",
    "reading_name": "Седмица Пентакли + Тройка Чаши",
    "reading_cards": "Седмица Пентакли + Тройка Чаши",
    "reading_combination": ["seven_pentacles", "three_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Тройка Чаши – празник и радост. Очаквате повод за празнуване. Скоро ще имате причина за радост.",
    "reading_description": "Очакваш повод за празнуване. Скоро ще имаш причина за радост.",
    "reading_advice": "Подготвяй се за празника. Радостта идва – бъди готов да я посрещнеш."
  },
  {
    "reading_id": "seven_pentacles_four_cups",
    "reading_name": "Седмица Пентакли + Четворка Чаши",
    "reading_cards": "Седмица Пентакли + Четворка Чаши",
    "reading_combination": ["seven_pentacles", "four_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Четворка Чаши – апатия и неудовлетворение. Чакате, но нещо ви липсва. Неудовлетворение и скука. Потърсете радостта в малките неща.",
    "reading_description": "Чакаш, но нещо ти липсва. Неудовлетворение и скука.",
    "reading_advice": "Потърси радостта в малките неща. Очакването не трябва да те прави скучен."
  },
  {
    "reading_id": "seven_pentacles_five_cups",
    "reading_name": "Седмица Пентакли + Петица Чаши",
    "reading_cards": "Седмица Пентакли + Петица Чаши",
    "reading_combination": ["seven_pentacles", "five_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Петица Чаши – загуба и тъга. Усещате, че предстои загуба или разочарование. Страх и несигурност в очакването.",
    "reading_description": "Усещаш, че предстои загуба или разочарование. Страх и несигурност.",
    "reading_advice": "Каквото дойде, приеми го. Ще се справиш. Позволи си да скърбиш, после продължи."
  },
  {
    "reading_id": "seven_pentacles_six_cups",
    "reading_name": "Седмица Пентакли + Шестица Чаши",
    "reading_cards": "Седмица Пентакли + Шестица Чаши",
    "reading_combination": ["seven_pentacles", "six_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Шестица Чаши – спомени и носталгия. Очаквате завръщане от миналото – стар приятел, любов или ситуация. Носталгия и надежда.",
    "reading_description": "Очакваш някой от миналото да се появи или нещо старо да се завърне.",
    "reading_advice": "Бъди готов да посрещнеш миналото, но не спирай да живееш в настоящето."
  },
  {
    "reading_id": "seven_pentacles_seven_cups",
    "reading_name": "Седмица Пентакли + Седмица Чаши",
    "reading_cards": "Седмица Пентакли + Седмица Чаши",
    "reading_combination": ["seven_pentacles", "seven_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Седмица Чаши – илюзии и фантазии. Очаквате нещо, което вероятно е илюзия. Реалността ще е различна.",
    "reading_description": "Очакваш нещо, което вероятно е илюзия. Реалността ще е различна.",
    "reading_advice": "Слез на земята. Това, което очакваш, може да не е истина. Потърси реалността."
  },
  {
    "reading_id": "seven_pentacles_eight_cups",
    "reading_name": "Седмица Пентакли + Осмица Чаши",
    "reading_cards": "Седмица Пентакли + Осмица Чаши",
    "reading_combination": ["seven_pentacles", "eight_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Осмица Чаши – тръгване и оставяне. Очаквате момента да тръгнете и да започнете нов път. Подготовка за заминаване.",
    "reading_description": "Очакваш момента да тръгнеш и да започнеш нов път. Подготовка за заминаване.",
    "reading_advice": "Готов ли си за път? Скоро ще тръгнеш. Подготви се за новото начало."
  },
  {
    "reading_id": "seven_pentacles_nine_cups",
    "reading_name": "Седмица Пентакли + Деветка Чаши",
    "reading_cards": "Седмица Пентакли + Деветка Чаши",
    "reading_combination": ["seven_pentacles", "nine_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Деветка Чаши – сбъднато желание. Очаквате с нетърпение сбъдването на дългогодишна мечта. Скоро ще се случи.",
    "reading_description": "Очакваш с нетърпение сбъдването на дългогодишна мечта. Скоро ще се случи.",
    "reading_advice": "Търпение. Мечтите се сбъдват, когато е време. Бъди готов да ги посрещнеш."
  },
  {
    "reading_id": "seven_pentacles_ten_cups",
    "reading_name": "Седмица Пентакли + Десетка Чаши",
    "reading_cards": "Седмица Пентакли + Десетка Чаши",
    "reading_combination": ["seven_pentacles", "ten_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Десетка Чаши – семейно щастие. Очаквате семейно събитие – сватба, раждане, събиране. Радостно очакване.",
    "reading_description": "Очакваш семейно събитие – сватба, раждане, събиране. Радост и топлина.",
    "reading_advice": "Семейството те очаква. Бъди там, в момента. Тези мигове са безценни."
  },
  {
    "reading_id": "seven_pentacles_page_cups",
    "reading_name": "Седмица Пентакли + Паж Чаши",
    "reading_cards": "Седмица Пентакли + Паж Чаши",
    "reading_combination": ["seven_pentacles", "page_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Паж Чаши – емоционално послание. Очаквайте вест, която ще докосне сърцето ви. Някой иска да ви каже нещо важно.",
    "reading_description": "Очакваш емоционално послание, което ще докосне сърцето ти.",
    "reading_advice": "Отвори сърцето си за посланието. То носи нещо ценно за теб."
  },
  {
    "reading_id": "seven_pentacles_knight_cups",
    "reading_name": "Седмица Пентакли + Рицар Чаши",
    "reading_cards": "Седмица Пентакли + Рицар Чаши",
    "reading_combination": ["seven_pentacles", "knight_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Рицар Чаши – романтика и ухажване. Очаквайте романтичен жест или предложение. Някой идва при вас с отворено сърце.",
    "reading_description": "Очакваш романтичен жест или предложение. Някой идва при теб с любов.",
    "reading_advice": "Бъди готов да приемеш романтиката. Следвай сърцето си – то знае пътя."
  },
  {
    "reading_id": "seven_pentacles_queen_cups",
    "reading_name": "Седмица Пентакли + Царица Чаши",
    "reading_cards": "Седмица Пентакли + Царица Чаши",
    "reading_combination": ["seven_pentacles", "queen_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Царица Чаши – интуиция и емпатия. Интуицията ви подсказва какво да очаквате. Доверете се на вътрешния си глас.",
    "reading_description": "Интуицията ти подсказва какво да очакваш. Довери се на вътрешния си глас.",
    "reading_advice": "Слушай вътрешния си глас. Той знае повече, отколкото си мислиш."
  },
  {
    "reading_id": "seven_pentacles_king_cups",
    "reading_name": "Седмица Пентакли + Цар Чаши",
    "reading_cards": "Седмица Пентакли + Цар Чаши",
    "reading_combination": ["seven_pentacles", "king_cups"],
    "reading_meaning": "Седмица Пентакли носи търпение и чакане, а Цар Чаши – емоционална зрялост и баланс. Очаквате със спокойствие и мъдрост. Знаете, че всичко идва в точното време.",
    "reading_description": "Очакваш със спокойствие и мъдрост. Знаеш, че всичко идва в точното време.",
    "reading_advice": "Чакай с мир в сърцето. Емоционалната зрялост води до правилните резултати."
  },
    {
    "reading_id": "eight_pentacles_two_wands",
    "reading_name": "Осмица Пентакли + Двойка Жезли",
    "reading_cards": "Осмица Пентакли + Двойка Жезли",
    "reading_combination": ["eight_pentacles", "two_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Двойка Жезли – избор и планиране. Учите нови умения и предстои важен избор за посоката. Изберете пътя, който най-добре отговаря на новите ви умения.",
    "reading_description": "Учиш нови умения и предстои важен избор. Избери пътя, който отговаря на новите ти умения.",
    "reading_advice": "Избери посоката, която най-добре използва новите ти умения. Инвестицията в себе си си заслужава."
  },
  {
    "reading_id": "eight_pentacles_three_wands",
    "reading_name": "Осмица Пентакли + Тройка Жезли",
    "reading_cards": "Осмица Пентакли + Тройка Жезли",
    "reading_combination": ["eight_pentacles", "three_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Тройка Жезли – очакване и разширяване. Усъвършенствате уменията си и чакате възможност да ги приложите. Бъдете търпеливи – моментът идва.",
    "reading_description": "Усъвършенстваш уменията си и чакаш възможност да ги приложиш.",
    "reading_advice": "Чакай търпеливо. Уменията, които градиш сега, ще ти потрябват скоро."
  },
  {
    "reading_id": "eight_pentacles_four_wands",
    "reading_name": "Осмица Пентакли + Четворка Жезли",
    "reading_cards": "Осмица Пентакли + Четворка Жезли",
    "reading_combination": ["eight_pentacles", "four_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Четворка Жезли – празник и стабилност. Завършвате обучение или проект и имате повод за празнуване. Гордейте се с труда си.",
    "reading_description": "Завършваш обучение или проект – повод за празнуване. Гордей се с труда си.",
    "reading_advice": "Празнувай труда си. Ти вложи усилие и сега събираш плодовете."
  },
  {
    "reading_id": "eight_pentacles_five_wands",
    "reading_name": "Осмица Пентакли + Петица Жезли",
    "reading_cards": "Осмица Пентакли + Петица Жезли",
    "reading_combination": ["eight_pentacles", "five_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Петица Жезли – конфликт и съперничество. Конкуренция в обучението или на работното място. Не се отказвайте – усърдието ви ще надделее.",
    "reading_description": "Конкуренция в обучението или на работното място. Усърдието ти ще надделее.",
    "reading_advice": "Не се отказвай при първото препятствие. Конкуренцията означава, че си на прав път."
  },
  {
    "reading_id": "eight_pentacles_six_wands",
    "reading_name": "Осмица Пентакли + Шестица Жезли",
    "reading_cards": "Осмица Пентакли + Шестица Жезли",
    "reading_combination": ["eight_pentacles", "six_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Шестица Жезли – победа и признание. Трудът ви получава признание. Майсторството, което сте изградили, носи успех.",
    "reading_description": "Трудът ти получава признание. Майсторството, което си изградил, носи успех.",
    "reading_advice": "Наслаждавай се на успеха, но не спирай да се учиш. Майсторството няма край."
  },
  {
    "reading_id": "eight_pentacles_seven_wands",
    "reading_name": "Осмица Пентакли + Седмица Жезли",
    "reading_cards": "Осмица Пентакли + Седмица Жезли",
    "reading_combination": ["eight_pentacles", "seven_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Седмица Жезли – защита на позицията. Трябва да защитавате уменията и постиженията си от критици. Дръжте се – знаете какво сте.",
    "reading_description": "Трябва да защитаваш уменията и постиженията си от критици.",
    "reading_advice": "Не се огъвай пред критиката. Знаеш какво струваш – защитавай го."
  },
  {
    "reading_id": "eight_pentacles_eight_wands",
    "reading_name": "Осмица Пентакли + Осмица Жезли",
    "reading_cards": "Осмица Пентакли + Осмица Жезли",
    "reading_combination": ["eight_pentacles", "eight_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Осмица Жезли – бързина и движение. Учите бързо и напредвате светкавично. Хванете темпото, докато сте в зоната.",
    "reading_description": "Учиш бързо и напредваш светкавично. Хвани темпото, докато си в зоната.",
    "reading_advice": "Язди вълната на ученето. Сега усвояваш нови неща с невероятна скорост."
  },
  {
    "reading_id": "eight_pentacles_nine_wands",
    "reading_name": "Осмица Пентакли + Деветка Жезли",
    "reading_cards": "Осмица Пентакли + Деветка Жезли",
    "reading_combination": ["eight_pentacles", "nine_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Деветка Жезли – устойчивост и изтощение. Учите упорито, но сте изтощени. Починете си, преди да сте прегорели.",
    "reading_description": "Учиш упорито, но си изтощен. Почини си, преди да си прегорял.",
    "reading_advice": "Почини си. Ученето е маратон, не спринт. Свежите сили ще ти помогнат да стигнеш до финала."
  },
  {
    "reading_id": "eight_pentacles_ten_wands",
    "reading_name": "Осмица Пентакли + Десетка Жезли",
    "reading_cards": "Осмица Пентакли + Десетка Жезли",
    "reading_combination": ["eight_pentacles", "ten_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Десетка Жезли – претоварване и бреме. Поемате твърде много задачи и обучение едновременно. Претоварване – споделете бремето.",
    "reading_description": "Поемаш твърде много задачи и обучение едновременно. Претоварване.",
    "reading_advice": "Сподели бремето. Не можеш да учиш всичко наведнъж. Приоритизирай."
  },
  {
    "reading_id": "eight_pentacles_page_wands",
    "reading_name": "Осмица Пентакли + Паж Жезли",
    "reading_cards": "Осмица Пентакли + Паж Жезли",
    "reading_combination": ["eight_pentacles", "page_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Паж Жезли – новини и ентусиазъм. Получавате вълнуваща новина, свързана с обучение или нова работа. Ентусиазъм и вдъхновение.",
    "reading_description": "Получаваш вълнуваща новина, свързана с обучение или нова работа.",
    "reading_advice": "Отвори се за новините. Те носят енергията, от която имаш нужда, за да продължиш."
  },
  {
    "reading_id": "eight_pentacles_knight_wands",
    "reading_name": "Осмица Пентакли + Рицар Жезли",
    "reading_cards": "Осмица Пентакли + Рицар Жезли",
    "reading_combination": ["eight_pentacles", "knight_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Рицар Жезли – импулсивност и бързина. Учите с неудържима енергия, но внимавайте да не прегорите. Страстта е добра, но не трябва да изгаря.",
    "reading_description": "Учиш с неудържима енергия, но внимавай да не прегориш.",
    "reading_advice": "Действай със страст, но не забравяй да дишаш. Ученето е път, не спринт."
  },
  {
    "reading_id": "eight_pentacles_queen_wands",
    "reading_name": "Осмица Пентакли + Царица Жезли",
    "reading_cards": "Осмица Пентакли + Царица Жезли",
    "reading_combination": ["eight_pentacles", "queen_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Царица Жезли – увереност и харизма. Учите с увереност и топлина. Вашето усърдие вдъхновява другите да се развиват.",
    "reading_description": "Учиш с увереност и топлина. Усърдието ти вдъхновява другите.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина вдъхновява другите да учат."
  },
  {
    "reading_id": "eight_pentacles_king_wands",
    "reading_name": "Осмица Пентакли + Цар Жезли",
    "reading_cards": "Осмица Пентакли + Цар Жезли",
    "reading_combination": ["eight_pentacles", "king_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Цар Жезли – лидерство и визия. Вие сте лидер, който учи и води с пример. Вашето майсторство вдъхновява другите.",
    "reading_description": "Ти си лидер, който учи и води с пример. Майсторството ти вдъхновява.",
    "reading_advice": "Води с пример. Твоето усърдие и майсторство са най-добрият урок за другите."
  },
  {
    "reading_id": "eight_pentacles_ace_wands",
    "reading_name": "Осмица Пентакли + Асо Жезли",
    "reading_cards": "Осмица Пентакли + Асо Жезли",
    "reading_combination": ["eight_pentacles", "ace_wands"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Асо Жезли – ново начало и вдъхновение. Нова страст или идея за обучение се появява. Искрата е запалена – сега работете за развитието ѝ.",
    "reading_description": "Нова страст или идея за обучение се появява. Искрата е запалена.",
    "reading_advice": "Хвани искрата. Новата страст може да те отведе до майсторство."
  },
  {
    "reading_id": "eight_pentacles_ace_cups",
    "reading_name": "Осмица Пентакли + Асо Чаши",
    "reading_cards": "Осмица Пентакли + Асо Чаши",
    "reading_combination": ["eight_pentacles", "ace_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Асо Чаши – нови чувства и любов. Нова любов или приятелство идва чрез общо обучение или работа. Сърцето и умът заедно.",
    "reading_description": "Нова любов или приятелство идва чрез общо обучение или работа.",
    "reading_advice": "Отвори сърцето си. Любовта може да дойде, когато най-малко я очакваш."
  },
  {
    "reading_id": "eight_pentacles_two_cups",
    "reading_name": "Осмица Пентакли + Двойка Чаши",
    "reading_cards": "Осмица Пентакли + Двойка Чаши",
    "reading_combination": ["eight_pentacles", "two_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Двойка Чаши – любов и връзка. Връзка, основана на общи интереси и учене. Заедно се развивате и учите един от друг.",
    "reading_description": "Връзка, основана на общи интереси и учене. Заедно се развивате.",
    "reading_advice": "Ценете връзката, в която и двамата растете. Това е здрава основа."
  },
  {
    "reading_id": "eight_pentacles_three_cups",
    "reading_name": "Осмица Пентакли + Тройка Чаши",
    "reading_cards": "Осмица Пентакли + Тройка Чаши",
    "reading_combination": ["eight_pentacles", "three_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Тройка Чаши – празник и радост. Празнувате завършване на обучение или проект с приятели. Споделена радост.",
    "reading_description": "Празнуваш завършване на обучение или проект с приятели. Споделена радост.",
    "reading_advice": "Празнувай успеха си с тези, които са били с теб по пътя."
  },
  {
    "reading_id": "eight_pentacles_four_cups",
    "reading_name": "Осмица Пентакли + Четворка Чаши",
    "reading_cards": "Осмица Пентакли + Четворка Чаши",
    "reading_combination": ["eight_pentacles", "four_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Четворка Чаши – апатия и неудовлетворение. Учите, но не сте удовлетворени. Нещо ви липсва. Преосмислете защо учите това.",
    "reading_description": "Учиш, но не си удовлетворен. Нещо ти липсва.",
    "reading_advice": "Попитай се защо учиш това. Истинската мотивация идва от сърцето, не от задължение."
  },
  {
    "reading_id": "eight_pentacles_five_cups",
    "reading_name": "Осмица Пентакли + Петица Чаши",
    "reading_cards": "Осмица Пентакли + Петица Чаши",
    "reading_combination": ["eight_pentacles", "five_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Петица Чаши – загуба и тъга. Загуба или разочарование в обучението или работата. Учете се от грешките и продължавайте напред.",
    "reading_description": "Загуба или разочарование в обучението или работата. Учи се от грешките.",
    "reading_advice": "Неуспехът е учител. Стани, отърси се и продължи напред."
  },
  {
    "reading_id": "eight_pentacles_six_cups",
    "reading_name": "Осмица Пентакли + Шестица Чаши",
    "reading_cards": "Осмица Пентакли + Шестица Чаши",
    "reading_combination": ["eight_pentacles", "six_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Шестица Чаши – спомени и носталгия. Ученето ви напомня за миналото – може би се връщате към старо хоби или умение. Носталгия и развитие.",
    "reading_description": "Ученето ти напомня за миналото – връщаш се към старо хоби или умение.",
    "reading_advice": "Използвай миналото като вдъхновение. Старите умения могат да получат нов живот."
  },
  {
    "reading_id": "eight_pentacles_seven_cups",
    "reading_name": "Осмица Пентакли + Седмица Чаши",
    "reading_cards": "Осмица Пентакли + Седмица Чаши",
    "reading_combination": ["eight_pentacles", "seven_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Седмица Чаши – илюзии и фантазии. Имате илюзорни представи за това, което учите. Свали розовите очила – ученето изисква реалност.",
    "reading_description": "Имаш илюзорни представи за това, което учиш. Свали розовите очила.",
    "reading_advice": "Бъди реалист. Ученето изисква труд, не само мечти. Реалността е по-ценна от фантазията."
  },
  {
    "reading_id": "eight_pentacles_eight_cups",
    "reading_name": "Осмица Пентакли + Осмица Чаши",
    "reading_cards": "Осмица Пентакли + Осмица Чаши",
    "reading_combination": ["eight_pentacles", "eight_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Осмица Чаши – тръгване и оставяне. Решавате да напуснете обучение или работа и да тръгнете по нов път. Смела стъпка.",
    "reading_description": "Решаваш да напуснеш обучение или работа и да тръгнеш по нов път.",
    "reading_advice": "Тръгни смело. Понякога трябва да оставиш, за да намериш истинското си призвание."
  },
  {
    "reading_id": "eight_pentacles_nine_cups",
    "reading_name": "Осмица Пентакли + Деветка Чаши",
    "reading_cards": "Осмица Пентакли + Деветка Чаши",
    "reading_combination": ["eight_pentacles", "nine_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Деветка Чаши – сбъднато желание. Ученето ви води до сбъдване на дългогодишна мечта. Удовлетворение и радост.",
    "reading_description": "Ученето ти води до сбъдване на дългогодишна мечта. Удовлетворение и радост.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Майсторството донесе мечтата."
  },
  {
    "reading_id": "eight_pentacles_ten_cups",
    "reading_name": "Осмица Пентакли + Десетка Чаши",
    "reading_cards": "Осмица Пентакли + Десетка Чаши",
    "reading_combination": ["eight_pentacles", "ten_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Десетка Чаши – семейно щастие. Ученето или работата ви носи полза на цялото семейство. Споделен успех и хармония.",
    "reading_description": "Ученето или работата ти носи полза на цялото семейство. Споделен успех.",
    "reading_advice": "Сподели успеха със семейството си. Щастието е по-голямо, когато е споделено."
  },
  {
    "reading_id": "eight_pentacles_page_cups",
    "reading_name": "Осмица Пентакли + Паж Чаши",
    "reading_cards": "Осмица Пентакли + Паж Чаши",
    "reading_combination": ["eight_pentacles", "page_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Паж Чаши – емоционално послание. Получавате нежно послание, свързано с обучение или работа. Някой вярва във вас.",
    "reading_description": "Получаваш нежно послание, свързано с обучение или работа. Някой вярва в теб.",
    "reading_advice": "Отвори сърцето си за посланието. То носи подкрепа и насърчение."
  },
  {
    "reading_id": "eight_pentacles_knight_cups",
    "reading_name": "Осмица Пентакли + Рицар Чаши",
    "reading_cards": "Осмица Пентакли + Рицар Чаши",
    "reading_combination": ["eight_pentacles", "knight_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Рицар Чаши – романтика и ухажване. Романтичен жест или предложение идва от съученик или колега. Любов и учене заедно.",
    "reading_description": "Романтичен жест идва от съученик или колега. Любов и учене заедно.",
    "reading_advice": "Позволи на любовта да влезе. Тя може да дойде, където най-малко я очакваш."
  },
  {
    "reading_id": "eight_pentacles_queen_cups",
    "reading_name": "Осмица Пентакли + Царица Чаши",
    "reading_cards": "Осмица Пентакли + Царица Чаши",
    "reading_combination": ["eight_pentacles", "queen_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Царица Чаши – интуиция и емпатия. Интуицията ви води в обучението. Слушайте вътрешния си глас – той знае какво е най-добро за вас.",
    "reading_description": "Интуицията ти води в обучението. Слушай вътрешния си глас.",
    "reading_advice": "Довери се на интуицията си. Тя знае какво наистина искаш да учиш."
  },
  {
    "reading_id": "eight_pentacles_king_cups",
    "reading_name": "Осмица Пентакли + Цар Чаши",
    "reading_cards": "Осмица Пентакли + Цар Чаши",
    "reading_combination": ["eight_pentacles", "king_cups"],
    "reading_meaning": "Осмица Пентакли носи усърдие и учене, а Цар Чаши – емоционална зрялост и баланс. Учите с мъдрост и спокойствие. Без прибързване, без стрес – знаете, че майсторството идва с времето.",
    "reading_description": "Учиш с мъдрост и спокойствие. Знаеш, че майсторството идва с времето.",
    "reading_advice": "Продължавай така. Бавното и сигурно учене води до истинско майсторство."
  },
    {
    "reading_id": "nine_pentacles_two_wands",
    "reading_name": "Деветка Пентакли + Двойка Жезли",
    "reading_cards": "Деветка Пентакли + Двойка Жезли",
    "reading_combination": ["nine_pentacles", "two_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Двойка Жезли – избор и планиране. Постигнали сте независимост и предстои важен избор. Изберете пътя, който поддържа свободата, която сте изградили.",
    "reading_description": "Постигнал си независимост и предстои важен избор. Избери пътя, който поддържа свободата ти.",
    "reading_advice": "Избери с мъдрост. Свободата, която имаш, е ценна – пази я."
  },
  {
    "reading_id": "nine_pentacles_three_wands",
    "reading_name": "Деветка Пентакли + Тройка Жезли",
    "reading_cards": "Деветка Пентакли + Тройка Жезли",
    "reading_combination": ["nine_pentacles", "three_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Тройка Жезли – очакване и разширяване. Постигнали сте успех и сега гледате към нови хоризонти. Чакате следващата стъпка с увереност.",
    "reading_description": "Постигнал си успех и гледаш към нови хоризонти. Чакаш следващата стъпка с увереност.",
    "reading_advice": "Гледай напред с надежда. Ти си изградил основа – сега можеш да разширяваш."
  },
  {
    "reading_id": "nine_pentacles_four_wands",
    "reading_name": "Деветка Пентакли + Четворка Жезли",
    "reading_cards": "Деветка Пентакли + Четворка Жезли",
    "reading_combination": ["nine_pentacles", "four_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Четворка Жезли – празник и стабилност. Празнувате успеха и независимостта си у дома. Споделена радост със семейството.",
    "reading_description": "Празнуваш успеха и независимостта си у дома. Споделена радост със семейството.",
    "reading_advice": "Празнувай, но не спирай да градиш. Успехът е момент, независимостта е път."
  },
  {
    "reading_id": "nine_pentacles_five_wands",
    "reading_name": "Деветка Пентакли + Петица Жезли",
    "reading_cards": "Деветка Пентакли + Петица Жезли",
    "reading_combination": ["nine_pentacles", "five_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Петица Жезли – конфликт и съперничество. Успехът ви предизвиква завист и конкуренция. Не се поддавайте – знаете колко струвате.",
    "reading_description": "Успехът ти предизвиква завист и конкуренция. Не се поддавай – знаеш колко струваш.",
    "reading_advice": "Не позволявай на завистниците да помрачат успеха ти. Ти си изградил това сам."
  },
  {
    "reading_id": "nine_pentacles_six_wands",
    "reading_name": "Деветка Пентакли + Шестица Жезли",
    "reading_cards": "Деветка Пентакли + Шестица Жезли",
    "reading_combination": ["nine_pentacles", "six_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Шестица Жезли – победа и признание. Успехът ви получава заслужено признание. Гордейте се – заслужили сте всяка минута.",
    "reading_description": "Успехът ти получава заслужено признание. Гордей се – заслужил си всяка минута.",
    "reading_advice": "Наслади се на признанието. Ти го заслужи. Но не спирай да вървиш напред."
  },
  {
    "reading_id": "nine_pentacles_seven_wands",
    "reading_name": "Деветка Пентакли + Седмица Жезли",
    "reading_cards": "Деветка Пентакли + Седмица Жезли",
    "reading_combination": ["nine_pentacles", "seven_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Седмица Жезли – защита на позицията. Трябва да защитавате независимостта си от хора, които искат да ви я отнемат. Дръжте се.",
    "reading_description": "Трябва да защитаваш независимостта си от хора, които искат да ти я отнемат.",
    "reading_advice": "Дръж позицията си. Това, което си изградил, си заслужава защита."
  },
  {
    "reading_id": "nine_pentacles_eight_wands",
    "reading_name": "Деветка Пентакли + Осмица Жезли",
    "reading_cards": "Деветка Пентакли + Осмица Жезли",
    "reading_combination": ["nine_pentacles", "eight_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Осмица Жезли – бързина и движение. Успехът идва бързо и неочаквано. Бъдете готови да го посрещнете.",
    "reading_description": "Успехът идва бързо и неочаквано. Бъди готов да го посрещнеш.",
    "reading_advice": "Приеми успеха с благодарност и смирение. Наслади се на скоростта."
  },
  {
    "reading_id": "nine_pentacles_nine_wands",
    "reading_name": "Деветка Пентакли + Деветка Жезли",
    "reading_cards": "Деветка Пентакли + Деветка Жезли",
    "reading_combination": ["nine_pentacles", "nine_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Деветка Жезли – устойчивост и изтощение. Постигнали сте успех, но цената беше висока. Чувствате се изтощени, но независими.",
    "reading_description": "Постигнал си успех, но цената беше висока. Изтощен, но независим.",
    "reading_advice": "Почини си. Заслужил си този успех. Наслади се на независимостта, но не забравяй да се грижиш за себе си."
  },
  {
    "reading_id": "nine_pentacles_ten_wands",
    "reading_name": "Деветка Пентакли + Десетка Жезли",
    "reading_cards": "Деветка Пентакли + Десетка Жезли",
    "reading_combination": ["nine_pentacles", "ten_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Десетка Жезли – претоварване и бреме. Успели сте, но носите тежестта на отговорностите. Освободете се от ненужното бреме.",
    "reading_description": "Успя, но носиш тежестта на отговорностите. Освободи се от ненужното бреме.",
    "reading_advice": "Потърси помощ. Успехът не трябва да те заробва. Сподели бремето."
  },
  {
    "reading_id": "nine_pentacles_page_wands",
    "reading_name": "Деветка Пентакли + Паж Жезли",
    "reading_cards": "Деветка Пентакли + Паж Жезли",
    "reading_combination": ["nine_pentacles", "page_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Паж Жезли – новини и ентусиазъм. Получавате вълнуваща новина, свързана с успеха ви. Ентусиазъм и нови възможности.",
    "reading_description": "Получаваш вълнуваща новина, свързана с успеха ти. Ентусиазъм и нови възможности.",
    "reading_advice": "Отвори се за новините. Те носят още повече радост и вдъхновение."
  },
  {
    "reading_id": "nine_pentacles_knight_wands",
    "reading_name": "Деветка Пентакли + Рицар Жезли",
    "reading_cards": "Деветка Пентакли + Рицар Жезли",
    "reading_combination": ["nine_pentacles", "knight_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Рицар Жезли – импулсивност и бързина. Успехът ви кара да действате импулсивно. Насладете се, но не вземайте прибързани решения.",
    "reading_description": "Успехът те кара да действаш импулсивно. Наслади се, но не вземай прибързани решения.",
    "reading_advice": "Наслаждавай се на успеха, но не позволявай на егото да те заслепи. Бъди мъдър."
  },
  {
    "reading_id": "nine_pentacles_queen_wands",
    "reading_name": "Деветка Пентакли + Царица Жезли",
    "reading_cards": "Деветка Пентакли + Царица Жезли",
    "reading_combination": ["nine_pentacles", "queen_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Царица Жезли – увереност и харизма. Вие сте пример за успех и независимост. Вашата увереност вдъхновява другите.",
    "reading_description": "Ти си пример за успех и независимост. Увереността ти вдъхновява другите.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина води другите."
  },
  {
    "reading_id": "nine_pentacles_king_wands",
    "reading_name": "Деветка Пентакли + Цар Жезли",
    "reading_cards": "Деветка Пентакли + Цар Жезли",
    "reading_combination": ["nine_pentacles", "king_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Цар Жезли – лидерство и визия. Вие сте лидер, който е изградил независимост. Вашата визия и успех вдъхновяват другите.",
    "reading_description": "Ти си лидер, който е изградил независимост. Визията и успехът ти вдъхновяват.",
    "reading_advice": "Води с пример. Твоят успех е доказателство, че независимостта е възможна."
  },
  {
    "reading_id": "nine_pentacles_ace_wands",
    "reading_name": "Деветка Пентакли + Асо Жезли",
    "reading_cards": "Деветка Пентакли + Асо Жезли",
    "reading_combination": ["nine_pentacles", "ace_wands"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Асо Жезли – ново начало и вдъхновение. След успеха идва нова искра. Нов проект или страст се появява. Готови ли сте?",
    "reading_description": "След успеха идва нова искра. Нов проект или страст се появява.",
    "reading_advice": "Хвани новата искра. Успехът не е край – той е начало на нещо ново."
  },
  {
    "reading_id": "nine_pentacles_ace_cups",
    "reading_name": "Деветка Пентакли + Асо Чаши",
    "reading_cards": "Деветка Пентакли + Асо Чаши",
    "reading_combination": ["nine_pentacles", "ace_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Асо Чаши – нови чувства и любов. Нова любов идва в живота ви, докато сте независими и силни. Готови сте да споделите.",
    "reading_description": "Нова любов идва, докато си независим и силен. Готов си да споделиш.",
    "reading_advice": "Отвори сърцето си. Истинската любов не отнема независимостта – тя я споделя."
  },
  {
    "reading_id": "nine_pentacles_two_cups",
    "reading_name": "Деветка Пентакли + Двойка Чаши",
    "reading_cards": "Деветка Пентакли + Двойка Чаши",
    "reading_combination": ["nine_pentacles", "two_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Двойка Чаши – любов и връзка. Връзка, в която и двамата са независими и силни. Любов без зависимост.",
    "reading_description": "Връзка, в която и двамата сте независими и силни. Любов без зависимост.",
    "reading_advice": "Цени тази връзка. Независимостта не пречи на любовта – напротив, прави я по-здрава."
  },
  {
    "reading_id": "nine_pentacles_three_cups",
    "reading_name": "Деветка Пентакли + Тройка Чаши",
    "reading_cards": "Деветка Пентакли + Тройка Чаши",
    "reading_combination": ["nine_pentacles", "three_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Тройка Чаши – празник и радост. Празнувате успеха си с приятели. Споделена радост, която умножава щастието.",
    "reading_description": "Празнуваш успеха си с приятели. Споделена радост умножава щастието.",
    "reading_advice": "Сподели радостта си. Тя става по-голяма, когато я споделяш с тези, които обичаш."
  },
  {
    "reading_id": "nine_pentacles_four_cups",
    "reading_name": "Деветка Пентакли + Четворка Чаши",
    "reading_cards": "Деветка Пентакли + Четворка Чаши",
    "reading_combination": ["nine_pentacles", "four_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Четворка Чаши – апатия и неудовлетворение. Имате всичко, но не сте щастливи. Потърсете какво наистина ви липсва.",
    "reading_description": "Имаш всичко, но не си щастлив. Потърси какво наистина ти липсва.",
    "reading_advice": "Щастието не е в притежанията. Потърси го вътре в себе си."
  },
  {
    "reading_id": "nine_pentacles_five_cups",
    "reading_name": "Деветка Пентакли + Петица Чаши",
    "reading_cards": "Деветка Пентакли + Петица Чаши",
    "reading_combination": ["nine_pentacles", "five_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Петица Чаши – загуба и тъга. Успех, но с цената на загуба. Позволете си да скърбите, но не забравяйте какво имате.",
    "reading_description": "Успех, но с цената на загуба. Позволи си да скърбиш, но не забравяй какво имаш.",
    "reading_advice": "Понякога успехът идва със загуба. Позволи си да чувстваш и двете."
  },
  {
    "reading_id": "nine_pentacles_six_cups",
    "reading_name": "Деветка Пентакли + Шестица Чаши",
    "reading_cards": "Деветка Пентакли + Шестица Чаши",
    "reading_combination": ["nine_pentacles", "six_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Шестица Чаши – спомени и носталгия. Успехът ви напомня за корените ви. Носталгия и благодарност към миналото.",
    "reading_description": "Успехът ти напомня за корените ти. Носталгия и благодарност към миналото.",
    "reading_advice": "Благодари на миналото, което те доведе тук. Но гледай напред."
  },
  {
    "reading_id": "nine_pentacles_seven_cups",
    "reading_name": "Деветка Пентакли + Седмица Чаши",
    "reading_cards": "Деветка Пентакли + Седмица Чаши",
    "reading_combination": ["nine_pentacles", "seven_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Седмица Чаши – илюзии и фантазии. Мислите, че имате всичко, но може да е илюзия. Проверете реалността.",
    "reading_description": "Мислиш, че имаш всичко, но може да е илюзия. Провери реалността.",
    "reading_advice": "Свали розовите очила. Истинският успех е реален. Провери дали това, което имаш, е истинско."
  },
  {
    "reading_id": "nine_pentacles_eight_cups",
    "reading_name": "Деветка Пентакли + Осмица Чаши",
    "reading_cards": "Деветка Пентакли + Осмица Чаши",
    "reading_combination": ["nine_pentacles", "eight_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Осмица Чаши – тръгване и оставяне. Решавате да оставите успеха зад гърба си и да тръгнете на нов път. Смела стъпка.",
    "reading_description": "Решаваш да оставиш успеха зад гърба си и да тръгнеш на нов път.",
    "reading_advice": "Тръгни смело. Истинската свобода е да можеш да оставиш дори успеха, когато е време."
  },
  {
    "reading_id": "nine_pentacles_nine_cups",
    "reading_name": "Деветка Пентакли + Деветка Чаши",
    "reading_cards": "Деветка Пентакли + Деветка Чаши",
    "reading_combination": ["nine_pentacles", "nine_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Деветка Чаши – сбъднато желание. Пълно удовлетворение – имате всичко, за което сте мечтали. Насладете се на момента.",
    "reading_description": "Пълно удовлетворение – имаш всичко, за което си мечтал. Наслади се на момента.",
    "reading_advice": "Ти постигна всичко. Наслади се на момента. Бъди благодарен."
  },
  {
    "reading_id": "nine_pentacles_ten_cups",
    "reading_name": "Деветка Пентакли + Десетка Чаши",
    "reading_cards": "Деветка Пентакли + Десетка Чаши",
    "reading_combination": ["nine_pentacles", "ten_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Десетка Чаши – семейно щастие. Успехът ви носи радост на цялото семейство. Споделена хармония и любов.",
    "reading_description": "Успехът ти носи радост на цялото семейство. Споделена хармония и любов.",
    "reading_advice": "Сподели успеха със семейството си. Те са част от твоята история."
  },
  {
    "reading_id": "nine_pentacles_page_cups",
    "reading_name": "Деветка Пентакли + Паж Чаши",
    "reading_cards": "Деветка Пентакли + Паж Чаши",
    "reading_combination": ["nine_pentacles", "page_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Паж Чаши – емоционално послание. Получавате нежно послание, което докосва сърцето ви. Някой ви признава чувствата си.",
    "reading_description": "Получаваш нежно послание, което докосва сърцето ти. Някой ти признава чувствата си.",
    "reading_advice": "Отвори сърцето си за посланието. То носи нещо ценно."
  },
  {
    "reading_id": "nine_pentacles_knight_cups",
    "reading_name": "Деветка Пентакли + Рицар Чаши",
    "reading_cards": "Деветка Пентакли + Рицар Чаши",
    "reading_combination": ["nine_pentacles", "knight_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Рицар Чаши – романтика и ухажване. Романтичен жест от някой, който цени вашата независимост. Любов и уважение заедно.",
    "reading_description": "Романтичен жест от някой, който цени независимостта ти. Любов и уважение заедно.",
    "reading_advice": "Позволи на любовта да влезе. Някой те обича точно такава, каквато си."
  },
  {
    "reading_id": "nine_pentacles_queen_cups",
    "reading_name": "Деветка Пентакли + Царица Чаши",
    "reading_cards": "Деветка Пентакли + Царица Чаши",
    "reading_combination": ["nine_pentacles", "queen_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Царица Чаши – интуиция и емпатия. Успехът ви идва, защото сте слушали сърцето си. Интуицията ви води правилно.",
    "reading_description": "Успехът ти идва, защото си слушал сърцето си. Интуицията те води правилно.",
    "reading_advice": "Довери се на интуицията си. Тя знае пътя към истинския успех."
  },
  {
    "reading_id": "nine_pentacles_king_cups",
    "reading_name": "Деветка Пентакли + Цар Чаши",
    "reading_cards": "Деветка Пентакли + Цар Чаши",
    "reading_combination": ["nine_pentacles", "king_cups"],
    "reading_meaning": "Деветка Пентакли носи самодостатъчност и успех, а Цар Чаши – емоционална зрялост и баланс. Постигате успех с мъдрост и емоционален баланс. Зряла победа.",
    "reading_description": "Постигаш успех с мъдрост и емоционален баланс. Зряла победа.",
    "reading_advice": "Наслади се на успеха с мъдростта, която си придобил. Ти заслужи този момент."
  },
   {
    "reading_id": "ten_pentacles_two_wands",
    "reading_name": "Десетка Пентакли + Двойка Жезли",
    "reading_cards": "Десетка Пентакли + Двойка Жезли",
    "reading_combination": ["ten_pentacles", "two_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Двойка Жезли – избор и планиране. Предстои важен избор, който ще засегне цялото семейство. Съветвайте се с близките си.",
    "reading_description": "Предстои важен избор, който ще засегне цялото семейство. Съветвай се с близките.",
    "reading_advice": "Съветвай се със семейството. Този избор е за всички вас."
  },
  {
    "reading_id": "ten_pentacles_three_wands",
    "reading_name": "Десетка Пентакли + Тройка Жезли",
    "reading_cards": "Десетка Пентакли + Тройка Жезли",
    "reading_combination": ["ten_pentacles", "three_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Тройка Жезли – очакване и разширяване. Очаквате събитие, което ще донесе полза на цялото семейство. Търпение и надежда.",
    "reading_description": "Очакваш събитие, което ще донесе полза на цялото семейство. Търпение и надежда.",
    "reading_advice": "Чакай търпеливо. Най-доброто за семейството тепърва идва."
  },
  {
    "reading_id": "ten_pentacles_four_wands",
    "reading_name": "Десетка Пентакли + Четворка Жезли",
    "reading_cards": "Десетка Пентакли + Четворка Жезли",
    "reading_combination": ["ten_pentacles", "four_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Четворка Жезли – празник и стабилност. Семеен празник, на който се събират поколения. Традиция и приемственост.",
    "reading_description": "Семеен празник, на който се събират поколения. Традиция и приемственост.",
    "reading_advice": "Почитай корените си. Семейството е най-голямото богатство."
  },
  {
    "reading_id": "ten_pentacles_five_wands",
    "reading_name": "Десетка Пентакли + Петица Жезли",
    "reading_cards": "Десетка Пентакли + Петица Жезли",
    "reading_combination": ["ten_pentacles", "five_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Петица Жезли – конфликт и съперничество. Спорове в семейството за наследство или ресурси. Търсете мирно решение.",
    "reading_description": "Спорове в семейството за наследство или ресурси. Търси мирно решение.",
    "reading_advice": "Семейството е по-важно от парите. Търсете компромис."
  },
  {
    "reading_id": "ten_pentacles_six_wands",
    "reading_name": "Десетка Пентакли + Шестица Жезли",
    "reading_cards": "Десетка Пентакли + Шестица Жезли",
    "reading_combination": ["ten_pentacles", "six_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Шестица Жезли – победа и признание. Семейният ви успех получава признание. Гордейте се с рода си.",
    "reading_description": "Семейният ти успех получава признание. Гордей се с рода си.",
    "reading_advice": "Семейството ти се гордее. Сподели успеха с тях."
  },
  {
    "reading_id": "ten_pentacles_seven_wands",
    "reading_name": "Десетка Пентакли + Седмица Жезли",
    "reading_cards": "Десетка Пентакли + Седмица Жезли",
    "reading_combination": ["ten_pentacles", "seven_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Седмица Жезли – защита на позицията. Трябва да защитавате семейното наследство от външни заплахи. Дръжте се.",
    "reading_description": "Трябва да защитаваш семейното наследство от външни заплахи.",
    "reading_advice": "Пази семейното богатство. То е наследство за следващите поколения."
  },
  {
    "reading_id": "ten_pentacles_eight_wands",
    "reading_name": "Десетка Пентакли + Осмица Жезли",
    "reading_cards": "Десетка Пентакли + Осмица Жезли",
    "reading_combination": ["ten_pentacles", "eight_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Осмица Жезли – бързина и движение. Семейно събитие (сватба, раждане) се случва неочаквано бързо. Бъдете готови.",
    "reading_description": "Семейно събитие се случва неочаквано бързо. Бъди готов.",
    "reading_advice": "Приеми радостта с отворени обятия. Някои от най-добрите моменти идват бързо."
  },
  {
    "reading_id": "ten_pentacles_nine_wands",
    "reading_name": "Десетка Пентакли + Деветка Жезли",
    "reading_cards": "Десетка Пентакли + Деветка Жезли",
    "reading_combination": ["ten_pentacles", "nine_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Деветка Жезли – устойчивост и изтощение. Носите тежестта на семейните отговорности и сте изтощени. Потърсете подкрепа.",
    "reading_description": "Носиш тежестта на семейните отговорности и си изтощен. Потърси подкрепа.",
    "reading_advice": "Не носи бремето сам. Семейството е за да се подкрепяте."
  },
  {
    "reading_id": "ten_pentacles_ten_wands",
    "reading_name": "Десетка Пентакли + Десетка Жезли",
    "reading_cards": "Десетка Пентакли + Десетка Жезли",
    "reading_combination": ["ten_pentacles", "ten_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Десетка Жезли – претоварване и бреме. Носите тежкото бреме на семейните отговорности. Претоварване – споделете бремето.",
    "reading_description": "Носиш тежкото бреме на семейните отговорности. Сподели бремето.",
    "reading_advice": "Потърси помощ от семейството. Не можеш да носиш всичко сам."
  },
  {
    "reading_id": "ten_pentacles_page_wands",
    "reading_name": "Десетка Пентакли + Паж Жезли",
    "reading_cards": "Десетка Пентакли + Паж Жезли",
    "reading_combination": ["ten_pentacles", "page_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Паж Жезли – новини и ентусиазъм. Очаквайте вълнуваща новина, свързана със семейството. Добри вести идват.",
    "reading_description": "Очаквай вълнуваща новина, свързана със семейството. Добри вести идват.",
    "reading_advice": "Отвори се за новините. Те носят радост за цялото семейство."
  },
  {
    "reading_id": "ten_pentacles_knight_wands",
    "reading_name": "Десетка Пентакли + Рицар Жезли",
    "reading_cards": "Десетка Пентакли + Рицар Жезли",
    "reading_combination": ["ten_pentacles", "knight_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Рицар Жезли – импулсивност и бързина. Някой в семейството действа импулсивно. Забавете, преди да сте взели прибързани решения.",
    "reading_description": "Някой в семейството действа импулсивно. Забавете, преди да сте взели прибързани решения.",
    "reading_advice": "Не взимайте прибързани семейни решения. Обмислете заедно."
  },
  {
    "reading_id": "ten_pentacles_queen_wands",
    "reading_name": "Десетка Пентакли + Царица Жезли",
    "reading_cards": "Десетка Пентакли + Царица Жезли",
    "reading_combination": ["ten_pentacles", "queen_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Царица Жезли – увереност и харизма. Вие сте сърцето на семейството – вашата увереност и топлина държат всички заедно.",
    "reading_description": "Ти си сърцето на семейството – увереността и топлината ти държат всички заедно.",
    "reading_advice": "Бъди топъл и уверен. Твоята светлина държи семейството заедно."
  },
  {
    "reading_id": "ten_pentacles_king_wands",
    "reading_name": "Десетка Пентакли + Цар Жезли",
    "reading_cards": "Десетка Пентакли + Цар Жезли",
    "reading_combination": ["ten_pentacles", "king_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Цар Жезли – лидерство и визия. Вие сте главата на семейството – вашата визия води рода напред.",
    "reading_description": "Ти си главата на семейството – визията ти води рода напред.",
    "reading_advice": "Води с мъдрост. Твоето лидерство определя бъдещето на рода."
  },
  {
    "reading_id": "ten_pentacles_ace_wands",
    "reading_name": "Десетка Пентакли + Асо Жезли",
    "reading_cards": "Десетка Пентакли + Асо Жезли",
    "reading_combination": ["ten_pentacles", "ace_wands"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Асо Жезли – ново начало и вдъхновение. Ново начало в семейството – нов член, нов бизнес, нов етап. Искрата е запалена.",
    "reading_description": "Ново начало в семейството – нов член, нов бизнес, нов етап.",
    "reading_advice": "Хвани искрата. Новото начало носи надежда за цялото семейство."
  },
  {
    "reading_id": "ten_pentacles_ace_cups",
    "reading_name": "Десетка Пентакли + Асо Чаши",
    "reading_cards": "Десетка Пентакли + Асо Чаши",
    "reading_combination": ["ten_pentacles", "ace_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Асо Чаши – нови чувства и любов. Нова любов идва в семейството – нов член, нова връзка. Сърцето се разширява.",
    "reading_description": "Нова любов идва в семейството – нов член, нова връзка.",
    "reading_advice": "Отвори сърцето си за новия член. Семейството расте с любов."
  },
  {
    "reading_id": "ten_pentacles_two_cups",
    "reading_name": "Десетка Пентакли + Двойка Чаши",
    "reading_cards": "Десетка Пентакли + Двойка Чаши",
    "reading_combination": ["ten_pentacles", "two_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Двойка Чаши – любов и връзка. Нова връзка или брак, който носи стабилност на семейството. Любов и сигурност заедно.",
    "reading_description": "Нова връзка или брак, който носи стабилност на семейството.",
    "reading_advice": "Празнувайте новата любов. Тя носи сила на рода."
  },
  {
    "reading_id": "ten_pentacles_three_cups",
    "reading_name": "Десетка Пентакли + Тройка Чаши",
    "reading_cards": "Десетка Пентакли + Тройка Чаши",
    "reading_combination": ["ten_pentacles", "three_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Тройка Чаши – празник и радост. Семеен празник, който събира всички поколения. Радост и хармония.",
    "reading_description": "Семеен празник, който събира всички поколения. Радост и хармония.",
    "reading_advice": "Цени тези моменти. Те са най-ценното наследство."
  },
  {
    "reading_id": "ten_pentacles_four_cups",
    "reading_name": "Десетка Пентакли + Четворка Чаши",
    "reading_cards": "Десетка Пентакли + Четворка Чаши",
    "reading_combination": ["ten_pentacles", "four_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Четворка Чаши – апатия и неудовлетворение. Имате семейна сигурност, но не сте щастливи. Потърсете какво ви липсва.",
    "reading_description": "Имаш семейна сигурност, но не си щастлив. Потърси какво ти липсва.",
    "reading_advice": "Щастието не е само в сигурността. Потърси го в малките неща."
  },
  {
    "reading_id": "ten_pentacles_five_cups",
    "reading_name": "Десетка Пентакли + Петица Чаши",
    "reading_cards": "Десетка Пентакли + Петица Чаши",
    "reading_combination": ["ten_pentacles", "five_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Петица Чаши – загуба и тъга. Загуба в семейството. Позволете си да скърбите заедно – семейството е опора.",
    "reading_description": "Загуба в семейството. Позволи си да скърбиш заедно – семейството е опора.",
    "reading_advice": "Скърбете заедно. Семейството е най-силно, когато е заедно в болката."
  },
  {
    "reading_id": "ten_pentacles_six_cups",
    "reading_name": "Десетка Пентакли + Шестица Чаши",
    "reading_cards": "Десетка Пентакли + Шестица Чаши",
    "reading_combination": ["ten_pentacles", "six_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Шестица Чаши – спомени и носталгия. Семейна среща, която носи спомени и носталгия. Завръщане към корените.",
    "reading_description": "Семейна среща, която носи спомени и носталгия. Завръщане към корените.",
    "reading_advice": "Цени корените си. Те са основата на семейството."
  },
  {
    "reading_id": "ten_pentacles_seven_cups",
    "reading_name": "Десетка Пентакли + Седмица Чаши",
    "reading_cards": "Десетка Пентакли + Седмица Чаши",
    "reading_combination": ["ten_pentacles", "seven_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Седмица Чаши – илюзии и фантазии. Илюзорни представи за семейното богатство. Проверете реалността.",
    "reading_description": "Илюзорни представи за семейното богатство. Провери реалността.",
    "reading_advice": "Свали розовите очила. Истинското богатство на семейството е любовта, не парите."
  },
  {
    "reading_id": "ten_pentacles_eight_cups",
    "reading_name": "Десетка Пентакли + Осмица Чаши",
    "reading_cards": "Десетка Пентакли + Осмица Чаши",
    "reading_combination": ["ten_pentacles", "eight_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Осмица Чаши – тръгване и оставяне. Някой от семейството тръгва на път или напуска дома. Тъжна раздяла.",
    "reading_description": "Някой от семейството тръгва на път или напуска дома. Тъжна раздяла.",
    "reading_advice": "Пожелай успех. Пътищата се разделят, за да се срещнат отново."
  },
  {
    "reading_id": "ten_pentacles_nine_cups",
    "reading_name": "Десетка Пентакли + Деветка Чаши",
    "reading_cards": "Десетка Пентакли + Деветка Чаши",
    "reading_combination": ["ten_pentacles", "nine_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Деветка Чаши – сбъднато желание. Семейна мечта се сбъдва. Щастие и удовлетворение за всички.",
    "reading_description": "Семейна мечта се сбъдва. Щастие и удовлетворение за всички.",
    "reading_advice": "Празнувайте заедно. Това е успех на цялото семейство."
  },
  {
    "reading_id": "ten_pentacles_ten_cups",
    "reading_name": "Десетка Пентакли + Десетка Чаши",
    "reading_cards": "Десетка Пентакли + Десетка Чаши",
    "reading_combination": ["ten_pentacles", "ten_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Десетка Чаши – пълно семейно щастие. Върхът на семейното благополучие. Хармония, любов и стабилност.",
    "reading_description": "Върхът на семейното благополучие. Хармония, любов и стабилност.",
    "reading_advice": "Наслади се на момента. Това е, за което си работил – семейно щастие."
  },
  {
    "reading_id": "ten_pentacles_page_cups",
    "reading_name": "Десетка Пентакли + Паж Чаши",
    "reading_cards": "Десетка Пентакли + Паж Чаши",
    "reading_combination": ["ten_pentacles", "page_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Паж Чаши – емоционално послание. Нежно послание идва от член на семейството. Някой иска да ви каже нещо от сърце.",
    "reading_description": "Нежно послание идва от член на семейството. Някой иска да ти каже нещо от сърце.",
    "reading_advice": "Отвори сърцето си за посланието. То носи любов и топлина."
  },
  {
    "reading_id": "ten_pentacles_knight_cups",
    "reading_name": "Десетка Пентакли + Рицар Чаши",
    "reading_cards": "Десетка Пентакли + Рицар Чаши",
    "reading_combination": ["ten_pentacles", "knight_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Рицар Чаши – романтика и ухажване. Романтичен жест или предложение в семейството. Любов и стабилност заедно.",
    "reading_description": "Романтичен жест или предложение в семейството. Любов и стабилност заедно.",
    "reading_advice": "Празнувайте любовта. Тя носи сила на семейството."
  },
  {
    "reading_id": "ten_pentacles_queen_cups",
    "reading_name": "Десетка Пентакли + Царица Чаши",
    "reading_cards": "Десетка Пентакли + Царица Чаши",
    "reading_combination": ["ten_pentacles", "queen_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Царица Чаши – интуиция и емпатия. Вие сте сърцето на семейството – вашата интуиция и емпатия държат всички заедно.",
    "reading_description": "Ти си сърцето на семейството – интуицията и емпатията ти държат всички заедно.",
    "reading_advice": "Слушай сърцето си. То знае какво е най-добро за семейството."
  },
  {
    "reading_id": "ten_pentacles_king_cups",
    "reading_name": "Десетка Пентакли + Цар Чаши",
    "reading_cards": "Десетка Пентакли + Цар Чаши",
    "reading_combination": ["ten_pentacles", "king_cups"],
    "reading_meaning": "Десетка Пентакли носи семейно наследство и дългосрочна сигурност, а Цар Чаши – емоционална зрялост и баланс. Вие сте емоционалният стълб на семейството – вашият баланс държи всички.",
    "reading_description": "Ти си емоционалният стълб на семейството – балансът ти държи всички.",
    "reading_advice": "Бъди спокоен и мъдър. Твоят баланс е опората на семейството."
  },
   {
    "reading_id": "page_pentacles_two_wands",
    "reading_name": "Паж Пентакли + Двойка Жезли",
    "reading_cards": "Паж Пентакли + Двойка Жезли",
    "reading_combination": ["page_pentacles", "two_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Двойка Жезли – избор и планиране. Нова възможност се появява и предстои важен избор. Учете се, планирайте и изберете мъдро.",
    "reading_description": "Нова финансова възможност и важен избор пред теб. Учи се, планирай и избери мъдро.",
    "reading_advice": "Избери с мъдрост. Новата възможност носи растеж, ако я хванеш правилно."
  },
  {
    "reading_id": "page_pentacles_three_wands",
    "reading_name": "Паж Пентакли + Тройка Жезли",
    "reading_cards": "Паж Пентакли + Тройка Жезли",
    "reading_combination": ["page_pentacles", "three_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Тройка Жезли – очакване и разширяване. Инвестирали сте в ново обучение или проект и сега чакате резултати. Търпение и вяра.",
    "reading_description": "Инвестирал си в ново обучение или проект и чакаш резултати.",
    "reading_advice": "Чакай търпеливо. Добрите неща идват при тези, които умеят да чакат."
  },
  {
    "reading_id": "page_pentacles_four_wands",
    "reading_name": "Паж Пентакли + Четворка Жезли",
    "reading_cards": "Паж Пентакли + Четворка Жезли",
    "reading_combination": ["page_pentacles", "four_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Четворка Жезли – празник и стабилност. Новата възможност носи повод за празнуване. Радост и стабилност в дома.",
    "reading_description": "Новата възможност носи повод за празнуване. Радост и стабилност в дома.",
    "reading_advice": "Празнувай новото начало. То носи надежда за бъдещето."
  },
  {
    "reading_id": "page_pentacles_five_wands",
    "reading_name": "Паж Пентакли + Петица Жезли",
    "reading_cards": "Паж Пентакли + Петица Жезли",
    "reading_combination": ["page_pentacles", "five_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Петица Жезли – конфликт и съперничество. Новата ви възможност среща конкуренция. Не се отказвайте – ученето ви ще надделее.",
    "reading_description": "Новата ти възможност среща конкуренция. Не се отказвай – ученето ти ще надделее.",
    "reading_advice": "Не се отказвай при първото препятствие. Конкуренцията означава, че си на прав път."
  },
  {
    "reading_id": "page_pentacles_six_wands",
    "reading_name": "Паж Пентакли + Шестица Жезли",
    "reading_cards": "Паж Пентакли + Шестица Жезли",
    "reading_combination": ["page_pentacles", "six_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Шестица Жезли – победа и признание. Новата ви възможност носи успех още в началото. Признание за вашия труд.",
    "reading_description": "Новата ти възможност носи успех още в началото. Признание за труда ти.",
    "reading_advice": "Наслаждавай се на успеха, но не спирай да се учиш. Това е само началото."
  },
  {
    "reading_id": "page_pentacles_seven_wands",
    "reading_name": "Паж Пентакли + Седмица Жезли",
    "reading_cards": "Паж Пентакли + Седмица Жезли",
    "reading_combination": ["page_pentacles", "seven_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Седмица Жезли – защита на позицията. Трябва да защитавате новата си възможност от критици. Дръжте се – знаете колко струвате.",
    "reading_description": "Трябва да защитаваш новата си възможност от критици. Дръж се – знаеш колко струваш.",
    "reading_advice": "Не се огъвай пред критиката. Твоят труд ще говори сам за себе си."
  },
  {
    "reading_id": "page_pentacles_eight_wands",
    "reading_name": "Паж Пентакли + Осмица Жезли",
    "reading_cards": "Паж Пентакли + Осмица Жезли",
    "reading_combination": ["page_pentacles", "eight_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Осмица Жезли – бързина и движение. Новата възможност идва бързо – трябва да действате светкавично. Ученето ви ще помогне.",
    "reading_description": "Новата възможност идва бързо – трябва да действаш светкавично.",
    "reading_advice": "Хвани възможността, докато е гореща. Бързината е твой съюзник."
  },
  {
    "reading_id": "page_pentacles_nine_wands",
    "reading_name": "Паж Пентакли + Деветка Жезли",
    "reading_cards": "Паж Пентакли + Деветка Жезли",
    "reading_combination": ["page_pentacles", "nine_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Деветка Жезли – устойчивост и изтощение. Учите и работите упорито, но сте изтощени. Починете си – заслужавате го.",
    "reading_description": "Учиш и работиш упорито, но си изтощен. Почини си – заслужаваш го.",
    "reading_advice": "Почини си. Ученето е маратон, не спринт. Свежите сили ще ти помогнат да стигнеш до финала."
  },
  {
    "reading_id": "page_pentacles_ten_wands",
    "reading_name": "Паж Пентакли + Десетка Жезли",
    "reading_cards": "Паж Пентакли + Десетка Жезли",
    "reading_combination": ["page_pentacles", "ten_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Десетка Жезли – претоварване и бреме. Поемате твърде много – работа, учене, нова възможност. Претоварване – споделете бремето.",
    "reading_description": "Поемаш твърде много – работа, учене, нова възможност. Претоварване.",
    "reading_advice": "Сподели бремето. Не можеш да учиш всичко наведнъж. Приоритизирай."
  },
  {
    "reading_id": "page_pentacles_page_wands",
    "reading_name": "Паж Пентакли + Паж Жезли",
    "reading_cards": "Паж Пентакли + Паж Жезли",
    "reading_combination": ["page_pentacles", "page_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Паж Жезли – новини и ентусиазъм. Вълнуваща новина за нова работа или обучение идва. Ентусиазъм и нови начала.",
    "reading_description": "Вълнуваща новина за нова работа или обучение идва. Ентусиазъм и нови начала.",
    "reading_advice": "Отвори се за новините. Те носят вдъхновение и нова енергия."
  },
  {
    "reading_id": "page_pentacles_knight_wands",
    "reading_name": "Паж Пентакли + Рицар Жезли",
    "reading_cards": "Паж Пентакли + Рицар Жезли",
    "reading_combination": ["page_pentacles", "knight_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Рицар Жезли – импулсивност и бързина. Учите с неудържима енергия, но внимавайте да не прегорите. Страстта е добра, но не трябва да изгаря.",
    "reading_description": "Учиш с неудържима енергия, но внимавай да не прегориш.",
    "reading_advice": "Действай със страст, но не забравяй да дишаш. Ученето е път, не спринт."
  },
  {
    "reading_id": "page_pentacles_queen_wands",
    "reading_name": "Паж Пентакли + Царица Жезли",
    "reading_cards": "Паж Пентакли + Царица Жезли",
    "reading_combination": ["page_pentacles", "queen_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Царица Жезли – увереност и харизма. Учите с увереност и топлина. Вашето усърдие вдъхновява другите да се развиват.",
    "reading_description": "Учиш с увереност и топлина. Усърдието ти вдъхновява другите.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина вдъхновява другите да учат."
  },
  {
    "reading_id": "page_pentacles_king_wands",
    "reading_name": "Паж Пентакли + Цар Жезли",
    "reading_cards": "Паж Пентакли + Цар Жезли",
    "reading_combination": ["page_pentacles", "king_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Цар Жезли – лидерство и визия. Вие сте лидер, който учи и води с пример. Вашето майсторство вдъхновява другите.",
    "reading_description": "Ти си лидер, който учи и води с пример. Майсторството ти вдъхновява.",
    "reading_advice": "Води с пример. Твоето усърдие и учене са най-добрият урок за другите."
  },
  {
    "reading_id": "page_pentacles_ace_wands",
    "reading_name": "Паж Пентакли + Асо Жезли",
    "reading_cards": "Паж Пентакли + Асо Жезли",
    "reading_combination": ["page_pentacles", "ace_wands"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Асо Жезли – ново начало и вдъхновение. Нова искра за учене или работа се появява. Искрата е запалена – сега работете за развитието ѝ.",
    "reading_description": "Нова искра за учене или работа се появява. Искрата е запалена.",
    "reading_advice": "Хвани искрата. Новата страст може да те отведе до майсторство."
  },
  {
    "reading_id": "page_pentacles_ace_cups",
    "reading_name": "Паж Пентакли + Асо Чаши",
    "reading_cards": "Паж Пентакли + Асо Чаши",
    "reading_combination": ["page_pentacles", "ace_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Асо Чаши – нови чувства и любов. Нова любов или приятелство идва чрез общо обучение или работа. Сърцето и умът заедно.",
    "reading_description": "Нова любов или приятелство идва чрез общо обучение или работа.",
    "reading_advice": "Отвори сърцето си. Любовта може да дойде, когато най-малко я очакваш."
  },
  {
    "reading_id": "page_pentacles_two_cups",
    "reading_name": "Паж Пентакли + Двойка Чаши",
    "reading_cards": "Паж Пентакли + Двойка Чаши",
    "reading_combination": ["page_pentacles", "two_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Двойка Чаши – любов и връзка. Връзка, основана на общи интереси и учене. Заедно се развивате и учите един от друг.",
    "reading_description": "Връзка, основана на общи интереси и учене. Заедно се развивате.",
    "reading_advice": "Ценете връзката, в която и двамата растете. Това е здрава основа."
  },
  {
    "reading_id": "page_pentacles_three_cups",
    "reading_name": "Паж Пентакли + Тройка Чаши",
    "reading_cards": "Паж Пентакли + Тройка Чаши",
    "reading_combination": ["page_pentacles", "three_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Тройка Чаши – празник и радост. Празнувате завършване на обучение или нов проект с приятели. Споделена радост.",
    "reading_description": "Празнуваш завършване на обучение или нов проект с приятели. Споделена радост.",
    "reading_advice": "Празнувай успеха си с тези, които са били с теб по пътя."
  },
  {
    "reading_id": "page_pentacles_four_cups",
    "reading_name": "Паж Пентакли + Четворка Чаши",
    "reading_cards": "Паж Пентакли + Четворка Чаши",
    "reading_combination": ["page_pentacles", "four_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Четворка Чаши – апатия и неудовлетворение. Учите, но не сте удовлетворени. Нещо ви липсва. Преосмислете защо учите това.",
    "reading_description": "Учиш, но не си удовлетворен. Нещо ти липсва.",
    "reading_advice": "Попитай се защо учиш това. Истинската мотивация идва от сърцето, не от задължение."
  },
  {
    "reading_id": "page_pentacles_five_cups",
    "reading_name": "Паж Пентакли + Петица Чаши",
    "reading_cards": "Паж Пентакли + Петица Чаши",
    "reading_combination": ["page_pentacles", "five_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Петица Чаши – загуба и тъга. Загуба или разочарование в обучението или работата. Учете се от грешките и продължавайте напред.",
    "reading_description": "Загуба или разочарование в обучението или работата. Учи се от грешките.",
    "reading_advice": "Неуспехът е учител. Стани, отърси се и продължи напред."
  },
  {
    "reading_id": "page_pentacles_six_cups",
    "reading_name": "Паж Пентакли + Шестица Чаши",
    "reading_cards": "Паж Пентакли + Шестица Чаши",
    "reading_combination": ["page_pentacles", "six_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Шестица Чаши – спомени и носталгия. Ученето ви напомня за миналото – може би се връщате към старо хоби или умение. Носталгия и развитие.",
    "reading_description": "Ученето ти напомня за миналото – връщаш се към старо хоби или умение.",
    "reading_advice": "Използвай миналото като вдъхновение. Старите умения могат да получат нов живот."
  },
  {
    "reading_id": "page_pentacles_seven_cups",
    "reading_name": "Паж Пентакли + Седмица Чаши",
    "reading_cards": "Паж Пентакли + Седмица Чаши",
    "reading_combination": ["page_pentacles", "seven_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Седмица Чаши – илюзии и фантазии. Имате илюзорни представи за това, което учите. Свали розовите очила – ученето изисква реалност.",
    "reading_description": "Имаш илюзорни представи за това, което учиш. Свали розовите очила.",
    "reading_advice": "Бъди реалист. Ученето изисква труд, не само мечти. Реалността е по-ценна от фантазията."
  },
  {
    "reading_id": "page_pentacles_eight_cups",
    "reading_name": "Паж Пентакли + Осмица Чаши",
    "reading_cards": "Паж Пентакли + Осмица Чаши",
    "reading_combination": ["page_pentacles", "eight_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Осмица Чаши – тръгване и оставяне. Решавате да напуснете обучение или работа и да тръгнете по нов път. Смела стъпка.",
    "reading_description": "Решаваш да напуснеш обучение или работа и да тръгнеш по нов път.",
    "reading_advice": "Тръгни смело. Понякога трябва да оставиш, за да намериш истинското си призвание."
  },
  {
    "reading_id": "page_pentacles_nine_cups",
    "reading_name": "Паж Пентакли + Деветка Чаши",
    "reading_cards": "Паж Пентакли + Деветка Чаши",
    "reading_combination": ["page_pentacles", "nine_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Деветка Чаши – сбъднато желание. Ученето ви води до сбъдване на дългогодишна мечта. Удовлетворение и радост.",
    "reading_description": "Ученето ти води до сбъдване на дългогодишна мечта. Удовлетворение и радост.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Ученето донесе мечтата."
  },
  {
    "reading_id": "page_pentacles_ten_cups",
    "reading_name": "Паж Пентакли + Десетка Чаши",
    "reading_cards": "Паж Пентакли + Десетка Чаши",
    "reading_combination": ["page_pentacles", "ten_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Десетка Чаши – семейно щастие. Ученето или работата ви носи полза на цялото семейство. Споделен успех и хармония.",
    "reading_description": "Ученето или работата ти носи полза на цялото семейство. Споделен успех.",
    "reading_advice": "Сподели успеха със семейството си. Щастието е по-голямо, когато е споделено."
  },
  {
    "reading_id": "page_pentacles_page_cups",
    "reading_name": "Паж Пентакли + Паж Чаши",
    "reading_cards": "Паж Пентакли + Паж Чаши",
    "reading_combination": ["page_pentacles", "page_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Паж Чаши – емоционално послание. Получавате нежно послание, свързано с обучение или работа. Някой вярва във вас.",
    "reading_description": "Получаваш нежно послание, свързано с обучение или работа. Някой вярва в теб.",
    "reading_advice": "Отвори сърцето си за посланието. То носи подкрепа и насърчение."
  },
  {
    "reading_id": "page_pentacles_knight_cups",
    "reading_name": "Паж Пентакли + Рицар Чаши",
    "reading_cards": "Паж Пентакли + Рицар Чаши",
    "reading_combination": ["page_pentacles", "knight_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Рицар Чаши – романтика и ухажване. Романтичен жест или предложение идва от съученик или колега. Любов и учене заедно.",
    "reading_description": "Романтичен жест идва от съученик или колега. Любов и учене заедно.",
    "reading_advice": "Позволи на любовта да влезе. Тя може да дойде, където най-малко я очакваш."
  },
  {
    "reading_id": "page_pentacles_queen_cups",
    "reading_name": "Паж Пентакли + Царица Чаши",
    "reading_cards": "Паж Пентакли + Царица Чаши",
    "reading_combination": ["page_pentacles", "queen_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Царица Чаши – интуиция и емпатия. Интуицията ви води в обучението. Слушайте вътрешния си глас – той знае какво е най-добро за вас.",
    "reading_description": "Интуицията ти води в обучението. Слушай вътрешния си глас.",
    "reading_advice": "Довери се на интуицията си. Тя знае какво наистина искаш да учиш."
  },
  {
    "reading_id": "page_pentacles_king_cups",
    "reading_name": "Паж Пентакли + Цар Чаши",
    "reading_cards": "Паж Пентакли + Цар Чаши",
    "reading_combination": ["page_pentacles", "king_cups"],
    "reading_meaning": "Паж Пентакли носи нова финансова възможност и учене, а Цар Чаши – емоционална зрялост и баланс. Учите с мъдрост и спокойствие. Без прибързване, без стрес – знаете, че майсторството идва с времето.",
    "reading_description": "Учиш с мъдрост и спокойствие. Знаеш, че майсторството идва с времето.",
    "reading_advice": "Продължавай така. Бавното и сигурно учене води до истинско майсторство."
  },
  {
    "reading_id": "knight_pentacles_two_wands",
    "reading_name": "Рицар Пентакли + Двойка Жезли",
    "reading_cards": "Рицар Пентакли + Двойка Жезли",
    "reading_combination": ["knight_pentacles", "two_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Двойка Жезли – избор и планиране. Напредвате бавно, но сигурно и предстои важен избор. Не бързайте – обмислете всички възможности.",
    "reading_description": "Напредваш бавно, но сигурно. Предстои важен избор – обмисли добре.",
    "reading_advice": "Не бързай. Сигурният път е бавен, но води до целта. Обмисли добре избора си."
  },
  {
    "reading_id": "knight_pentacles_three_wands",
    "reading_name": "Рицар Пентакли + Тройка Жезли",
    "reading_cards": "Рицар Пентакли + Тройка Жезли",
    "reading_combination": ["knight_pentacles", "three_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Тройка Жезли – очакване и разширяване. Инвестирали сте време и усилия и сега чакате резултати. Търпението ще бъде възнаградено.",
    "reading_description": "Инвестирал си време и усилия и чакаш резултати. Търпението ще бъде възнаградено.",
    "reading_advice": "Чакай търпеливо. Бавното и сигурно винаги печели."
  },
  {
    "reading_id": "knight_pentacles_four_wands",
    "reading_name": "Рицар Пентакли + Четворка Жезли",
    "reading_cards": "Рицар Пентакли + Четворка Жезли",
    "reading_combination": ["knight_pentacles", "four_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Четворка Жезли – празник и стабилност. След дълга и сигурна работа идва момент на празнуване. Насладете се на постигнатото.",
    "reading_description": "След дълга и сигурна работа идва момент на празнуване.",
    "reading_advice": "Празнувай, но не спирай да работиш. Сигурният напредък изисква постоянство."
  },
  {
    "reading_id": "knight_pentacles_five_wands",
    "reading_name": "Рицар Пентакли + Петица Жезли",
    "reading_cards": "Рицар Пентакли + Петица Жезли",
    "reading_combination": ["knight_pentacles", "five_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Петица Жезли – конфликт и съперничество. Бавният ви напредък предизвиква нетърпение у другите. Не се поддавайте на провокации – продължавайте със своето темпо.",
    "reading_description": "Бавният ти напредък предизвиква нетърпение у другите. Продължавай със своето темпо.",
    "reading_advice": "Не се поддавай на провокации. Твоето темпо е правилното за теб."
  },
  {
    "reading_id": "knight_pentacles_six_wands",
    "reading_name": "Рицар Пентакли + Шестица Жезли",
    "reading_cards": "Рицар Пентакли + Шестица Жезли",
    "reading_combination": ["knight_pentacles", "six_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Шестица Жезли – победа и признание. Бавният, но сигурен напредък ви носи успех. Признание за търпението и постоянството ви.",
    "reading_description": "Бавният, но сигурен напредък ти носи успех. Признание за търпението.",
    "reading_advice": "Наслади се на успеха. Търпението и постоянството дават плод."
  },
  {
    "reading_id": "knight_pentacles_seven_wands",
    "reading_name": "Рицар Пентакли + Седмица Жезли",
    "reading_cards": "Рицар Пентакли + Седмица Жезли",
    "reading_combination": ["knight_pentacles", "seven_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Седмица Жезли – защита на позицията. Трябва да защитавате бавно изградената си позиция от нетърпеливи критици. Дръжте се – знаете колко струвате.",
    "reading_description": "Трябва да защитаваш бавно изградената си позиция от нетърпеливи критици.",
    "reading_advice": "Дръж се. Това, което си изградил бавно, е стабилно. Не позволявай на никого да го разруши."
  },
  {
    "reading_id": "knight_pentacles_eight_wands",
    "reading_name": "Рицар Пентакли + Осмица Жезли",
    "reading_cards": "Рицар Пентакли + Осмица Жезли",
    "reading_combination": ["knight_pentacles", "eight_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Осмица Жезли – бързина и движение. Светът около вас се движи бързо, но вие продължавате със своето темпо. Не се поддавайте на натиска за скорост.",
    "reading_description": "Светът около теб се движи бързо, но ти продължаваш със своето темпо.",
    "reading_advice": "Не се поддавай на натиска за скорост. Твоето темпо е правилното за теб."
  },
  {
    "reading_id": "knight_pentacles_nine_wands",
    "reading_name": "Рицар Пентакли + Деветка Жезли",
    "reading_cards": "Рицар Пентакли + Деветка Жезли",
    "reading_combination": ["knight_pentacles", "nine_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Деветка Жезли – устойчивост и изтощение. Били сте упорити, но сте изтощени. Починете си – заслужавате го. Бавният напредък не бяга.",
    "reading_description": "Бил си упорит, но си изтощен. Почини си – заслужаваш го.",
    "reading_advice": "Почини си. Бавният напредък не бяга. Свежите сили ще ти помогнат да стигнеш до финала."
  },
  {
    "reading_id": "knight_pentacles_ten_wands",
    "reading_name": "Рицар Пентакли + Десетка Жезли",
    "reading_cards": "Рицар Пентакли + Десетка Жезли",
    "reading_combination": ["knight_pentacles", "ten_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Десетка Жезли – претоварване и бреме. Носите твърде много отговорности и напредвате бавно. Споделете бремето – не можете да носите всичко сам.",
    "reading_description": "Носиш твърде много отговорности и напредваш бавно. Сподели бремето.",
    "reading_advice": "Потърси помощ. Бавният напредък не означава, че трябва да си сам."
  },
  {
    "reading_id": "knight_pentacles_page_wands",
    "reading_name": "Рицар Пентакли + Паж Жезли",
    "reading_cards": "Рицар Пентакли + Паж Жезли",
    "reading_combination": ["knight_pentacles", "page_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Паж Жезли – новини и ентусиазъм. Получавате вълнуваща новина за напредъка си. Ентусиазъм и вдъхновение за продължаване.",
    "reading_description": "Получаваш вълнуваща новина за напредъка си. Ентусиазъм и вдъхновение.",
    "reading_advice": "Отвори се за новините. Те носят енергията, от която имаш нужда, за да продължиш."
  },
  {
    "reading_id": "knight_pentacles_knight_wands",
    "reading_name": "Рицар Пентакли + Рицар Жезли",
    "reading_cards": "Рицар Пентакли + Рицар Жезли",
    "reading_combination": ["knight_pentacles", "knight_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Рицар Жезли – импулсивност и бързина. Вътрешен конфликт между желанието за скорост и нуждата от сигурност. Намерете баланс.",
    "reading_description": "Конфликт между желанието за скорост и нуждата от сигурност. Намери баланс.",
    "reading_advice": "Намери златната среда. Понякога бързото е добре, но сигурното е по-важно."
  },
  {
    "reading_id": "knight_pentacles_queen_wands",
    "reading_name": "Рицар Пентакли + Царица Жезли",
    "reading_cards": "Рицар Пентакли + Царица Жезли",
    "reading_combination": ["knight_pentacles", "queen_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Царица Жезли – увереност и харизма. Напредвате с увереност и топлина. Вашата сигурност вдъхновява другите да ви се доверят.",
    "reading_description": "Напредваш с увереност и топлина. Сигурността ти вдъхновява доверие.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята сигурност вдъхновява другите."
  },
  {
    "reading_id": "knight_pentacles_king_wands",
    "reading_name": "Рицар Пентакли + Цар Жезли",
    "reading_cards": "Рицар Пентакли + Цар Жезли",
    "reading_combination": ["knight_pentacles", "king_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Цар Жезли – лидерство и визия. Вие сте лидер, който строи бавно, но сигурно. Вашата стабилност е опора за екипа.",
    "reading_description": "Ти си лидер, който строи бавно, но сигурно. Стабилността ти е опора.",
    "reading_advice": "Води с пример. Твоята стабилност и търпение са най-доброто лидерско качество."
  },
  {
    "reading_id": "knight_pentacles_ace_wands",
    "reading_name": "Рицар Пентакли + Асо Жезли",
    "reading_cards": "Рицар Пентакли + Асо Жезли",
    "reading_combination": ["knight_pentacles", "ace_wands"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Асо Жезли – ново начало и вдъхновение. Нова искра се появява, но не бързайте – развивайте я бавно и сигурно. Искрата няма да изгасне.",
    "reading_description": "Нова искра се появява, но не бързай – развивай я бавно и сигурно.",
    "reading_advice": "Хвани искрата, но не бързай. Бавното и сигурно развитие ще доведе до устойчив успех."
  },
  {
    "reading_id": "knight_pentacles_ace_cups",
    "reading_name": "Рицар Пентакли + Асо Чаши",
    "reading_cards": "Рицар Пентакли + Асо Чаши",
    "reading_combination": ["knight_pentacles", "ace_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Асо Чаши – нови чувства и любов. Нова любов идва бавно, но сигурно. Не бързайте – истинската любов узрява с времето.",
    "reading_description": "Нова любов идва бавно, но сигурно. Не бързай – истинската любов узрява с времето.",
    "reading_advice": "Позволи на любовта да расте бавно. Тя ще бъде по-здрава."
  },
  {
    "reading_id": "knight_pentacles_two_cups",
    "reading_name": "Рицар Пентакли + Двойка Чаши",
    "reading_cards": "Рицар Пентакли + Двойка Чаши",
    "reading_combination": ["knight_pentacles", "two_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Двойка Чаши – любов и връзка. Връзка, която се развива бавно, но сигурно. Търпението в любовта носи дълбоки корени.",
    "reading_description": "Връзка, която се развива бавно, но сигурно. Търпението в любовта носи дълбоки корени.",
    "reading_advice": "Не бързай. Истинската любов не бърза – тя узрява с времето."
  },
  {
    "reading_id": "knight_pentacles_three_cups",
    "reading_name": "Рицар Пентакли + Тройка Чаши",
    "reading_cards": "Рицар Пентакли + Тройка Чаши",
    "reading_combination": ["knight_pentacles", "three_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Тройка Чаши – празник и радост. Бавно, но сигурно стигате до повод за празнуване. Насладете се на момента.",
    "reading_description": "Бавно, но сигурно стигаш до повод за празнуване. Наслади се на момента.",
    "reading_advice": "Празнувай успеха – ти го заслужи. Бавният път също води до целта."
  },
  {
    "reading_id": "knight_pentacles_four_cups",
    "reading_name": "Рицар Пентакли + Четворка Чаши",
    "reading_cards": "Рицар Пентакли + Четворка Чаши",
    "reading_combination": ["knight_pentacles", "four_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Четворка Чаши – апатия и неудовлетворение. Напредвате, но не сте удовлетворени. Нещо ви липсва. Потърсете какво наистина искате.",
    "reading_description": "Напредваш, но не си удовлетворен. Нещо ти липсва.",
    "reading_advice": "Попитай се какво наистина искаш. Бавният напредък трябва да води към истинската ти цел."
  },
  {
    "reading_id": "knight_pentacles_five_cups",
    "reading_name": "Рицар Пентакли + Петица Чаши",
    "reading_cards": "Рицар Пентакли + Петица Чаши",
    "reading_combination": ["knight_pentacles", "five_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Петица Чаши – загуба и тъга. Напредвате, но носите загуба. Позволете си да скърбите, но не спирайте – бавният път напред лекува.",
    "reading_description": "Напредваш, но носиш загуба. Скърби, но не спирай – бавният път напред лекува.",
    "reading_advice": "Позволи си да скърбиш, после продължи. Бавният напредък ще те изведе от тъгата."
  },
  {
    "reading_id": "knight_pentacles_six_cups",
    "reading_name": "Рицар Пентакли + Шестица Чаши",
    "reading_cards": "Рицар Пентакли + Шестица Чаши",
    "reading_combination": ["knight_pentacles", "six_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Шестица Чаши – спомени и носталгия. Напредвате, но миналото ви държи. Използвайте спомените като вдъхновение, не като спирачка.",
    "reading_description": "Напредваш, но миналото те държи. Използвай спомените като вдъхновение.",
    "reading_advice": "Миналото е учител, не водач. Вземи наученото и продължи напред."
  },
  {
    "reading_id": "knight_pentacles_seven_cups",
    "reading_name": "Рицар Пентакли + Седмица Чаши",
    "reading_cards": "Рицар Пентакли + Седмица Чаши",
    "reading_combination": ["knight_pentacles", "seven_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Седмица Чаши – илюзии и фантазии. Имате илюзорни представи за напредъка си. Свали розовите очила – бавният път изисква реалност.",
    "reading_description": "Имаш илюзорни представи за напредъка си. Свали розовите очила.",
    "reading_advice": "Бъди реалист. Бавният напредък е реален – не се заблуждавай с илюзии."
  },
  {
    "reading_id": "knight_pentacles_eight_cups",
    "reading_name": "Рицар Пентакли + Осмица Чаши",
    "reading_cards": "Рицар Пентакли + Осмица Чаши",
    "reading_combination": ["knight_pentacles", "eight_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Осмица Чаши – тръгване и оставяне. Решавате да оставите бавния път и да тръгнете по-бързо. Смела стъпка – но не забравяйте сигурността.",
    "reading_description": "Решаваш да оставиш бавния път и да тръгнеш по-бързо. Смела стъпка.",
    "reading_advice": "Тръгни, но не забравяй сигурността. Понякога бързината е оправдана."
  },
  {
    "reading_id": "knight_pentacles_nine_cups",
    "reading_name": "Рицар Пентакли + Деветка Чаши",
    "reading_cards": "Рицар Пентакли + Деветка Чаши",
    "reading_combination": ["knight_pentacles", "nine_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Деветка Чаши – сбъднато желание. Бавният, но сигурен път ви води до сбъдване на мечта. Удовлетворение и радост.",
    "reading_description": "Бавният, но сигурен път те води до сбъдване на мечта. Удовлетворение и радост.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Бавният път доведе до мечтата."
  },
  {
    "reading_id": "knight_pentacles_ten_cups",
    "reading_name": "Рицар Пентакли + Десетка Чаши",
    "reading_cards": "Рицар Пентакли + Десетка Чаши",
    "reading_combination": ["knight_pentacles", "ten_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Десетка Чаши – семейно щастие. Бавно, но сигурно сте изградили семейно щастие. Споделена стабилност и любов.",
    "reading_description": "Бавно, но сигурно си изградил семейно щастие. Споделена стабилност и любов.",
    "reading_advice": "Цени семейството си. То е резултат от твоето търпение и постоянство."
  },
  {
    "reading_id": "knight_pentacles_page_cups",
    "reading_name": "Рицар Пентакли + Паж Чаши",
    "reading_cards": "Рицар Пентакли + Паж Чаши",
    "reading_combination": ["knight_pentacles", "page_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Паж Чаши – емоционално послание. Получавате нежно послание, което ви насърчава да продължите. Някой вярва в бавния ви път.",
    "reading_description": "Получаваш нежно послание, което те насърчава да продължиш.",
    "reading_advice": "Отвори сърцето си за посланието. То носи подкрепа и насърчение."
  },
  {
    "reading_id": "knight_pentacles_knight_cups",
    "reading_name": "Рицар Пентакли + Рицар Чаши",
    "reading_cards": "Рицар Пентакли + Рицар Чаши",
    "reading_combination": ["knight_pentacles", "knight_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Рицар Чаши – романтика и ухажване. Бавно, но сигурно се развива романтична връзка. Търпението в любовта носи дълбоки чувства.",
    "reading_description": "Бавно, но сигурно се развива романтична връзка. Търпението в любовта носи дълбоки чувства.",
    "reading_advice": "Не бързай. Истинската любов заслужава да изчакаш."
  },
  {
    "reading_id": "knight_pentacles_queen_cups",
    "reading_name": "Рицар Пентакли + Царица Чаши",
    "reading_cards": "Рицар Пентакли + Царица Чаши",
    "reading_combination": ["knight_pentacles", "queen_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Царица Чаши – интуиция и емпатия. Интуицията ви подсказва, че бавният път е правилният. Слушайте сърцето си.",
    "reading_description": "Интуицията ти подсказва, че бавният път е правилният.",
    "reading_advice": "Довери се на интуицията си. Тя знае, че бавният път води до истинския успех."
  },
  {
    "reading_id": "knight_pentacles_king_cups",
    "reading_name": "Рицар Пентакли + Цар Чаши",
    "reading_cards": "Рицар Пентакли + Цар Чаши",
    "reading_combination": ["knight_pentacles", "king_cups"],
    "reading_meaning": "Рицар Пентакли носи бавен и сигурен напредък, а Цар Чаши – емоционална зрялост и баланс. Напредвате с мъдрост и спокойствие. Без прибързване, без стрес – знаете, че бавният път води до целта.",
    "reading_description": "Напредваш с мъдрост и спокойствие. Знаеш, че бавният път води до целта.",
    "reading_advice": "Продължавай така. Бавното и сигурно с мъдрост води до истински успех."
  },

    {
    "reading_id": "queen_pentacles_two_wands",
    "reading_name": "Царица Пентакли + Двойка Жезли",
    "reading_cards": "Царица Пентакли + Двойка Жезли",
    "reading_combination": ["queen_pentacles", "two_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Двойка Жезли – избор и планиране. Предстои избор, който засяга дома и семейството. Съветвайте се с близките и изберете практичното.",
    "reading_description": "Предстои избор, който засяга дома и семейството. Избери практичното.",
    "reading_advice": "Съветвай се със семейството. Практичният избор носи дългосрочна стабилност."
  },
  {
    "reading_id": "queen_pentacles_three_wands",
    "reading_name": "Царица Пентакли + Тройка Жезли",
    "reading_cards": "Царица Пентакли + Тройка Жезли",
    "reading_combination": ["queen_pentacles", "three_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Тройка Жезли – очакване и разширяване. Инвестирали сте в дома или семейството и сега чакате резултати. Търпение и грижа.",
    "reading_description": "Инвестирал си в дома или семейството и чакаш резултати. Търпение и грижа.",
    "reading_advice": "Чакай търпеливо. Грижата, която вложи сега, ще даде плодове."
  },
  {
    "reading_id": "queen_pentacles_four_wands",
    "reading_name": "Царица Пентакли + Четворка Жезли",
    "reading_cards": "Царица Пентакли + Четворка Жезли",
    "reading_combination": ["queen_pentacles", "four_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Четворка Жезли – празник и стабилност. Празнувате у дома с грижа и топлина. Вашата практичност прави празника незабравим.",
    "reading_description": "Празнуваш у дома с грижа и топлина. Практичността ти прави празника незабравим.",
    "reading_advice": "Грижи се за дома и гостите. Твоята топлина прави празника специален."
  },
  {
    "reading_id": "queen_pentacles_five_wands",
    "reading_name": "Царица Пентакли + Петица Жезли",
    "reading_cards": "Царица Пентакли + Петица Жезли",
    "reading_combination": ["queen_pentacles", "five_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Петица Жезли – конфликт и съперничество. Конфликти в дома или семейството. Вашата практичност и грижа могат да помогнат за разрешаването им.",
    "reading_description": "Конфликти в дома или семейството. Твоята практичност може да помогне.",
    "reading_advice": "Използвай практичността и грижата си. Те могат да успокоят духовете."
  },
  {
    "reading_id": "queen_pentacles_six_wands",
    "reading_name": "Царица Пентакли + Шестица Жезли",
    "reading_cards": "Царица Пентакли + Шестица Жезли",
    "reading_combination": ["queen_pentacles", "six_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Шестица Жезли – победа и признание. Вашата грижа за дома и семейството получава признание. Гордейте се – заслужили сте го.",
    "reading_description": "Твоята грижа за дома и семейството получава признание.",
    "reading_advice": "Наслади се на признанието. Твоята грижа прави света по-добър."
  },
  {
    "reading_id": "queen_pentacles_seven_wands",
    "reading_name": "Царица Пентакли + Седмица Жезли",
    "reading_cards": "Царица Пентакли + Седмица Жезли",
    "reading_combination": ["queen_pentacles", "seven_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Седмица Жезли – защита на позицията. Трябва да защитавате дома и семейството си от външни заплахи. Дръжте се – вашата грижа ще надделее.",
    "reading_description": "Трябва да защитаваш дома и семейството си от външни заплахи.",
    "reading_advice": "Защитавай с грижа и твърдост. Твоят дом си заслужава защита."
  },
  {
    "reading_id": "queen_pentacles_eight_wands",
    "reading_name": "Царица Пентакли + Осмица Жезли",
    "reading_cards": "Царица Пентакли + Осмица Жезли",
    "reading_combination": ["queen_pentacles", "eight_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Осмица Жезли – бързина и движение. Домашни дела се случват бързо – преместване, ремонт, гости. Грижете се, но не се претоварвайте.",
    "reading_description": "Домашни дела се случват бързо – преместване, ремонт, гости.",
    "reading_advice": "Действай бързо, но с грижа. Твоята практичност ще помогне всичко да мине гладко."
  },
  {
    "reading_id": "queen_pentacles_nine_wands",
    "reading_name": "Царица Пентакли + Деветка Жезли",
    "reading_cards": "Царица Пентакли + Деветка Жезли",
    "reading_combination": ["queen_pentacles", "nine_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Деветка Жезли – устойчивост и изтощение. Грижите за дома ви изтощават. Починете си – заслужавате го. Грижата започва от себе си.",
    "reading_description": "Грижите за дома те изтощават. Почини си – заслужаваш го.",
    "reading_advice": "Почини си. Грижата започва от себе си. Не можеш да се грижиш за другите, ако си изтощен."
  },
  {
    "reading_id": "queen_pentacles_ten_wands",
    "reading_name": "Царица Пентакли + Десетка Жезли",
    "reading_cards": "Царица Пентакли + Десетка Жезли",
    "reading_combination": ["queen_pentacles", "ten_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Десетка Жезли – претоварване и бреме. Носите тежкото бреме на домашните отговорности. Споделете грижите – не можете да носите всичко сам.",
    "reading_description": "Носиш тежкото бреме на домашните отговорности. Сподели грижите.",
    "reading_advice": "Потърси помощ. Грижата за дома не трябва да е само твоя отговорност."
  },
  {
    "reading_id": "queen_pentacles_page_wands",
    "reading_name": "Царица Пентакли + Паж Жезли",
    "reading_cards": "Царица Пентакли + Паж Жезли",
    "reading_combination": ["queen_pentacles", "page_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Паж Жезли – новини и ентусиазъм. Получавате вълнуваща новина, свързана с дома или семейството. Добри вести идват.",
    "reading_description": "Получаваш вълнуваща новина, свързана с дома или семейството.",
    "reading_advice": "Отвори се за новините. Те носят радост и надежда за семейството."
  },
  {
    "reading_id": "queen_pentacles_knight_wands",
    "reading_name": "Царица Пентакли + Рицар Жезли",
    "reading_cards": "Царица Пентакли + Рицар Жезли",
    "reading_combination": ["queen_pentacles", "knight_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Рицар Жезли – импулсивност и бързина. Някой в дома действа импулсивно. Успокойте ги с вашата практичност и грижа.",
    "reading_description": "Някой в дома действа импулсивно. Успокой ги с практичността и грижата си.",
    "reading_advice": "Успокой духовете с практичност. Понякога бавното и сигурно е по-добро."
  },
  {
    "reading_id": "queen_pentacles_queen_wands",
    "reading_name": "Царица Пентакли + Царица Жезли",
    "reading_cards": "Царица Пентакли + Царица Жезли",
    "reading_combination": ["queen_pentacles", "queen_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Царица Жезли – увереност и харизма. Вие сте сърцето на дома – вашата грижа и увереност държат семейството заедно.",
    "reading_description": "Ти си сърцето на дома – грижата и увереността ти държат семейството заедно.",
    "reading_advice": "Бъди себе си – грижовна и уверена. Твоята светлина прави дома топъл."
  },
  {
    "reading_id": "queen_pentacles_king_wands",
    "reading_name": "Царица Пентакли + Цар Жезли",
    "reading_cards": "Царица Пентакли + Цар Жезли",
    "reading_combination": ["queen_pentacles", "king_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Цар Жезли – лидерство и визия. Вие сте опората на дома – вашата практичност и лидерство държат всичко заедно.",
    "reading_description": "Ти си опората на дома – практичността и лидерството ти държат всичко заедно.",
    "reading_advice": "Води с грижа и практичност. Твоята стабилност е основата на семейството."
  },
  {
    "reading_id": "queen_pentacles_ace_wands",
    "reading_name": "Царица Пентакли + Асо Жезли",
    "reading_cards": "Царица Пентакли + Асо Жезли",
    "reading_combination": ["queen_pentacles", "ace_wands"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Асо Жезли – ново начало и вдъхновение. Ново начало в дома – нов член, нов проект, нов етап. Грижата ви ще помогне то да се развие.",
    "reading_description": "Ново начало в дома – нов член, нов проект, нов етап.",
    "reading_advice": "Хвани новото начало с грижа. Твоята практичност ще го направи стабилно."
  },
  {
    "reading_id": "queen_pentacles_ace_cups",
    "reading_name": "Царица Пентакли + Асо Чаши",
    "reading_cards": "Царица Пентакли + Асо Чаши",
    "reading_combination": ["queen_pentacles", "ace_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Асо Чаши – нови чувства и любов. Нова любов идва в дома – нов член на семейството или ново начало в любовта. Сърцето ви се разширява.",
    "reading_description": "Нова любов идва в дома – нов член на семейството или ново начало в любовта.",
    "reading_advice": "Отвори сърцето си. Любовта, дошла в дома, ще бъде приета с грижа."
  },
  {
    "reading_id": "queen_pentacles_two_cups",
    "reading_name": "Царица Пентакли + Двойка Чаши",
    "reading_cards": "Царица Пентакли + Двойка Чаши",
    "reading_combination": ["queen_pentacles", "two_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Двойка Чаши – любов и връзка. Връзка, основана на взаимна грижа и практичност. Любов, която се проявява в ежедневните грижи.",
    "reading_description": "Връзка, основана на взаимна грижа и практичност. Любов в ежедневните грижи.",
    "reading_advice": "Цени любовта, която се проявява в грижата. Тя е най-истинската."
  },
  {
    "reading_id": "queen_pentacles_three_cups",
    "reading_name": "Царица Пентакли + Тройка Чаши",
    "reading_cards": "Царица Пентакли + Тройка Чаши",
    "reading_combination": ["queen_pentacles", "three_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Тройка Чаши – празник и радост. Празнувате с грижа и топлина. Вашата практичност прави празника незабравим за всички.",
    "reading_description": "Празнуваш с грижа и топлина. Практичността ти прави празника незабравим.",
    "reading_advice": "Празнувай с грижа. Твоята топлина прави всеки да се чувства специален."
  },
  {
    "reading_id": "queen_pentacles_four_cups",
    "reading_name": "Царица Пентакли + Четворка Чаши",
    "reading_cards": "Царица Пентакли + Четворка Чаши",
    "reading_combination": ["queen_pentacles", "four_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Четворка Чаши – апатия и неудовлетворение. Грижите ви тежат и сте неудовлетворени. Потърсете какво наистина ви липсва – може би малко време за себе си.",
    "reading_description": "Грижите ти тежат и си неудовлетворен. Потърси време за себе си.",
    "reading_advice": "Погрижи се за себе си. Само така можеш да се грижиш за другите."
  },
  {
    "reading_id": "queen_pentacles_five_cups",
    "reading_name": "Царица Пентакли + Петица Чаши",
    "reading_cards": "Царица Пентакли + Петица Чаши",
    "reading_combination": ["queen_pentacles", "five_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Петица Чаши – загуба и тъга. Загуба в семейството. Вашата грижа ще помогне на всички да преминат през тъгата. Бъдете опора.",
    "reading_description": "Загуба в семейството. Твоята грижа ще помогне на всички да преминат през тъгата.",
    "reading_advice": "Бъди опора. Твоята грижа лекува."
  },
  {
    "reading_id": "queen_pentacles_six_cups",
    "reading_name": "Царица Пентакли + Шестица Чаши",
    "reading_cards": "Царица Пентакли + Шестица Чаши",
    "reading_combination": ["queen_pentacles", "six_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Шестица Чаши – спомени и носталгия. Спомени от миналото ви карат да се грижите за семейството. Носталгия и топлина.",
    "reading_description": "Спомени от миналото те карат да се грижиш за семейството.",
    "reading_advice": "Използвай миналото като вдъхновение за грижа. Създавай нови спомени."
  },
  {
    "reading_id": "queen_pentacles_seven_cups",
    "reading_name": "Царица Пентакли + Седмица Чаши",
    "reading_cards": "Царица Пентакли + Седмица Чаши",
    "reading_combination": ["queen_pentacles", "seven_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Седмица Чаши – илюзии и фантазии. Илюзорни представи за дома или семейството. Свали розовите очила – грижата изисква реалност.",
    "reading_description": "Илюзорни представи за дома или семейството. Свали розовите очила.",
    "reading_advice": "Бъди реалист. Истинската грижа започва с реалността, не с илюзии."
  },
  {
    "reading_id": "queen_pentacles_eight_cups",
    "reading_name": "Царица Пентакли + Осмица Чаши",
    "reading_cards": "Царица Пентакли + Осмица Чаши",
    "reading_combination": ["queen_pentacles", "eight_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Осмица Чаши – тръгване и оставяне. Решавате да оставите дома или семейството и да тръгнете. Трудно решение, но понякога необходимо.",
    "reading_description": "Решаваш да оставиш дома или семейството и да тръгнеш.",
    "reading_advice": "Тръгни, ако трябва. Понякога грижата изисква да оставиш."
  },
  {
    "reading_id": "queen_pentacles_nine_cups",
    "reading_name": "Царица Пентакли + Деветка Чаши",
    "reading_cards": "Царица Пентакли + Деветка Чаши",
    "reading_combination": ["queen_pentacles", "nine_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Деветка Чаши – сбъднато желание. Грижата ви за дома води до сбъдване на семейна мечта. Удовлетворение и радост.",
    "reading_description": "Грижата ти за дома води до сбъдване на семейна мечта.",
    "reading_advice": "Наслади се на момента. Твоята грижа донесе тази радост."
  },
  {
    "reading_id": "queen_pentacles_ten_cups",
    "reading_name": "Царица Пентакли + Десетка Чаши",
    "reading_cards": "Царица Пентакли + Десетка Чаши",
    "reading_combination": ["queen_pentacles", "ten_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Десетка Чаши – семейно щастие. Вашата грижа и практичност създават семейно щастие. Хармония и любов в дома.",
    "reading_description": "Твоята грижа и практичност създават семейно щастие. Хармония и любов в дома.",
    "reading_advice": "Цени това, което си изградила. Твоята грижа прави дома дом."
  },
  {
    "reading_id": "queen_pentacles_page_cups",
    "reading_name": "Царица Пентакли + Паж Чаши",
    "reading_cards": "Царица Пентакли + Паж Чаши",
    "reading_combination": ["queen_pentacles", "page_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Паж Чаши – емоционално послание. Получавате нежно послание от член на семейството. Отворете сърцето си за него.",
    "reading_description": "Получаваш нежно послание от член на семейството.",
    "reading_advice": "Отвори сърцето си за посланието. То носи любов и топлина."
  },
  {
    "reading_id": "queen_pentacles_knight_cups",
    "reading_name": "Царица Пентакли + Рицар Чаши",
    "reading_cards": "Царица Пентакли + Рицар Чаши",
    "reading_combination": ["queen_pentacles", "knight_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Рицар Чаши – романтика и ухажване. Романтичен жест в дома. Някой изразява любовта си с грижа и практичност.",
    "reading_description": "Романтичен жест в дома. Някой изразява любовта си с грижа и практичност.",
    "reading_advice": "Позволи на любовта да влезе. Тя идва с грижа."
  },
  {
    "reading_id": "queen_pentacles_queen_cups",
    "reading_name": "Царица Пентакли + Царица Чаши",
    "reading_cards": "Царица Пентакли + Царица Чаши",
    "reading_combination": ["queen_pentacles", "queen_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Царица Чаши – интуиция и емпатия. Вие сте сърцето и ума на дома – вашата интуиция и практичност създават хармония.",
    "reading_description": "Ти си сърцето и ума на дома – интуицията и практичността ти създават хармония.",
    "reading_advice": "Слушай сърцето и ума си. Заедно те знаят какво е най-добро за дома."
  },
  {
    "reading_id": "queen_pentacles_king_cups",
    "reading_name": "Царица Пентакли + Цар Чаши",
    "reading_cards": "Царица Пентакли + Цар Чаши",
    "reading_combination": ["queen_pentacles", "king_cups"],
    "reading_meaning": "Царица Пентакли носи грижа и практичност, а Цар Чаши – емоционална зрялост и баланс. Вашата грижа и емоционална зрялост правят дома стабилен и топъл. Баланс между сърце и ум.",
    "reading_description": "Твоята грижа и емоционална зрялост правят дома стабилен и топъл.",
    "reading_advice": "Продължавай така. Балансът между грижа и мъдрост е ключът към щастлив дом."
  },
    {
    "reading_id": "king_pentacles_two_wands",
    "reading_name": "Цар Пентакли + Двойка Жезли",
    "reading_cards": "Цар Пентакли + Двойка Жезли",
    "reading_combination": ["king_pentacles", "two_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Двойка Жезли – избор и планиране. Предстои важен бизнес или финансов избор. Вашата стабилност ще ви помогне да изберете правилно.",
    "reading_description": "Предстои важен бизнес или финансов избор. Стабилността ти ще помогне да избереш правилно.",
    "reading_advice": "Избери с мъдрост. Твоята стабилност е основата за правилното решение."
  },
  {
    "reading_id": "king_pentacles_three_wands",
    "reading_name": "Цар Пентакли + Тройка Жезли",
    "reading_cards": "Цар Пентакли + Тройка Жезли",
    "reading_combination": ["king_pentacles", "three_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Тройка Жезли – очакване и разширяване. Инвестирали сте и чакате резултати. Вашата стабилност ще ви помогне да изчакате търпеливо.",
    "reading_description": "Инвестирал си и чакаш резултати. Стабилността ти ще помогне да изчакаш търпеливо.",
    "reading_advice": "Чакай търпеливо. Стабилността, която си изградил, ще издържи."
  },
  {
    "reading_id": "king_pentacles_four_wands",
    "reading_name": "Цар Пентакли + Четворка Жезли",
    "reading_cards": "Цар Пентакли + Четворка Жезли",
    "reading_combination": ["king_pentacles", "four_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Четворка Жезли – празник и стабилност. Празнувате успех с увереност и размах. Вашата стабилност дава сигурност на всички.",
    "reading_description": "Празнуваш успех с увереност и размах. Стабилността ти дава сигурност.",
    "reading_advice": "Празнувай, но не спирай да градиш. Стабилността изисква постоянство."
  },
  {
    "reading_id": "king_pentacles_five_wands",
    "reading_name": "Цар Пентакли + Петица Жезли",
    "reading_cards": "Цар Пентакли + Петица Жезли",
    "reading_combination": ["king_pentacles", "five_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Петица Жезли – конфликт и съперничество. Конкуренция в бизнеса. Вашата стабилност и авторитет ще ви помогнат да надделеете.",
    "reading_description": "Конкуренция в бизнеса. Стабилността и авторитетът ти ще помогнат да надделееш.",
    "reading_advice": "Дръж се. Твоята стабилност е по-силна от временните конфликти."
  },
  {
    "reading_id": "king_pentacles_six_wands",
    "reading_name": "Цар Пентакли + Шестица Жезли",
    "reading_cards": "Цар Пентакли + Шестица Жезли",
    "reading_combination": ["king_pentacles", "six_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Шестица Жезли – победа и признание. Бизнес успехът ви получава признание. Гордейте се – стабилността ви доведе до тук.",
    "reading_description": "Бизнес успехът ти получава признание. Стабилността те доведе до тук.",
    "reading_advice": "Наслади се на успеха. Ти го заслужи. Стабилността и търпението дават плод."
  },
  {
    "reading_id": "king_pentacles_seven_wands",
    "reading_name": "Цар Пентакли + Седмица Жезли",
    "reading_cards": "Цар Пентакли + Седмица Жезли",
    "reading_combination": ["king_pentacles", "seven_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Седмица Жезли – защита на позицията. Трябва да защитавате бизнеса си от нападки. Вашата стабилност и авторитет ще ви помогнат.",
    "reading_description": "Трябва да защитаваш бизнеса си от нападки. Стабилността и авторитетът ти ще помогнат.",
    "reading_advice": "Дръж позицията си. Твоята стабилност е твоята сила."
  },
  {
    "reading_id": "king_pentacles_eight_wands",
    "reading_name": "Цар Пентакли + Осмица Жезли",
    "reading_cards": "Цар Пентакли + Осмица Жезли",
    "reading_combination": ["king_pentacles", "eight_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Осмица Жезли – бързина и движение. Бизнес възможност идва бързо. Вашата стабилност ви позволява да я хванете без риск.",
    "reading_description": "Бизнес възможност идва бързо. Стабилността ти позволява да я хванеш без риск.",
    "reading_advice": "Хвани възможността. Стабилността ти дава свобода да действаш бързо."
  },
  {
    "reading_id": "king_pentacles_nine_wands",
    "reading_name": "Цар Пентакли + Деветка Жезли",
    "reading_cards": "Цар Пентакли + Деветка Жезли",
    "reading_combination": ["king_pentacles", "nine_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Деветка Жезли – устойчивост и изтощение. Изтощени сте от защитата на бизнеса си. Починете си – стабилността ви няма да се срине.",
    "reading_description": "Изтощен си от защитата на бизнеса си. Почини си – стабилността ти няма да се срине.",
    "reading_advice": "Почини си. Стабилността, която си изградил, ще издържи."
  },
  {
    "reading_id": "king_pentacles_ten_wands",
    "reading_name": "Цар Пентакли + Десетка Жезли",
    "reading_cards": "Цар Пентакли + Десетка Жезли",
    "reading_combination": ["king_pentacles", "ten_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Десетка Жезли – претоварване и бреме. Носите тежкото бреме на бизнес отговорностите. Споделете бремето – не можете да носите всичко сам.",
    "reading_description": "Носиш тежкото бреме на бизнес отговорностите. Сподели бремето.",
    "reading_advice": "Потърси партньори. Дори царят има нужда от съветници."
  },
  {
    "reading_id": "king_pentacles_page_wands",
    "reading_name": "Цар Пентакли + Паж Жезли",
    "reading_cards": "Цар Пентакли + Паж Жезли",
    "reading_combination": ["king_pentacles", "page_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Паж Жезли – новини и ентусиазъм. Получавате вълнуваща бизнес новина. Ентусиазъм и нови възможности.",
    "reading_description": "Получаваш вълнуваща бизнес новина. Ентусиазъм и нови възможности.",
    "reading_advice": "Отвори се за новините. Те носят растеж и просперитет."
  },
  {
    "reading_id": "king_pentacles_knight_wands",
    "reading_name": "Цар Пентакли + Рицар Жезли",
    "reading_cards": "Цар Пентакли + Рицар Жезли",
    "reading_combination": ["king_pentacles", "knight_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Рицар Жезли – импулсивност и бързина. Някой в бизнеса действа импулсивно. Вашата стабилност ще балансира нещата.",
    "reading_description": "Някой в бизнеса действа импулсивно. Стабилността ти ще балансира нещата.",
    "reading_advice": "Бъди стабилният стълб. Импулсивността се нуждае от твоята мъдрост."
  },
  {
    "reading_id": "king_pentacles_queen_wands",
    "reading_name": "Цар Пентакли + Царица Жезли",
    "reading_cards": "Цар Пентакли + Царица Жезли",
    "reading_combination": ["king_pentacles", "queen_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Царица Жезли – увереност и харизма. Вие сте царят и царицата на своята област – стабилност и харизма заедно.",
    "reading_description": "Ти си царят и царицата на своята област – стабилност и харизма заедно.",
    "reading_advice": "Води с увереност и стабилност. Твоят пример вдъхновява другите."
  },
  {
    "reading_id": "king_pentacles_king_wands",
    "reading_name": "Цар Пентакли + Цар Жезли",
    "reading_cards": "Цар Пентакли + Цар Жезли",
    "reading_combination": ["king_pentacles", "king_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Цар Жезли – лидерство и визия. Двама царе – вие сте лидер с визия и стабилност. Няма кой да ви спре.",
    "reading_description": "Ти си лидер с визия и стабилност. Няма кой да те спре.",
    "reading_advice": "Води с мъдрост. Твоята визия и стабилност са непобедима комбинация."
  },
  {
    "reading_id": "king_pentacles_ace_wands",
    "reading_name": "Цар Пентакли + Асо Жезли",
    "reading_cards": "Цар Пентакли + Асо Жезли",
    "reading_combination": ["king_pentacles", "ace_wands"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Асо Жезли – ново начало и вдъхновение. Нов бизнес проект започва на стабилна основа. Искрата е запалена – сега я развивайте.",
    "reading_description": "Нов бизнес проект започва на стабилна основа. Искрата е запалена.",
    "reading_advice": "Хвани новата искра. Стабилността ти ще я направи устойчива."
  },
  {
    "reading_id": "king_pentacles_ace_cups",
    "reading_name": "Цар Пентакли + Асо Чаши",
    "reading_cards": "Цар Пентакли + Асо Чаши",
    "reading_combination": ["king_pentacles", "ace_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Асо Чаши – нови чувства и любов. Нова любов идва в живота на стабилна основа. Сърцето и умът в хармония.",
    "reading_description": "Нова любов идва на стабилна основа. Сърцето и умът в хармония.",
    "reading_advice": "Отвори сърцето си. Стабилността ти позволява да обичаш без страх."
  },
  {
    "reading_id": "king_pentacles_two_cups",
    "reading_name": "Цар Пентакли + Двойка Чаши",
    "reading_cards": "Цар Пентакли + Двойка Чаши",
    "reading_combination": ["king_pentacles", "two_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Двойка Чаши – любов и връзка. Връзка, основана на стабилност и взаимно уважение. Любов, която гради бъдеще.",
    "reading_description": "Връзка, основана на стабилност и взаимно уважение. Любов, която гради бъдеще.",
    "reading_advice": "Цени тази връзка. Тя има всичко необходимо да бъде вечна."
  },
  {
    "reading_id": "king_pentacles_three_cups",
    "reading_name": "Цар Пентакли + Тройка Чаши",
    "reading_cards": "Цар Пентакли + Тройка Чаши",
    "reading_combination": ["king_pentacles", "three_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Тройка Чаши – празник и радост. Празнувате успех с партньори и приятели. Щедрост и стабилност.",
    "reading_description": "Празнуваш успех с партньори и приятели. Щедрост и стабилност.",
    "reading_advice": "Сподели успеха. Той става по-голям, когато го споделяш."
  },
  {
    "reading_id": "king_pentacles_four_cups",
    "reading_name": "Цар Пентакли + Четворка Чаши",
    "reading_cards": "Цар Пентакли + Четворка Чаши",
    "reading_combination": ["king_pentacles", "four_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Четворка Чаши – апатия и неудовлетворение. Имате стабилност, но не сте удовлетворени. Потърсете какво наистина искате – успехът не е всичко.",
    "reading_description": "Имаш стабилност, но не си удовлетворен. Потърси какво наистина искаш.",
    "reading_advice": "Успехът не е всичко. Потърси какво те прави щастлив."
  },
    {
    "reading_id": "ten_wands_nine_swords",
    "reading_name": "Десетка Жезли + Деветка Мечове",
    "reading_cards": "Десетка Жезли + Деветка Мечове",
    "reading_combination": ["ten_wands", "nine_swords"],
    "reading_meaning": "Десетка Жезли носи претоварване и бреме, а Деветка Мечове – тревога и безсъние. Носите тежко бреме и то ви причинява безсънни нощи. Мислите ви се въртят около отговорностите и не ви оставят да спите. Омагьосан кръг от умора и тревога.",
    "reading_description": "Носиш тежко бреме и не спиш от тревоги. Умора и безсъние – омагьосан кръг.",
    "reading_advice": "Спри за момент. Не можеш да решиш всичко наведнъж. Потърси помощ и си почини – тревогите ти не са реалност."
  },
  {
    "reading_id": "king_pentacles_five_cups",
    "reading_name": "Цар Пентакли + Петица Чаши",
    "reading_cards": "Цар Пентакли + Петица Чаши",
    "reading_combination": ["king_pentacles", "five_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Петица Чаши – загуба и тъга. Успех, но с цената на загуба. Позволете си да скърбите, но не забравяйте какво имате.",
    "reading_description": "Успех, но с цената на загуба. Скърби, но не забравяй какво имаш.",
    "reading_advice": "Позволи си да скърбиш. Стабилността ти ще издържи."
  },
  {
    "reading_id": "king_pentacles_six_cups",
    "reading_name": "Цар Пентакли + Шестица Чаши",
    "reading_cards": "Цар Пентакли + Шестица Чаши",
    "reading_combination": ["king_pentacles", "six_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Шестица Чаши – спомени и носталгия. Успехът ви напомня за корените ви. Носталгия и благодарност към миналото.",
    "reading_description": "Успехът ти напомня за корените ти. Благодарност към миналото.",
    "reading_advice": "Благодари на миналото, което те доведе тук. Но гледай напред."
  },
  {
    "reading_id": "king_pentacles_seven_cups",
    "reading_name": "Цар Пентакли + Седмица Чаши",
    "reading_cards": "Цар Пентакли + Седмица Чаши",
    "reading_combination": ["king_pentacles", "seven_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Седмица Чаши – илюзии и фантазии. Илюзорни представи за успеха. Свали розовите очила – истинският успех е реален.",
    "reading_description": "Илюзорни представи за успеха. Свали розовите очила.",
    "reading_advice": "Бъди реалист. Истинският успех се гради на реалност, не на илюзии."
  },
  {
    "reading_id": "king_pentacles_eight_cups",
    "reading_name": "Цар Пентакли + Осмица Чаши",
    "reading_cards": "Цар Пентакли + Осмица Чаши",
    "reading_combination": ["king_pentacles", "eight_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Осмица Чаши – тръгване и оставяне. Решавате да оставите успеха и да тръгнете към нещо ново. Смела стъпка за истински цар.",
    "reading_description": "Решаваш да оставиш успеха и да тръгнеш към нещо ново. Смела стъпка.",
    "reading_advice": "Тръгни смело. Истинският цар знае кога да остави дори успеха."
  },
  {
    "reading_id": "king_pentacles_nine_cups",
    "reading_name": "Цар Пентакли + Деветка Чаши",
    "reading_cards": "Цар Пентакли + Деветка Чаши",
    "reading_combination": ["king_pentacles", "nine_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Деветка Чаши – сбъднато желание. Успехът ви води до сбъдване на дългогодишна мечта. Удовлетворение и радост.",
    "reading_description": "Успехът ти води до сбъдване на дългогодишна мечта. Удовлетворение и радост.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Стабилността доведе до мечтата."
  },
  {
    "reading_id": "king_pentacles_ten_cups",
    "reading_name": "Цар Пентакли + Десетка Чаши",
    "reading_cards": "Цар Пентакли + Десетка Чаши",
    "reading_combination": ["king_pentacles", "ten_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Десетка Чаши – семейно щастие. Успехът ви носи щастие на цялото семейство. Споделена стабилност и любов.",
    "reading_description": "Успехът ти носи щастие на цялото семейство. Споделена стабилност и любов.",
    "reading_advice": "Сподели успеха със семейството. Те са част от твоята история."
  },
  {
    "reading_id": "king_pentacles_page_cups",
    "reading_name": "Цар Пентакли + Паж Чаши",
    "reading_cards": "Цар Пентакли + Паж Чаши",
    "reading_combination": ["king_pentacles", "page_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Паж Чаши – емоционално послание. Получавате нежно послание от някой, който цени стабилността ви. Отворете сърцето си.",
    "reading_description": "Получаваш нежно послание от някой, който цени стабилността ти.",
    "reading_advice": "Отвори сърцето си за посланието. То носи признание и топлина."
  },
  
  {
    "reading_id": "king_pentacles_queen_cups",
    "reading_name": "Цар Пентакли + Царица Чаши",
    "reading_cards": "Цар Пентакли + Царица Чаши",
    "reading_combination": ["king_pentacles", "queen_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Царица Чаши – интуиция и емпатия. Стабилност и интуиция заедно – вие знаете кога да слушате сърцето и кога ума.",
    "reading_description": "Стабилност и интуиция заедно – знаеш кога да слушаш сърцето и кога ума.",
    "reading_advice": "Балансирай сърце и ум. Това е твоята сила."
  },
  {
    "reading_id": "king_pentacles_king_cups",
    "reading_name": "Цар Пентакли + Цар Чаши",
    "reading_cards": "Цар Пентакли + Цар Чаши",
    "reading_combination": ["king_pentacles", "king_cups"],
    "reading_meaning": "Цар Пентакли носи стабилност и бизнес успех, а Цар Чаши – емоционална зрялост и баланс. Двама царе – стабилност и емоционална мъдрост заедно. Няма кой да ви спре.",
    "reading_description": "Стабилност и емоционална мъдрост заедно. Няма кой да те спре.",
    "reading_advice": "Води с мъдрост. Твоят баланс между стабилност и емоция е непобедим."
  },
    {
    "reading_id": "ace_cups_two_wands",
    "reading_name": "Асо Чаши + Двойка Жезли",
    "reading_cards": "Асо Чаши + Двойка Жезли",
    "reading_combination": ["ace_cups", "two_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Двойка Жезли – избор и планиране. Нова любов или емоционално начало се появява, но предстои важен избор. Слушайте сърцето си – то ще ви насочи правилно.",
    "reading_description": "Нови чувства и важен избор пред вас. Сърцето ще ви покаже пътя.",
    "reading_advice": "Избери с любов. Сърцето знае повече от ума."
  },
  {
    "reading_id": "ace_cups_three_wands",
    "reading_name": "Асо Чаши + Тройка Жезли",
    "reading_cards": "Асо Чаши + Тройка Жезли",
    "reading_combination": ["ace_cups", "three_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Тройка Жезли – очакване и разширяване. Нова любов или емоционална връзка се развива, но резултатите ще дойдат с времето. Търпение и надежда.",
    "reading_description": "Нова любов се развива бавно. Търпение и надежда.",
    "reading_advice": "Чакай търпеливо. Истинската любов не бърза – тя узрява с времето."
  },
  {
    "reading_id": "ace_cups_four_wands",
    "reading_name": "Асо Чаши + Четворка Жезли",
    "reading_cards": "Асо Чаши + Четворка Жезли",
    "reading_combination": ["ace_cups", "four_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Четворка Жезли – празник и стабилност. Нова любов или емоционално начало носи повод за празнуване. Радост и топлина в дома.",
    "reading_description": "Нова любов носи радост и повод за празнуване. Сърцето се изпълва с топлина.",
    "reading_advice": "Празнувай новата любов. Сподели радостта със семейството."
  },
  {
    "reading_id": "ace_cups_five_wands",
    "reading_name": "Асо Чаши + Петица Жезли",
    "reading_cards": "Асо Чаши + Петица Жезли",
    "reading_combination": ["ace_cups", "five_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Петица Жезли – конфликт и съперничество. Новата ви любов или чувства срещат съпротива. Борете се за сърцето, но не позволявайте на конфликта да ви озлоби.",
    "reading_description": "Нова любов среща съпротива. Бори се за сърцето, но не губи себе си.",
    "reading_advice": "Не се отказвай при първото препятствие. Истинската любов си заслужава борбата."
  },
  {
    "reading_id": "ace_cups_six_wands",
    "reading_name": "Асо Чаши + Шестица Жезли",
    "reading_cards": "Асо Чаши + Шестица Жезли",
    "reading_combination": ["ace_cups", "six_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Шестица Жезли – победа и признание. Новата ви любов или чувства получават признание. Сърцето ви тържествува.",
    "reading_description": "Новата любов получава признание. Сърцето тържествува.",
    "reading_advice": "Радвай се на победата на сърцето. Ти го заслужи."
  },
  {
    "reading_id": "ace_cups_seven_wands",
    "reading_name": "Асо Чаши + Седмица Жезли",
    "reading_cards": "Асо Чаши + Седмица Жезли",
    "reading_combination": ["ace_cups", "seven_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Седмица Жезли – защита на позицията. Трябва да защитавате новите си чувства от критици и недоброжелатели. Дръжте се – любовта ви е истинска.",
    "reading_description": "Защитаваш новата любов от критици. Дръж се – любовта ти е истинска.",
    "reading_advice": "Не се огъвай пред критиката. Истинската любов издържа на всичко."
  },
  {
    "reading_id": "ace_cups_eight_wands",
    "reading_name": "Асо Чаши + Осмица Жезли",
    "reading_cards": "Асо Чаши + Осмица Жезли",
    "reading_combination": ["ace_cups", "eight_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Осмица Жезли – бързина и движение. Нова любов идва светкавично, без предупреждение. Сърцето ви бие бързо – уловете момента.",
    "reading_description": "Нова любов идва светкавично. Сърцето бие бързо – хвани момента.",
    "reading_advice": "Наслаждавай се на скоростта, но не забравяй да дишаш. Любовта не трябва да те задуши."
  },
  {
    "reading_id": "ace_cups_nine_wands",
    "reading_name": "Асо Чаши + Деветка Жезли",
    "reading_cards": "Асо Чаши + Деветка Жезли",
    "reading_combination": ["ace_cups", "nine_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Деветка Жезли – устойчивост и изтощение. Борите се за новата любов и сте изтощени. Дръжте се – краят на усилията наближава.",
    "reading_description": "Бориш се за любовта и си изтощен. Дръж се – финалът наближава.",
    "reading_advice": "Дръж се още малко. Истинската любов си заслужава всяко усилие."
  },
  {
    "reading_id": "ace_cups_ten_wands",
    "reading_name": "Асо Чаши + Десетка Жезли",
    "reading_cards": "Асо Чаши + Десетка Жезли",
    "reading_combination": ["ace_cups", "ten_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Десетка Жезли – претоварване и бреме. Новата любов идва с тежестта на отговорности. Не позволявайте на бремето да задуши чувствата.",
    "reading_description": "Нова любов идва с тежестта на отговорности. Пази чувствата си.",
    "reading_advice": "Сподели бремето с любимия. Любовта не трябва да те претоварва."
  },
  {
    "reading_id": "ace_cups_page_wands",
    "reading_name": "Асо Чаши + Паж Жезли",
    "reading_cards": "Асо Чаши + Паж Жезли",
    "reading_combination": ["ace_cups", "page_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Паж Жезли – новини и ентусиазъм. Получавате вълнуваща новина, свързана със сърдечни въпроси. Някой може да ви признае чувствата си.",
    "reading_description": "Вълнуваща новина за любов идва. Отвори сърцето си.",
    "reading_advice": "Отвори се за новината. Тя носи нещо ценно за сърцето ти."
  },
  {
    "reading_id": "ace_cups_knight_wands",
    "reading_name": "Асо Чаши + Рицар Жезли",
    "reading_cards": "Асо Чаши + Рицар Жезли",
    "reading_combination": ["ace_cups", "knight_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Рицар Жезли – импулсивност и бързина. Страстна любов, която идва бързо и интензивно. Наслаждавайте се, но внимавайте да не изгорите.",
    "reading_description": "Страстна любов идва бързо и интензивно. Наслаждавай се, но не изгаряй.",
    "reading_advice": "Действай със страст, но не забравяй да дишаш. Любовта е огън – може да стопли или да изгори."
  },
  {
    "reading_id": "ace_cups_queen_wands",
    "reading_name": "Асо Чаши + Царица Жезли",
    "reading_cards": "Асо Чаши + Царица Жезли",
    "reading_combination": ["ace_cups", "queen_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Царица Жезли – увереност и харизма. Новата любов идва с увереност и топлина. Вие сте привлекателни и харизматични – хората се влюбват в светлината ви.",
    "reading_description": "Нова любов идва с увереност и топлина. Твоята светлина привлича сърца.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина привлича истинската любов."
  },
  {
    "reading_id": "ace_cups_king_wands",
    "reading_name": "Асо Чаши + Цар Жезли",
    "reading_cards": "Асо Чаши + Цар Жезли",
    "reading_combination": ["ace_cups", "king_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Цар Жезли – лидерство и визия. Новата любов идва с лидерска енергия. Някой взима инициативата и ви води със сила и увереност.",
    "reading_description": "Нова любов идва с лидерска енергия. Някой взима инициативата.",
    "reading_advice": "Позволи да бъдеш воден, но не губи себе си. Истинският лидер те води, без да те заробва."
  },
  {
    "reading_id": "ace_cups_ace_wands",
    "reading_name": "Асо Чаши + Асо Жезли",
    "reading_cards": "Асо Чаши + Асо Жезли",
    "reading_combination": ["ace_cups", "ace_wands"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Асо Жезли – ново начало и вдъхновение. Две аса заедно – ново начало в любовта с огромна страст и енергия. Искрата е запалена – сега се грижете за нея.",
    "reading_description": "Ново начало в любовта с огромна страст. Искрата е запалена.",
    "reading_advice": "Хвани искрата. Тази любов има потенциала да бъде велика. Грижи се за нея."
  },
  {
    "reading_id": "ace_cups_two_cups",
    "reading_name": "Асо Чаши + Двойка Чаши",
    "reading_cards": "Асо Чаши + Двойка Чаши",
    "reading_combination": ["ace_cups", "two_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Двойка Чаши – любов и връзка. Две чаши заедно – мощна комбинация за нова любовна връзка. Среща, която носи дълбока емоционална връзка.",
    "reading_description": "Мощна комбинация за нова любовна връзка. Дълбока емоционална връзка.",
    "reading_advice": "Отвори сърцето си. Тази среща може да промени живота ти."
  },
  {
    "reading_id": "ace_cups_three_cups",
    "reading_name": "Асо Чаши + Тройка Чаши",
    "reading_cards": "Асо Чаши + Тройка Чаши",
    "reading_combination": ["ace_cups", "three_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Тройка Чаши – празник и радост. Новата любов идва с много радост и поводи за празнуване. Щастие, което се споделя с приятели.",
    "reading_description": "Нова любов идва с много радост. Празнувай с приятели.",
    "reading_advice": "Празнувай любовта с близките си. Споделената радост е двойна радост."
  },
  {
    "reading_id": "ace_cups_four_cups",
    "reading_name": "Асо Чаши + Четворка Чаши",
    "reading_cards": "Асо Чаши + Четворка Чаши",
    "reading_combination": ["ace_cups", "four_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Четворка Чаши – апатия и неудовлетворение. Нова възможност за любов се появява, но вие сте твърде заети със себе си, за да я забележите. Вдигнете поглед.",
    "reading_description": "Нова любов се появява, но ти не я забелязваш. Вдигни поглед.",
    "reading_advice": "Свали превръзката от очите. Любовта може да е точно пред теб."
  },
  {
    "reading_id": "ace_cups_five_cups",
    "reading_name": "Асо Чаши + Петица Чаши",
    "reading_cards": "Асо Чаши + Петица Чаши",
    "reading_combination": ["ace_cups", "five_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Петица Чаши – загуба и тъга. Нова любов се появява след период на тъга и загуба. Светлина след тъмнина – отворете сърцето си.",
    "reading_description": "Нова любов идва след период на тъга. Светлина след мрак.",
    "reading_advice": "Дори в скръбта има място за нова любов. Отвори сърцето си."
  },
  {
    "reading_id": "ace_cups_six_cups",
    "reading_name": "Асо Чаши + Шестица Чаши",
    "reading_cards": "Асо Чаши + Шестица Чаши",
    "reading_combination": ["ace_cups", "six_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Шестица Чаши – спомени и носталгия. Новата любов ви напомня за нещо от миналото. Носталгия и ново начало – познато, но ново.",
    "reading_description": "Нова любов напомня за миналото. Носталгия и ново начало.",
    "reading_advice": "Използвай миналото като вдъхновение, но не позволявай то да те държи в капан."
  },
  {
    "reading_id": "ace_cups_seven_cups",
    "reading_name": "Асо Чаши + Седмица Чаши",
    "reading_cards": "Асо Чаши + Седмица Чаши",
    "reading_combination": ["ace_cups", "seven_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Седмица Чаши – множество избори и илюзии. Много възможности за любов, но не всички са реални. Изберете с разум и сърце.",
    "reading_description": "Много възможности за любов, но не всички са реални. Избери внимателно.",
    "reading_advice": "Избери една възможност и ѝ се посвети. Не се разпилявай в илюзии."
  },
  {
    "reading_id": "ace_cups_eight_cups",
    "reading_name": "Асо Чаши + Осмица Чаши",
    "reading_cards": "Асо Чаши + Осмица Чаши",
    "reading_combination": ["ace_cups", "eight_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Осмица Чаши – тръгване и оставяне. Започвате нова любов, което означава да оставите нещо старо зад гърба си. Пътят към новото изисква освобождаване.",
    "reading_description": "Започваш нова любов и оставяш старото зад гърба си.",
    "reading_advice": "Тръгни смело. Старото вече не ти служи. Новата любов те очаква."
  },
  {
    "reading_id": "ace_cups_nine_cups",
    "reading_name": "Асо Чаши + Деветка Чаши",
    "reading_cards": "Асо Чаши + Деветка Чаши",
    "reading_combination": ["ace_cups", "nine_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Деветка Чаши – сбъднато желание. Новата любов носи сбъдване на дългогодишна мечта. Удовлетворение и радост.",
    "reading_description": "Новата любов носи сбъдване на дългогодишна мечта.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Мечтата ти се сбъдва."
  },
  {
    "reading_id": "ace_cups_ten_cups",
    "reading_name": "Асо Чаши + Десетка Чаши",
    "reading_cards": "Асо Чаши + Десетка Чаши",
    "reading_combination": ["ace_cups", "ten_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Десетка Чаши – семейно щастие. Новата любов носи радост на цялото семейство. Споделена хармония и топлина в дома.",
    "reading_description": "Новата любов носи радост на цялото семейство. Споделена хармония.",
    "reading_advice": "Сподели любовта със семейството си. Щастието е по-голямо, когато е споделено."
  },
  {
    "reading_id": "ace_cups_page_cups",
    "reading_name": "Асо Чаши + Паж Чаши",
    "reading_cards": "Асо Чаши + Паж Чаши",
    "reading_combination": ["ace_cups", "page_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Паж Чаши – емоционално послание. Получавате нежно послание, свързано със сърдечни въпроси. Някой иска да ви признае чувствата си.",
    "reading_description": "Нежно послание идва. Някой иска да ти признае чувствата си.",
    "reading_advice": "Отвори сърцето си за посланието. То носи нещо ценно."
  },
  {
    "reading_id": "ace_cups_knight_cups",
    "reading_name": "Асо Чаши + Рицар Чаши",
    "reading_cards": "Асо Чаши + Рицар Чаши",
    "reading_combination": ["ace_cups", "knight_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Рицар Чаши – романтика и ухажване. Романтичен жест или предложение идва. Някой идва при вас с отворено сърце и романтични намерения.",
    "reading_description": "Романтичен жест или предложение идва. Някой идва с отворено сърце.",
    "reading_advice": "Кажи какво чувстваш. Бъди смел в любовта – сърцето ти знае пътя."
  },
  {
    "reading_id": "ace_cups_queen_cups",
    "reading_name": "Асо Чаши + Царица Чаши",
    "reading_cards": "Асо Чаши + Царица Чаши",
    "reading_combination": ["ace_cups", "queen_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Царица Чаши – интуиция и дълбока емоционалност. Новата любов е водена от силна интуиция. Сърцето ви знае какво иска – доверете му се.",
    "reading_description": "Новата любов е водена от интуиция. Слушай сърцето си.",
    "reading_advice": "Довери се на вътрешния си глас. Интуицията ти води правилно."
  },
  {
    "reading_id": "ace_cups_king_cups",
    "reading_name": "Асо Чаши + Цар Чаши",
    "reading_cards": "Асо Чаши + Цар Чаши",
    "reading_combination": ["ace_cups", "king_cups"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Цар Чаши – емоционална зрялост и контрол. Новата любов е силна, но вие умеете да я контролирате. Баланс между страст и зрялост.",
    "reading_description": "Нова любов, която умееш да контролираш. Емоционална зрялост и баланс.",
    "reading_advice": "Управлявай чувствата си с мъдрост. Любовта е силна, но ти си по-силен."
  },
 
  
  {
    "reading_id": "ace_cups_six_swords",
    "reading_name": "Асо Чаши + Шестица Мечове",
    "reading_cards": "Асо Чаши + Шестица Мечове",
    "reading_combination": ["ace_cups", "six_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Шестица Мечове – пътуване и преход. Новата любов или чувства ще ви отведат на ново място. Пътуване или промяна на средата ви очаква.",
    "reading_description": "Новата любов те отвежда на ново място. Пътуване или промяна те очаква.",
    "reading_advice": "Тръгни с увереност. Новите води носят нови възможности за любов."
  },
  {
    "reading_id": "ace_cups_seven_swords",
    "reading_name": "Асо Чаши + Седмица Мечове",
    "reading_cards": "Асо Чаши + Седмица Мечове",
    "reading_combination": ["ace_cups", "seven_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Седмица Мечове – измама и хитрост. Внимавайте – някой може да се опита да ви измами в любовта. Пазите сърцето си.",
    "reading_description": "Нова любов крие риск от измама. Бъди внимателен.",
    "reading_advice": "Проверявай два пъти. Доверието е хубаво, но проверката е по-добра."
  },
  {
    "reading_id": "ace_cups_eight_swords",
    "reading_name": "Асо Чаши + Осмица Мечове",
    "reading_cards": "Асо Чаши + Осмица Мечове",
    "reading_combination": ["ace_cups", "eight_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Осмица Мечове – чувство на капан и ограничение. Чувствате се блокирани и без изход в любовта. Страхът ви пречи да обичате.",
    "reading_description": "Чувстваш се блокиран в любовта. Страхът ти пречи да обичаш.",
    "reading_advice": "Оковите са в главата ти. Освободи се от страха – любовта те очаква."
  },
  {
    "reading_id": "ace_cups_nine_swords",
    "reading_name": "Асо Чаши + Деветка Мечове",
    "reading_cards": "Асо Чаши + Деветка Мечове",
    "reading_combination": ["ace_cups", "nine_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Деветка Мечове – тревога и безсъние. Новата любов ви вълнува, но също така ви тревожи. Мислите ви се въртят около нея и не ви оставят да спите.",
    "reading_description": "Новата любов те вълнува, но носи и тревоги. Безсъние и премисляне.",
    "reading_advice": "Спокойствие. Повечето неща, за които се тревожим, никога не се случват. Довери се на любовта."
  },
  {
    "reading_id": "ace_cups_ten_swords",
    "reading_name": "Асо Чаши + Десетка Мечове",
    "reading_cards": "Асо Чаши + Десетка Мечове",
    "reading_combination": ["ace_cups", "ten_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Десетка Мечове – край и дъно. Нещо старо приключва, за да може нова любов да започне. Краят е болезнен, но носи освобождение.",
    "reading_description": "След тежък край идва нова любов. Феникс от пепелта.",
    "reading_advice": "Остави старото да умре. Новата любов вече чука на вратата. Позволи ѝ да влезе."
  },
  {
    "reading_id": "ace_cups_page_swords",
    "reading_name": "Асо Чаши + Паж Мечове",
    "reading_cards": "Асо Чаши + Паж Мечове",
    "reading_combination": ["ace_cups", "page_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Паж Мечове – търсене на истината. Новата любов ви кара да търсите истината за себе си и за другия. Любопитство и открития.",
    "reading_description": "Новата любов те кара да търсиш истината. Любопитство и открития.",
    "reading_advice": "Задавай въпроси. Не приемай нищо за дадено. Истината ще освободи любовта."
  },
  {
    "reading_id": "ace_cups_knight_swords",
    "reading_name": "Асо Чаши + Рицар Мечове",
    "reading_cards": "Асо Чаши + Рицар Мечове",
    "reading_combination": ["ace_cups", "knight_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Рицар Мечове – бързина и прямота. Любовта идва светкавично и с пълна сила. Няма време за колебание – действайте, ако чувствата са истински.",
    "reading_description": "Любовта идва светкавично и с пълна сила. Действай, ако чувствата са истински.",
    "reading_advice": "Действай бързо, но не безразсъдно. Любовта е страстна, но не трябва да заслепява."
  },
  {
    "reading_id": "ace_cups_queen_swords",
    "reading_name": "Асо Чаши + Царица Мечове",
    "reading_cards": "Асо Чаши + Царица Мечове",
    "reading_combination": ["ace_cups", "queen_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Царица Мечове – яснота и независимост. Виждате любовта кристално ясно, без илюзии. Знаете какво искате и какво не искате.",
    "reading_description": "Виждаш любовта кристално ясно, без илюзии. Знаеш какво искаш.",
    "reading_advice": "Бъди честен със себе си. Яснотата в любовта е безценна."
  },
  {
    "reading_id": "ace_cups_king_swords",
    "reading_name": "Асо Чаши + Цар Мечове",
    "reading_cards": "Асо Чаши + Цар Мечове",
    "reading_combination": ["ace_cups", "king_swords"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Цар Мечове – интелект и стратегия. Любовта ви е добре обмислена и стратегически издържана. Ум и сърце в хармония.",
    "reading_description": "Любовта ти е добре обмислена. Ум и сърце в хармония.",
    "reading_advice": "Вземи решение с ума и сърцето заедно. Стратегията е важна, но и чувствата имат значение."
  },
  {
    "reading_id": "ace_cups_two_pentacles",
    "reading_name": "Асо Чаши + Двойка Пентакли",
    "reading_cards": "Асо Чаши + Двойка Пентакли",
    "reading_combination": ["ace_cups", "two_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Двойка Пентакли – баланс и жонглиране. Новата любов изисква да балансирате време, емоции и ресурси. Жонглирайте внимателно.",
    "reading_description": "Новата любов изисква баланс. Жонглирай внимателно.",
    "reading_advice": "Балансирай, но не изпускай любовта. Финансовият и времеви баланс са ключови."
  },
  {
    "reading_id": "ace_cups_three_pentacles",
    "reading_name": "Асо Чаши + Тройка Пентакли",
    "reading_cards": "Асо Чаши + Тройка Пентакли",
    "reading_combination": ["ace_cups", "three_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Тройка Пентакли – екипна работа и сътрудничество. Новата любов изисква да работите заедно. Заедно можете да изградите нещо прекрасно.",
    "reading_description": "Новата любов изисква екипна работа. Заедно строите нещо прекрасно.",
    "reading_advice": "Работете в екип. Учете се един от друг. Заедно сте по-силни."
  },
  {
    "reading_id": "ace_cups_four_pentacles",
    "reading_name": "Асо Чаши + Четворка Пентакли",
    "reading_cards": "Асо Чаши + Четворка Пентакли",
    "reading_combination": ["ace_cups", "four_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Четворка Пентакли – сигурност и стискане. Страхувате се да инвестирате в новата любов. Стискането може да ви попречи да обичате напълно.",
    "reading_description": "Страхуваш се да инвестираш в новата любов. Пусни малко.",
    "reading_advice": "Пусни малко. Страхът от загуба може да ти попречи да обичаш истински."
  },
  {
    "reading_id": "ace_cups_five_pentacles",
    "reading_name": "Асо Чаши + Петица Пентакли",
    "reading_cards": "Асо Чаши + Петица Пентакли",
    "reading_combination": ["ace_cups", "five_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Петица Пентакли – финансови трудности и липса. Нова любов идва в момент на финансови трудности. Не позволявайте на липсата да помрачи радостта.",
    "reading_description": "Нова любов идва в момент на финансови трудности. Радостта не зависи от парите.",
    "reading_advice": "Истинската любов не изисква много пари. Наслаждавай се на чувствата."
  },
  {
    "reading_id": "ace_cups_six_pentacles",
    "reading_name": "Асо Чаши + Шестица Пентакли",
    "reading_cards": "Асо Чаши + Шестица Пентакли",
    "reading_combination": ["ace_cups", "six_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Шестица Пентакли – помощ и щедрост. Новата любов идва с подкрепа – емоционална или финансова. Някой вярва във вас и във връзката ви.",
    "reading_description": "Новата любов идва с подкрепа. Някой вярва във вас.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "ace_cups_seven_pentacles",
    "reading_name": "Асо Чаши + Седмица Пентакли",
    "reading_cards": "Асо Чаши + Седмица Пентакли",
    "reading_combination": ["ace_cups", "seven_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Седмица Пентакли – търпение и чакане. Новата любов се развива бавно – не очаквайте бързи резултати. Търпение и вяра.",
    "reading_description": "Новата любов се развива бавно. Чакай търпеливо.",
    "reading_advice": "Чакай търпеливо. Добрите неща идват при тези, които умеят да чакат."
  },
  {
    "reading_id": "ace_cups_eight_pentacles",
    "reading_name": "Асо Чаши + Осмица Пентакли",
    "reading_cards": "Асо Чаши + Осмица Пентакли",
    "reading_combination": ["ace_cups", "eight_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Осмица Пентакли – усърдие и учене. Новата любов изисква да научите нови неща за себе си и за партньора. Вложете време и усилия.",
    "reading_description": "Новата любов изисква учене. Вложи време и усилия.",
    "reading_advice": "Учи се с желание. Любовта е практика – майсторството идва с времето."
  },
  {
    "reading_id": "ace_cups_nine_pentacles",
    "reading_name": "Асо Чаши + Деветка Пентакли",
    "reading_cards": "Асо Чаши + Деветка Пентакли",
    "reading_combination": ["ace_cups", "nine_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Деветка Пентакли – самодостатъчност и успех. Новата любов идва, когато сте независими и силни. Готови сте да обичате от изобилие.",
    "reading_description": "Новата любов идва, когато си независим и силен. Готов си да обичаш.",
    "reading_advice": "Ти си самостоятелен. Наслади се на любовта от позиция на сила."
  },
  {
    "reading_id": "ace_cups_ten_pentacles",
    "reading_name": "Асо Чаши + Десетка Пентакли",
    "reading_cards": "Асо Чаши + Десетка Пентакли",
    "reading_combination": ["ace_cups", "ten_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Десетка Пентакли – семейно наследство и дългосрочна сигурност. Новата любов има потенциала да донесе стабилност и радост на цялото семейство.",
    "reading_description": "Новата любов носи стабилност на семейството.",
    "reading_advice": "Мисли за бъдещето. Тази любов може да е начало на нещо трайно."
  },
  {
    "reading_id": "ace_cups_page_pentacles",
    "reading_name": "Асо Чаши + Паж Пентакли",
    "reading_cards": "Асо Чаши + Паж Пентакли",
    "reading_combination": ["ace_cups", "page_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Паж Пентакли – нова възможност и учене. Новата любов идва с възможност за учене и растеж. Инвестиция в себе си и в любовта.",
    "reading_description": "Новата любов носи възможност за учене. Инвестиция в себе си.",
    "reading_advice": "Започни да учиш. Инвестирай в любовта и в себе си."
  },
  {
    "reading_id": "ace_cups_knight_pentacles",
    "reading_name": "Асо Чаши + Рицар Пентакли",
    "reading_cards": "Асо Чаши + Рицар Пентакли",
    "reading_combination": ["ace_cups", "knight_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Рицар Пентакли – бавен и сигурен напредък. Новата любов се развива бавно, но сигурно. Търпение – истинската любов не бърза.",
    "reading_description": "Новата любов се развива бавно, но сигурно. Не бързай.",
    "reading_advice": "Не бързай. Сигурният път в любовта е бавен, но води до истинска дълбочина."
  },
  {
    "reading_id": "ace_cups_queen_pentacles",
    "reading_name": "Асо Чаши + Царица Пентакли",
    "reading_cards": "Асо Чаши + Царица Пентакли",
    "reading_combination": ["ace_cups", "queen_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Царица Пентакли – грижа и дом. Новата любов е свързана с дома, семейството или създаване на уют. Вложете сърце в нея.",
    "reading_description": "Новата любов е свързана с дома и семейството. Вложи сърце.",
    "reading_advice": "Грижи се за любовта като за дом. Вложи любов и практичност."
  },
  {
    "reading_id": "ace_cups_king_pentacles",
    "reading_name": "Асо Чаши + Цар Пентакли",
    "reading_cards": "Асо Чаши + Цар Пентакли",
    "reading_combination": ["ace_cups", "king_pentacles"],
    "reading_meaning": "Асо Чаши носи нови чувства и любов, а Цар Пентакли – стабилност и бизнес успех. Новата любов има потенциала да се превърне в стабилна, дългосрочна връзка. Имате всички качества да успеете.",
    "reading_description": "Новата любов има потенциал за дългосрочна връзка.",
    "reading_advice": "Поеми отговорност. Имаш всичко необходимо да изградиш стабилна любов."
  },
    {
    "reading_id": "two_cups_two_wands",
    "reading_name": "Двойка Чаши + Двойка Жезли",
    "reading_cards": "Двойка Чаши + Двойка Жезли",
    "reading_combination": ["two_cups", "two_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Двойка Жезли – избор и планиране. В любовната ви връзка предстои важен избор. Слушайте сърцето си, но не забравяйте и главата. Изберете заедно.",
    "reading_description": "В любовната връзка предстои важен избор. Изберете заедно.",
    "reading_advice": "Съветвайте се с партньора. Заедно ще вземете правилното решение."
  },
  {
    "reading_id": "two_cups_three_wands",
    "reading_name": "Двойка Чаши + Тройка Жезли",
    "reading_cards": "Двойка Чаши + Тройка Жезли",
    "reading_combination": ["two_cups", "three_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Тройка Жезли – очакване и разширяване. Връзката ви се развива и вие чакате следващата стъпка. Търпение – добрите неща идват с времето.",
    "reading_description": "Връзката се развива – чакате следващата стъпка. Търпение.",
    "reading_advice": "Чакай търпеливо. Истинската любов не бърза – тя узрява с времето."
  },
  {
    "reading_id": "two_cups_four_wands",
    "reading_name": "Двойка Чаши + Четворка Жезли",
    "reading_cards": "Двойка Чаши + Четворка Жезли",
    "reading_combination": ["two_cups", "four_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Четворка Жезли – празник и стабилност. Връзката ви навлиза в нова, по-стабилна фаза. Празнувайте любовта си – заслужавате я.",
    "reading_description": "Връзката навлиза в стабилна фаза. Празнувайте любовта си.",
    "reading_advice": "Празнувайте заедно. Стабилността в любовта е ценна – пазете я."
  },
  {
    "reading_id": "two_cups_five_wands",
    "reading_name": "Двойка Чаши + Петица Жезли",
    "reading_cards": "Двойка Чаши + Петица Жезли",
    "reading_combination": ["two_cups", "five_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Петица Жезли – конфликт и съперничество. Спорове и конфликти в любовната връзка. Борба за надмощие. В любовта няма победители – търсете разбирателство.",
    "reading_description": "Спорове в любовната връзка. Търсете разбирателство, не победа.",
    "reading_advice": "В любовта няма победители. Когато единият печели, връзката губи."
  },
  {
    "reading_id": "two_cups_six_wands",
    "reading_name": "Двойка Чаши + Шестица Жезли",
    "reading_cards": "Двойка Чаши + Шестица Жезли",
    "reading_combination": ["two_cups", "six_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Шестица Жезли – победа и признание. Любовната ви връзка получава признание. Хората виждат силата на вашата любов и ви уважават.",
    "reading_description": "Любовната ви връзка получава признание. Хората уважават любовта ви.",
    "reading_advice": "Радвайте се заедно на признанието. Вашата любов вдъхновява другите."
  },
  {
    "reading_id": "two_cups_seven_wands",
    "reading_name": "Двойка Чаши + Седмица Жезли",
    "reading_cards": "Двойка Чаши + Седмица Жезли",
    "reading_combination": ["two_cups", "seven_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Седмица Жезли – защита на позицията. Трябва да защитавате любовта си от външни заплахи. Дръжте се заедно – вашата връзка е силна.",
    "reading_description": "Защитавате любовта си от външни заплахи. Дръжте се заедно.",
    "reading_advice": "Пази любовта си. Истинската любов издържа на всичко, когато сте заедно."
  },
  {
    "reading_id": "two_cups_eight_wands",
    "reading_name": "Двойка Чаши + Осмица Жезли",
    "reading_cards": "Двойка Чаши + Осмица Жезли",
    "reading_combination": ["two_cups", "eight_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Осмица Жезли – бързина и движение. Връзката ви се развива с неочаквана скорост. Наслаждавайте се на момента, но не забравяйте да дишате.",
    "reading_description": "Връзката ви се развива бързо. Наслаждавайте се на момента.",
    "reading_advice": "Язди вълната, но не забравяй да дишаш. Скоростта е вълнуваща, но и изтощителна."
  },
  {
    "reading_id": "two_cups_nine_wands",
    "reading_name": "Двойка Чаши + Деветка Жезли",
    "reading_cards": "Двойка Чаши + Деветка Жезли",
    "reading_combination": ["two_cups", "nine_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Деветка Жезли – устойчивост и изтощение. Борите се за връзката си и сте изтощени. Дръжте се още малко – краят на усилията наближава.",
    "reading_description": "Бориш се за връзката и си изтощен. Дръж се още малко.",
    "reading_advice": "Дръж се. Истинската любов си заслужава всяко усилие. Финалната права е близо."
  },
  {
    "reading_id": "two_cups_ten_wands",
    "reading_name": "Двойка Чаши + Десетка Жезли",
    "reading_cards": "Двойка Чаши + Десетка Жезли",
    "reading_combination": ["two_cups", "ten_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Десетка Жезли – претоварване и бреме. Носите тежестта на връзката или семейството. Споделете бремето – любовта не трябва да те претоварва.",
    "reading_description": "Носиш тежестта на връзката. Сподели бремето с партньора.",
    "reading_advice": "Сподели бремето. Истинската любов не тежи – тя облекчава."
  },
  {
    "reading_id": "two_cups_page_wands",
    "reading_name": "Двойка Чаши + Паж Жезли",
    "reading_cards": "Двойка Чаши + Паж Жезли",
    "reading_combination": ["two_cups", "page_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Паж Жезли – новини и ентусиазъм. Получавате вълнуваща новина, свързана с връзката ви. Ентусиазъм и надежда за бъдещето.",
    "reading_description": "Вълнуваща новина за връзката идва. Ентусиазъм и надежда.",
    "reading_advice": "Отвори се за новините. Те носят енергия и радост във връзката."
  },
  {
    "reading_id": "two_cups_knight_wands",
    "reading_name": "Двойка Чаши + Рицар Жезли",
    "reading_cards": "Двойка Чаши + Рицар Жезли",
    "reading_combination": ["two_cups", "knight_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Рицар Жезли – импулсивност и бързина. Връзката ви се развива бързо, водена от страст и енергия. Наслаждавайте се, но внимавайте да не прегазите.",
    "reading_description": "Връзката се развива бързо, водена от страст. Наслаждавайте се, но внимавайте.",
    "reading_advice": "Действай със страст, но не забравяй да слушаш и партньора. Любовта е танц, не надбягване."
  },
  {
    "reading_id": "two_cups_queen_wands",
    "reading_name": "Двойка Чаши + Царица Жезли",
    "reading_cards": "Двойка Чаши + Царица Жезли",
    "reading_combination": ["two_cups", "queen_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Царица Жезли – увереност и харизма. Вие сте уверени в любовта си. Вашата топлина и увереност привличат партньора и укрепват връзката.",
    "reading_description": "Уверен в любовта си. Топлината и увереността укрепват връзката.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина прави любовта по-силна."
  },
  {
    "reading_id": "two_cups_king_wands",
    "reading_name": "Двойка Чаши + Цар Жезли",
    "reading_cards": "Двойка Чаши + Цар Жезли",
    "reading_combination": ["two_cups", "king_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Цар Жезли – лидерство и визия. Вие сте лидер във връзката – вашата визия води и двамата напред. Водете с любов и мъдрост.",
    "reading_description": "Ти си лидер във връзката – визията ти води и двамата.",
    "reading_advice": "Води с любов и мъдрост. Истинският лидер в любовта не командва – той вдъхновява."
  },
  {
    "reading_id": "two_cups_ace_wands",
    "reading_name": "Двойка Чаши + Асо Жезли",
    "reading_cards": "Двойка Чаши + Асо Жезли",
    "reading_combination": ["two_cups", "ace_wands"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Асо Жезли – ново начало и вдъхновение. Нова искра в любовта – начало на връзка или нов етап. Искрата е запалена – сега се грижете за нея.",
    "reading_description": "Нова искра в любовта. Начало на връзка или нов етап.",
    "reading_advice": "Хвани искрата. Грижи се за любовта, за да не угасне."
  },
  {
    "reading_id": "two_cups_ace_cups",
    "reading_name": "Двойка Чаши + Асо Чаши",
    "reading_cards": "Двойка Чаши + Асо Чаши",
    "reading_combination": ["two_cups", "ace_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Асо Чаши – нови чувства и любов. Две чаши заедно – мощна комбинация за нова любов или задълбочаване на съществуваща връзка. Сърцето ви е пълно.",
    "reading_description": "Мощна комбинация за нова любов или задълбочаване на връзката.",
    "reading_advice": "Отвори сърцето си. Любовта, която идва, е дълбока и истинска."
  },
  {
    "reading_id": "two_cups_three_cups",
    "reading_name": "Двойка Чаши + Тройка Чаши",
    "reading_cards": "Двойка Чаши + Тройка Чаши",
    "reading_combination": ["two_cups", "three_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Тройка Чаши – празник и радост. Празнувате любовта си с приятели и семейство. Споделена радост, която умножава щастието.",
    "reading_description": "Празнувате любовта си с приятели и семейство. Споделена радост.",
    "reading_advice": "Празнувайте заедно. Щастието е по-голямо, когато е споделено."
  },
  {
    "reading_id": "two_cups_four_cups",
    "reading_name": "Двойка Чаши + Четворка Чаши",
    "reading_cards": "Двойка Чаши + Четворка Чаши",
    "reading_combination": ["two_cups", "four_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Четворка Чаши – апатия и неудовлетворение. Връзката ви е стабилна, но нещо ви липсва. Потърсете какво наистина искате от любовта.",
    "reading_description": "Връзката е стабилна, но нещо липсва. Потърси какво искаш.",
    "reading_advice": "Попитай се какво наистина искаш от любовта. Понякога сигурността не е всичко."
  },
  {
    "reading_id": "two_cups_five_cups",
    "reading_name": "Двойка Чаши + Петица Чаши",
    "reading_cards": "Двойка Чаши + Петица Чаши",
    "reading_combination": ["two_cups", "five_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Петица Чаши – загуба и тъга. Връзката ви преминава през труден период. Загуба или разочарование. Позволете си да скърбите, но не губете надежда.",
    "reading_description": "Връзката преминава през труден период. Скърби, но не губи надежда.",
    "reading_advice": "Позволи си да скърбиш. След дъжда идва слънце – и любовта може да се възстанови."
  },
  {
    "reading_id": "two_cups_six_cups",
    "reading_name": "Двойка Чаши + Шестица Чаши",
    "reading_cards": "Двойка Чаши + Шестица Чаши",
    "reading_combination": ["two_cups", "six_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Шестица Чаши – спомени и носталгия. Връзката ви носи спомени от миналото. Носталгия и топлина – стари спомени, които укрепват настоящето.",
    "reading_description": "Връзката носи спомени от миналото. Носталгия и топлина.",
    "reading_advice": "Използвай спомените като основа. Те са доказателство, че любовта ви е истинска."
  },
  {
    "reading_id": "two_cups_seven_cups",
    "reading_name": "Двойка Чаши + Седмица Чаши",
    "reading_cards": "Двойка Чаши + Седмица Чаши",
    "reading_combination": ["two_cups", "seven_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Седмица Чаши – илюзии и фантазии. Илюзорни представи за връзката. Свали розовите очила – истинската любов е реална, не фантазия.",
    "reading_description": "Илюзорни представи за връзката. Свали розовите очила.",
    "reading_advice": "Бъди реалист. Истинската любов не се нуждае от фантазии – тя е истинска."
  },
  {
    "reading_id": "two_cups_eight_cups",
    "reading_name": "Двойка Чаши + Осмица Чаши",
    "reading_cards": "Двойка Чаши + Осмица Чаши",
    "reading_combination": ["two_cups", "eight_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Осмица Чаши – тръгване и оставяне. Решавате да оставите връзката и да тръгнете по нов път. Трудно решение, но понякога необходимо.",
    "reading_description": "Решаваш да оставиш връзката и да тръгнеш по нов път.",
    "reading_advice": "Тръгни, ако трябва. Понякога най-доброто за любовта е да я оставиш."
  },
  {
    "reading_id": "two_cups_nine_cups",
    "reading_name": "Двойка Чаши + Деветка Чаши",
    "reading_cards": "Двойка Чаши + Деветка Чаши",
    "reading_combination": ["two_cups", "nine_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Деветка Чаши – сбъднато желание. Връзката ви води до сбъдване на дългогодишна мечта. Щастие и удовлетворение.",
    "reading_description": "Връзката води до сбъдване на дългогодишна мечта.",
    "reading_advice": "Наслади се на момента. Ти го заслужи. Любовта ти донесе мечтата."
  },
  {
    "reading_id": "two_cups_ten_cups",
    "reading_name": "Двойка Чаши + Десетка Чаши",
    "reading_cards": "Двойка Чаши + Десетка Чаши",
    "reading_combination": ["two_cups", "ten_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Десетка Чаши – семейно щастие. Връзката ви носи радост на цялото семейство. Хармония, любов и споделено щастие.",
    "reading_description": "Връзката носи радост на цялото семейство. Хармония и любов.",
    "reading_advice": "Сподели любовта със семейството. Те са част от вашето щастие."
  },
  {
    "reading_id": "two_cups_page_cups",
    "reading_name": "Двойка Чаши + Паж Чаши",
    "reading_cards": "Двойка Чаши + Паж Чаши",
    "reading_combination": ["two_cups", "page_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Паж Чаши – емоционално послание. Получавате нежно послание от партньора си. Отворете сърцето си за него.",
    "reading_description": "Нежно послание от партньора идва. Отвори сърцето си.",
    "reading_advice": "Слушай с отворено сърце. Посланието носи любов и топлина."
  },
  {
    "reading_id": "two_cups_knight_cups",
    "reading_name": "Двойка Чаши + Рицар Чаши",
    "reading_cards": "Двойка Чаши + Рицар Чаши",
    "reading_combination": ["two_cups", "knight_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Рицар Чаши – романтика и ухажване. Романтичен жест или предложение от партньора. Любовта ви достига ново ниво.",
    "reading_description": "Романтичен жест или предложение идва. Любовта достига ново ниво.",
    "reading_advice": "Кажи 'да' на любовта. Този момент е специален – наслади му се."
  },
  {
    "reading_id": "two_cups_queen_cups",
    "reading_name": "Двойка Чаши + Царица Чаши",
    "reading_cards": "Двойка Чаши + Царица Чаши",
    "reading_combination": ["two_cups", "queen_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Царица Чаши – интуиция и дълбока емоционалност. Интуицията ви води във връзката. Слушайте сърцето си – то знае какво е най-добро.",
    "reading_description": "Интуицията води във връзката. Слушай сърцето си.",
    "reading_advice": "Довери се на интуицията си. Тя знае какво е най-добро за любовта ви."
  },
  {
    "reading_id": "two_cups_king_cups",
    "reading_name": "Двойка Чаши + Цар Чаши",
    "reading_cards": "Двойка Чаши + Цар Чаши",
    "reading_combination": ["two_cups", "king_cups"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Цар Чаши – емоционална зрялост и баланс. Връзката ви се гради на емоционална зрялост и баланс. Без крайности, без драма – само истинска любов.",
    "reading_description": "Връзката се гради на емоционална зрялост и баланс.",
    "reading_advice": "Продължавай така. Емоционалният баланс е ключът към вечна любов."
  },
  {
    "reading_id": "two_cups_two_swords",
    "reading_name": "Двойка Чаши + Двойка Мечове",
    "reading_cards": "Двойка Чаши + Двойка Мечове",
    "reading_combination": ["two_cups", "two_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Двойка Мечове – нерешителност и съмнение. В любовта има съмнения и нерешителност. Свалете превръзката – сърцето знае повече от ума.",
    "reading_description": "В любовта има съмнения. Свали превръзката – сърцето знае.",
    "reading_advice": "Не позволявай на страха да задуши любовта. Понякога трябва да рискуваш."
  },
  {
    "reading_id": "two_cups_three_swords",
    "reading_name": "Двойка Чаши + Тройка Мечове",
    "reading_cards": "Двойка Чаши + Тройка Мечове",
    "reading_combination": ["two_cups", "three_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Тройка Мечове – болка и разбито сърце. Връзка, която носи повече болка, отколкото радост. Преосмислете дали си струва.",
    "reading_description": "Връзка, която носи повече болка, отколкото радост.",
    "reading_advice": "Любовта не трябва да боли толкова. Имаш право да търсиш щастие."
  },
  {
    "reading_id": "two_cups_four_swords",
    "reading_name": "Двойка Чаши + Четворка Мечове",
    "reading_cards": "Двойка Чаши + Четворка Мечове",
    "reading_combination": ["two_cups", "four_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Четворка Мечове – почивка и възстановяване. Връзката ви има нужда от почивка. Отстъпете, за да съберете сили. Любовта може да изчака.",
    "reading_description": "Връзката има нужда от почивка. Отстъпете, за да съберете сили.",
    "reading_advice": "Почини си. Любовта не бяга – можеш да си вземеш време за себе си."
  },
  {
    "reading_id": "two_cups_five_swords",
    "reading_name": "Двойка Чаши + Петица Мечове",
    "reading_cards": "Двойка Чаши + Петица Мечове",
    "reading_combination": ["two_cups", "five_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Петица Мечове – конфликт и празна победа. Спор, в който няма истински победител. Дори да спечелите, връзката губи.",
    "reading_description": "Спор, в който няма истински победител. Дори да спечелиш, връзката губи.",
    "reading_advice": "Понякога да оставиш другия да спечели е по-голяма победа за любовта."
  },
    {
    "reading_id": "two_cups_six_swords",
    "reading_name": "Двойка Чаши + Шестица Мечове",
    "reading_cards": "Двойка Чаши + Шестица Мечове",
    "reading_combination": ["two_cups", "six_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Шестица Мечове – пътуване и преход. Любовта ви отвежда на ново място. Пътуване или преместване заедно ви очаква.",
    "reading_description": "Любовта ви отвежда на ново място. Пътуване или преместване заедно.",
    "reading_advice": "Тръгнете заедно. Новите води носят нови възможности за любовта."
  },
  {
    "reading_id": "two_cups_seven_swords",
    "reading_name": "Двойка Чаши + Седмица Мечове",
    "reading_cards": "Двойка Чаши + Седмица Мечове",
    "reading_combination": ["two_cups", "seven_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Седмица Мечове – измама и хитрост. Внимавайте – някой може да се опита да се намеси във връзката ви. Пазите любовта си.",
    "reading_description": "Някой се опитва да се намеси във връзката ви. Пази любовта си.",
    "reading_advice": "Бъдете бдителни. Истинската любов не се страхува от намеса, но трябва да я пазите."
  },
  {
    "reading_id": "two_cups_eight_swords",
    "reading_name": "Двойка Чаши + Осмица Мечове",
    "reading_cards": "Двойка Чаши + Осмица Мечове",
    "reading_combination": ["two_cups", "eight_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Осмица Мечове – чувство на капан и ограничение. Чувствате се в капан във връзката. Оковите може да са само в главата ви.",
    "reading_description": "Чувстваш се в капан във връзката. Оковите са в главата ти.",
    "reading_advice": "Освободи се от страха. Имаш повече възможности, отколкото си мислиш."
  },
  {
    "reading_id": "two_cups_nine_swords",
    "reading_name": "Двойка Чаши + Деветка Мечове",
    "reading_cards": "Двойка Чаши + Деветка Мечове",
    "reading_combination": ["two_cups", "nine_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Деветка Мечове – тревога и безсъние. Тревогите за връзката ви карат да не спите. Мислите ви се въртят около любовта.",
    "reading_description": "Тревоги за връзката те карат да не спиш. Мислите се въртят.",
    "reading_advice": "Спокойствие. Повечето неща, за които се тревожим, никога не се случват. Говори с партньора си."
  },
  {
    "reading_id": "two_cups_ten_swords",
    "reading_name": "Двойка Чаши + Десетка Мечове",
    "reading_cards": "Двойка Чаши + Десетка Мечове",
    "reading_combination": ["two_cups", "ten_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Десетка Мечове – край и дъно. Връзката приключва. Краят е болезнен, но носи освобождение и ново начало.",
    "reading_description": "Връзката приключва. Краят е болезнен, но носи освобождение.",
    "reading_advice": "Остави връзката зад гърба си. Това, което е свършило, вече не тежи. Новото начало идва."
  },
  {
    "reading_id": "two_cups_page_swords",
    "reading_name": "Двойка Чаши + Паж Мечове",
    "reading_cards": "Двойка Чаши + Паж Мечове",
    "reading_combination": ["two_cups", "page_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Паж Мечове – търсене на истината. Истината за връзката ви излиза наяве. Бъдете отворени за това, което ще научите.",
    "reading_description": "Истината за връзката излиза наяве. Бъди отворен за нея.",
    "reading_advice": "Търси истината. Тя може да боли, но винаги лекува."
  },
  {
    "reading_id": "two_cups_knight_swords",
    "reading_name": "Двойка Чаши + Рицар Мечове",
    "reading_cards": "Двойка Чаши + Рицар Мечове",
    "reading_combination": ["two_cups", "knight_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Рицар Мечове – бързина и прямота. Истината за връзката идва бързо и рязко. Бъдете готови да я приемете.",
    "reading_description": "Истината за връзката идва бързо и рязко. Бъди готов.",
    "reading_advice": "Приеми истината с отворено сърце. Тя може да промени всичко."
  },
  {
    "reading_id": "two_cups_queen_swords",
    "reading_name": "Двойка Чаши + Царица Мечове",
    "reading_cards": "Двойка Чаши + Царица Мечове",
    "reading_combination": ["two_cups", "queen_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Царица Мечове – яснота и независимост. Виждате връзката си ясно, без илюзии. Знаете какво искате и какво не искате.",
    "reading_description": "Виждаш връзката си ясно, без илюзии. Знаеш какво искаш.",
    "reading_advice": "Бъди честен със себе си. Яснотата в любовта е безценна."
  },
  {
    "reading_id": "two_cups_king_swords",
    "reading_name": "Двойка Чаши + Цар Мечове",
    "reading_cards": "Двойка Чаши + Цар Мечове",
    "reading_combination": ["two_cups", "king_swords"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Цар Мечове – интелект и стратегия. Любовта ви е добре обмислена. Ум и сърце в хармония – рецепта за успешна връзка.",
    "reading_description": "Любовта ти е добре обмислена. Ум и сърце в хармония.",
    "reading_advice": "Вземайте решения заедно с ума и сърцето. Балансът води до успех."
  },
  {
    "reading_id": "two_cups_two_pentacles",
    "reading_name": "Двойка Чаши + Двойка Пентакли",
    "reading_cards": "Двойка Чаши + Двойка Пентакли",
    "reading_combination": ["two_cups", "two_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Двойка Пентакли – баланс и жонглиране. Любовта изисква да балансирате време, пари и емоции. Жонглирайте внимателно.",
    "reading_description": "Любовта изисква баланс. Жонглирай внимателно.",
    "reading_advice": "Балансирай, но не изпускай любовта. Финансовият и времеви баланс са ключови."
  },
  {
    "reading_id": "two_cups_three_pentacles",
    "reading_name": "Двойка Чаши + Тройка Пентакли",
    "reading_cards": "Двойка Чаши + Тройка Пентакли",
    "reading_combination": ["two_cups", "three_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Тройка Пентакли – екипна работа и сътрудничество. Вие и партньорът ви сте екип. Заедно можете да изградите нещо прекрасно.",
    "reading_description": "Ти и партньорът сте екип. Заедно строите нещо прекрасно.",
    "reading_advice": "Работете в екип. Учете се един от друг. Заедно сте по-силни."
  },
  {
    "reading_id": "two_cups_four_pentacles",
    "reading_name": "Двойка Чаши + Четворка Пентакли",
    "reading_cards": "Двойка Чаши + Четворка Пентакли",
    "reading_combination": ["two_cups", "four_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Четворка Пентакли – сигурност и стискане. Страхувате се да инвестирате емоционално във връзката. Пуснете малко – любовта изисква смелост.",
    "reading_description": "Страхуваш се да инвестираш емоционално. Пусни малко.",
    "reading_advice": "Пусни малко. Страхът от загуба може да ти попречи да обичаш истински."
  },
  {
    "reading_id": "two_cups_five_pentacles",
    "reading_name": "Двойка Чаши + Петица Пентакли",
    "reading_cards": "Двойка Чаши + Петица Пентакли",
    "reading_combination": ["two_cups", "five_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Петица Пентакли – финансови трудности и липса. Финансовите трудности изпитват връзката ви. Дръжте се заедно – любовта е по-силна от парите.",
    "reading_description": "Финансовите трудности изпитват връзката. Дръжте се заедно.",
    "reading_advice": "Истинската любов не зависи от парите. Заедно ще преодолеете всичко."
  },
  {
    "reading_id": "two_cups_six_pentacles",
    "reading_name": "Двойка Чаши + Шестица Пентакли",
    "reading_cards": "Двойка Чаши + Шестица Пентакли",
    "reading_combination": ["two_cups", "six_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Шестица Пентакли – помощ и щедрост. Някой ви помага във връзката или вие помагате на други. Щедростта укрепва любовта.",
    "reading_description": "Помощ идва във връзката. Щедростта укрепва любовта.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "two_cups_seven_pentacles",
    "reading_name": "Двойка Чаши + Седмица Пентакли",
    "reading_cards": "Двойка Чаши + Седмица Пентакли",
    "reading_combination": ["two_cups", "seven_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Седмица Пентакли – търпение и чакане. Връзката ви се развива бавно. Търпение – истинската любов не бърза.",
    "reading_description": "Връзката се развива бавно. Чакай търпеливо.",
    "reading_advice": "Чакай търпеливо. Най-добрите неща в любовта идват с времето."
  },
  {
    "reading_id": "two_cups_eight_pentacles",
    "reading_name": "Двойка Чаши + Осмица Пентакли",
    "reading_cards": "Двойка Чаши + Осмица Пентакли",
    "reading_combination": ["two_cups", "eight_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Осмица Пентакли – усърдие и учене. Връзката ви изисква да се учите един от друг. Вложете време и усилия.",
    "reading_description": "Връзката изисква учене. Вложи време и усилия.",
    "reading_advice": "Учи се с желание. Любовта е практика – майсторството идва с времето."
  },
  {
    "reading_id": "two_cups_nine_pentacles",
    "reading_name": "Двойка Чаши + Деветка Пентакли",
    "reading_cards": "Двойка Чаши + Деветка Пентакли",
    "reading_combination": ["two_cups", "nine_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Деветка Пентакли – самодостатъчност и успех. Любовта ви идва, когато и двамата сте независими и силни. Зряла любов.",
    "reading_description": "Любовта идва, когато и двамата сте независими. Зряла любов.",
    "reading_advice": "Цени независимостта си. Тя прави любовта ви по-здрава."
  },
  {
    "reading_id": "two_cups_ten_pentacles",
    "reading_name": "Двойка Чаши + Десетка Пентакли",
    "reading_cards": "Двойка Чаши + Десетка Пентакли",
    "reading_combination": ["two_cups", "ten_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Десетка Пентакли – семейно наследство и дългосрочна сигурност. Връзката ви носи стабилност и радост на цялото семейство.",
    "reading_description": "Връзката носи стабилност на цялото семейство.",
    "reading_advice": "Мислете за бъдещето. Тази любов има потенциала да бъде вечна."
  },
  {
    "reading_id": "two_cups_page_pentacles",
    "reading_name": "Двойка Чаши + Паж Пентакли",
    "reading_cards": "Двойка Чаши + Паж Пентакли",
    "reading_combination": ["two_cups", "page_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Паж Пентакли – нова възможност и учене. Връзката ви отваря нова възможност за учене и растеж. Инвестиция в любовта.",
    "reading_description": "Връзката отваря нова възможност за учене. Инвестиция в любовта.",
    "reading_advice": "Хвани възможността. Тя носи растеж и задълбочаване на любовта."
  },
  {
    "reading_id": "two_cups_knight_pentacles",
    "reading_name": "Двойка Чаши + Рицар Пентакли",
    "reading_cards": "Двойка Чаши + Рицар Пентакли",
    "reading_combination": ["two_cups", "knight_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Рицар Пентакли – бавен и сигурен напредък. Връзката ви се развива бавно, но сигурно. Търпение – истинската любов не бърза.",
    "reading_description": "Връзката се развива бавно, но сигурно. Не бързай.",
    "reading_advice": "Не бързай. Сигурният път в любовта е бавен, но води до истинска дълбочина."
  },
  {
    "reading_id": "two_cups_queen_pentacles",
    "reading_name": "Двойка Чаши + Царица Пентакли",
    "reading_cards": "Двойка Чаши + Царица Пентакли",
    "reading_combination": ["two_cups", "queen_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Царица Пентакли – грижа и дом. Връзката ви е свързана с дома и семейството. Грижете се за нея като за дом.",
    "reading_description": "Връзката е свързана с дома и семейството. Грижи се за нея.",
    "reading_advice": "Грижи се за любовта като за дом. Вложи любов и практичност."
  },
  {
    "reading_id": "two_cups_king_pentacles",
    "reading_name": "Двойка Чаши + Цар Пентакли",
    "reading_cards": "Двойка Чаши + Цар Пентакли",
    "reading_combination": ["two_cups", "king_pentacles"],
    "reading_meaning": "Двойка Чаши носи любов и връзка, а Цар Пентакли – стабилност и бизнес успех. Връзката ви има потенциала да бъде стабилна и дълготрайна. Имате всички качества да успеете.",
    "reading_description": "Връзката има потенциал за дълготрайна стабилност.",
    "reading_advice": "Градете заедно. Стабилността и любовта вървят ръка за ръка."
  },
   
  {
    "reading_id": "three_cups_king_wands",
    "reading_name": "Тройка Чаши + Цар Жезли",
    "reading_cards": "Тройка Чаши + Цар Жезли",
    "reading_combination": ["three_cups", "king_wands"],
    "reading_meaning": "Тройка Чаши носи празник и радост, а Цар Жезли – лидерство и визия. Вие сте организаторът на празника. Вашата визия води другите и създава незабравими моменти.",
    "reading_description": "Ти си организаторът на празника. Визията ти води другите.",
    "reading_advice": "Води с пример. Твоята визия прави празника незабравим за всички."
  },
   
  {
    "reading_id": "three_cups_three_swords",
    "reading_name": "Тройка Чаши + Тройка Мечове",
    "reading_cards": "Тройка Чаши + Тройка Мечове",
    "reading_combination": ["three_cups", "three_swords"],
    "reading_meaning": "Тройка Чаши носи празник и радост, а Тройка Мечове – болка и разбито сърце. Празнувате, но носите болка в сърцето си. Смесени чувства.",
    "reading_description": "Празнуваш, но носиш болка в сърцето си. Радост и тъга заедно.",
    "reading_advice": "Позволи си да чувстваш и двете. Нормално е. Болката не отрича радостта."
  },
  
    {
    "reading_id": "three_cups_five_swords",
    "reading_name": "Тройка Чаши + Петица Мечове",
    "reading_cards": "Тройка Чаши + Петица Мечове",
    "reading_combination": ["three_cups", "five_swords"],
    "reading_meaning": "Тройка Чаши носи празник и радост, а Петица Мечове – конфликт и празна победа. Празнувате победа, но цената може да е била висока. Някой е наранен. Празнувай, но помни победените.",
    "reading_description": "Празнуваш победа, но цената може да е била висока. Някой е наранен.",
    "reading_advice": "Понякога да спечелиш не означава да унищожиш другия. Празнувай с мярка."
  },
  {
    "reading_id": "three_cups_six_swords",
    "reading_name": "Тройка Чаши + Шестица Мечове",
    "reading_cards": "Тройка Чаши + Шестица Мечове",
    "reading_combination": ["three_cups", "six_swords"],
    "reading_meaning": "Тройка Чаши носи празник и радост, а Шестица Мечове – пътуване и преход. Празнувате по време на пътуване или преместване. Радост в движение.",
    "reading_description": "Празнуваш по време на пътуване. Радост в движение.",
    "reading_advice": "Пътувай и се радвай едновременно. Животът е път – наслаждавай се на всяка спирка."
  },
  {
    "reading_id": "three_cups_seven_swords",
    "reading_name": "Тройка Чаши + Седмица Мечове",
    "reading_cards": "Тройка Чаши + Седмица Мечове",
    "reading_combination": ["three_cups", "seven_swords"],
    "reading_meaning": "Тройка Чаши носи празник и радост, а Седмица Мечове – измама и хитрост. Празнувате, но има тайна, която тежи. Радост с угризения. Истината ще излезе.",
    "reading_description": "Празнуваш, но има тайна, която те тежи. Радост с угризения.",
    "reading_advice": "По-добре сам да кажеш истината, отколкото тя да излезе сама. Освободи се от тежестта."
  },
  {
    "reading_id": "three_cups_eight_swords",
    "reading_name": "Тройка Чаши + Осмица Мечове",
    "reading_cards": "Тройка Чаши + Осмица Мечове",
    "reading_combination": ["three_cups", "eight_swords"],
    "reading_meaning": "Тройка Чаши носи празник и радост, а Осмица Мечове – чувство на капан и ограничение. Празнувате, но се чувствате в капан от обстоятелствата. Нямате истинска свобода.",
    "reading_description": "Празнуваш, но се чувстваш в капан. Нямаш истинска свобода.",
    "reading_advice": "Истинската радост е свободна. Ако се чувстваш в капан, нещо не е наред. Потърси изход."
  },
  {
    "reading_id": "three_cups_nine_swords",
    "reading_name": "Тройка Чаши + Деветка Мечове",
    "reading_cards": "Тройка Чаши + Деветка Мечове",
    "reading_combination": ["three_cups", "nine_swords"],
    "reading_meaning": "Тройка Чаши носи празник и радост, а Деветка Мечове – тревога и безсъние. Празнувате, но не спите от тревоги. Радост и страх едновременно.",
    "reading_description": "Празнуваш, но не спиш от тревоги. Радост и страх заедно.",
    "reading_advice": "Тревогите могат да развалят всеки празник. Освободи се от тях – дишай дълбоко и бъди в момента."
  },
 
    {
    "reading_id": "four_cups_two_wands",
    "reading_name": "Четворка Чаши + Двойка Жезли",
    "reading_cards": "Четворка Чаши + Двойка Жезли",
    "reading_combination": ["four_cups", "two_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Двойка Жезли – избор и планиране. Изправени сте пред избор, но никоя от опциите не ви удовлетворява. Понякога липсата на избор е най-добрият избор.",
    "reading_description": "Изправен си пред избор, но никоя опция не те радва.",
    "reading_advice": "Изчакай, преди да решиш. Понякога най-доброто решение е да не избираш веднага."
  },
  {
    "reading_id": "four_cups_three_wands",
    "reading_name": "Четворка Чаши + Тройка Жезли",
    "reading_cards": "Четворка Чаши + Тройка Жезли",
    "reading_combination": ["four_cups", "three_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Тройка Жезли – очакване и разширяване. Чакате нещо, но дори когато дойде, може да не ви удовлетвори. Преосмислете очакванията си.",
    "reading_description": "Чакаш нещо, но се съмняваш дали ще те зарадва.",
    "reading_advice": "Провери дали това, което очакваш, наистина е това, което искаш. Понякога очакванията ни не съвпадат с истинските ни нужди."
  },
  {
    "reading_id": "four_cups_four_wands",
    "reading_name": "Четворка Чаши + Четворка Жезли",
    "reading_cards": "Четворка Чаши + Четворка Жезли",
    "reading_combination": ["four_cups", "four_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Четворка Жезли – празник и стабилност. Около вас има празник, но вие не усещате радост. Сякаш нещо ви липсва. Потърсете причината вътре в себе си.",
    "reading_description": "Около теб има празник, но ти не усещаш радост. Сякаш нещо липсва.",
    "reading_advice": "Потърси причината вътре в себе си, не вън от теб. Радостта идва отвътре."
  },
  {
    "reading_id": "four_cups_five_wands",
    "reading_name": "Четворка Чаши + Петица Жезли",
    "reading_cards": "Четворка Чаши + Петица Жезли",
    "reading_combination": ["four_cups", "five_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Петица Жезли – конфликт и съперничество. Споровете около вас ви правят още по-неудовлетворени. Не се замесвайте – фокусът ви трябва да е върху себе си.",
    "reading_description": "Споровете около теб те правят още по-неудовлетворен. Не се замесвай.",
    "reading_advice": "Не се замесвай в драми. Фокусирай се върху себе си и това, което наистина искаш."
  },
  {
    "reading_id": "four_cups_six_wands",
    "reading_name": "Четворка Чаши + Шестица Жезли",
    "reading_cards": "Четворка Чаши + Шестица Жезли",
    "reading_combination": ["four_cups", "six_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Шестица Жезли – победа и признание. Постигате успех, но не усещате радост. Нещо ви липсва или сте прегорели. Попитайте се какво наистина искате.",
    "reading_description": "Постигаш успех, но не усещаш радост. Нещо липсва.",
    "reading_advice": "Попитай се какво наистина искаш. Успехът без сърце е празен. Намери истинската си цел."
  },
  {
    "reading_id": "four_cups_seven_wands",
    "reading_name": "Четворка Чаши + Седмица Жезли",
    "reading_cards": "Четворка Чаши + Седмица Жезли",
    "reading_combination": ["four_cups", "seven_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Седмица Жезли – защита на позицията. Защитавате се от света, защото нищо не ви радва. Но затварянето няма да реши проблема.",
    "reading_description": "Защитаваш се от света, защото нищо не те радва. Но затварянето не помага.",
    "reading_advice": "Отвори се малко. Понякога радостта идва, когато спреш да се защитаваш."
  },
  {
    "reading_id": "four_cups_eight_wands",
    "reading_name": "Четворка Чаши + Осмица Жезли",
    "reading_cards": "Четворка Чаши + Осмица Жезли",
    "reading_combination": ["four_cups", "eight_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Осмица Жезли – бързина и движение. Внезапен край на скуката и апатията. Нещо бързо раздвижва нещата. Хвани вълната на промяната.",
    "reading_description": "Внезапен край на скуката. Нещо бързо раздвижва нещата.",
    "reading_advice": "Хвани вълната на промяната. Тя може да извади от апатията."
  },
  {
    "reading_id": "four_cups_nine_wands",
    "reading_name": "Четворка Чаши + Деветка Жезли",
    "reading_cards": "Четворка Чаши + Деветка Жезли",
    "reading_combination": ["four_cups", "nine_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Деветка Жезли – устойчивост и изтощение. Изтощени сте от апатията и неудовлетворението. Умора, но надеждата, че скоро ще мине, ви крепи.",
    "reading_description": "Изтощен си от апатията и неудовлетворението. Умора, но надежда.",
    "reading_advice": "Дръж се още малко. Този период ще отмине. Не се отказвай."
  },
  {
    "reading_id": "four_cups_ten_wands",
    "reading_name": "Четворка Чаши + Десетка Жезли",
    "reading_cards": "Четворка Чаши + Десетка Жезли",
    "reading_combination": ["four_cups", "ten_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Десетка Жезли – претоварване и бреме. Носите тежестта на неудовлетворението и сте претоварени. Потърсете какво наистина тежи.",
    "reading_description": "Носиш тежестта на неудовлетворението и си претоварен.",
    "reading_advice": "Потърси какво наистина тежи. Понякога трябва да пуснеш, за да бъдеш свободен."
  },
  {
    "reading_id": "four_cups_page_wands",
    "reading_name": "Четворка Чаши + Паж Жезли",
    "reading_cards": "Четворка Чаши + Паж Жезли",
    "reading_combination": ["four_cups", "page_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Паж Жезли – новини и ентусиазъм. Вълнуваща новина идва, която може да разчупи апатията. Отворете се за нея.",
    "reading_description": "Вълнуваща новина идва, която може да разчупи апатията.",
    "reading_advice": "Отвори се за новините. Те могат да донесат радост, която не очакваш."
  },
  {
    "reading_id": "four_cups_knight_wands",
    "reading_name": "Четворка Чаши + Рицар Жезли",
    "reading_cards": "Четворка Чаши + Рицар Жезли",
    "reading_combination": ["four_cups", "knight_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Рицар Жезли – импулсивност и бързина. Нетърпението ви расте – искате да излезете от апатията веднага. Но бързината не винаги е решение.",
    "reading_description": "Искаш да излезеш от апатията веднага. Но бързината не винаги е решение.",
    "reading_advice": "Забави малко. Понякога бавното и сигурно води до по-добър резултат."
  },
  {
    "reading_id": "four_cups_queen_wands",
    "reading_name": "Четворка Чаши + Царица Жезли",
    "reading_cards": "Четворка Чаши + Царица Жезли",
    "reading_combination": ["four_cups", "queen_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Царица Жезли – увереност и харизма. Въпреки апатията, запазвате увереност. Вашата топлина може да ви помогне да излезете от застоя.",
    "reading_description": "Въпреки апатията, запазваш увереност. Топлината ти може да помогне.",
    "reading_advice": "Бъди топъл и уверен. Твоята светлина може да разчупи апатията."
  },
  {
    "reading_id": "four_cups_king_wands",
    "reading_name": "Четворка Чаши + Цар Жезли",
    "reading_cards": "Четворка Чаши + Цар Жезли",
    "reading_combination": ["four_cups", "king_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Цар Жезли – лидерство и визия. Вие сте лидер, който преминава през период на апатия. Използвайте визията си, за да намерите изход.",
    "reading_description": "Ти си лидер, който преминава през период на апатия. Намери изход с визията си.",
    "reading_advice": "Използвай визията си. Тя може да те изведе от апатията и да води другите."
  },
  {
    "reading_id": "four_cups_ace_wands",
    "reading_name": "Четворка Чаши + Асо Жезли",
    "reading_cards": "Четворка Чаши + Асо Жезли",
    "reading_combination": ["four_cups", "ace_wands"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Асо Жезли – ново начало и вдъхновение. Нова искра се появява, която може да извади от апатията. Хванете я.",
    "reading_description": "Нова искра се появява, която може да извади от апатията.",
    "reading_advice": "Хвани искрата. Тя може да е началото на нещо ново и вълнуващо."
  },
  {
    "reading_id": "four_cups_ace_cups",
    "reading_name": "Четворка Чаши + Асо Чаши",
    "reading_cards": "Четворка Чаши + Асо Чаши",
    "reading_combination": ["four_cups", "ace_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Асо Чаши – нови чувства и любов. Нови чувства се появяват, но вие сте твърде заети със себе си, за да ги забележите. Вдигнете поглед.",
    "reading_description": "Нови чувства се появяват, но ти не ги забелязваш. Вдигни поглед.",
    "reading_advice": "Свали превръзката от очите. Любовта може да е точно пред теб."
  },
  {
    "reading_id": "four_cups_two_cups",
    "reading_name": "Четворка Чаши + Двойка Чаши",
    "reading_cards": "Четворка Чаши + Двойка Чаши",
    "reading_combination": ["four_cups", "two_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Двойка Чаши – любов и връзка. Връзката ви е стабилна, но вие сте неудовлетворени. Потърсете какво наистина ви липсва.",
    "reading_description": "Връзката е стабилна, но ти си неудовлетворен. Потърси какво липсва.",
    "reading_advice": "Попитай се какво наистина искаш от любовта. Понякога сигурността не е всичко."
  },
  {
    "reading_id": "four_cups_three_cups",
    "reading_name": "Четворка Чаши + Тройка Чаши",
    "reading_cards": "Четворка Чаши + Тройка Чаши",
    "reading_combination": ["four_cups", "three_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Тройка Чаши – празник и радост. Около вас има празник, но вие не усещате радост. Не позволявайте на апатията да развали празника.",
    "reading_description": "Около теб има празник, но ти не усещаш радост.",
    "reading_advice": "Не позволявай на апатията да развали празника. Опитай се да се включиш."
  },
   
  {
    "reading_id": "four_cups_five_cups",
    "reading_name": "Четворка Чаши + Петица Чаши",
    "reading_cards": "Четворка Чаши + Петица Чаши",
    "reading_combination": ["four_cups", "five_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Петица Чаши – загуба и тъга. Апатията и тъгата вървят ръка за ръка. Позволете си да скърбите, но не оставайте в застоя.",
    "reading_description": "Апатия и тъга заедно. Скърби, но не оставай в застой.",
    "reading_advice": "Позволи си да скърбиш, после продължи. Апатията не се побеждава с бездействие."
  },
  {
    "reading_id": "four_cups_six_cups",
    "reading_name": "Четворка Чаши + Шестица Чаши",
    "reading_cards": "Четворка Чаши + Шестица Чаши",
    "reading_combination": ["four_cups", "six_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Шестица Чаши – спомени и носталгия. Спомените от миналото ви правят неудовлетворени от настоящето. Не живейте в миналото.",
    "reading_description": "Спомените от миналото те правят неудовлетворен от настоящето.",
    "reading_advice": "Миналото е учител, не водач. Вземи наученото, но гледай напред."
  },
  {
    "reading_id": "four_cups_seven_cups",
    "reading_name": "Четворка Чаши + Седмица Чаши",
    "reading_cards": "Четворка Чаши + Седмица Чаши",
    "reading_combination": ["four_cups", "seven_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Седмица Чаши – илюзии и фантазии. Живеете в илюзия, че нещо ви липсва. Истинската радост може да е точно пред вас.",
    "reading_description": "Живееш в илюзия, че нещо ти липсва. Истинската радост може да е точно пред теб.",
    "reading_advice": "Свали розовите очила. Погледни какво имаш – може да е повече, отколкото си мислиш."
  },
  {
    "reading_id": "four_cups_eight_cups",
    "reading_name": "Четворка Чаши + Осмица Чаши",
    "reading_cards": "Четворка Чаши + Осмица Чаши",
    "reading_combination": ["four_cups", "eight_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Осмица Чаши – тръгване и оставяне. Решавате да напуснете ситуацията, която ви прави неудовлетворени. Тръгвайте смело.",
    "reading_description": "Решаваш да напуснеш ситуацията, която те прави неудовлетворен.",
    "reading_advice": "Тръгни смело. Понякога трябва да оставиш, за да намериш това, което търсиш."
  },
  {
    "reading_id": "four_cups_nine_cups",
    "reading_name": "Четворка Чаши + Деветка Чаши",
    "reading_cards": "Четворка Чаши + Деветка Чаши",
    "reading_combination": ["four_cups", "nine_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Деветка Чаши – сбъднато желание. Имате всичко, което сте искали, но не сте щастливи. Потърсете какво наистина ви липсва.",
    "reading_description": "Имаш всичко, което си искал, но не си щастлив.",
    "reading_advice": "Щастието не е в притежанията. Потърси го вътре в себе си."
  },
  {
    "reading_id": "four_cups_ten_cups",
    "reading_name": "Четворка Чаши + Десетка Чаши",
    "reading_cards": "Четворка Чаши + Десетка Чаши",
    "reading_combination": ["four_cups", "ten_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Десетка Чаши – семейно щастие. Имате семейна сигурност, но не сте щастливи. Потърсете какво наистина ви липсва.",
    "reading_description": "Имаш семейна сигурност, но не си щастлив. Потърси какво липсва.",
    "reading_advice": "Щастието не е само в сигурността. Потърси го в малките неща."
  },
  {
    "reading_id": "four_cups_page_cups",
    "reading_name": "Четворка Чаши + Паж Чаши",
    "reading_cards": "Четворка Чаши + Паж Чаши",
    "reading_combination": ["four_cups", "page_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Паж Чаши – емоционално послание. Нежно послание идва, което може да разчупи апатията. Отворете сърцето си за него.",
    "reading_description": "Нежно послание идва, което може да разчупи апатията.",
    "reading_advice": "Отвори сърцето си за посланието. То носи нещо ценно."
  },
  {
    "reading_id": "four_cups_knight_cups",
    "reading_name": "Четворка Чаши + Рицар Чаши",
    "reading_cards": "Четворка Чаши + Рицар Чаши",
    "reading_combination": ["four_cups", "knight_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Рицар Чаши – романтика и ухажване. Романтичен жест идва, но вие сте твърде апатични, за да го забележите. Вдигнете поглед.",
    "reading_description": "Романтичен жест идва, но ти си твърде апатичен, за да го забележиш.",
    "reading_advice": "Вдигни поглед. Любовта може да е точно пред теб, но ти не я виждаш."
  },
  {
    "reading_id": "four_cups_queen_cups",
    "reading_name": "Четворка Чаши + Царица Чаши",
    "reading_cards": "Четворка Чаши + Царица Чаши",
    "reading_combination": ["four_cups", "queen_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Царица Чаши – интуиция и емпатия. Интуицията ви подсказва какво ви липсва. Слушайте вътрешния си глас.",
    "reading_description": "Интуицията ти подсказва какво ти липсва. Слушай вътрешния си глас.",
    "reading_advice": "Довери се на интуицията си. Тя знае какво наистина искаш."
  },
  {
    "reading_id": "four_cups_king_cups",
    "reading_name": "Четворка Чаши + Цар Чаши",
    "reading_cards": "Четворка Чаши + Цар Чаши",
    "reading_combination": ["four_cups", "king_cups"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Цар Чаши – емоционална зрялост и баланс. Апатията не е постоянна – с мъдрост и търпение ще я преодолеете.",
    "reading_description": "Апатията не е постоянна. С мъдрост и търпение ще я преодолееш.",
    "reading_advice": "Чакай с мир в сърцето. Този период ще отмине. Емоционалната зрялост ще ти помогне."
  },
  {
    "reading_id": "four_cups_two_swords",
    "reading_name": "Четворка Чаши + Двойка Мечове",
    "reading_cards": "Четворка Чаши + Двойка Мечове",
    "reading_combination": ["four_cups", "two_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Двойка Мечове – нерешителност и съмнение. Апатията и нерешителността ви държат в застой. Свалете превръзката – имате повече възможности, отколкото си мислите.",
    "reading_description": "Апатията и нерешителността те държат в застой.",
    "reading_advice": "Свали превръзката. Имаш повече възможности, отколкото си мислиш."
  },
  {
    "reading_id": "four_cups_three_swords",
    "reading_name": "Четворка Чаши + Тройка Мечове",
    "reading_cards": "Четворка Чаши + Тройка Мечове",
    "reading_combination": ["four_cups", "three_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Тройка Мечове – болка и разбито сърце. Апатията идва от разбито сърце. Позволете си да скърбите, но не оставайте в застоя.",
    "reading_description": "Апатията идва от разбито сърце. Скърби, но не оставай в застой.",
    "reading_advice": "Позволи си да скърбиш, после продължи. Болката не е вечна."
  },
    {
    "reading_id": "four_cups_four_swords",
    "reading_name": "Четворка Чаши + Четворка Мечове",
    "reading_cards": "Четворка Чаши + Четворка Мечове",
    "reading_combination": ["four_cups", "four_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Четворка Мечове – почивка и уединение. Имате нужда от почивка, за да излезете от апатията. Уединението може да ви помогне да намерите себе си.",
    "reading_description": "Имаш нужда от почивка, за да излезеш от апатията.",
    "reading_advice": "Почини си. Уединението може да ти помогне да намериш себе си и да излезеш от застоя."
  },
  {
    "reading_id": "four_cups_five_swords",
    "reading_name": "Четворка Чаши + Петица Мечове",
    "reading_cards": "Четворка Чаши + Петица Мечове",
    "reading_combination": ["four_cups", "five_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Петица Мечове – конфликт и празна победа. Апатията ви кара да търсите конфликти, за да усетите нещо. Но празната победа няма да ви удовлетвори.",
    "reading_description": "Апатията те кара да търсиш конфликти. Но празната победа няма да те удовлетвори.",
    "reading_advice": "Потърси истински източници на радост, не временни конфликти."
  },
  {
    "reading_id": "four_cups_six_swords",
    "reading_name": "Четворка Чаши + Шестица Мечове",
    "reading_cards": "Четворка Чаши + Шестица Мечове",
    "reading_combination": ["four_cups", "six_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Шестица Мечове – пътуване и преход. Пътуване или промяна на средата може да извади от апатията. Новите води носят нови възможности.",
    "reading_description": "Пътуване или промяна на средата може да извади от апатията.",
    "reading_advice": "Тръгни. Новите води носят нови възможности. Промяната може да разчупи застоя."
  },
  {
    "reading_id": "four_cups_seven_swords",
    "reading_name": "Четворка Чаши + Седмица Мечове",
    "reading_cards": "Четворка Чаши + Седмица Мечове",
    "reading_combination": ["four_cups", "seven_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Седмица Мечове – измама и хитрост. Апатията ви прави уязвими за измама. Внимавайте – някой може да се възползва от състоянието ви.",
    "reading_description": "Апатията те прави уязвим за измама. Бъди внимателен.",
    "reading_advice": "Пази се. Когато си апатичен, решенията ти не са най-добрите. Не взимай важни решения сега."
  },
  {
    "reading_id": "four_cups_eight_swords",
    "reading_name": "Четворка Чаши + Осмица Мечове",
    "reading_cards": "Четворка Чаши + Осмица Мечове",
    "reading_combination": ["four_cups", "eight_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Осмица Мечове – чувство на капан и ограничение. Чувствате се в капан от апатията си. Оковите са в главата ви – имате повече възможности, отколкото си мислите.",
    "reading_description": "Чувстваш се в капан от апатията си. Оковите са в главата ти.",
    "reading_advice": "Освободи се от страха. Имаш повече възможности, отколкото си мислиш. Потърси нова перспектива."
  },
  {
    "reading_id": "four_cups_nine_swords",
    "reading_name": "Четворка Чаши + Деветка Мечове",
    "reading_cards": "Четворка Чаши + Деветка Мечове",
    "reading_combination": ["four_cups", "nine_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Деветка Мечове – тревога и безсъние. Апатията и тревогата вървят ръка за ръка. Не можете да спите, защото сте неудовлетворени, и сте апатични, защото не спите.",
    "reading_description": "Апатия и тревога заедно. Не спиш, защото си неудовлетворен, и си апатичен, защото не спиш.",
    "reading_advice": "Спри за момент. Тревогите ти не са реалност. Потърси помощ, ако не можеш сам да се измъкнеш."
  },
  {
    "reading_id": "four_cups_ten_swords",
    "reading_name": "Четворка Чаши + Десетка Мечове",
    "reading_cards": "Четворка Чаши + Десетка Мечове",
    "reading_combination": ["four_cups", "ten_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Десетка Мечове – край и дъно. Периодът на апатия приключва. Краят носи облекчение, дори да е труден. След дъното идва ново начало.",
    "reading_description": "Периодът на апатия приключва. Краят носи облекчение.",
    "reading_advice": "Остави апатията зад гърба си. Това, което свърши, вече не тежи. Гледай напред."
  },
  {
    "reading_id": "four_cups_page_swords",
    "reading_name": "Четворка Чаши + Паж Мечове",
    "reading_cards": "Четворка Чаши + Паж Мечове",
    "reading_combination": ["four_cups", "page_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Паж Мечове – търсене на истината. Истината за това, което ви липсва, може да излезе наяве. Бъдете отворени за прозрения.",
    "reading_description": "Истината за това, което ти липсва, може да излезе наяве.",
    "reading_advice": "Търси истината. Тя може да ти помогне да разбереш какво наистина искаш."
  },
  {
    "reading_id": "four_cups_knight_swords",
    "reading_name": "Четворка Чаши + Рицар Мечове",
    "reading_cards": "Четворка Чаши + Рицар Мечове",
    "reading_combination": ["four_cups", "knight_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Рицар Мечове – бързина и прямота. Истината за апатията ви идва бързо и рязко. Бъдете готови да я приемете.",
    "reading_description": "Истината за апатията ти идва бързо и рязко. Бъди готов.",
    "reading_advice": "Приеми истината с отворено сърце. Тя може да е ключът към излизане от апатията."
  },
  {
    "reading_id": "four_cups_queen_swords",
    "reading_name": "Четворка Чаши + Царица Мечове",
    "reading_cards": "Четворка Чаши + Царица Мечове",
    "reading_combination": ["four_cups", "queen_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Царица Мечове – яснота и независимост. Виждате апатията си ясно, без илюзии. Яснотата може да ви помогне да намерите изход.",
    "reading_description": "Виждаш апатията си ясно, без илюзии. Яснотата може да помогне.",
    "reading_advice": "Бъди честен със себе си. Яснотата, колкото и да е сурова, е първата стъпка към промяна."
  },
  {
    "reading_id": "four_cups_king_swords",
    "reading_name": "Четворка Чаши + Цар Мечове",
    "reading_cards": "Четворка Чаши + Цар Мечове",
    "reading_combination": ["four_cups", "king_swords"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Цар Мечове – интелект и стратегия. С логика и анализ можете да разберете какво ви липсва. Използвайте ума си, за да намерите решение.",
    "reading_description": "С логика и анализ можеш да разбереш какво ти липсва.",
    "reading_advice": "Използвай ума си. Анализът може да ти помогне да разбереш корена на апатията."
  },
  {
    "reading_id": "four_cups_two_pentacles",
    "reading_name": "Четворка Чаши + Двойка Пентакли",
    "reading_cards": "Четворка Чаши + Двойка Пентакли",
    "reading_combination": ["four_cups", "two_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Двойка Пентакли – баланс и жонглиране. Опитвате се да балансирате неудовлетворението с другите си задължения. Жонглирайте внимателно.",
    "reading_description": "Опитваш се да балансираш неудовлетворението с другите си задължения.",
    "reading_advice": "Балансирай, но не изпускай себе си. Не позволявай на апатията да завладее целия ти живот."
  },
  {
    "reading_id": "four_cups_three_pentacles",
    "reading_name": "Четворка Чаши + Тройка Пентакли",
    "reading_cards": "Четворка Чаши + Тройка Пентакли",
    "reading_combination": ["four_cups", "three_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Тройка Пентакли – екипна работа и сътрудничество. В екипа има неудовлетворение и апатия. Някой не дава най-доброто от себе си. Потърсете причината.",
    "reading_description": "В екипа има неудовлетворение. Някой не дава най-доброто от себе си.",
    "reading_advice": "Потърсете причината. Понякога човек има нужда да бъде чут. Екипната подкрепа може да помогне."
  },
  {
    "reading_id": "four_cups_four_pentacles",
    "reading_name": "Четворка Чаши + Четворка Пентакли",
    "reading_cards": "Четворка Чаши + Четворка Пентакли",
    "reading_combination": ["four_cups", "four_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Четворка Пентакли – сигурност и стискане. Стискате толкова силно, че сте забравили да живеете. Сигурността не е в парите, а в способността да се радваш.",
    "reading_description": "Стискаш толкова силно, че си забравил да живееш.",
    "reading_advice": "Пусни малко. Сигурността не е в парите, а в способността да се радваш на живота."
  },
  {
    "reading_id": "four_cups_five_pentacles",
    "reading_name": "Четворка Чаши + Петица Пентакли",
    "reading_cards": "Четворка Чаши + Петица Пентакли",
    "reading_combination": ["four_cups", "five_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Петица Пентакли – финансови трудности и липса. Финансовите трудности ви правят апатични. Не затваряйте очи – помощ може да е точно пред вас.",
    "reading_description": "Финансовите трудности те правят апатичен. Помощ може да е точно пред теб.",
    "reading_advice": "Вдигни поглед. Помощта може да е точно пред теб, но ти не я виждаш заради апатията."
  },
  {
    "reading_id": "four_cups_six_pentacles",
    "reading_name": "Четворка Чаши + Шестица Пентакли",
    "reading_cards": "Четворка Чаши + Шестица Пентакли",
    "reading_combination": ["four_cups", "six_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Шестица Пентакли – помощ и щедрост. Някой протяга ръка да ви помогне, но вие сте твърде апатични, за да забележите. Приемете помощта.",
    "reading_description": "Някой протяга ръка да ти помогне, но си твърде апатичен, за да забележиш.",
    "reading_advice": "Приеми помощта. Няма срам да поискаш помощ, когато си в апатия. Някой ден ще върнеш жеста."
  },
  {
    "reading_id": "four_cups_seven_pentacles",
    "reading_name": "Четворка Чаши + Седмица Пентакли",
    "reading_cards": "Четворка Чаши + Седмица Пентакли",
    "reading_combination": ["four_cups", "seven_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Седмица Пентакли – търпение и чакане. Апатията изисква търпение. Не очаквайте бързо излизане от застоя. Бавно, но сигурно.",
    "reading_description": "Апатията изисква търпение. Не очаквай бързо излизане.",
    "reading_advice": "Чакай търпеливо. Някои периоди на апатия се разрешават с времето, не с усилие."
  },
  {
    "reading_id": "four_cups_eight_pentacles",
    "reading_name": "Четворка Чаши + Осмица Пентакли",
    "reading_cards": "Четворка Чаши + Осмица Пентакли",
    "reading_combination": ["four_cups", "eight_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Осмица Пентакли – усърдие и учене. Ученето може да ви извади от апатията. Вложете енергия в ново умение или хоби.",
    "reading_description": "Ученето може да те извади от апатията. Вложи енергия в нещо ново.",
    "reading_advice": "Използвай времето на апатия, за да се учиш. Новото знание може да донесе нова радост."
  },
  {
    "reading_id": "four_cups_nine_pentacles",
    "reading_name": "Четворка Чаши + Деветка Пентакли",
    "reading_cards": "Четворка Чаши + Деветка Пентакли",
    "reading_combination": ["four_cups", "nine_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Деветка Пентакли – самодостатъчност и успех. Имате успех, но не сте щастливи. Потърсете какво наистина ви липсва – може би нещо, което парите не могат да купят.",
    "reading_description": "Имаш успех, но не си щастлив. Потърси какво наистина липсва.",
    "reading_advice": "Успехът не е всичко. Потърси какво те прави истински щастлив."
  },
  {
    "reading_id": "four_cups_ten_pentacles",
    "reading_name": "Четворка Чаши + Десетка Пентакли",
    "reading_cards": "Четворка Чаши + Десетка Пентакли",
    "reading_combination": ["four_cups", "ten_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Десетка Пентакли – семейно наследство и богатство. Имате семейна сигурност, но не сте щастливи. Потърсете какво наистина ви липсва.",
    "reading_description": "Имаш семейна сигурност, но не си щастлив. Потърси какво липсва.",
    "reading_advice": "Щастието не е само в сигурността. Потърси го в малките неща и в сърцето си."
  },
  {
    "reading_id": "four_cups_page_pentacles",
    "reading_name": "Четворка Чаши + Паж Пентакли",
    "reading_cards": "Четворка Чаши + Паж Пентакли",
    "reading_combination": ["four_cups", "page_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Паж Пентакли – нова възможност и учене. Нова финансова възможност или кариерен шанс се появява. Това може да разчупи апатията.",
    "reading_description": "Нова финансова възможност се появява. Може да разчупи апатията.",
    "reading_advice": "Хвани възможността. Тя може да донесе нова цел и радост в живота ти."
  },
  {
    "reading_id": "four_cups_knight_pentacles",
    "reading_name": "Четворка Чаши + Рицар Пентакли",
    "reading_cards": "Четворка Чаши + Рицар Пентакли",
    "reading_combination": ["four_cups", "knight_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Рицар Пентакли – бавен и сигурен напредък. Излизането от апатията няма да стане бързо. Бавно, но сигурно – стъпка по стъпка.",
    "reading_description": "Излизането от апатията няма да стане бързо. Бавно, но сигурно.",
    "reading_advice": "Не очаквай бързо решение. Движи се бавно, но сигурно. Всяка малка стъпка напред има значение."
  },
  {
    "reading_id": "four_cups_queen_pentacles",
    "reading_name": "Четворка Чаши + Царица Пентакли",
    "reading_cards": "Четворка Чаши + Царица Пентакли",
    "reading_combination": ["four_cups", "queen_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Царица Пентакли – грижа и дом. Грижите за дома тежат и ви правят апатични. Потърсете време за себе си.",
    "reading_description": "Грижите за дома тежат и те правят апатичен. Потърси време за себе си.",
    "reading_advice": "Погрижи се за себе си. Само така можеш да се грижиш за другите. Апатията не се побеждава с повече грижа, а с баланс."
  },
  {
    "reading_id": "four_cups_king_pentacles",
    "reading_name": "Четворка Чаши + Цар Пентакли",
    "reading_cards": "Четворка Чаши + Цар Пентакли",
    "reading_combination": ["four_cups", "king_pentacles"],
    "reading_meaning": "Четворка Чаши носи апатия и неудовлетворение, а Цар Пентакли – стабилност и успех. Имате стабилност, но не сте щастливи. Потърсете какво наистина искате – успехът не е всичко.",
    "reading_description": "Имаш стабилност, но не си щастлив. Потърси какво наистина искаш.",
    "reading_advice": "Успехът не е всичко. Потърси какво те прави истински щастлив. Може би нещо, което не можеш да купиш с пари."
  },
    {
    "reading_id": "five_cups_two_wands",
    "reading_name": "Петица Чаши + Двойка Жезли",
    "reading_cards": "Петица Чаши + Двойка Жезли",
    "reading_combination": ["five_cups", "two_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Двойка Жезли – избор и планиране. Преживявате загуба и предстои важен избор. Трудно е да мислите ясно, но изборът ще определи пътя напред. Позволете си да скърбите, после изберете.",
    "reading_description": "Преживяваш загуба и предстои важен избор. Трудно, но трябва да избереш.",
    "reading_advice": "Позволи си да скърбиш, после избери. Всяка посока е по-добра от липсата на такава."
  },
  {
    "reading_id": "five_cups_three_wands",
    "reading_name": "Петица Чаши + Тройка Жезли",
    "reading_cards": "Петица Чаши + Тройка Жезли",
    "reading_combination": ["five_cups", "three_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Тройка Жезли – очакване и разширяване. Усещате, че предстои разочарование или загуба. Страх и несигурност в очакването. Каквото дойде, ще се справите.",
    "reading_description": "Усещаш, че предстои загуба или разочарование. Страх и несигурност.",
    "reading_advice": "Каквото дойде, приеми го. Ще се справиш. Позволи си да скърбиш, после продължи."
  },
  {
    "reading_id": "five_cups_four_wands",
    "reading_name": "Петица Чаши + Четворка Жезли",
    "reading_cards": "Петица Чаши + Четворка Жезли",
    "reading_combination": ["five_cups", "four_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Четворка Жезли – празник и стабилност. Празнувате, но в сърцето ви има тъга. Радост и болка едновременно – може би празнувате, докато скърбите за нещо загубено.",
    "reading_description": "Празнуваш, но в сърцето ти има тъга. Радост и болка заедно.",
    "reading_advice": "Позволи си да чувстваш и двете. Нормално е. Радостта не изключва тъгата."
  },
  {
    "reading_id": "five_cups_five_wands",
    "reading_name": "Петица Чаши + Петица Жезли",
    "reading_cards": "Петица Чаши + Петица Жезли",
    "reading_combination": ["five_cups", "five_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Петица Жезли – конфликт и съперничество. Загуба и конфликт заедно. Спорът води до загуба – на приятелство, доверие или възможност. Горчив край.",
    "reading_description": "Загуба и конфликт заедно. Спорът води до загуба.",
    "reading_advice": "Понякога най-добрата победа е да не влизаш в битка. Загубата не винаги си струва цената."
  },
  {
    "reading_id": "five_cups_six_wands",
    "reading_name": "Петица Чаши + Шестица Жезли",
    "reading_cards": "Петица Чаши + Шестица Жезли",
    "reading_combination": ["five_cups", "six_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Шестица Жезли – победа и признание. Успех, но с цената на загуба. Смесени чувства – радост и тъга едновременно. Понякога победата не си струва цената.",
    "reading_description": "Успех, но с цената на загуба. Радост и тъга заедно.",
    "reading_advice": "Понякога победата не си струва цената. Позволи си да скърбиш за загубата, дори да празнуваш успеха."
  },
  {
    "reading_id": "five_cups_seven_wands",
    "reading_name": "Петица Чаши + Седмица Жезли",
    "reading_cards": "Петица Чаши + Седмица Жезли",
    "reading_combination": ["five_cups", "seven_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Седмица Жезли – защита на позицията. Опитвате се да защитите остатъците от това, което сте загубили. Дръжте се, но не се вкопчвайте прекалено.",
    "reading_description": "Опитваш се да защитиш остатъците от това, което си загубил.",
    "reading_advice": "Защитавай, но не се вкопчвай. Понякога трябва да пуснеш, за да получиш нещо ново."
  },
  {
    "reading_id": "five_cups_eight_wands",
    "reading_name": "Петица Чаши + Осмица Жезли",
    "reading_cards": "Петица Чаши + Осмица Жезли",
    "reading_combination": ["five_cups", "eight_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Осмица Жезли – бързина и движение. Загубата идва внезапно и бързо. Почти не можете да повярвате, че се случва. Позволете си да скърбите, но не оставайте там.",
    "reading_description": "Загубата идва внезапно и бързо. Почти не можеш да повярваш.",
    "reading_advice": "Позволи си да скърбиш, но не оставай в тъгата. Бързината на промяната носи и бързо възстановяване."
  },
  {
    "reading_id": "five_cups_nine_wands",
    "reading_name": "Петица Чаши + Деветка Жезли",
    "reading_cards": "Петица Чаши + Деветка Жезли",
    "reading_combination": ["five_cups", "nine_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Деветка Жезли – устойчивост и изтощение. Носите тежестта на загубата и сте изтощени. Умора, но надеждата, че болката ще отмине, ви крепи.",
    "reading_description": "Носиш тежестта на загубата и си изтощен. Умора, но надежда.",
    "reading_advice": "Дръж се още малко. Болката не е вечна. Изтощението ще отмине, когато приемеш загубата."
  },
  {
    "reading_id": "five_cups_ten_wands",
    "reading_name": "Петица Чаши + Десетка Жезли",
    "reading_cards": "Петица Чаши + Десетка Жезли",
    "reading_combination": ["five_cups", "ten_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Десетка Жезли – претоварване и бреме. Загубата добавя тежест към и без това претоварения ви живот. Твърде много едновременно. Освободете се от ненужното.",
    "reading_description": "Загубата добавя тежест към и без това претоварения ти живот.",
    "reading_advice": "Освободи се от ненужните отговорности. Не можеш да носиш всичко, особено когато скърбиш."
  },
  {
    "reading_id": "five_cups_page_wands",
    "reading_name": "Петица Чаши + Паж Жезли",
    "reading_cards": "Петица Чаши + Паж Жезли",
    "reading_combination": ["five_cups", "page_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Паж Жезли – новини и ентусиазъм. По време на тъга идват новини, които могат да променят перспективата. Отворете се за тях.",
    "reading_description": "По време на тъга идват новини, които могат да променят перспективата.",
    "reading_advice": "Изслушай новините. Те може да носят надежда в тъжния момент."
  },
  {
    "reading_id": "five_cups_knight_wands",
    "reading_name": "Петица Чаши + Рицар Жезли",
    "reading_cards": "Петица Чаши + Рицар Жезли",
    "reading_combination": ["five_cups", "knight_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Рицар Жезли – импулсивност и бързина. Импулсивно решение, взето в момент на тъга, може да влоши нещата. Забавете – не вземайте важни решения, докато скърбите.",
    "reading_description": "Импулсивно решение, взето в момент на тъга, може да влоши нещата.",
    "reading_advice": "Забави. Не вземай важни решения, докато скърбиш. Дай си време."
  },
  {
    "reading_id": "five_cups_queen_wands",
    "reading_name": "Петица Чаши + Царица Жезли",
    "reading_cards": "Петица Чаши + Царица Жезли",
    "reading_combination": ["five_cups", "queen_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Царица Жезли – увереност и харизма. Въпреки тъгата, запазвате достойнство и увереност. Вашата топлина ще ви помогне да преодолеете загубата.",
    "reading_description": "Въпреки тъгата, запазваш достойнство и увереност.",
    "reading_advice": "Бъди топъл и уверен. Твоята светлина ще ти помогне да преодолееш тъгата."
  },
  {
    "reading_id": "five_cups_king_wands",
    "reading_name": "Петица Чаши + Цар Жезли",
    "reading_cards": "Петица Чаши + Цар Жезли",
    "reading_combination": ["five_cups", "king_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Цар Жезли – лидерство и визия. Вие сте лидер, който води през тъгата. Вашата визия за бъдещето ще помогне на вас и на другите да преодолеят загубата.",
    "reading_description": "Ти си лидер, който води през тъгата. Визията ти помага.",
    "reading_advice": "Води с пример. Твоята сила вдъхновява другите да продължат напред."
  },
  {
    "reading_id": "five_cups_ace_wands",
    "reading_name": "Петица Чаши + Асо Жезли",
    "reading_cards": "Петица Чаши + Асо Жезли",
    "reading_combination": ["five_cups", "ace_wands"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Асо Жезли – ново начало и вдъхновение. След загубата идва нова искра. Светлина след тъмнина. Отворете се за новото начало.",
    "reading_description": "След загубата идва нова искра. Светлина след тъмнина.",
    "reading_advice": "Хвани новата искра. Тя може да е началото на нещо ново и прекрасно."
  },
  {
    "reading_id": "five_cups_ace_cups",
    "reading_name": "Петица Чаши + Асо Чаши",
    "reading_cards": "Петица Чаши + Асо Чаши",
    "reading_combination": ["five_cups", "ace_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Асо Чаши – нови чувства и любов. Нова любов или приятелство се появява след загуба. Сърцето ви намира утеха. Отворете се за новото.",
    "reading_description": "Нова любов или приятелство се появява след загуба. Утеха.",
    "reading_advice": "Отвори сърцето си. Любовта лекува дори най-тежките рани."
  },
  {
    "reading_id": "five_cups_two_cups",
    "reading_name": "Петица Чаши + Двойка Чаши",
    "reading_cards": "Петица Чаши + Двойка Чаши",
    "reading_combination": ["five_cups", "two_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Двойка Чаши – любов и връзка. Загуба в любовта – раздяла или разочарование. Позволете си да скърбите, но не затваряйте сърцето си завинаги.",
    "reading_description": "Загуба в любовта – раздяла или разочарование.",
    "reading_advice": "Позволи си да скърбиш, но не затваряй сърцето си. Истинската любов идва, когато не я чакаш."
  },
  {
    "reading_id": "five_cups_three_cups",
    "reading_name": "Петица Чаши + Тройка Чаши",
    "reading_cards": "Петица Чаши + Тройка Чаши",
    "reading_combination": ["five_cups", "three_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Тройка Чаши – празник и радост. Празнувате, но в сърцето ви има тъга. Радост и болка едновременно – може би празнувате, докато скърбите.",
    "reading_description": "Празнуваш, но в сърцето ти има тъга. Радост и болка заедно.",
    "reading_advice": "Позволи си да чувстваш и двете. Нормално е. Тъгата не отрича радостта."
  },
  {
    "reading_id": "five_cups_four_cups",
    "reading_name": "Петица Чаши + Четворка Чаши",
    "reading_cards": "Петица Чаши + Четворка Чаши",
    "reading_combination": ["five_cups", "four_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Четворка Чаши – апатия и неудовлетворение. Загубата ви прави апатични. Не затваряйте очи – помощ може да е точно пред вас, но вие не я виждате.",
    "reading_description": "Загубата те прави апатичен. Помощ може да е точно пред теб.",
    "reading_advice": "Вдигни поглед. Помощта може да е точно пред теб, но ти не я виждаш заради тъгата."
  },
 
  {
    "reading_id": "five_cups_six_cups",
    "reading_name": "Петица Чаши + Шестица Чаши",
    "reading_cards": "Петица Чаши + Шестица Чаши",
    "reading_combination": ["five_cups", "six_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Шестица Чаши – спомени и носталгия. Спомените за по-добри времена ви крепят в тъгата. Използвайте ги като вдъхновение, но не живейте в миналото.",
    "reading_description": "Спомените за по-добри времена те крепят. Използвай ги като вдъхновение.",
    "reading_advice": "Спомените са утеха, но не живей в миналото. Гледай напред."
  },
  {
    "reading_id": "five_cups_seven_cups",
    "reading_name": "Петица Чаши + Седмица Чаши",
    "reading_cards": "Петица Чаши + Седмица Чаши",
    "reading_combination": ["five_cups", "seven_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Седмица Чаши – илюзии и фантазии. Бягате в илюзии, за да избегнете реалността на загубата. Свали розовите очила – само истината може да ви помогне да оздравеете.",
    "reading_description": "Бягаш в илюзии, за да избегнеш реалността на загубата.",
    "reading_advice": "Погледни истината в очите. Само тя може да ти помогне да оздравееш."
  },
  {
    "reading_id": "five_cups_eight_cups",
    "reading_name": "Петица Чаши + Осмица Чаши",
    "reading_cards": "Петица Чаши + Осмица Чаши",
    "reading_combination": ["five_cups", "eight_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Осмица Чаши – тръгване и оставяне. Решавате да оставите загубата зад гърба си и да тръгнете на нов път. Смела стъпка към изцеление.",
    "reading_description": "Решаваш да оставиш загубата зад гърба си и да тръгнеш на нов път.",
    "reading_advice": "Тръгни смело. Понякога трябва да оставиш, за да намериш себе си отново."
  },
  {
    "reading_id": "five_cups_nine_cups",
    "reading_name": "Петица Чаши + Деветка Чаши",
    "reading_cards": "Петица Чаши + Деветка Чаши",
    "reading_combination": ["five_cups", "nine_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Деветка Чаши – сбъднато желание. Въпреки загубата, една мечта се сбъдва. Радост сред тъгата. Позволете си да се радвате, дори да скърбите.",
    "reading_description": "Въпреки загубата, една мечта се сбъдва. Радост сред тъгата.",
    "reading_advice": "Наслади се на тази радост. Тя е доказателство, че дори в тъга има място за щастие."
  },
  {
    "reading_id": "five_cups_ten_cups",
    "reading_name": "Петица Чаши + Десетка Чаши",
    "reading_cards": "Петица Чаши + Десетка Чаши",
    "reading_combination": ["five_cups", "ten_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Десетка Чаши – семейно щастие. Загуба в семейството. Позволете си да скърбите заедно – семейството е опора. Заедно ще преодолеете тъгата.",
    "reading_description": "Загуба в семейството. Скърби заедно – семейството е опора.",
    "reading_advice": "Скърбете заедно. Семейството е най-силно, когато е заедно в болката."
  },
  {
    "reading_id": "five_cups_page_cups",
    "reading_name": "Петица Чаши + Паж Чаши",
    "reading_cards": "Петица Чаши + Паж Чаши",
    "reading_combination": ["five_cups", "page_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Паж Чаши – емоционално послание. Нежно послание идва, носейки утеха в тъгата. Отворете сърцето си за него.",
    "reading_description": "Нежно послание идва, носейки утеха в тъгата.",
    "reading_advice": "Отвори сърцето си за посланието. То носи надежда и утеха."
  },
  {
    "reading_id": "five_cups_knight_cups",
    "reading_name": "Петица Чаши + Рицар Чаши",
    "reading_cards": "Петица Чаши + Рицар Чаши",
    "reading_combination": ["five_cups", "knight_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Рицар Чаши – романтика и ухажване. Романтичен жест идва в момент на тъга. Позволете на любовта да ви утеши.",
    "reading_description": "Романтичен жест идва в момент на тъга. Позволи на любовта да те утеши.",
    "reading_advice": "Позволи на любовта да влезе. Тя може да е точно това, от което имаш нужда сега."
  },
  {
    "reading_id": "five_cups_queen_cups",
    "reading_name": "Петица Чаши + Царица Чаши",
    "reading_cards": "Петица Чаши + Царица Чаши",
    "reading_combination": ["five_cups", "queen_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Царица Чаши – интуиция и емпатия. Интуицията ви подсказва как да преодолеете загубата. Слушайте сърцето си – то знае пътя през тъгата.",
    "reading_description": "Интуицията ти подсказва как да преодолееш загубата.",
    "reading_advice": "Довери се на вътрешния си глас. Той знае пътя през тъгата."
  },
  {
    "reading_id": "five_cups_king_cups",
    "reading_name": "Петица Чаши + Цар Чаши",
    "reading_cards": "Петица Чаши + Цар Чаши",
    "reading_combination": ["five_cups", "king_cups"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Цар Чаши – емоционална зрялост и баланс. Преодолявате загубата с мъдрост и спокойствие. Зряла скръб, която води до изцеление.",
    "reading_description": "Преодоляваш загубата с мъдрост и спокойствие. Зряла скръб.",
    "reading_advice": "Бъди спокоен и мъдър. Емоционалната зрялост ще те изведе от тъгата."
  },
  {
    "reading_id": "five_cups_two_swords",
    "reading_name": "Петица Чаши + Двойка Мечове",
    "reading_cards": "Петица Чаши + Двойка Мечове",
    "reading_combination": ["five_cups", "two_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Двойка Мечове – нерешителност и съмнение. Тъгата ви кара да се съмнявате във всичко. Свалете превръзката – имате повече възможности, отколкото си мислите.",
    "reading_description": "Тъгата те кара да се съмняваш във всичко.",
    "reading_advice": "Свали превръзката. Имаш повече възможности, отколкото си мислиш. Тъгата замъглява перспективата."
  },
  {
    "reading_id": "five_cups_three_swords",
    "reading_name": "Петица Чаши + Тройка Мечове",
    "reading_cards": "Петица Чаши + Тройка Мечове",
    "reading_combination": ["five_cups", "three_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Тройка Мечове – болка и разбито сърце. Двойна болка – загуба и разбито сърце. Позволете си да скърбите, но не губете надежда – болката не е вечна.",
    "reading_description": "Двойна болка – загуба и разбито сърце.",
    "reading_advice": "Позволи си да скърбиш, но помни – болката не е вечна. Тя ще отмине, както всичко."
  },
    {
    "reading_id": "five_cups_four_swords",
    "reading_name": "Петица Чаши + Четворка Мечове",
    "reading_cards": "Петица Чаши + Четворка Мечове",
    "reading_combination": ["five_cups", "four_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Четворка Мечове – почивка и възстановяване. След загубата имате нужда от почивка. Позволете си да спрете и да възстановите сили. Скръбта изисква време.",
    "reading_description": "След загубата имаш нужда от почивка. Позволи си да спреш.",
    "reading_advice": "Почини си. Скръбта изисква време. Не бързай да се върнеш към нормалния ритъм."
  },
  {
    "reading_id": "five_cups_five_swords",
    "reading_name": "Петица Чаши + Петица Мечове",
    "reading_cards": "Петица Чаши + Петица Мечове",
    "reading_combination": ["five_cups", "five_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Петица Мечове – конфликт и празна победа. Загубата води до конфликт, който носи само повече болка. Понякога най-добрата победа е да излезеш от битката.",
    "reading_description": "Загубата води до конфликт, който носи само повече болка.",
    "reading_advice": "Помисли дали си струва да продължаваш. Понякога да излезеш от битката е по-голяма победа."
  },
  {
    "reading_id": "five_cups_six_swords",
    "reading_name": "Петица Чаши + Шестица Мечове",
    "reading_cards": "Петица Чаши + Шестица Мечове",
    "reading_combination": ["five_cups", "six_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Шестица Мечове – пътуване и преход. Решавате да оставите загубата зад гърба си и да тръгнете на път. Пътуването носи изцеление.",
    "reading_description": "Решаваш да оставиш загубата зад гърба си и да тръгнеш на път.",
    "reading_advice": "Тръгни. Новите води носят ново начало. Пътуването може да донесе изцеление."
  },
  {
    "reading_id": "five_cups_seven_swords",
    "reading_name": "Петица Чаши + Седмица Мечове",
    "reading_cards": "Петица Чаши + Седмица Мечове",
    "reading_combination": ["five_cups", "seven_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Седмица Мечове – измама и хитрост. Внимавайте – някой може да се опита да се възползва от тъгата ви, за да ви измами. Пазите се.",
    "reading_description": "Някой може да се опита да се възползва от тъгата ти.",
    "reading_advice": "Пази се. Когато скърбиш, не си най-добрият съдник. Не вземай важни решения, докато не се успокоиш."
  },
  {
    "reading_id": "five_cups_eight_swords",
    "reading_name": "Петица Чаши + Осмица Мечове",
    "reading_cards": "Петица Чаши + Осмица Мечове",
    "reading_combination": ["five_cups", "eight_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Осмица Мечове – чувство на капан и ограничение. Чувствате се в капан от тъгата си. Оковите са в главата ви – имате повече възможности, отколкото си мислите.",
    "reading_description": "Чувстваш се в капан от тъгата си. Оковите са в главата ти.",
    "reading_advice": "Освободи се от страха. Имаш повече възможности, отколкото си мислиш. Тъгата замъглява, но не затваря вратите."
  },
  {
    "reading_id": "five_cups_nine_swords",
    "reading_name": "Петица Чаши + Деветка Мечове",
    "reading_cards": "Петица Чаши + Деветка Мечове",
    "reading_combination": ["five_cups", "nine_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Деветка Мечове – тревога и безсъние. Тъгата ви носи безсъние и тревожни мисли. Не можете да спрете да мислите за загубата. Тревогите ви измъчват.",
    "reading_description": "Тъгата ти носи безсъние и тревожни мисли.",
    "reading_advice": "Спокойствие. Мислите ти не са реалност. Потърси помощ, ако тревогата те завладява."
  },
  {
    "reading_id": "five_cups_ten_swords",
    "reading_name": "Петица Чаши + Десетка Мечове",
    "reading_cards": "Петица Чаши + Десетка Мечове",
    "reading_combination": ["five_cups", "ten_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Десетка Мечове – край и дъно. Периодът на тъга приключва. Краят е болезнен, но носи освобождение. След дъното идва ново начало.",
    "reading_description": "Периодът на тъга приключва. Краят носи освобождение.",
    "reading_advice": "Остави тъгата зад гърба си. Това, което е свършило, вече не тежи. Гледай напред."
  },
  {
    "reading_id": "five_cups_page_swords",
    "reading_name": "Петица Чаши + Паж Мечове",
    "reading_cards": "Петица Чаши + Паж Мечове",
    "reading_combination": ["five_cups", "page_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Паж Мечове – търсене на истината. Истината за загубата излиза наяве. Бъдете отворени за прозренията, които идват.",
    "reading_description": "Истината за загубата излиза наяве. Бъди отворен.",
    "reading_advice": "Търси истината. Тя може да боли, но винаги лекува. Прозрението ще ти помогне да приемеш загубата."
  },
  {
    "reading_id": "five_cups_knight_swords",
    "reading_name": "Петица Чаши + Рицар Мечове",
    "reading_cards": "Петица Чаши + Рицар Мечове",
    "reading_combination": ["five_cups", "knight_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Рицар Мечове – бързина и прямота. Истината за загубата идва бързо и рязко. Бъдете готови да я приемете, колкото и да боли.",
    "reading_description": "Истината за загубата идва бързо и рязко. Бъди готов.",
    "reading_advice": "Приеми истината с отворено сърце. Тя може да е ключът към изцелението."
  },
  {
    "reading_id": "five_cups_queen_swords",
    "reading_name": "Петица Чаши + Царица Мечове",
    "reading_cards": "Петица Чаши + Царица Мечове",
    "reading_combination": ["five_cups", "queen_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Царица Мечове – яснота и независимост. Виждате загубата ясно, без илюзии. Яснотата, колкото и да е сурова, е първата стъпка към изцеление.",
    "reading_description": "Виждаш загубата ясно, без илюзии.",
    "reading_advice": "Бъди честен със себе си. Яснотата, колкото и да е сурова, води към изцеление."
  },
  {
    "reading_id": "five_cups_king_swords",
    "reading_name": "Петица Чаши + Цар Мечове",
    "reading_cards": "Петица Чаши + Цар Мечове",
    "reading_combination": ["five_cups", "king_swords"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Цар Мечове – интелект и стратегия. С логика и анализ можете да разберете защо се е случила загубата. Използвайте ума си, за да намерите смисъл.",
    "reading_description": "С логика и анализ можеш да разбереш защо се е случила загубата.",
    "reading_advice": "Използвай ума си. Анализът може да ти помогне да намериш смисъл в загубата и да продължиш напред."
  },
  {
    "reading_id": "five_cups_two_pentacles",
    "reading_name": "Петица Чаши + Двойка Пентакли",
    "reading_cards": "Петица Чаши + Двойка Пентакли",
    "reading_combination": ["five_cups", "two_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Двойка Пентакли – баланс и жонглиране. Опитвате се да балансирате тъгата с другите си задължения. Жонглирайте внимателно – не изпускайте себе си.",
    "reading_description": "Опитваш се да балансираш тъгата с другите си задължения.",
    "reading_advice": "Балансирай, но не изпускай себе си. Позволи си да скърбиш – това също е важно."
  },
  {
    "reading_id": "five_cups_three_pentacles",
    "reading_name": "Петица Чаши + Тройка Пентакли",
    "reading_cards": "Петица Чаши + Тройка Пентакли",
    "reading_combination": ["five_cups", "three_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Тройка Пентакли – екипна работа и сътрудничество. Не сте сами в тъгата си – споделете я с екипа или семейството. Заедно ще преодолеете загубата.",
    "reading_description": "Не си сам в тъгата – сподели я с другите.",
    "reading_advice": "Сподели тъгата с близките. Заедно сте по-силни. Тъгата, споделена, става по-лека."
  },
  {
    "reading_id": "five_cups_four_pentacles",
    "reading_name": "Петица Чаши + Четворка Пентакли",
    "reading_cards": "Петица Чаши + Четворка Пентакли",
    "reading_combination": ["five_cups", "four_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Четворка Пентакли – сигурност и стискане. След загубата се вкопчвате в това, което ви е останало. Позволете си да скърбите, но не се вкопчвайте прекалено.",
    "reading_description": "След загубата се вкопчваш в това, което ти е останало.",
    "reading_advice": "Пусни малко. Вкопчването няма да върне загубата. Позволи си да скърбиш, после отвори ръце за новото."
  },
  {
    "reading_id": "five_cups_five_pentacles",
    "reading_name": "Петица Чаши + Петица Пентакли",
    "reading_cards": "Петица Чаши + Петица Пентакли",
    "reading_combination": ["five_cups", "five_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Петица Пентакли – финансови трудности и липса. Двойна загуба – емоционална и финансова. Тежък период. Потърсете помощ – не сте сами.",
    "reading_description": "Двойна загуба – емоционална и финансова. Тежък период.",
    "reading_advice": "Потърси помощ. Не си сам. Има хора, готови да ти помогнат и в двете области."
  },
  {
    "reading_id": "five_cups_six_pentacles",
    "reading_name": "Петица Чаши + Шестица Пентакли",
    "reading_cards": "Петица Чаши + Шестица Пентакли",
    "reading_combination": ["five_cups", "six_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Шестица Пентакли – помощ и щедрост. Някой протяга ръка да ви помогне в тъгата. Приемете помощта – не сте сами.",
    "reading_description": "Някой протяга ръка да ти помогне в тъгата. Приеми.",
    "reading_advice": "Приеми помощта. Няма срам да поискаш помощ, когато скърбиш. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "five_cups_seven_pentacles",
    "reading_name": "Петица Чаши + Седмица Пентакли",
    "reading_cards": "Петица Чаши + Седмица Пентакли",
    "reading_combination": ["five_cups", "seven_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Седмица Пентакли – търпение и чакане. Тъгата изисква търпение. Не очаквайте бързо възстановяване. Бавно, но сигурно ще заздравеете.",
    "reading_description": "Тъгата изисква търпение. Не очаквай бързо възстановяване.",
    "reading_advice": "Чакай търпеливо. Времето лекува. Не форсирай изцелението – то идва бавно, но сигурно."
  },
  {
    "reading_id": "five_cups_eight_pentacles",
    "reading_name": "Петица Чаши + Осмица Пентакли",
    "reading_cards": "Петица Чаши + Осмица Пентакли",
    "reading_combination": ["five_cups", "eight_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Осмица Пентакли – усърдие и учене. Ученето може да ви помогне да преодолеете тъгата. Вложете енергия в ново умение или хоби.",
    "reading_description": "Ученето може да ти помогне да преодолееш тъгата.",
    "reading_advice": "Използвай времето на тъга, за да се учиш. Новото знание може да донесе нова радост."
  },
  {
    "reading_id": "five_cups_nine_pentacles",
    "reading_name": "Петица Чаши + Деветка Пентакли",
    "reading_cards": "Петица Чаши + Деветка Пентакли",
    "reading_combination": ["five_cups", "nine_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Деветка Пентакли – самодостатъчност и успех. Въпреки загубата, запазвате независимост. Гордейте се със себе си – успявате да продължите напред.",
    "reading_description": "Въпреки загубата, запазваш независимост.",
    "reading_advice": "Ти си силен. Гордей се, че продължаваш напред въпреки тъгата. Независимостта ти е сила."
  },
  {
    "reading_id": "five_cups_ten_pentacles",
    "reading_name": "Петица Чаши + Десетка Пентакли",
    "reading_cards": "Петица Чаши + Десетка Пентакли",
    "reading_combination": ["five_cups", "ten_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Десетка Пентакли – семейно наследство и богатство. Загуба в семейството – но семейството остава опора. Дръжте се заедно.",
    "reading_description": "Загуба в семейството – но семейството остава опора.",
    "reading_advice": "Дръжте се заедно. Семейството е най-силно, когато е заедно в тъгата. Традициите и споделените спомени лекуват."
  },
  {
    "reading_id": "five_cups_page_pentacles",
    "reading_name": "Петица Чаши + Паж Пентакли",
    "reading_cards": "Петица Чаши + Паж Пентакли",
    "reading_combination": ["five_cups", "page_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Паж Пентакли – нова възможност и учене. Нова възможност се появява в момент на тъга. Тя може да донесе нова цел и надежда.",
    "reading_description": "Нова възможност се появява в момент на тъга.",
    "reading_advice": "Хвани възможността. Тя може да донесе нова цел и надежда в тъжния момент."
  },
  {
    "reading_id": "five_cups_knight_pentacles",
    "reading_name": "Петица Чаши + Рицар Пентакли",
    "reading_cards": "Петица Чаши + Рицар Пентакли",
    "reading_combination": ["five_cups", "knight_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Рицар Пентакли – бавен и сигурен напредък. Излизането от тъгата няма да стане бързо. Бавно, но сигурно – стъпка по стъпка.",
    "reading_description": "Излизането от тъгата няма да стане бързо. Бавно, но сигурно.",
    "reading_advice": "Не очаквай бързо изцеление. Движи се бавно, но сигурно. Всяка малка стъпка напред има значение."
  },
  {
    "reading_id": "five_cups_queen_pentacles",
    "reading_name": "Петица Чаши + Царица Пентакли",
    "reading_cards": "Петица Чаши + Царица Пентакли",
    "reading_combination": ["five_cups", "queen_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Царица Пентакли – грижа и дом. Грижете се за дома и семейството – те са вашата опора в тъгата. Но не забравяйте и себе си.",
    "reading_description": "Грижи се за дома и семейството – те са опора в тъгата.",
    "reading_advice": "Грижи се за дома, но не забравяй и себе си. Тъгата изисква време и грижа и за теб."
  },
  {
    "reading_id": "five_cups_king_pentacles",
    "reading_name": "Петица Чаши + Цар Пентакли",
    "reading_cards": "Петица Чаши + Цар Пентакли",
    "reading_combination": ["five_cups", "king_pentacles"],
    "reading_meaning": "Петица Чаши носи загуба и тъга, а Цар Пентакли – стабилност и успех. Въпреки загубата, имате стабилна основа. Използвайте я, за да се изправите и да продължите напред.",
    "reading_description": "Въпреки загубата, имаш стабилна основа.",
    "reading_advice": "Използвай стабилността, която имаш. Тя ще ти помогне да се изправиш след загубата и да продължиш напред."
  },
    {
    "reading_id": "six_cups_two_wands",
    "reading_name": "Шестица Чаши + Двойка Жезли",
    "reading_cards": "Шестица Чаши + Двойка Жезли",
    "reading_combination": ["six_cups", "two_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Двойка Жезли – избор и планиране. Предстои ви избор, свързан с миналото – завръщане на стар човек или ситуация. Носталгия и решение. Миналото е учител, не водач.",
    "reading_description": "Избор, свързан с миналото. Носталгия и решение.",
    "reading_advice": "Вземи наученото от миналото, но гледай напред. Изборът трябва да служи на бъдещето ти."
  },
  {
    "reading_id": "six_cups_three_wands",
    "reading_name": "Шестица Чаши + Тройка Жезли",
    "reading_cards": "Шестица Чаши + Тройка Жезли",
    "reading_combination": ["six_cups", "three_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Тройка Жезли – очакване и разширяване. Очаквате завръщане на някого или нещо от миналото. Носталгия и надежда. Бъдете готови да посрещнете миналото, но не спирайте да живеете в настоящето.",
    "reading_description": "Очакваш завръщане от миналото. Носталгия и надежда.",
    "reading_advice": "Бъди готов да посрещнеш миналото, но не спирай да живееш в настоящето."
  },
  {
    "reading_id": "six_cups_four_wands",
    "reading_name": "Шестица Чаши + Четворка Жезли",
    "reading_cards": "Шестица Чаши + Четворка Жезли",
    "reading_combination": ["six_cups", "four_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Четворка Жезли – празник и стабилност. Празник, на който се събират стари приятели или семейство. Носталгия, спомени, топлина. Завръщане към корените.",
    "reading_description": "Празник, на който се събират стари приятели. Носталгия и радост.",
    "reading_advice": "Цени тези моменти. Те са безценни. Старите приятели са като вино – с времето стават по-добри."
  },
  {
    "reading_id": "six_cups_five_wands",
    "reading_name": "Шестица Чаши + Петица Жезли",
    "reading_cards": "Шестица Чаши + Петица Жезли",
    "reading_combination": ["six_cups", "five_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Петица Жезли – конфликт и съперничество. Стар конфликт от миналото излиза отново на повърхността. Неразрешени сметки. Оставете миналото – то не заслужава нова битка.",
    "reading_description": "Стар конфликт от миналото излиза отново. Неразрешени сметки.",
    "reading_advice": "Остави миналото. То не заслужава нова битка. Наученото – вземи, болката – остави."
  },
  {
    "reading_id": "six_cups_six_wands",
    "reading_name": "Шестица Чаши + Шестица Жезли",
    "reading_cards": "Шестица Чаши + Шестица Жезли",
    "reading_combination": ["six_cups", "six_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Шестица Жезли – победа и признание. Получавате признание за нещо, което сте направили в миналото. Закъснял, но заслужен успех. По-добре късно, отколкото никога.",
    "reading_description": "Признание за нещо от миналото. Закъснял, но заслужен успех.",
    "reading_advice": "По-добре късно, отколкото никога. Приеми признанието с благодарност и продължи напред."
  },
  {
    "reading_id": "six_cups_seven_wands",
    "reading_name": "Шестица Чаши + Седмица Жезли",
    "reading_cards": "Шестица Чаши + Седмица Жезли",
    "reading_combination": ["six_cups", "seven_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Седмица Жезли – защита на позицията. Трябва да защитавате спомените и миналото си от хора, които искат да ги омаловажат. Спомените са твои – никой няма право да ти ги отнема.",
    "reading_description": "Защитаваш спомените си от хора, които искат да ги омаловажат.",
    "reading_advice": "Пази спомените си. Те са твои. Никой няма право да ти ги отнема."
  },
  {
    "reading_id": "six_cups_eight_wands",
    "reading_name": "Шестица Чаши + Осмица Жезли",
    "reading_cards": "Шестица Чаши + Осмица Жезли",
    "reading_combination": ["six_cups", "eight_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Осмица Жезли – бързина и движение. Спомен от миналото идва внезапно и неочаквано. Носталгия, която връхлита. Приеми спомена, после продължи напред.",
    "reading_description": "Спомен идва внезапно. Носталгия връхлита.",
    "reading_advice": "Приеми спомена, после продължи напред. Не позволявай на носталгията да те държи в миналото."
  },
  {
    "reading_id": "six_cups_nine_wands",
    "reading_name": "Шестица Чаши + Деветка Жезли",
    "reading_cards": "Шестица Чаши + Деветка Жезли",
    "reading_combination": ["six_cups", "nine_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Деветка Жезли – устойчивост и изтощение. Носталгията и спомените те изтощават емоционално. Миналото тежи. Остави миналото – то не заслужава енергията ти.",
    "reading_description": "Носталгията и спомените те изтощават. Миналото тежи.",
    "reading_advice": "Остави миналото. То не заслужава енергията ти. Спомените са хубави, но не трябва да те изтощават."
  },
  {
    "reading_id": "six_cups_ten_wands",
    "reading_name": "Шестица Чаши + Десетка Жезли",
    "reading_cards": "Шестица Чаши + Десетка Жезли",
    "reading_combination": ["six_cups", "ten_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Десетка Жезли – претоварване и бреме. Носите тежестта на минали спомени и преживявания. Миналото тежи. Освободете се от ненужното бреме.",
    "reading_description": "Носиш тежестта на минали спомени. Миналото тежи.",
    "reading_advice": "Освободи се от бремето на миналото. Не можеш да носиш всичко със себе си."
  },
  {
    "reading_id": "six_cups_page_wands",
    "reading_name": "Шестица Чаши + Паж Жезли",
    "reading_cards": "Шестица Чаши + Паж Жезли",
    "reading_combination": ["six_cups", "page_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Паж Жезли – новини и ентусиазъм. Получавате вест, свързана с миналото – може би някой от миналото се свързва. Носталгия и надежда.",
    "reading_description": "Вест, свързана с миналото – някой се свързва.",
    "reading_advice": "Отвори се за новината. Тя носи нещо ценно за теб."
  },
  {
    "reading_id": "six_cups_knight_wands",
    "reading_name": "Шестица Чаши + Рицар Жезли",
    "reading_cards": "Шестица Чаши + Рицар Жезли",
    "reading_combination": ["six_cups", "knight_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Рицар Жезли – импулсивност и бързина. Някой от миналото идва бързо и неочаквано. Бъдете готови да го посрещнете, но не позволявайте на импулсивността да ви завладее.",
    "reading_description": "Някой от миналото идва бързо и неочаквано.",
    "reading_advice": "Посрещни, но не позволявай на импулсивността да те завладее. Дай си време да помислиш."
  },
  {
    "reading_id": "six_cups_queen_wands",
    "reading_name": "Шестица Чаши + Царица Жезли",
    "reading_cards": "Шестица Чаши + Царица Жезли",
    "reading_combination": ["six_cups", "queen_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Царица Жезли – увереност и харизма. Носталгията ви кара да се чувствате уверени в корените си. Вашата топлина идва от спомените за дома.",
    "reading_description": "Носталгията те кара да се чувстваш уверен в корените си.",
    "reading_advice": "Използвай спомените като източник на увереност. Корените ти са твоята сила."
  },
  {
    "reading_id": "six_cups_king_wands",
    "reading_name": "Шестица Чаши + Цар Жезли",
    "reading_cards": "Шестица Чаши + Цар Жезли",
    "reading_combination": ["six_cups", "king_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Цар Жезли – лидерство и визия. Вие сте лидер, който черпи сила от миналото. Вашата визия е основана на опита, който сте придобили.",
    "reading_description": "Ти си лидер, който черпи сила от миналото.",
    "reading_advice": "Използвай миналото като основа за визията си. Опитът ти е най-добрият учител."
  },
  {
    "reading_id": "six_cups_ace_wands",
    "reading_name": "Шестица Чаши + Асо Жезли",
    "reading_cards": "Шестица Чаши + Асо Жезли",
    "reading_combination": ["six_cups", "ace_wands"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Асо Жезли – ново начало и вдъхновение. Ново начало, което носи спомени от миналото. Искрата е запалена от нещо познато. Творете новото с опита на старото.",
    "reading_description": "Ново начало, което носи спомени от миналото.",
    "reading_advice": "Хвани искрата. Творете новото с опита на старото. Миналото може да вдъхнови бъдещето."
  },
  {
    "reading_id": "six_cups_ace_cups",
    "reading_name": "Шестица Чаши + Асо Чаши",
    "reading_cards": "Шестица Чаши + Асо Чаши",
    "reading_combination": ["six_cups", "ace_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Асо Чаши – нови чувства и любов. Нова любов, която ви напомня за миналото. Познато чувство, но ново начало. Отворете сърцето си.",
    "reading_description": "Нова любов, която напомня за миналото. Познато, но ново.",
    "reading_advice": "Отвори сърцето си. Познатото чувство може да доведе до нова, истинска любов."
  },
  {
    "reading_id": "six_cups_two_cups",
    "reading_name": "Шестица Чаши + Двойка Чаши",
    "reading_cards": "Шестица Чаши + Двойка Чаши",
    "reading_combination": ["six_cups", "two_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Двойка Чаши – любов и връзка. Завръщане на стара любов или приятелство. Връзка от миналото се възражда. Носталгия и надежда.",
    "reading_description": "Завръщане на стара любов или приятелство. Връзка от миналото се възражда.",
    "reading_advice": "Бъди отворен, но гледай с реализъм. Хората се променят, но понякога някои връзки са вечни."
  },
  {
    "reading_id": "six_cups_three_cups",
    "reading_name": "Шестица Чаши + Тройка Чаши",
    "reading_cards": "Шестица Чаши + Тройка Чаши",
    "reading_combination": ["six_cups", "three_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Тройка Чаши – празник и радост. Събиране на стари приятели или семейство. Носталгия, спомени, топлина. Завръщане към корените.",
    "reading_description": "Събиране на стари приятели. Носталгия и радост.",
    "reading_advice": "Цени тези моменти. Те са безценни. Старите приятели са като вино – с времето стават по-добри."
  },
  {
    "reading_id": "six_cups_four_cups",
    "reading_name": "Шестица Чаши + Четворка Чаши",
    "reading_cards": "Шестица Чаши + Четворка Чаши",
    "reading_combination": ["six_cups", "four_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Четворка Чаши – апатия и неудовлетворение. Носталгията ви прави неудовлетворени от настоящето. Не живейте в миналото – то не може да се върне.",
    "reading_description": "Носталгията те прави неудовлетворен от настоящето.",
    "reading_advice": "Миналото е учител, не водач. Вземи наученото, но гледай напред. Настоящето заслужава вниманието ти."
  },
  {
    "reading_id": "six_cups_five_cups",
    "reading_name": "Шестица Чаши + Петица Чаши",
    "reading_cards": "Шестица Чаши + Петица Чаши",
    "reading_combination": ["six_cups", "five_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Петица Чаши – загуба и тъга. Носталгия по нещо, което сте загубили. Спомените за загубата ви тъжат. Позволете си да скърбите, но не оставайте там.",
    "reading_description": "Носталгия по нещо, което си загубил. Спомените тъжат.",
    "reading_advice": "Позволи си да скърбиш, но не оставай в миналото. Загубата е част от живота – продължи напред."
  },
 
  {
    "reading_id": "six_cups_seven_cups",
    "reading_name": "Шестица Чаши + Седмица Чаши",
    "reading_cards": "Шестица Чаши + Седмица Чаши",
    "reading_combination": ["six_cups", "seven_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Седмица Чаши – илюзии и фантазии. Илюзорни представи за миналото. Спомените не винаги са точни – не идеализирайте миналото.",
    "reading_description": "Илюзорни представи за миналото. Не идеализирай.",
    "reading_advice": "Свали розовите очила. Спомените не винаги са точни. Реалността е по-ценна от идеализираното минало."
  },
  {
    "reading_id": "six_cups_eight_cups",
    "reading_name": "Шестица Чаши + Осмица Чаши",
    "reading_cards": "Шестица Чаши + Осмица Чаши",
    "reading_combination": ["six_cups", "eight_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Осмица Чаши – тръгване и оставяне. Решавате да оставите миналото зад гърба си и да тръгнете напред. Смела стъпка към свободата.",
    "reading_description": "Решаваш да оставиш миналото и да тръгнеш напред.",
    "reading_advice": "Тръгни смело. Миналото те държеше – сега си свободен да вървиш напред."
  },
  {
    "reading_id": "six_cups_nine_cups",
    "reading_name": "Шестица Чаши + Деветка Чаши",
    "reading_cards": "Шестица Чаши + Деветка Чаши",
    "reading_combination": ["six_cups", "nine_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Деветка Чаши – сбъднато желание. Мечта от миналото се сбъдва. Носталгия и удовлетворение. По-добре късно, отколкото никога.",
    "reading_description": "Мечта от миналото се сбъдва. Носталгия и удовлетворение.",
    "reading_advice": "Наслади се на момента. Някои мечти заслужават да изчакаш. По-добре късно, отколкото никога."
  },
  {
    "reading_id": "six_cups_ten_cups",
    "reading_name": "Шестица Чаши + Десетка Чаши",
    "reading_cards": "Шестица Чаши + Десетка Чаши",
    "reading_combination": ["six_cups", "ten_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Десетка Чаши – семейно щастие. Семейна среща, която носи спомени и носталгия. Завръщане към корените, към семейството. Ценете тези моменти.",
    "reading_description": "Семейна среща, която носи спомени. Завръщане към корените.",
    "reading_advice": "Цени корените си. Те са основата на семейството. Тези моменти са безценни."
  },
  {
    "reading_id": "six_cups_page_cups",
    "reading_name": "Шестица Чаши + Паж Чаши",
    "reading_cards": "Шестица Чаши + Паж Чаши",
    "reading_combination": ["six_cups", "page_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Паж Чаши – емоционално послание. Получавате нежно послание от някого от миналото. Отворете сърцето си за него.",
    "reading_description": "Нежно послание от някого от миналото идва.",
    "reading_advice": "Отвори сърцето си за посланието. То носи спомени и топлина."
  },
  {
    "reading_id": "six_cups_knight_cups",
    "reading_name": "Шестица Чаши + Рицар Чаши",
    "reading_cards": "Шестица Чаши + Рицар Чаши",
    "reading_combination": ["six_cups", "knight_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Рицар Чаши – романтика и ухажване. Романтичен жест от някого от миналото. Стара любов се завръща с романтично предложение.",
    "reading_description": "Романтичен жест от някого от миналото. Стара любов се завръща.",
    "reading_advice": "Позволи на любовта да влезе. Някои истории заслужават втори шанс."
  },
  {
    "reading_id": "six_cups_queen_cups",
    "reading_name": "Шестица Чаши + Царица Чаши",
    "reading_cards": "Шестица Чаши + Царица Чаши",
    "reading_combination": ["six_cups", "queen_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Царица Чаши – интуиция и емпатия. Интуицията ви води към спомени, които имат значение. Слушайте сърцето си – то знае кои спомени са важни.",
    "reading_description": "Интуицията води към спомени, които имат значение.",
    "reading_advice": "Довери се на интуицията си. Тя знае кои спомени да цениш и кои да оставиш."
  },
  {
    "reading_id": "six_cups_king_cups",
    "reading_name": "Шестица Чаши + Цар Чаши",
    "reading_cards": "Шестица Чаши + Цар Чаши",
    "reading_combination": ["six_cups", "king_cups"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Цар Чаши – емоционална зрялост и баланс. Поглеждате назад с мъдрост и спокойствие. Носталгия без болка – зряло приемане на миналото.",
    "reading_description": "Поглеждаш назад с мъдрост и спокойствие. Носталгия без болка.",
    "reading_advice": "Приеми миналото с мъдрост. То те направи това, което си днес. Благодари му и продължи напред."
  },
  {
    "reading_id": "six_cups_two_swords",
    "reading_name": "Шестица Чаши + Двойка Мечове",
    "reading_cards": "Шестица Чаши + Двойка Мечове",
    "reading_combination": ["six_cups", "two_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Двойка Мечове – нерешителност и съмнение. Съмнявате се дали да се върнете към миналото или да продължите напред. Свалете превръзката – вижте истината.",
    "reading_description": "Съмняваш се дали да се върнеш към миналото или да продължиш напред.",
    "reading_advice": "Свали превръзката. Истината ще ти покаже пътя. Понякога най-добрият начин да вървиш напред е да приемеш миналото."
  },
  {
    "reading_id": "six_cups_three_swords",
    "reading_name": "Шестица Чаши + Тройка Мечове",
    "reading_cards": "Шестица Чаши + Тройка Мечове",
    "reading_combination": ["six_cups", "three_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Тройка Мечове – болка и разбито сърце. Спомените носят болка. Някои спомени трябва да оставим, за да оздравеем. Позволете си да скърбите, после продължете.",
    "reading_description": "Спомените носят болка. Някои спомени трябва да оставиш.",
    "reading_advice": "Позволи си да скърбиш, после продължи. Не всички спомени заслужават да ги носиш."
  },
    {
    "reading_id": "six_cups_four_swords",
    "reading_name": "Шестица Чаши + Четворка Мечове",
    "reading_cards": "Шестица Чаши + Четворка Мечове",
    "reading_combination": ["six_cups", "four_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Четворка Мечове – почивка и уединение. Имате нужда от почивка, за да обработите спомените си. Уединението може да ви помогне да намерите мир с миналото.",
    "reading_description": "Имаш нужда от почивка, за да обработиш спомените си.",
    "reading_advice": "Почини си. Уединението може да ти помогне да намериш мир с миналото."
  },
  {
    "reading_id": "six_cups_five_swords",
    "reading_name": "Шестица Чаши + Петица Мечове",
    "reading_cards": "Шестица Чаши + Петица Мечове",
    "reading_combination": ["six_cups", "five_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Петица Мечове – конфликт и празна победа. Стар конфликт от миналото излиза, но победата ще бъде празна. Не си струва да се връщаш.",
    "reading_description": "Стар конфликт от миналото излиза, но победата ще бъде празна.",
    "reading_advice": "Не си струва да се връщаш. Остави миналото – то не заслужава нова битка."
  },
  {
    "reading_id": "six_cups_six_swords",
    "reading_name": "Шестица Чаши + Шестица Мечове",
    "reading_cards": "Шестица Чаши + Шестица Мечове",
    "reading_combination": ["six_cups", "six_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Шестица Мечове – пътуване и преход. Пътуване, което ви връща към корените или към спомени. Завръщане на място от миналото. Носталгично пътешествие.",
    "reading_description": "Пътуване, което те връща към корените. Носталгично пътешествие.",
    "reading_advice": "Пътувай с отворено сърце. Новите места могат да събудят стари спомени. Приеми ги с благодарност."
  },
  {
    "reading_id": "six_cups_seven_swords",
    "reading_name": "Шестица Чаши + Седмица Мечове",
    "reading_cards": "Шестица Чаши + Седмица Мечове",
    "reading_combination": ["six_cups", "seven_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Седмица Мечове – измама и хитрост. Внимавайте – някой от миналото може да се опита да ви измами. Не всички спомени са красиви – някои крият измама.",
    "reading_description": "Някой от миналото може да се опита да те измами.",
    "reading_advice": "Пази се. Не всички спомени са красиви – някои крият измама. Проверявай фактите."
  },
  {
    "reading_id": "six_cups_eight_swords",
    "reading_name": "Шестица Чаши + Осмица Мечове",
    "reading_cards": "Шестица Чаши + Осмица Мечове",
    "reading_combination": ["six_cups", "eight_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Осмица Мечове – чувство на капан и ограничение. Чувствате се в капан от спомените си. Оковите са в главата ви – миналото не трябва да ви държи в плен.",
    "reading_description": "Чувстваш се в капан от спомените си. Оковите са в главата ти.",
    "reading_advice": "Освободи се от страха. Миналото не трябва да те държи в плен. Имаш повече възможности, отколкото си мислиш."
  },
  {
    "reading_id": "six_cups_nine_swords",
    "reading_name": "Шестица Чаши + Деветка Мечове",
    "reading_cards": "Шестица Чаши + Деветка Мечове",
    "reading_combination": ["six_cups", "nine_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Деветка Мечове – тревога и безсъние. Спомените ви причиняват тревога и безсъние. Мислите ви се въртят около миналото. Тревогите ви измъчват.",
    "reading_description": "Спомените ти причиняват тревога и безсъние. Мислите се въртят.",
    "reading_advice": "Спокойствие. Мислите ти не са реалност. Потърси помощ, ако тревогата те завладява. Не позволявай на миналото да краде настоящето ти."
  },
  {
    "reading_id": "six_cups_ten_swords",
    "reading_name": "Шестица Чаши + Десетка Мечове",
    "reading_cards": "Шестица Чаши + Десетка Мечове",
    "reading_combination": ["six_cups", "ten_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Десетка Мечове – край и дъно. Периодът на носталгия приключва. Краят носи освобождение. Оставете миналото зад гърба си – то вече не тежи.",
    "reading_description": "Периодът на носталгия приключва. Краят носи освобождение.",
    "reading_advice": "Остави миналото зад гърба си. Това, което е свършило, вече не тежи. Гледай напред."
  },
  {
    "reading_id": "six_cups_page_swords",
    "reading_name": "Шестица Чаши + Паж Мечове",
    "reading_cards": "Шестица Чаши + Паж Мечове",
    "reading_combination": ["six_cups", "page_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Паж Мечове – търсене на истината. Истината за нещо от миналото излиза наяве. Бъдете отворени за прозренията, които идват.",
    "reading_description": "Истината за нещо от миналото излиза наяве.",
    "reading_advice": "Търси истината. Тя може да ти помогне да разбереш миналото и да го оставиш зад гърба си."
  },
  {
    "reading_id": "six_cups_knight_swords",
    "reading_name": "Шестица Чаши + Рицар Мечове",
    "reading_cards": "Шестица Чаши + Рицар Мечове",
    "reading_combination": ["six_cups", "knight_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Рицар Мечове – бързина и прямота. Истината за миналото идва бързо и рязко. Бъдете готови да я приемете, колкото и да боли.",
    "reading_description": "Истината за миналото идва бързо и рязко. Бъди готов.",
    "reading_advice": "Приеми истината с отворено сърце. Тя може да те освободи от миналото."
  },
  {
    "reading_id": "six_cups_queen_swords",
    "reading_name": "Шестица Чаши + Царица Мечове",
    "reading_cards": "Шестица Чаши + Царица Мечове",
    "reading_combination": ["six_cups", "queen_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Царица Мечове – яснота и независимост. Виждате миналото ясно, без илюзии. Яснотата, колкото и да е сурова, ви позволява да продължите напред.",
    "reading_description": "Виждаш миналото ясно, без илюзии.",
    "reading_advice": "Бъди честен със себе си. Яснотата, колкото и да е сурова, те освобождава от миналото."
  },
  {
    "reading_id": "six_cups_king_swords",
    "reading_name": "Шестица Чаши + Цар Мечове",
    "reading_cards": "Шестица Чаши + Цар Мечове",
    "reading_combination": ["six_cups", "king_swords"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Цар Мечове – интелект и стратегия. С логика и анализ можете да разберете миналото и да извлечете уроци от него. Използвайте ума си, за да осмислите спомените.",
    "reading_description": "С логика и анализ можеш да разбереш миналото и да извлечеш уроци.",
    "reading_advice": "Използвай ума си. Анализът може да ти помогне да осмислиш спомените и да продължиш напред."
  },
  {
    "reading_id": "six_cups_two_pentacles",
    "reading_name": "Шестица Чаши + Двойка Пентакли",
    "reading_cards": "Шестица Чаши + Двойка Пентакли",
    "reading_combination": ["six_cups", "two_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Двойка Пентакли – баланс и жонглиране. Опитвате се да балансирате спомените с настоящето. Жонглирайте внимателно – не изпускайте себе си.",
    "reading_description": "Опитваш се да балансираш спомените с настоящето.",
    "reading_advice": "Балансирай, но не изпускай себе си. Спомените са важни, но настоящето заслужава вниманието ти."
  },
  {
    "reading_id": "six_cups_three_pentacles",
    "reading_name": "Шестица Чаши + Тройка Пентакли",
    "reading_cards": "Шестица Чаши + Тройка Пентакли",
    "reading_combination": ["six_cups", "three_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Тройка Пентакли – екипна работа и сътрудничество. Заедно с екипа или семейството се връщате към стари проекти или спомени. Носталгия, която може да вдъхнови новото.",
    "reading_description": "Заедно с екипа се връщате към стари проекти.",
    "reading_advice": "Използвайте миналото като вдъхновение, но гледайте напред. Заедно можете да създадете нещо ново от старото."
  },
  {
    "reading_id": "six_cups_four_pentacles",
    "reading_name": "Шестица Чаши + Четворка Пентакли",
    "reading_cards": "Шестица Чаши + Четворка Пентакли",
    "reading_combination": ["six_cups", "four_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Четворка Пентакли – сигурност и стискане. Държите се за стари вещи и спомени от страх да не ги загубите. Пуснете – спомените са в сърцето, не в нещата.",
    "reading_description": "Държиш се за стари вещи и спомени от страх да не ги загубиш.",
    "reading_advice": "Пусни. Спомените са в сърцето, не в нещата. Освободи място за новото."
  },
  {
    "reading_id": "six_cups_five_pentacles",
    "reading_name": "Шестица Чаши + Петица Пентакли",
    "reading_cards": "Шестица Чаши + Петица Пентакли",
    "reading_combination": ["six_cups", "five_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Петица Пентакли – финансови трудности и липса. Спомени за по-добри финансови времена ви тъжат. Не живейте в миналото – фокусирайте се върху настоящето.",
    "reading_description": "Спомени за по-добри финансови времена те тъжат.",
    "reading_advice": "Не живей в миналото. Фокусирай се върху настоящето и какво можеш да направиш сега."
  },
  {
    "reading_id": "six_cups_six_pentacles",
    "reading_name": "Шестица Чаши + Шестица Пентакли",
    "reading_cards": "Шестица Чаши + Шестица Пентакли",
    "reading_combination": ["six_cups", "six_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Шестица Пентакли – помощ и щедрост. Някой от миналото идва да ви помогне. Стар приятел или роднина протяга ръка. Приемете помощта с благодарност.",
    "reading_description": "Някой от миналото идва да ти помогне. Стар приятел протяга ръка.",
    "reading_advice": "Приеми помощта с благодарност. Някои връзки са вечни."
  },
  {
    "reading_id": "six_cups_seven_pentacles",
    "reading_name": "Шестица Чаши + Седмица Пентакли",
    "reading_cards": "Шестица Чаши + Седмица Пентакли",
    "reading_combination": ["six_cups", "seven_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Седмица Пентакли – търпение и чакане. Инвестиция от миналото започва да дава плодове. Търпението ви се отплаща. Чакайте още малко.",
    "reading_description": "Инвестиция от миналото започва да дава плодове.",
    "reading_advice": "Чакай търпеливо. Плодовете на миналите усилия скоро ще узреят."
  },
  {
    "reading_id": "six_cups_eight_pentacles",
    "reading_name": "Шестица Чаши + Осмица Пентакли",
    "reading_cards": "Шестица Чаши + Осмица Пентакли",
    "reading_combination": ["six_cups", "eight_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Осмица Пентакли – усърдие и учене. Връщате се към старо хоби или умение. Старите умения могат да получат нов живот. Учете се от миналото.",
    "reading_description": "Връщаш се към старо хоби или умение. Старите умения получават нов живот.",
    "reading_advice": "Използвай миналото като вдъхновение. Старите умения могат да ти донесат нова радост."
  },
  {
    "reading_id": "six_cups_nine_pentacles",
    "reading_name": "Шестица Чаши + Деветка Пентакли",
    "reading_cards": "Шестица Чаши + Деветка Пентакли",
    "reading_combination": ["six_cups", "nine_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Деветка Пентакли – самодостатъчност и успех. Успехът ви напомня за корените ви. Носталгия и благодарност към миналото, което ви доведе тук.",
    "reading_description": "Успехът ти напомня за корените ти. Благодарност към миналото.",
    "reading_advice": "Благодари на миналото, което те доведе тук. Но гледай напред."
  },
  {
    "reading_id": "six_cups_ten_pentacles",
    "reading_name": "Шестица Чаши + Десетка Пентакли",
    "reading_cards": "Шестица Чаши + Десетка Пентакли",
    "reading_combination": ["six_cups", "ten_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Десетка Пентакли – семейно наследство и богатство. Семейно наследство или традиция от миналото. Завръщане към корените, към семейната история.",
    "reading_description": "Семейно наследство или традиция от миналото. Завръщане към корените.",
    "reading_advice": "Цени корените си. Семейната история е твоето наследство. Предай я нататък."
  },
  {
    "reading_id": "six_cups_page_pentacles",
    "reading_name": "Шестица Чаши + Паж Пентакли",
    "reading_cards": "Шестица Чаши + Паж Пентакли",
    "reading_combination": ["six_cups", "page_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Паж Пентакли – нова възможност и учене. Нова възможност, свързана с нещо от миналото. Старо хоби може да стане нова професия. Шанс да се върнете към корените си.",
    "reading_description": "Нова възможност, свързана с нещо от миналото.",
    "reading_advice": "Хвани възможността. Старото може да стане ново и вълнуващо."
  },
  {
    "reading_id": "six_cups_knight_pentacles",
    "reading_name": "Шестица Чаши + Рицар Пентакли",
    "reading_cards": "Шестица Чаши + Рицар Пентакли",
    "reading_combination": ["six_cups", "knight_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Рицар Пентакли – бавен и сигурен напредък. Бавно, но сигурно се връщате към нещо от миналото. Търпение – старите пътища понякога водят до нови дестинации.",
    "reading_description": "Бавно, но сигурно се връщаш към нещо от миналото.",
    "reading_advice": "Не бързай. Старите пътища понякога водят до нови дестинации. Движи се бавно, но сигурно."
  },
  {
    "reading_id": "six_cups_queen_pentacles",
    "reading_name": "Шестица Чаши + Царица Пентакли",
    "reading_cards": "Шестица Чаши + Царица Пентакли",
    "reading_combination": ["six_cups", "queen_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Царица Пентакли – грижа и дом. Грижите за дома ви напомнят за семейните традиции. Носталгия и топлина. Грижете се за дома като за наследство.",
    "reading_description": "Грижите за дома ти напомнят за семейните традиции. Носталгия и топлина.",
    "reading_advice": "Грижи се за дома като за наследство. Традициите са важни, но създавай и нови спомени."
  },
  {
    "reading_id": "six_cups_king_pentacles",
    "reading_name": "Шестица Чаши + Цар Пентакли",
    "reading_cards": "Шестица Чаши + Цар Пентакли",
    "reading_combination": ["six_cups", "king_pentacles"],
    "reading_meaning": "Шестица Чаши носи спомени и носталгия, а Цар Пентакли – стабилност и успех. Успехът ви е изграден върху стабилна основа от миналото. Благодарете на корените си, но гледайте напред.",
    "reading_description": "Успехът ти е изграден върху стабилна основа от миналото.",
    "reading_advice": "Благодари на корените си. Те са основата на твоя успех. Но гледай напред и гради върху тях."
  },
    {
    "reading_id": "seven_cups_two_wands",
    "reading_name": "Седмица Чаши + Двойка Жезли",
    "reading_cards": "Седмица Чаши + Двойка Жезли",
    "reading_combination": ["seven_cups", "two_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Двойка Жезли – избор и планиране. Много възможности, но повечето са илюзорни. Трудно различавате истината от фантазията. Свалете розовите очила, преди да изберете.",
    "reading_description": "Много възможности, но повечето са илюзорни. Трудно различаваш истината.",
    "reading_advice": "Свали розовите очила, преди да избереш. Реалността е по-ценна от фантазията."
  },
  {
    "reading_id": "seven_cups_three_wands",
    "reading_name": "Седмица Чаши + Тройка Жезли",
    "reading_cards": "Седмица Чаши + Тройка Жезли",
    "reading_combination": ["seven_cups", "three_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Тройка Жезли – очакване и разширяване. Очаквате нещо, което вероятно не е реално. Илюзиите замъгляват перспективата. Слез на земята.",
    "reading_description": "Очакваш нещо, което вероятно не е реално. Илюзиите замъгляват перспективата.",
    "reading_advice": "Слез на земята. Това, което очакваш, може да не е истина. Бъди реалист."
  },
  {
    "reading_id": "seven_cups_four_wands",
    "reading_name": "Седмица Чаши + Четворка Жезли",
    "reading_cards": "Седмица Чаши + Четворка Жезли",
    "reading_combination": ["seven_cups", "four_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Четворка Жезли – празник и стабилност. Празнувате нещо, което може да е илюзия. Радост, която може да е временна. Проверете дали празнувате истинско постижение.",
    "reading_description": "Празнуваш нещо, което може да е илюзия. Провери дали е истинско.",
    "reading_advice": "Провери дали това, което празнуваш, е реално. Не се залъгвай с илюзорна радост."
  },
  {
    "reading_id": "seven_cups_five_wands",
    "reading_name": "Седмица Чаши + Петица Жезли",
    "reading_cards": "Седмица Чаши + Петица Жезли",
    "reading_combination": ["seven_cups", "five_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Петица Жезли – конфликт и съперничество. Борите се с илюзии или страхове, които съществуват само в главата ви. Най-големите битки са в ума ни. Освободете се.",
    "reading_description": "Бориш се с илюзии или страхове, които съществуват само в главата ти.",
    "reading_advice": "Най-големите битки са в ума ни. Освободи се. Повечето врагове, с които се бием, са въображаеми."
  },
  {
    "reading_id": "seven_cups_six_wands",
    "reading_name": "Седмица Чаши + Шестица Жезли",
    "reading_cards": "Седмица Чаши + Шестица Жезли",
    "reading_combination": ["seven_cups", "six_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Шестица Жезли – победа и признание. Мислите, че сте успели, но може да е илюзия. Проверете реалността – истинският успех е реален, не въображаем.",
    "reading_description": "Мислиш, че си успял, но може да е илюзия. Провери реалността.",
    "reading_advice": "Не се залъгвай. Истинският успех е реален. Свали розовите очила и виж нещата такива, каквито са."
  },
  {
    "reading_id": "seven_cups_seven_wands",
    "reading_name": "Седмица Чаши + Седмица Жезли",
    "reading_cards": "Седмица Чаши + Седмица Жезли",
    "reading_combination": ["seven_cups", "seven_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Седмица Жезли – защита на позицията. Защитавате се от илюзорни заплахи. Страховете ви не са реални. Истината е най-добрата защита.",
    "reading_description": "Защитаваш се от илюзорни заплахи. Страховете ти не са реални.",
    "reading_advice": "Истината е най-добрата защита. Освободи се от илюзиите и виж реалността."
  },
  {
    "reading_id": "seven_cups_eight_wands",
    "reading_name": "Седмица Чаши + Осмица Жезли",
    "reading_cards": "Седмица Чаши + Осмица Жезли",
    "reading_combination": ["seven_cups", "eight_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Осмица Жезли – бързина и движение. Илюзиите идват бързо и ви завладяват. Внимавайте да не изгубите реалността. Слез на земята, преди да е късно.",
    "reading_description": "Илюзиите идват бързо и те завладяват. Внимавай да не изгубиш реалността.",
    "reading_advice": "Слез на земята, преди да е късно. Бързината на илюзиите може да те отнесе."
  },
  {
    "reading_id": "seven_cups_nine_wands",
    "reading_name": "Седмица Чаши + Деветка Жезли",
    "reading_cards": "Седмица Чаши + Деветка Жезли",
    "reading_combination": ["seven_cups", "nine_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Деветка Жезли – устойчивост и изтощение. Живеенето в илюзии ви е изтощило. Време е да се сблъскате с реалността. Реалността може да е по-добра от фантазиите.",
    "reading_description": "Живеенето в илюзии те е изтощило. Време е да се сблъскаш с реалността.",
    "reading_advice": "Реалността може да е по-добра от фантазиите. Свали розовите очила и виж истината."
  },
  {
    "reading_id": "seven_cups_ten_wands",
    "reading_name": "Седмица Чаши + Десетка Жезли",
    "reading_cards": "Седмица Чаши + Десетка Жезли",
    "reading_combination": ["seven_cups", "ten_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Десетка Жезли – претоварване и бреме. Носите тежестта на нереалистични очаквания и илюзии. Освободете се от товара на нереалистичните мечти.",
    "reading_description": "Носиш тежестта на нереалистични очаквания и илюзии.",
    "reading_advice": "Свали товара на нереалистичните мечти. Истинският живот е по-лек."
  },
  {
    "reading_id": "seven_cups_page_wands",
    "reading_name": "Седмица Чаши + Паж Жезли",
    "reading_cards": "Седмица Чаши + Паж Жезли",
    "reading_combination": ["seven_cups", "page_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Паж Жезли – новини и ентусиазъм. Новината, която идва, може да е илюзорна. Проверете фактите, преди да се вълнувате. Не се залъгвайте.",
    "reading_description": "Новината, която идва, може да е илюзорна. Провери фактите.",
    "reading_advice": "Провери два пъти. Не се залъгвай с привидно добри новини."
  },
  {
    "reading_id": "seven_cups_knight_wands",
    "reading_name": "Седмица Чаши + Рицар Жезли",
    "reading_cards": "Седмица Чаши + Рицар Жезли",
    "reading_combination": ["seven_cups", "knight_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Рицар Жезли – импулсивност и бързина. Импулсивно действие, водено от илюзия, може да доведе до разочарование. Забавете и помислете – реално ли е това, което искате?",
    "reading_description": "Импулсивно действие, водено от илюзия, може да доведе до разочарование.",
    "reading_advice": "Забави. Преди да действаш, провери дали това, което искаш, е реално."
  },
  {
    "reading_id": "seven_cups_queen_wands",
    "reading_name": "Седмица Чаши + Царица Жезли",
    "reading_cards": "Седмица Чаши + Царица Жезли",
    "reading_combination": ["seven_cups", "queen_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Царица Жезли – увереност и харизма. Увереността ви може да ви заслепи за реалността. Бъдете уверени, но не позволявайте на егото да ви води по илюзорен път.",
    "reading_description": "Увереността ти може да те заслепи за реалността.",
    "reading_advice": "Бъди уверен, но не позволявай на егото да те води по илюзорен път. Проверявай реалността."
  },
  {
    "reading_id": "seven_cups_king_wands",
    "reading_name": "Седмица Чаши + Цар Жезли",
    "reading_cards": "Седмица Чаши + Цар Жезли",
    "reading_combination": ["seven_cups", "king_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Цар Жезли – лидерство и визия. Вашата визия може да е илюзорна. Уверете се, че мечтите ви са постижими. Истинският лидер гради върху реалност, не върху илюзии.",
    "reading_description": "Визията ти може да е илюзорна. Увери се, че мечтите ти са постижими.",
    "reading_advice": "Истинският лидер гради върху реалност, не върху илюзии. Провери дали визията ти е осъществима."
  },
  {
    "reading_id": "seven_cups_ace_wands",
    "reading_name": "Седмица Чаши + Асо Жезли",
    "reading_cards": "Седмица Чаши + Асо Жезли",
    "reading_combination": ["seven_cups", "ace_wands"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Асо Жезли – ново начало и вдъхновение. Нова идея, която може да е илюзорна. Проверете дали искрата, която ви води, е реална. Не се залъгвайте с фалшиво вдъхновение.",
    "reading_description": "Нова идея, която може да е илюзорна. Провери дали искрата е реална.",
    "reading_advice": "Не се залъгвай с фалшиво вдъхновение. Провери дали идеята ти е осъществима."
  },
  {
    "reading_id": "seven_cups_ace_cups",
    "reading_name": "Седмица Чаши + Асо Чаши",
    "reading_cards": "Седмица Чаши + Асо Чаши",
    "reading_combination": ["seven_cups", "ace_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Асо Чаши – нови чувства и любов. Нова любов, която може да е илюзия. Влюбвате се в идея, не в човека. Свали розовите очила, преди да е късно.",
    "reading_description": "Нова любов, която може да е илюзия. Влюбваш се в идея, не в човека.",
    "reading_advice": "Свали розовите очила. Истинската любов е реална, не фантазия. Познай човека, не идеята за него."
  },
  {
    "reading_id": "seven_cups_two_cups",
    "reading_name": "Седмица Чаши + Двойка Чаши",
    "reading_cards": "Седмица Чаши + Двойка Чаши",
    "reading_combination": ["seven_cups", "two_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Двойка Чаши – любов и връзка. Връзка, която може да е илюзорна. Идеализирате партньора или връзката. Свали розовите очила – вижте човека такъв, какъвто е.",
    "reading_description": "Връзка, която може да е илюзорна. Идеализираш партньора.",
    "reading_advice": "Свали розовите очила. Истинската любов приема човека такъв, какъвто е, не какъвто искаш да бъде."
  },
  {
    "reading_id": "seven_cups_three_cups",
    "reading_name": "Седмица Чаши + Тройка Чаши",
    "reading_cards": "Седмица Чаши + Тройка Чаши",
    "reading_combination": ["seven_cups", "three_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Тройка Чаши – празник и радост. Празнувате нещо, което може да е илюзия. Радост, която може да е временна. Проверете дали празнувате истинско постижение.",
    "reading_description": "Празнуваш нещо, което може да е илюзия. Провери дали е истинско.",
    "reading_advice": "Провери дали това, което празнуваш, е реално. Не се залъгвай с илюзорна радост."
  },
  {
    "reading_id": "seven_cups_four_cups",
    "reading_name": "Седмица Чаши + Четворка Чаши",
    "reading_cards": "Седмица Чаши + Четворка Чаши",
    "reading_combination": ["seven_cups", "four_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Четворка Чаши – апатия и неудовлетворение. Живеете в илюзия, че нещо ви липсва. Истинската радост може да е точно пред вас. Свали розовите очила.",
    "reading_description": "Живееш в илюзия, че нещо ти липсва. Истинската радост може да е точно пред теб.",
    "reading_advice": "Свали розовите очила. Погледни какво имаш – може да е повече, отколкото си мислиш."
  },
  {
    "reading_id": "seven_cups_five_cups",
    "reading_name": "Седмица Чаши + Петица Чаши",
    "reading_cards": "Седмица Чаши + Петица Чаши",
    "reading_combination": ["seven_cups", "five_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Петица Чаши – загуба и тъга. Тъгата ви идва от илюзорна загуба. Може да скърбите за нещо, което никога не сте имали. Освободете се от илюзията.",
    "reading_description": "Тъгата ти идва от илюзорна загуба. Скърбиш за нещо, което никога не си имал.",
    "reading_advice": "Освободи се от илюзията. Не можеш да загубиш това, което никога не си имал."
  },
  {
    "reading_id": "seven_cups_six_cups",
    "reading_name": "Седмица Чаши + Шестица Чаши",
    "reading_cards": "Седмица Чаши + Шестица Чаши",
    "reading_combination": ["seven_cups", "six_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Шестица Чаши – спомени и носталгия. Идеализирате миналото. Спомените не винаги са точни – не идеализирайте миналото. Живейте в настоящето.",
    "reading_description": "Идеализираш миналото. Спомените не винаги са точни.",
    "reading_advice": "Свали розовите очила. Миналото не е било толкова перфектно, колкото си спомняш. Живей в настоящето."
  },
 
  {
    "reading_id": "seven_cups_eight_cups",
    "reading_name": "Седмица Чаши + Осмица Чаши",
    "reading_cards": "Седмица Чаши + Осмица Чаши",
    "reading_combination": ["seven_cups", "eight_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Осмица Чаши – тръгване и оставяне. Решавате да оставите илюзиите зад гърба си и да тръгнете към реалността. Смела стъпка към истината.",
    "reading_description": "Решаваш да оставиш илюзиите и да тръгнеш към реалността.",
    "reading_advice": "Тръгни смело. Истината е по-ценна от фантазията. Реалността те очаква."
  },
  {
    "reading_id": "seven_cups_nine_cups",
    "reading_name": "Седмица Чаши + Деветка Чаши",
    "reading_cards": "Седмица Чаши + Деветка Чаши",
    "reading_combination": ["seven_cups", "nine_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Деветка Чаши – сбъднато желание. Мечтата ви се сбъдва, но може да не е такава, каквато сте си я представяли. Реалността често е различна от фантазията.",
    "reading_description": "Мечтата ти се сбъдва, но може да не е такава, каквато си я представял.",
    "reading_advice": "Приеми реалността. Тя може да е различна от фантазията, но не по-малко ценна."
  },
  {
    "reading_id": "seven_cups_ten_cups",
    "reading_name": "Седмица Чаши + Десетка Чаши",
    "reading_cards": "Седмица Чаши + Десетка Чаши",
    "reading_combination": ["seven_cups", "ten_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Десетка Чаши – семейно щастие. Илюзорни представи за семейното щастие. Истинското семейно щастие не е в идеалната картина – то е в реалните моменти.",
    "reading_description": "Илюзорни представи за семейното щастие.",
    "reading_advice": "Свали розовите очила. Истинското семейно щастие не е в идеалната картина – то е в реалните моменти."
  },
  {
    "reading_id": "seven_cups_page_cups",
    "reading_name": "Седмица Чаши + Паж Чаши",
    "reading_cards": "Седмица Чаши + Паж Чаши",
    "reading_combination": ["seven_cups", "page_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Паж Чаши – емоционално послание. Посланието, което идва, може да е илюзорно. Проверете фактите, преди да се вълнувате. Не се залъгвайте.",
    "reading_description": "Посланието, което идва, може да е илюзорно. Провери фактите.",
    "reading_advice": "Провери два пъти. Не се залъгвай с привидно добро послание."
  },
  {
    "reading_id": "seven_cups_knight_cups",
    "reading_name": "Седмица Чаши + Рицар Чаши",
    "reading_cards": "Седмица Чаши + Рицар Чаши",
    "reading_combination": ["seven_cups", "knight_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Рицар Чаши – романтика и ухажване. Романтичен жест, който може да е илюзия. Рицарят може да не е толкова искрен, колкото изглежда. Проверете намеренията.",
    "reading_description": "Романтичен жест, който може да е илюзия. Провери намеренията.",
    "reading_advice": "Не се залъгвай от привидна романтика. Провери дали чувствата са истински."
  },
  {
    "reading_id": "seven_cups_queen_cups",
    "reading_name": "Седмица Чаши + Царица Чаши",
    "reading_cards": "Седмица Чаши + Царица Чаши",
    "reading_combination": ["seven_cups", "queen_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Царица Чаши – интуиция и емпатия. Интуицията ви подсказва, че нещо не е наред с илюзиите ви. Слушайте вътрешния си глас – той различава истината от фантазията.",
    "reading_description": "Интуицията ти подсказва, че нещо не е наред с илюзиите ти.",
    "reading_advice": "Довери се на интуицията си. Тя различава истината от фантазията."
  },
  {
    "reading_id": "seven_cups_king_cups",
    "reading_name": "Седмица Чаши + Цар Чаши",
    "reading_cards": "Седмица Чаши + Цар Чаши",
    "reading_combination": ["seven_cups", "king_cups"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Цар Чаши – емоционална зрялост и баланс. Емоционалната зрялост ви помага да различите илюзията от реалността. Бъдете мъдри – не позволявайте на фантазиите да ви завладеят.",
    "reading_description": "Емоционалната зрялост ти помага да различиш илюзията от реалността.",
    "reading_advice": "Бъди мъдър. Не позволявай на фантазиите да те завладеят. Истината е по-ценна."
  },
  {
    "reading_id": "seven_cups_two_swords",
    "reading_name": "Седмица Чаши + Двойка Мечове",
    "reading_cards": "Седмица Чаши + Двойка Мечове",
    "reading_combination": ["seven_cups", "two_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Двойка Мечове – нерешителност и съмнение. Илюзиите ви карат да се съмнявате във всичко. Свалете превръзката – истината ще ви освободи от съмненията.",
    "reading_description": "Илюзиите те карат да се съмняваш във всичко.",
    "reading_advice": "Свали превръзката. Истината ще те освободи от съмненията."
  },
  {
    "reading_id": "seven_cups_three_swords",
    "reading_name": "Седмица Чаши + Тройка Мечове",
    "reading_cards": "Седмица Чаши + Тройка Мечове",
    "reading_combination": ["seven_cups", "three_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Тройка Мечове – болка и разбито сърце. Илюзорната любов ви носи болка. Разбито сърце от нещо, което никога не е било реално. Време е да приемете истината.",
    "reading_description": "Илюзорната любов ти носи болка. Скърбиш за нещо, което никога не е било реално.",
    "reading_advice": "Приеми истината. Болката от илюзията е реална, но илюзията не е. Освободи се."
  },
    {
    "reading_id": "seven_cups_four_swords",
    "reading_name": "Седмица Чаши + Четворка Мечове",
    "reading_cards": "Седмица Чаши + Четворка Мечове",
    "reading_combination": ["seven_cups", "four_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Четворка Мечове – почивка и уединение. Имате нужда от почивка, за да се отърсите от илюзиите. Уединението може да ви помогне да намерите истината.",
    "reading_description": "Имаш нужда от почивка, за да се отърсиш от илюзиите.",
    "reading_advice": "Почини си. Уединението може да ти помогне да намериш истината и да се върнеш към реалността."
  },
  {
    "reading_id": "seven_cups_five_swords",
    "reading_name": "Седмица Чаши + Петица Мечове",
    "reading_cards": "Седмица Чаши + Петица Мечове",
    "reading_combination": ["seven_cups", "five_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Петица Мечове – конфликт и празна победа. Битката, която водите, е с илюзорен враг. Дори да спечелите, победата ще е празна. Освободете се от илюзията.",
    "reading_description": "Битката, която водиш, е с илюзорен враг. Дори да спечелиш, победата ще е празна.",
    "reading_advice": "Освободи се от илюзията. Най-големите битки са в ума ни. Престани да се биеш с въображаеми врагове."
  },
  {
    "reading_id": "seven_cups_six_swords",
    "reading_name": "Седмица Чаши + Шестица Мечове",
    "reading_cards": "Седмица Чаши + Шестица Мечове",
    "reading_combination": ["seven_cups", "six_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Шестица Мечове – пътуване и преход. Пътуването ви помага да оставите илюзиите зад гърба си. Новите води носят нова перспектива и истина.",
    "reading_description": "Пътуването ти помага да оставиш илюзиите зад гърба си.",
    "reading_advice": "Тръгни. Новите води носят нова перспектива и истина. Остави илюзиите на старите места."
  },
  {
    "reading_id": "seven_cups_seven_swords",
    "reading_name": "Седмица Чаши + Седмица Мечове",
    "reading_cards": "Седмица Чаши + Седмица Мечове",
    "reading_combination": ["seven_cups", "seven_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Седмица Мечове – измама и хитрост. Внимавайте – някой може да се възползва от илюзиите ви, за да ви измами. Някой не играе честно. Пазите се.",
    "reading_description": "Някой може да се възползва от илюзиите ти, за да те измами.",
    "reading_advice": "Пази се. Не всички играят честно. Проверявай фактите и не се доверявай сляпо."
  },
  {
    "reading_id": "seven_cups_eight_swords",
    "reading_name": "Седмица Чаши + Осмица Мечове",
    "reading_cards": "Седмица Чаши + Осмица Мечове",
    "reading_combination": ["seven_cups", "eight_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Осмица Мечове – чувство на капан и ограничение. Илюзиите ви държат в капан. Чувствате се блокирани, но оковите са в главата ви. Освободете се.",
    "reading_description": "Илюзиите те държат в капан. Чувстваш се блокиран.",
    "reading_advice": "Оковите са в главата ти. Освободи се от илюзиите – имаш повече възможности, отколкото си мислиш."
  },
  {
    "reading_id": "seven_cups_nine_swords",
    "reading_name": "Седмица Чаши + Деветка Мечове",
    "reading_cards": "Седмица Чаши + Деветка Мечове",
    "reading_combination": ["seven_cups", "nine_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Деветка Мечове – тревога и безсъние. Илюзиите ви причиняват безсъние и тревожни мисли. Страховете ви са илюзорни – не позволявайте на фантазиите да крадат съня ви.",
    "reading_description": "Илюзиите ти причиняват безсъние и тревожни мисли.",
    "reading_advice": "Спокойствие. Страховете ти са илюзорни – не позволявай на фантазиите да крадат съня ти. Довери се на реалността."
  },
  {
    "reading_id": "seven_cups_ten_swords",
    "reading_name": "Седмица Чаши + Десетка Мечове",
    "reading_cards": "Седмица Чаши + Десетка Мечове",
    "reading_combination": ["seven_cups", "ten_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Десетка Мечове – край и дъно. Периодът на илюзии приключва. Краят носи освобождение. След дъното идва реалността и ново начало.",
    "reading_description": "Периодът на илюзии приключва. Краят носи освобождение.",
    "reading_advice": "Остави илюзиите зад гърба си. Това, което е свършило, вече не тежи. Реалността те очаква."
  },
  {
    "reading_id": "seven_cups_page_swords",
    "reading_name": "Седмица Чаши + Паж Мечове",
    "reading_cards": "Седмица Чаши + Паж Мечове",
    "reading_combination": ["seven_cups", "page_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Паж Мечове – търсене на истината. Истината за илюзиите ви излиза наяве. Любопитството ви води към открития. Бъдете отворени за истината.",
    "reading_description": "Истината за илюзиите ти излиза наяве. Бъди отворен.",
    "reading_advice": "Търси истината. Тя може да боли, но винаги лекува. Отвори се за прозренията, които идват."
  },
  {
    "reading_id": "seven_cups_knight_swords",
    "reading_name": "Седмица Чаши + Рицар Мечове",
    "reading_cards": "Седмица Чаши + Рицар Мечове",
    "reading_combination": ["seven_cups", "knight_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Рицар Мечове – бързина и прямота. Истината за илюзиите ви идва бързо и рязко. Бъдете готови да я приемете. Прозрението ще ви освободи.",
    "reading_description": "Истината за илюзиите ти идва бързо и рязко. Бъди готов.",
    "reading_advice": "Приеми истината с отворено сърце. Тя може да е рязка, но ще те освободи от илюзиите."
  },
  {
    "reading_id": "seven_cups_queen_swords",
    "reading_name": "Седмица Чаши + Царица Мечове",
    "reading_cards": "Седмица Чаши + Царица Мечове",
    "reading_combination": ["seven_cups", "queen_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Царица Мечове – яснота и независимост. Виждате илюзиите си ясно, без да се залъгвате. Яснотата, колкото и да е сурова, е първата стъпка към свободата.",
    "reading_description": "Виждаш илюзиите си ясно, без да се залъгваш.",
    "reading_advice": "Бъди честен със себе си. Яснотата, колкото и да е сурова, води към свобода от илюзиите."
  },
  {
    "reading_id": "seven_cups_king_swords",
    "reading_name": "Седмица Чаши + Цар Мечове",
    "reading_cards": "Седмица Чаши + Цар Мечове",
    "reading_combination": ["seven_cups", "king_swords"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Цар Мечове – интелект и стратегия. С логика и анализ можете да разберете кои от мечтите ви са реални и кои илюзорни. Използвайте ума си, за да различите истината.",
    "reading_description": "С логика и анализ можеш да разбереш кои мечти са реални.",
    "reading_advice": "Използвай ума си. Анализът може да ти помогне да различиш истината от фантазията."
  },
  {
    "reading_id": "seven_cups_two_pentacles",
    "reading_name": "Седмица Чаши + Двойка Пентакли",
    "reading_cards": "Седмица Чаши + Двойка Пентакли",
    "reading_combination": ["seven_cups", "two_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Двойка Пентакли – баланс и жонглиране. Опитвате се да балансирате илюзиите с реалността. Жонглирайте внимателно – не изпускайте истината.",
    "reading_description": "Опитваш се да балансираш илюзиите с реалността.",
    "reading_advice": "Балансирай, но не изпускай истината. Илюзиите са привлекателни, но реалността е по-ценна."
  },
  {
    "reading_id": "seven_cups_three_pentacles",
    "reading_name": "Седмица Чаши + Тройка Пентакли",
    "reading_cards": "Седмица Чаши + Тройка Пентакли",
    "reading_combination": ["seven_cups", "three_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Тройка Пентакли – екипна работа и сътрудничество. В екипа има нереалистични очаквания. Свалете розовите очила и погледнете реалността. Заедно можете да постигнете реални цели.",
    "reading_description": "В екипа има нереалистични очаквания. Свалете розовите очила.",
    "reading_advice": "Погледнете реалността. Заедно можете да постигнете реални цели, ако спрете да мечтаете за невъзможното."
  },
  {
    "reading_id": "seven_cups_four_pentacles",
    "reading_name": "Седмица Чаши + Четворка Пентакли",
    "reading_cards": "Седмица Чаши + Четворка Пентакли",
    "reading_combination": ["seven_cups", "four_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Четворка Пентакли – сигурност и стискане. Живеете в илюзия, че стискането ще ви донесе сигурност. Истинската сигурност идва отвътре, не от това, което стискате.",
    "reading_description": "Живееш в илюзия, че стискането ще ти донесе сигурност.",
    "reading_advice": "Свали розовите очила. Истинската сигурност идва отвътре, не от това, което стискаш."
  },
  {
    "reading_id": "seven_cups_five_pentacles",
    "reading_name": "Седмица Чаши + Петица Пентакли",
    "reading_cards": "Седмица Чаши + Петица Пентакли",
    "reading_combination": ["seven_cups", "five_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Петица Пентакли – финансови трудности и липса. Илюзиите ви за пари може да ви държат в бедност. Свали розовите очила и погледни реалността на финансите си.",
    "reading_description": "Илюзиите ти за пари може да те държат в бедност.",
    "reading_advice": "Погледни реалността на финансите си. Истината може да е трудна, но само тя може да те изведе от липсата."
  },
  {
    "reading_id": "seven_cups_six_pentacles",
    "reading_name": "Седмица Чаши + Шестица Пентакли",
    "reading_cards": "Седмица Чаши + Шестица Пентакли",
    "reading_combination": ["seven_cups", "six_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Шестица Пентакли – помощ и щедрост. Някой предлага помощ, но може да не е искрен. Проверете намеренията, преди да приемете. Не всяка предложена помощ е искрена.",
    "reading_description": "Някой предлага помощ, но може да не е искрен. Провери намеренията.",
    "reading_advice": "Провери два пъти. Не всяка предложена помощ е искрена. Някои илюзии са опасни."
  },
  {
    "reading_id": "seven_cups_seven_pentacles",
    "reading_name": "Седмица Чаши + Седмица Пентакли",
    "reading_cards": "Седмица Чаши + Седмица Пентакли",
    "reading_combination": ["seven_cups", "seven_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Седмица Пентакли – търпение и чакане. Чакате нещо, което вероятно е илюзия. Инвестирали сте време и надежда в нещо нереално. Проверете дали чакането си струва.",
    "reading_description": "Чакаш нещо, което вероятно е илюзия. Провери дали чакането си струва.",
    "reading_advice": "Провери дали това, което чакаш, е реално. Не инвестирай време в илюзии."
  },
  {
    "reading_id": "seven_cups_eight_pentacles",
    "reading_name": "Седмица Чаши + Осмица Пентакли",
    "reading_cards": "Седмица Чаши + Осмица Пентакли",
    "reading_combination": ["seven_cups", "eight_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Осмица Пентакли – усърдие и учене. Ученето може да ви помогне да различите илюзията от реалността. Вложете енергия в усвояване на нови умения, които да ви заземят.",
    "reading_description": "Ученето може да ти помогне да различиш илюзията от реалността.",
    "reading_advice": "Учи се. Новото знание ще ти помогне да видиш нещата такива, каквито са – без илюзии."
  },
  {
    "reading_id": "seven_cups_nine_pentacles",
    "reading_name": "Седмица Чаши + Деветка Пентакли",
    "reading_cards": "Седмица Чаши + Деветка Пентакли",
    "reading_combination": ["seven_cups", "nine_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Деветка Пентакли – самодостатъчност и успех. Мислите, че имате всичко, но може да е илюзия. Проверете дали успехът ви е реален, или само във фантазиите ви.",
    "reading_description": "Мислиш, че имаш всичко, но може да е илюзия. Провери дали успехът е реален.",
    "reading_advice": "Свали розовите очила. Истинският успех е реален. Провери дали това, което имаш, е истинско."
  },
  {
    "reading_id": "seven_cups_ten_pentacles",
    "reading_name": "Седмица Чаши + Десетка Пентакли",
    "reading_cards": "Седмица Чаши + Десетка Пентакли",
    "reading_combination": ["seven_cups", "ten_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Десетка Пентакли – семейно наследство и богатство. Илюзорни представи за семейното богатство. Проверете реалността. Истинското богатство на семейството е любовта, не парите.",
    "reading_description": "Илюзорни представи за семейното богатство. Провери реалността.",
    "reading_advice": "Свали розовите очила. Истинското богатство на семейството е любовта, не парите."
  },
  {
    "reading_id": "seven_cups_page_pentacles",
    "reading_name": "Седмица Чаши + Паж Пентакли",
    "reading_cards": "Седмица Чаши + Паж Пентакли",
    "reading_combination": ["seven_cups", "page_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Паж Пентакли – нова възможност и учене. Нова финансова възможност, която може да е илюзия. Проверете фактите, преди да инвестирате. Не се залъгвайте с привидно добри оферти.",
    "reading_description": "Нова финансова възможност, която може да е илюзия. Провери фактите.",
    "reading_advice": "Провери два пъти. Не се залъгвай с привидно добри оферти. Истинските възможности са реални."
  },
  {
    "reading_id": "seven_cups_knight_pentacles",
    "reading_name": "Седмица Чаши + Рицар Пентакли",
    "reading_cards": "Седмица Чаши + Рицар Пентакли",
    "reading_combination": ["seven_cups", "knight_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Рицар Пентакли – бавен и сигурен напредък. Илюзиите ви карат да очаквате бързи резултати. Реалността изисква търпение. Бавно, но сигурно – не се залъгвай.",
    "reading_description": "Илюзиите те карат да очакваш бързи резултати. Реалността изисква търпение.",
    "reading_advice": "Не бързай. Бавното и сигурно е реално. Бързите резултати често са илюзия."
  },
  {
    "reading_id": "seven_cups_queen_pentacles",
    "reading_name": "Седмица Чаши + Царица Пентакли",
    "reading_cards": "Седмица Чаши + Царица Пентакли",
    "reading_combination": ["seven_cups", "queen_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Царица Пентакли – грижа и дом. Илюзорни представи за дома или семейството. Свали розовите очила – грижата изисква реалност, не фантазии. Грижи се за това, което имаш.",
    "reading_description": "Илюзорни представи за дома или семейството. Свали розовите очила.",
    "reading_advice": "Бъди реалист. Грижата изисква реалност, не фантазии. Грижи се за това, което имаш, а не за това, което искаш да имаш."
  },
  {
    "reading_id": "seven_cups_king_pentacles",
    "reading_name": "Седмица Чаши + Цар Пентакли",
    "reading_cards": "Седмица Чаши + Цар Пентакли",
    "reading_combination": ["seven_cups", "king_pentacles"],
    "reading_meaning": "Седмица Чаши носи илюзии и фантазии, а Цар Пентакли – стабилност и успех. Илюзорни представи за успеха. Свали розовите очила – истинският успех се гради на реалност, не на фантазии. Бъди реалист.",
    "reading_description": "Илюзорни представи за успеха. Свали розовите очила.",
    "reading_advice": "Бъди реалист. Истинският успех се гради на реалност, не на фантазии. Гради стабилно и сигурно."
  },
 
  {
    "reading_id": "ace_wands_three_wands",
    "reading_name": "Асо Жезли + Тройка Жезли",
    "reading_cards": "Асо Жезли + Тройка Жезли",
    "reading_combination": ["ace_wands", "three_wands"],
    "reading_meaning": "Начало и очакване",
    "second_meaning": "Асо Жезли символизира старта и вдъхновението, а Тройка Жезли – търпеливото очакване на плодовете. Посяли сте семето на нещо ново и сега трябва да изчакате то да покълне. Енергията ви е насочена правилно, но резултатите ще дойдат с времето.",
    "reading_description": "Започнали сте нов проект и сега чакате първите резултати. Нетърпението е голямо, но трябва да проявите търпение.",
    "reading_advice": "Бъдете търпеливи – добрите неща идват при тези, които умеят да чакат, докато продължават да работят."
  },
  {
    "reading_id": "ace_wands_four_wands",
    "reading_name": "Асо Жезли + Четворка Жезли",
    "reading_cards": "Асо Жезли + Четворка Жезли",
    "reading_combination": ["ace_wands", "four_wands"],
    "reading_meaning": "Ново начало с празник",
    "second_meaning": "Асо Жезли носи искрата на новото начало, а Четворка Жезли – празника и завръщането у дома. Заедно предвещават радостно събитие, свързано с нов старт – нова работа, преместване или важен етап. Ентусиазмът ви ще бъде споделен от близките.",
    "reading_description": "Предстои нещо ново, което носи радост и повод за празнуване. Очаквайте щастливи събития и подкрепа от семейството.",
    "reading_advice": "Празнувайте малките победи – те са стъпалата към големия успех. Споделете радостта си с близките."
  },
  {
    "reading_id": "ace_wands_five_wands",
    "reading_name": "Асо Жезли + Петица Жезли",
    "reading_cards": "Асо Жезли + Петица Жезли",
    "reading_combination": ["ace_wands", "five_wands"],
    "reading_meaning": "Конкурентно начало",
    "second_meaning": "Асо Жезли носи нова идея, а Петица Жезли – конфликт и съперничество. Още в началото срещате конкуренция или съпротива. Това може да ви обезкуражи, но е знак, че сте на прав път – значимите неща винаги предизвикват реакция.",
    "reading_description": "Новото ви начинание среща съпротива още в зародиш. Конкуренция, спорове или хора, които не подкрепят идеята ви.",
    "reading_advice": "Не се отказвайте при първото препятствие. Конкуренцията означава, че идеята ви има стойност."
  },
  {
    "reading_id": "ace_wands_six_wands",
    "reading_name": "Асо Жезли + Шестица Жезли",
    "reading_cards": "Асо Жезли + Шестица Жезли",
    "reading_combination": ["ace_wands", "six_wands"],
    "reading_meaning": "Победно начало",
    "second_meaning": "Асо Жезли символизира старта, а Шестица Жезли – победата и признанието. Новото ви начинание ще има успех още от самото начало. Вашият ентусиазъм и увереност ще бъдат забелязани и оценени.",
    "reading_description": "Новият ви проект получава признание и успех още в началото. Всички виждат вашия талант и енергия.",
    "reading_advice": "Наслаждавайте се на успеха, но не спирайте да работите. Първата победа е само началото."
  },
  {
    "reading_id": "ace_wands_seven_wands",
    "reading_name": "Асо Жезли + Седмица Жезли",
    "reading_cards": "Асо Жезли + Седмица Жезли",
    "reading_combination": ["ace_wands", "seven_wands"],
    "reading_meaning": "Защита на идеята",
    "second_meaning": "Асо Жезли носи вдъхновението, а Седмица Жезли – защитата на позицията. Още в началото трябва да отстоявате новата си идея пред критици. Това е изпитание на вашата увереност.",
    "reading_description": "Новата ви идея се сблъсква с критики и съпротива. Трябва да защитавате позицията си.",
    "reading_advice": "Не се огъвайте пред първата съпротива. Убедеността ви ще спечели."
  },
  {
    "reading_id": "ace_wands_eight_wands",
    "reading_name": "Асо Жезли + Осмица Жезли",
    "reading_cards": "Асо Жезли + Осмица Жезли",
    "reading_combination": ["ace_wands", "eight_wands"],
    "reading_meaning": "Бърз старт",
    "second_meaning": "Асо Жезли носи искрата, а Осмица Жезли – бързината и движението. Всичко се случва светкавично – идеята се ражда и веднага започва да се развива. Няма време за колебание.",
    "reading_description": "Новата ви идея или проект се развива с неочаквана скорост. Трябва да действате бързо, за да не изпуснете вълната.",
    "reading_advice": "Хванете вълната на скоростта. Действайте сега, без да се бавите."
  },
  {
    "reading_id": "ace_wands_nine_wands",
    "reading_name": "Асо Жезли + Деветка Жезли",
    "reading_cards": "Асо Жезли + Деветка Жезли",
    "reading_combination": ["ace_wands", "nine_wands"],
    "reading_meaning": "Упорито начало",
    "second_meaning": "Асо Жезли носи ентусиазма, а Деветка Жезли – устойчивостта и последната линия на отбрана. Началото е трудно и изисква много усилия. Чувствате се изтощени, но не се отказвайте – краят на усилията наближава.",
    "reading_description": "Стартът е труден и изисква много енергия. Чувствате се изтощени, но трябва да издържите.",
    "reading_advice": "Дръжте се още малко. Финалната права е точно зад ъгъла."
  },
  {
    "reading_id": "ace_wands_ten_wands",
    "reading_name": "Асо Жезли + Десетка Жезли",
    "reading_cards": "Асо Жезли + Десетка Жезли",
    "reading_combination": ["ace_wands", "ten_wands"],
    "reading_meaning": "Претоварен старт",
    "second_meaning": "Асо Жезли носи ентусиазъм, а Десетка Жезли – претоварване и бреме. Поемате твърде много отговорности твърде рано. Ентусиазмът ви води до прегаряне, ако не забавите темпото.",
    "reading_description": "Започвате с ентусиазъм, но бързо се претоварвате. Поемате твърде много отговорности.",
    "reading_advice": "Забавете темпото. Никой не може да носи всичко сам. Потърсете помощ."
  },
  {
    "reading_id": "ace_wands_page_wands",
    "reading_name": "Асо Жезли + Паж Жезли",
    "reading_cards": "Асо Жезли + Паж Жезли",
    "reading_combination": ["ace_wands", "page_wands"],
    "reading_meaning": "Свежа енергия и новини",
    "second_meaning": "Асо Жезли носи искрата на новото начало, а Паж Жезли – ентусиазма и свежите новини. Заедно предвещават вълнуващо послание, свързано с нов проект или идея. Вашата енергия е заразителна.",
    "reading_description": "Получавате вълнуваща новина, свързана с ново начало. Ентусиазмът ви е на върха.",
    "reading_advice": "Споделете ентусиазма си с другите. Вашата енергия е заразителна и може да привлече подкрепа."
  },
  {
    "reading_id": "ace_wands_knight_wands",
    "reading_name": "Асо Жезли + Рицар Жезли",
    "reading_cards": "Асо Жезли + Рицар Жезли",
    "reading_combination": ["ace_wands", "knight_wands"],
    "reading_meaning": "Стремителен старт",
    "second_meaning": "Асо Жезли носи новото начало, а Рицар Жезли – импулсивността и бързото действие. Заедно създават експлозивна комбинация – идеята се ражда и веднага се втурвате да я реализирате с пълна сила. Внимавайте да не прегазите другите.",
    "reading_description": "Новата идея ви кара да действате светкавично. Имате неудържима енергия и желание за движение.",
    "reading_advice": "Действайте бързо, но не забравяйте за хората около вас. Страстта е добра, но не трябва да прегазва."
  },
  {
    "reading_id": "ace_wands_queen_wands",
    "reading_name": "Асо Жезли + Царица Жезли",
    "reading_cards": "Асо Жезли + Царица Жезли",
    "reading_combination": ["ace_wands", "queen_wands"],
    "reading_meaning": "Уверен старт",
    "second_meaning": "Асо Жезли носи искрата, а Царица Жезли – увереността и харизмата. Започвате нещо ново с голяма самоувереност. Вашата топлина и увереност привличат хората към вас и вашата идея.",
    "reading_description": "Започвате нов проект с увереност и харизма. Хората се вдъхновяват от вашата енергия.",
    "reading_advice": "Бъдете себе си – топло и уверено. Вашата светлина вдъхновява другите да ви последват."
  },
  {
    "reading_id": "ace_wands_king_wands",
    "reading_name": "Асо Жезли + Цар Жезли",
    "reading_cards": "Асо Жезли + Цар Жезли",
    "reading_combination": ["ace_wands", "king_wands"],
    "reading_meaning": "Лидерски старт",
    "second_meaning": "Асо Жезли носи новото начало, а Цар Жезли – лидерството и визията. Започвате нещо ново с ясна визия и авторитет. Имате всички качества да поведете другите и да реализирате идеята си.",
    "reading_description": "Започвате нов проект с ясна визия и лидерска позиция. Имате авторитета да водите другите.",
    "reading_advice": "Поемете лидерството. Имате визията и силата да я осъществите. Водете с пример."
  },
 
  {
    "reading_id": "ace_wands_three_cups",
    "reading_name": "Асо Жезли + Тройка Чаши",
    "reading_cards": "Асо Жезли + Тройка Чаши",
    "reading_combination": ["ace_wands", "three_cups"],
    "reading_meaning": "Празнична страст",
    "second_meaning": "Асо Жезли носи енергията, а Тройка Чаши – празника и радостта. Нова страст или проект идва с много поводи за празнуване. Вашият ентусиазъм е заразителен и събира хора около вас.",
    "reading_description": "Нов проект или страст носи много радост и поводи за празнуване. Енергията ви е заразителна.",
    "reading_advice": "Празнувайте всеки успех, дори малкия. Радостта, споделена с други, е двойна радост."
  },
  {
    "reading_id": "ace_wands_four_cups",
    "reading_name": "Асо Жезли + Четворка Чаши",
    "reading_cards": "Асо Жезли + Четворка Чаши",
    "reading_combination": ["ace_wands", "four_cups"],
    "reading_meaning": "Пропусната възможност",
    "second_meaning": "Асо Жезли носи нова възможност, а Четворка Чаши – апатията и неудовлетворението. Нова възможност се появява, но вие сте твърде заети със себе си, за да я забележите. Рискувате да пропуснете нещо ценно.",
    "reading_description": "Нова възможност се появява, но вие не я забелязвате. Твърде сте заети със себе си.",
    "reading_advice": "Вдигнете поглед. Може да пропускате нещо важно, което е точно пред вас."
  },
  {
    "reading_id": "ace_wands_five_cups",
    "reading_name": "Асо Жезли + Петица Чаши",
    "reading_cards": "Асо Жезли + Петица Чаши",
    "reading_combination": ["ace_wands", "five_cups"],
    "reading_meaning": "Ново начало след загуба",
    "second_meaning": "Асо Жезли носи новото начало, а Петица Чаши – тъгата и загубата. След период на скръб или разочарование идва нова надежда. Светлината се появява след тъмнината.",
    "reading_description": "Нова страст или проект се появява след период на тъга и загуба. Светлина след мрак.",
    "reading_advice": "Дори в скръбта има място за ново начало. Позволете си да се отворите към надеждата."
  },
  {
    "reading_id": "ace_wands_six_cups",
    "reading_name": "Асо Жезли + Шестица Чаши",
    "reading_cards": "Асо Жезли + Шестица Чаши",
    "reading_combination": ["ace_wands", "six_cups"],
    "reading_meaning": "Носталгична страст",
    "second_meaning": "Асо Жезли носи новото, а Шестица Чаши – спомените и носталгията. Новият проект или страст ви напомня за нещо от миналото. Усещате позната топлина и вдъхновение от стари спомени.",
    "reading_description": "Нов проект или страст ви напомня за нещо от миналото. Носталгия и ново начало.",
    "reading_advice": "Използвайте миналото като вдъхновение, но не позволявайте то да ви държи в капан. Творете новото с опита на старото."
  },
  {
    "reading_id": "ace_wands_seven_cups",
    "reading_name": "Асо Жезли + Седмица Чаши",
    "reading_cards": "Асо Жезли + Седмица Чаши",
    "reading_combination": ["ace_wands", "seven_cups"],
    "reading_meaning": "Много възможности",
    "second_meaning": "Асо Жезли носи нова енергия, а Седмица Чаши – множество избори и илюзии. Имате много възможности, но не всички са реални. Трудно е да изберете накъде да насочите енергията си.",
    "reading_description": "Нова страст и много възможности едновременно. Трудно е да изберете посока.",
    "reading_advice": "Изберете една възможност и ѝ се посветете. Не се разпилявайте в илюзии."
  },
 
   
  {
    "reading_id": "ace_wands_page_cups",
    "reading_name": "Асо Жезли + Паж Чаши",
    "reading_cards": "Асо Жезли + Паж Чаши",
    "reading_combination": ["ace_wands", "page_cups"],
    "reading_meaning": "Нова страст и послание",
    "second_meaning": "Асо Жезли носи енергията, а Паж Чаши – емоционално послание. Очаквайте вълнуваща новина, свързана със сърдечни въпроси или нов творчески проект. Някой може да ви признае чувствата си.",
    "reading_description": "Получавате емоционално послание, свързано с нова страст или проект. Сърцето ви бие по-бързо.",
    "reading_advice": "Отворете сърцето си за посланието. То носи нещо важно за вас."
  },
  {
    "reading_id": "ace_wands_knight_cups",
    "reading_name": "Асо Жезли + Рицар Чаши",
    "reading_cards": "Асо Жезли + Рицар Чаши",
    "reading_combination": ["ace_wands", "knight_cups"],
    "reading_meaning": "Романтична страст",
    "second_meaning": "Асо Жезли носи страстта, а Рицар Чаши – романтиката и ухажването. Очаквайте романтичен жест или предложение, което идва с много страст. Някой идва при вас с отворено сърце.",
    "reading_description": "Нова романтична връзка или романтичен жест идва с много страст и емоция.",
    "reading_advice": "Кажете какво чувствате. Бъдете смели в любовта – сърцето ви знае пътя."
  },
  {
    "reading_id": "ace_wands_queen_cups",
    "reading_name": "Асо Жезли + Царица Чаши",
    "reading_cards": "Асо Жезли + Царица Чаши",
    "reading_combination": ["ace_wands", "queen_cups"],
    "reading_meaning": "Интуитивна страст",
    "second_meaning": "Асо Жезли носи енергията, а Царица Чаши – интуицията и дълбоката емоционалност. Новата ви страст е водена от силна интуиция. Сърцето ви знае какво иска, дори умът да се съмнява.",
    "reading_description": "Нова страст или проект, воден от интуиция и дълбоки чувства. Слушайте сърцето си.",
    "reading_advice": "Доверете се на вътрешния си глас. Интуицията ви води правилно."
  },
  {
    "reading_id": "ace_wands_king_cups",
    "reading_name": "Асо Жезли + Цар Чаши",
    "reading_cards": "Асо Жезли + Цар Чаши",
    "reading_combination": ["ace_wands", "king_cups"],
    "reading_meaning": "Контролирана страст",
    "second_meaning": "Асо Жезли носи страстта, а Цар Чаши – емоционалната зрялост и контрол. Новата ви страст е силна, но вие умеете да я контролирате. Баланс между огън и вода.",
    "reading_description": "Нова страст, която умеете да контролирате. Емоционална зрялост и баланс.",
    "reading_advice": "Управлявайте енергията си с мъдрост. Страстта е силна, но вие сте по-силни."
  },
  {
    "reading_id": "ace_wands_two_swords",
    "reading_name": "Асо Жезли + Двойка Мечове",
    "reading_cards": "Асо Жезли + Двойка Мечове",
    "reading_combination": ["ace_wands", "two_swords"],
    "reading_meaning": "Идея и съмнение",
    "second_meaning": "Асо Жезли носи нова идея, а Двойка Мечове – нерешителност и блокиране. Имате нова идея, но се съмнявате дали да я реализирате. Страхът от грешка ви парализира.",
    "reading_description": "Нова идея се ражда, но я съпътстват съмнения и нерешителност. Не знаете дали да действате.",
    "reading_advice": "Свалете превръзката от очите. Понякога трябва да изберете, дори да не виждате ясно."
  },
  {
    "reading_id": "ace_wands_three_swords",
    "reading_name": "Асо Жезли + Тройка Мечове",
    "reading_cards": "Асо Жезли + Тройка Мечове",
    "reading_combination": ["ace_wands", "three_swords"],
    "reading_meaning": "Страст и болка",
    "second_meaning": "Асо Жезли носи страст, а Тройка Мечове – болка и разбито сърце. Новата ви страст може да донесе разочарование или болка. Внимавайте с кого споделяте ентусиазма си.",
    "reading_description": "Нова страст или проект носи не само радост, но и риск от разочарование.",
    "reading_advice": "Бъдете внимателни с доверието си. Не всяка страст носи само радост."
  },
  {
    "reading_id": "ace_wands_four_swords",
    "reading_name": "Асо Жезли + Четворка Мечове",
    "reading_cards": "Асо Жезли + Четворка Мечове",
    "reading_combination": ["ace_wands", "four_swords"],
    "reading_meaning": "Почивка преди старт",
    "second_meaning": "Асо Жезли носи нова енергия, а Четворка Мечове – почивка и възстановяване. Имате идея, но сега не е моментът за действие. Първо починете и съберете сили.",
    "reading_description": "Имате нова идея, но сега е време за почивка, не за действие. Съберете сили.",
    "reading_advice": "Починете си преди да започнете. Добрата подготовка води до успех."
  },
  {
    "reading_id": "ace_wands_five_swords",
    "reading_name": "Асо Жезли + Петица Мечове",
    "reading_cards": "Асо Жезли + Петица Мечове",
    "reading_combination": ["ace_wands", "five_swords"],
    "reading_meaning": "Конфликтна идея",
    "second_meaning": "Асо Жезли носи нова идея, а Петица Мечове – конфликт и празна победа. Идеята ви може да предизвика спор или да се опитате да я наложите по неправилен начин. Помислете дали си струва.",
    "reading_description": "Новата ви идея предизвиква конфликт. Може да спечелите, но с цената на нечии чувства.",
    "reading_advice": "Помислете дали си струва да нараните другите, за да спечелите. Понякога е по-добре да отстъпите."
  },
  {
    "reading_id": "ace_wands_six_swords",
    "reading_name": "Асо Жезли + Шестица Мечове",
    "reading_cards": "Асо Жезли + Шестица Мечове",
    "reading_combination": ["ace_wands", "six_swords"],
    "reading_meaning": "Ново начало и път",
    "second_meaning": "Асо Жезли носи новото начало, а Шестица Мечове – пътуването и прехода. Новата ви идея или проект ще ви отведе на ново място – физически или метафорично. Очаквайте промяна на средата.",
    "reading_description": "Нов проект или идея ви отвежда на ново място. Пътуване или преместване ви очаква.",
    "reading_advice": "Тръгнете с увереност. Новите води носят нови възможности."
  },
  {
    "reading_id": "ace_wands_seven_swords",
    "reading_name": "Асо Жезли + Седмица Мечове",
    "reading_cards": "Асо Жезли + Седмица Мечове",
    "reading_combination": ["ace_wands", "seven_swords"],
    "reading_meaning": "Идея и измама",
    "second_meaning": "Асо Жезли носи нова идея, а Седмица Мечове – измама и хитрост. Внимавайте – някой може да се опита да присвои идеята ви или да ви измами. Пазите интелектуалната си собственост.",
    "reading_description": "Новата ви идея е ценна, но има риск някой да се опита да ви я открадне.",
    "reading_advice": "Бъдете внимателни с кого споделяте идеите си. Проверявайте два пъти."
  },
  {
    "reading_id": "ace_wands_eight_swords",
    "reading_name": "Асо Жезли + Осмица Мечове",
    "reading_cards": "Асо Жезли + Осмица Мечове",
    "reading_combination": ["ace_wands", "eight_swords"],
    "reading_meaning": "Блокирана идея",
    "second_meaning": "Асо Жезли носи нова идея, а Осмица Мечове – чувство на капан и ограничение. Имате страхотна идея, но се чувствате блокирани и без изход. Страхът ви пречи да действате.",
    "reading_description": "Имате нова идея, но се чувствате в капан. Страховете ви пречат да действате.",
    "reading_advice": "Оковите са в главата ви. Освободете се от страха и ще видите, че имате повече възможности, отколкото си мислите."
  },
  {
    "reading_id": "ace_wands_nine_swords",
    "reading_name": "Асо Жезли + Деветка Мечове",
    "reading_cards": "Асо Жезли + Деветка Мечове",
    "reading_combination": ["ace_wands", "nine_swords"],
    "reading_meaning": "Тревожна идея",
    "second_meaning": "Асо Жезли носи нова енергия, а Деветка Мечове – тревога и безсъние. Новата идея ви вълнува, но също така ви тревожи. Мислите ви се въртят около нея и не ви оставят да спите.",
    "reading_description": "Нова идея ви вълнува, но носи и тревоги. Безсъние и премисляне.",
    "reading_advice": "Спокойствие. Повечето неща, за които се тревожим, никога не се случват. Доверете се на процеса."
  },
  {
    "reading_id": "ace_wands_ten_swords",
    "reading_name": "Асо Жезли + Десетка Мечове",
    "reading_cards": "Асо Жезли + Десетка Мечове",
    "reading_combination": ["ace_wands", "ten_swords"],
    "reading_meaning": "Край и ново начало",
    "second_meaning": "Асо Жезли носи новото, а Десетка Мечове – края и дъното. Нещо старо приключва, за да може нещо ново да започне. Краят е болезнен, но носи освобождение и нов път.",
    "reading_description": "След тежък край идва ново начало. Феникс от пепелта.",
    "reading_advice": "Оставете старото да умре. Новото вече чука на вратата. Позволете му да влезе."
  },
  {
    "reading_id": "ace_wands_page_swords",
    "reading_name": "Асо Жезли + Паж Мечове",
    "reading_cards": "Асо Жезли + Паж Мечове",
    "reading_combination": ["ace_wands", "page_swords"],
    "reading_meaning": "Идея и истина",
    "second_meaning": "Асо Жезли носи нова идея, а Паж Мечове – търсене на истината и любопитство. Новата ви идея ви кара да търсите отговори и да задавате въпроси. Любопитството ви води към открития.",
    "reading_description": "Нова идея ви кара да търсите истината. Любопитство и открития.",
    "reading_advice": "Задавайте въпроси. Не приемайте нищо за дадено. Истината е някъде там – открийте я."
  },
  {
    "reading_id": "ace_wands_knight_swords",
    "reading_name": "Асо Жезли + Рицар Мечове",
    "reading_cards": "Асо Жезли + Рицар Мечове",
    "reading_combination": ["ace_wands", "knight_swords"],
    "reading_meaning": "Стремителна идея",
    "second_meaning": "Асо Жезли носи новата идея, а Рицар Мечове – бързината и прямотата. Идеята ви идва светкавично и веднага искате да я реализирате. Действате бързо и решително.",
    "reading_description": "Новата идея идва светкавично и ви кара да действате без колебание. Бързина и решителност.",
    "reading_advice": "Действайте бързо, но не безразсъдно. Устремът ви е сила, но не прегазвайте другите."
  },
  {
    "reading_id": "ace_wands_queen_swords",
    "reading_name": "Асо Жезли + Царица Мечове",
    "reading_cards": "Асо Жезли + Царица Мечове",
    "reading_combination": ["ace_wands", "queen_swords"],
    "reading_meaning": "Ясна идея",
    "second_meaning": "Асо Жезли носи новата идея, а Царица Мечове – яснота и независимост. Имате кристално ясна визия за новото си начинание. Никой не може да ви заблуди – виждате истината.",
    "reading_description": "Новата ви идея е кристално ясна. Знаете точно какво искате и как да го постигнете.",
    "reading_advice": "Бъдете честни със себе си и с другите. Вашата яснота вдъхновява доверие."
  },
  {
    "reading_id": "ace_wands_king_swords",
    "reading_name": "Асо Жезли + Цар Мечове",
    "reading_cards": "Асо Жезли + Цар Мечове",
    "reading_combination": ["ace_wands", "king_swords"],
    "reading_meaning": "Стратегическа идея",
    "second_meaning": "Асо Жезли носи новата идея, а Цар Мечове – интелект и стратегия. Новата ви идея е добре обмислена и стратегически издържана. Имате ясен план за реализация.",
    "reading_description": "Новата ви идея е подкрепена с ясен план и стратегия. Интелект и логика водят напред.",
    "reading_advice": "Вземете решение с ума си, но не забравяйте и сърцето. Стратегията е важна, но и емоциите имат значение."
  },
  {
    "reading_id": "ace_wands_two_pentacles",
    "reading_name": "Асо Жезли + Двойка Пентакли",
    "reading_cards": "Асо Жезли + Двойка Пентакли",
    "reading_combination": ["ace_wands", "two_pentacles"],
    "reading_meaning": "Нов проект и баланс",
    "second_meaning": "Асо Жезли носи новата енергия, а Двойка Пентакли – баланса и жонглирането с ресурси. Новият проект изисква да балансирате време, пари и енергия. Ще трябва да жонглирате.",
    "reading_description": "Нов проект изисква да балансирате ресурсите си. Време, пари, енергия – всичко трябва да е в хармония.",
    "reading_advice": "Жонглирайте, но не изпускайте топката. Балансът е ключът към успеха."
  },
  {
    "reading_id": "ace_wands_three_pentacles",
    "reading_name": "Асо Жезли + Тройка Пентакли",
    "reading_cards": "Асо Жезли + Тройка Пентакли",
    "reading_combination": ["ace_wands", "three_pentacles"],
    "reading_meaning": "Нов проект в екип",
    "second_meaning": "Асо Жезли носи новата идея, а Тройка Пентакли – екипната работа и сътрудничество. Новият ви проект изисква да работите с други хора. Заедно можете да постигнете повече.",
    "reading_description": "Нов проект, който изисква сътрудничество с други. Екипна работа и споделени умения.",
    "reading_advice": "Работете в екип. Учете се от по-опитните и споделяйте знанията си. Заедно сте по-силни."
  },
  {
    "reading_id": "ace_wands_four_pentacles",
    "reading_name": "Асо Жезли + Четворка Пентакли",
    "reading_cards": "Асо Жезли + Четворка Пентакли",
    "reading_combination": ["ace_wands", "four_pentacles"],
    "reading_meaning": "Нов проект и сигурност",
    "second_meaning": "Асо Жезли носи новата идея, а Четворка Пентакли – сигурността и задържането. Новият проект изисква да инвестирате ресурси, но се страхувате да ги пуснете. Стискането може да ви попречи.",
    "reading_description": "Нова идея, но се страхувате да инвестирате ресурси. Стискате и се колебаете.",
    "reading_advice": "Пуснете малко. Страхът от загуба може да ви попречи да спечелите нещо по-голямо."
  },

  
  {
    "reading_id": "illness",
    "reading_name": "Болест",
    "reading_cards": "5 Пентакли + 4 Мечове",
    "reading_combination": ["five_pentacles", "four_swords"],
    "reading_meaning": "Здравословни проблеми",
    "reading_description": "Здравословни проблеми. Нужда от почивка и лечение.",
    "reading_advice": "Посети лекар! Не отлагай. Тялото ти крещи за внимание."
  },
  {
    "reading_id": "ace_wands_five_pentacles",
    "reading_name": "Асо Жезли + Петица Пентакли",
    "reading_cards": "Асо Жезли + Петица Пентакли",
    "reading_combination": ["ace_wands", "five_pentacles"],
    "reading_meaning": "Нов проект и липса",
    "second_meaning": "Асо Жезли носи новата идея, а Петица Пентакли – финансови трудности и липса. Имате страхотна идея, но ви липсват ресурси за реализация. Търсете помощ.",
    "reading_description": "Имате нова идея, но финансовите ресурси са ограничени. Чувствате се изолирани.",
    "reading_advice": "Потърсете помощ. Не сте сами. Има хора, готови да ви подкрепят, ако поискате."
  },
  {
    "reading_id": "ace_wands_six_pentacles",
    "reading_name": "Асо Жезли + Шестица Пентакли",
    "reading_cards": "Асо Жезли + Шестица Пентакли",
    "reading_combination": ["ace_wands", "six_pentacles"],
    "reading_meaning": "Нов проект и подкрепа",
    "second_meaning": "Асо Жезли носи новата идея, а Шестица Пентакли – помощта и щедростта. Новият ви проект получава подкрепа – финансова или емоционална. Някой вярва във вас.",
    "reading_description": "Новата ви идея получава подкрепа. Някой протяга ръка да ви помогне.",
    "reading_advice": "Приемете помощта с благодарност. Някой ден ще имате възможност да върнете жеста."
  },
  {
    "reading_id": "ace_wands_seven_pentacles",
    "reading_name": "Асо Жезли + Седмица Пентакли",
    "reading_cards": "Асо Жезли + Седмица Пентакли",
    "reading_combination": ["ace_wands", "seven_pentacles"],
    "reading_meaning": "Нов проект и търпение",
    "second_meaning": "Асо Жезли носи новата енергия, а Седмица Пентакли – търпението и чакането на резултати. Започнали сте нещо ново, но резултатите няма да дойдат веднага. Трябва да изчакате.",
    "reading_description": "Започнали сте нов проект, но трябва да изчакате резултатите. Търпение и вяра.",
    "reading_advice": "Чакайте търпеливо. Добрите неща идват при тези, които умеят да чакат, докато продължават да работят."
  },
  {
    "reading_id": "ace_wands_eight_pentacles",
    "reading_name": "Асо Жезли + Осмица Пентакли",
    "reading_cards": "Асо Жезли + Осмица Пентакли",
    "reading_combination": ["ace_wands", "eight_pentacles"],
    "reading_meaning": "Нов занаят",
    "second_meaning": "Асо Жезли носи новата идея, а Осмица Пентакли – усърдието и ученето. Новият ви проект изисква да научите нови умения. Вложете време и усилия в усъвършенстването.",
    "reading_description": "Нов проект изисква да научите нови умения. Усърдие и постоянство.",
    "reading_advice": "Учете се с желание. Майсторството идва с практика. Не спирайте да се развивате."
  },
  {
    "reading_id": "ace_wands_nine_pentacles",
    "reading_name": "Асо Жезли + Деветка Пентакли",
    "reading_cards": "Асо Жезли + Деветка Пентакли",
    "reading_combination": ["ace_wands", "nine_pentacles"],
    "reading_meaning": "Нов проект и независимост",
    "second_meaning": "Асо Жезли носи новата идея, а Деветка Пентакли – самодостатъчността и успеха. Новият ви проект ви води към финансова независимост и свобода. Наслаждавайте се на плодовете.",
    "reading_description": "Новият проект ви води към независимост и успех. Наслаждавайте се на постигнатото.",
    "reading_advice": "Ти постигна самостоятелност. Наслади се на свободата, но не спирай да твориш."
  },
  {
    "reading_id": "ace_wands_ten_pentacles",
    "reading_name": "Асо Жезли + Десетка Пентакли",
    "reading_cards": "Асо Жезли + Десетка Пентакли",
    "reading_combination": ["ace_wands", "ten_pentacles"],
    "reading_meaning": "Нов проект и наследство",
    "second_meaning": "Асо Жезли носи новото начало, а Десетка Пентакли – семейното наследство и дългосрочната сигурност. Новият ви проект има потенциала да осигури бъдещето на семейството ви.",
    "reading_description": "Нов проект, който носи дългосрочна сигурност и полза за семейството.",
    "reading_advice": "Мислете за бъдещето. Това, което градите сега, ще остане след вас."
  },
  {
    "reading_id": "ace_wands_page_pentacles",
    "reading_name": "Асо Жезли + Паж Пентакли",
    "reading_cards": "Асо Жезли + Паж Пентакли",
    "reading_combination": ["ace_wands", "page_pentacles"],
    "reading_meaning": "Нова възможност и учене",
    "second_meaning": "Асо Жезли носи новата възможност, а Паж Пентакли – ученето и новото начало в материалната сфера. Получавате шанс да научите нещо ново, което ще ви донесе полза.",
    "reading_description": "Нова възможност за учене или старт в материалната сфера. Инвестиция в себе си.",
    "reading_advice": "Започнете да учите. Инвестирайте в себе си. Търпеливо градете, стъпка по стъпка."
  },
  {
    "reading_id": "ace_wands_knight_pentacles",
    "reading_name": "Асо Жезли + Рицар Пентакли",
    "reading_cards": "Асо Жезли + Рицар Пентакли",
    "reading_combination": ["ace_wands", "knight_pentacles"],
    "reading_meaning": "Нов проект и търпение",
    "second_meaning": "Асо Жезли носи ентусиазма, а Рицар Пентакли – бавния и сигурен напредък. Новият ви проект изисква търпение – не очаквайте бързи резултати. Бавно, но сигурно.",
    "reading_description": "Нов проект, който изисква търпение и постоянство. Бързите резултати не са реалистични.",
    "reading_advice": "Не бързайте. Работете търпеливо. Сигурният път е бавен, но води до целта."
  },
  {
    "reading_id": "ace_wands_queen_pentacles",
    "reading_name": "Асо Жезли + Царица Пентакли",
    "reading_cards": "Асо Жезли + Царица Пентакли",
    "reading_combination": ["ace_wands", "queen_pentacles"],
    "reading_meaning": "Нов проект и грижа",
    "second_meaning": "Асо Жезли носи новата енергия, а Царица Пентакли – грижата и дома. Новият ви проект е свързан с дома, семейството или създаване на уют. Вложете сърце в него.",
    "reading_description": "Нов проект, свързан с дома, семейството или материалния уют. Грижа и практичност.",
    "reading_advice": "Грижете се за проекта като за дом. Вложете любов и практичност – резултатът ще бъде прекрасен."
  },
  {
    "reading_id": "ace_wands_king_pentacles",
    "reading_name": "Асо Жезли + Цар Пентакли",
    "reading_cards": "Асо Жезли + Цар Пентакли",
    "reading_combination": ["ace_wands", "king_pentacles"],
    "reading_meaning": "Нов бизнес проект",
    "second_meaning": "Асо Жезли носи новата идея, а Цар Пентакли – бизнес успеха и стабилността. Новият ви проект има потенциала да се превърне в успешен бизнес. Имате всички качества да успеете.",
    "reading_description": "Нов бизнес проект с потенциал за успех и стабилност. Лидерски качества.",
    "reading_advice": "Поемете лидерството. Имате визията и практичността да успеете. Градете стабилно."
  },
    {
    "reading_id": "eight_cups_four_swords",
    "reading_name": "Осмица Чаши + Четворка Мечове",
    "reading_cards": "Осмица Чаши + Четворка Мечове",
    "reading_combination": ["eight_cups", "four_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Четворка Мечове – почивка и възстановяване. Преди да тръгнете, имате нужда от почивка. Съберете сили за пътя. Почивката не е застой – тя е подготовка.",
    "reading_description": "Преди да тръгнеш, имаш нужда от почивка. Събери сили.",
    "reading_advice": "Почини си. Свежите сили ще ти помогнат да тръгнеш по-леко и уверено."
  },
  {
    "reading_id": "eight_cups_five_swords",
    "reading_name": "Осмица Чаши + Петица Мечове",
    "reading_cards": "Осмица Чаши + Петица Мечове",
    "reading_combination": ["eight_cups", "five_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Петица Мечове – конфликт и празна победа. Тръгвате след конфликт, в който няма истински победител. Оставете битката зад гърба си – тя не си струваше.",
    "reading_description": "Тръгваш след конфликт, в който няма истински победител.",
    "reading_advice": "Остави битката зад гърба си. Тя не си струваше. Продължи напред."
  },
  {
    "reading_id": "eight_cups_six_swords",
    "reading_name": "Осмица Чаши + Шестица Мечове",
    "reading_cards": "Осмица Чаши + Шестица Мечове",
    "reading_combination": ["eight_cups", "six_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Шестица Мечове – пътуване и преход. Две карти на пътуване заедно – мощна комбинация. Тръгвате на дълъг път, носейки само необходимото. Новите води ви очакват.",
    "reading_description": "Две карти на пътуване заедно. Тръгваш на дълъг път.",
    "reading_advice": "Тръгни с увереност. Новите води носят нови възможности. Пътят те очаква."
  },
  {
    "reading_id": "eight_cups_seven_swords",
    "reading_name": "Осмица Чаши + Седмица Мечове",
    "reading_cards": "Осмица Чаши + Седмица Мечове",
    "reading_combination": ["eight_cups", "seven_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Седмица Мечове – измама и хитрост. Тръгвате, защото някой ви е измамил или сте избрали да избягате от измамата. Пазите се и на пътя.",
    "reading_description": "Тръгваш, защото някой те е измамил или бягаш от измама.",
    "reading_advice": "Пази се и на пътя. Не всички, които срещнеш, са искрени. Носи мъдростта със себе си."
  },
  {
    "reading_id": "eight_cups_eight_swords",
    "reading_name": "Осмица Чаши + Осмица Мечове",
    "reading_cards": "Осмица Чаши + Осмица Мечове",
    "reading_combination": ["eight_cups", "eight_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Осмица Мечове – чувство на капан и ограничение. Чувствате се в капан и решавате да тръгнете. Оковите падат, когато напуснете. Свободата е в движението.",
    "reading_description": "Чувстваш се в капан и решаваш да тръгнеш. Оковите падат.",
    "reading_advice": "Свободата е в движението. Тръгни – оковите ще паднат. Не се връщай."
  },
  {
    "reading_id": "eight_cups_nine_swords",
    "reading_name": "Осмица Чаши + Деветка Мечове",
    "reading_cards": "Осмица Чаши + Деветка Мечове",
    "reading_combination": ["eight_cups", "nine_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Деветка Мечове – тревога и безсъние. Тръгвате, защото тревогите не ви оставят да спите. Пътят ще донесе успокоение. Оставете страховете зад гърба си.",
    "reading_description": "Тръгваш, защото тревогите не те оставят да спиш.",
    "reading_advice": "Пътят ще донесе успокоение. Остави страховете зад гърба си. Те не те заслужават."
  },
  {
    "reading_id": "eight_cups_ten_swords",
    "reading_name": "Осмица Чаши + Десетка Мечове",
    "reading_cards": "Осмица Чаши + Десетка Мечове",
    "reading_combination": ["eight_cups", "ten_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Десетка Мечове – край и дъно. Тръгвате след тежък край. Оставяте дъното зад гърба си. След най-тъмната нощ идва зора. Тръгвайте към светлината.",
    "reading_description": "Тръгваш след тежък край. Оставяш дъното зад гърба си.",
    "reading_advice": "След най-тъмната нощ идва зора. Тръгвай към светлината. Новото начало те очаква."
  },
  {
    "reading_id": "eight_cups_page_swords",
    "reading_name": "Осмица Чаши + Паж Мечове",
    "reading_cards": "Осмица Чаши + Паж Мечове",
    "reading_combination": ["eight_cups", "page_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Паж Мечове – търсене на истината. Тръгвате, за да търсите истината. Любопитството ви води напред. Носете отворен ум и сърце.",
    "reading_description": "Тръгваш, за да търсиш истината. Любопитството те води.",
    "reading_advice": "Търси истината. Тя ще те води по пътя. Бъди отворен за това, което ще научиш."
  },
  {
    "reading_id": "eight_cups_knight_swords",
    "reading_name": "Осмица Чаши + Рицар Мечове",
    "reading_cards": "Осмица Чаши + Рицар Мечове",
    "reading_combination": ["eight_cups", "knight_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Рицар Мечове – бързина и прямота. Тръгвате бързо, решително, без да се обръщате назад. Няма време за съжаления. Действайте с яснота.",
    "reading_description": "Тръгваш бързо, решително, без да се обръщаш назад.",
    "reading_advice": "Действай с яснота. Няма време за съжаления. Бъди смел и продължавай напред."
  },
  {
    "reading_id": "eight_cups_queen_swords",
    "reading_name": "Осмица Чаши + Царица Мечове",
    "reading_cards": "Осмица Чаши + Царица Мечове",
    "reading_combination": ["eight_cups", "queen_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Царица Мечове – яснота и независимост. Тръгвате с ясна глава и независимост. Знаете защо тръгвате и какво оставяте. Няма илюзии, няма съмнения.",
    "reading_description": "Тръгваш с ясна глава и независимост. Знаеш защо.",
    "reading_advice": "Бъди честен със себе си. Яснотата ти води по правилния път. Носи я със себе си."
  },
  {
    "reading_id": "eight_cups_king_swords",
    "reading_name": "Осмица Чаши + Цар Мечове",
    "reading_cards": "Осмица Чаши + Цар Мечове",
    "reading_combination": ["eight_cups", "king_swords"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Цар Мечове – интелект и стратегия. Тръгвате с план и стратегия. Не тръгвате на сляпо – знаете накъде. Умът ви води.",
    "reading_description": "Тръгваш с план и стратегия. Знаеш накъде.",
    "reading_advice": "Използвай ума си. Стратегията и логиката ще те водят по пътя. Води с мъдрост."
  },
  {
    "reading_id": "eight_cups_two_pentacles",
    "reading_name": "Осмица Чаши + Двойка Пентакли",
    "reading_cards": "Осмица Чаши + Двойка Пентакли",
    "reading_combination": ["eight_cups", "two_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Двойка Пентакли – баланс и жонглиране. Тръгвате, но трябва да балансирате ресурсите си за пътя. Жонглирайте внимателно – не изпускайте важните неща.",
    "reading_description": "Тръгваш, но трябва да балансираш ресурсите си за пътя.",
    "reading_advice": "Балансирай, но не изпускай важните неща. Носи само необходимото – останалото остава."
  },
  {
    "reading_id": "eight_cups_three_pentacles",
    "reading_name": "Осмица Чаши + Тройка Пентакли",
    "reading_cards": "Осмица Чаши + Тройка Пентакли",
    "reading_combination": ["eight_cups", "three_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Тройка Пентакли – екипна работа и сътрудничество. Не тръгвате сами – имате екип или семейство с вас. Заедно ще изминете пътя. Споделете тежестта.",
    "reading_description": "Не тръгваш сам – имаш екип или семейство с теб.",
    "reading_advice": "Сподели пътя с другите. Заедно сте по-силни. Тежестта на тръгването е по-лека, когато не си сам."
  },
  {
    "reading_id": "eight_cups_four_pentacles",
    "reading_name": "Осмица Чаши + Четворка Пентакли",
    "reading_cards": "Осмица Чаши + Четворка Пентакли",
    "reading_combination": ["eight_cups", "four_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Четворка Пентакли – сигурност и стискане. Тръгвате, но се страхувате да оставите сигурността. Пуснете – истинската свобода идва, когато спреш да се страхуваш да пуснеш.",
    "reading_description": "Тръгваш, но се страхуваш да оставиш сигурността.",
    "reading_advice": "Пусни. Истинската свобода идва, когато спреш да се страхуваш да пуснеш. Носи само смелостта."
  },
  {
    "reading_id": "eight_cups_five_pentacles",
    "reading_name": "Осмица Чаши + Петица Пентакли",
    "reading_cards": "Осмица Чаши + Петица Пентакли",
    "reading_combination": ["eight_cups", "five_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Петица Пентакли – финансови трудности и липса. Тръгвате с ограничени ресурси, но с богато сърце. Пътят ще ви даде каквото ви трябва. Вярвайте.",
    "reading_description": "Тръгваш с ограничени ресурси, но с богато сърце.",
    "reading_advice": "Вярвай. Пътят ще ти даде каквото ти трябва. Носи смелостта, не тежестта."
  },
  {
    "reading_id": "eight_cups_six_pentacles",
    "reading_name": "Осмица Чаши + Шестица Пентакли",
    "reading_cards": "Осмица Чаши + Шестица Пентакли",
    "reading_combination": ["eight_cups", "six_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Шестица Пентакли – помощ и щедрост. Някой ви помага да тръгнете – финансова или емоционална подкрепа. Приемете помощта с благодарност. Някой вярва в пътя ви.",
    "reading_description": "Някой ти помага да тръгнеш. Приеми помощта.",
    "reading_advice": "Приеми помощта с благодарност. Някой вярва в пътя ти. Носи тази вяра със себе си."
  },
  {
    "reading_id": "eight_cups_seven_pentacles",
    "reading_name": "Осмица Чаши + Седмица Пентакли",
    "reading_cards": "Осмица Чаши + Седмица Пентакли",
    "reading_combination": ["eight_cups", "seven_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Седмица Пентакли – търпение и чакане. Тръгвате, но плодовете на усилията ви ще дойдат по-късно. Бъдете търпеливи – реколтата идва, но не веднага.",
    "reading_description": "Тръгваш, но плодовете ще дойдат по-късно. Бъди търпелив.",
    "reading_advice": "Чакай търпеливо. Това, което си посял, ще поникне на новото място. Не бързай да береш."
  },

  {
    "reading_id": "eight_cups_nine_pentacles",
    "reading_name": "Осмица Чаши + Деветка Пентакли",
    "reading_cards": "Осмица Чаши + Деветка Пентакли",
    "reading_combination": ["eight_cups", "nine_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Деветка Пентакли – самодостатъчност и успех. Тръгвате самостоятелно, без да носите тежест. Вие сте достатъчни сами за себе си. Носете независимостта със себе си.",
    "reading_description": "Тръгваш самостоятелно, без да носиш тежест. Ти си достатъчен.",
    "reading_advice": "Ти си самостоятелен. Носи независимостта със себе си. Тя ще ти помага по пътя."
  },
  {
    "reading_id": "eight_cups_ten_pentacles",
    "reading_name": "Осмица Чаши + Десетка Пентакли",
    "reading_cards": "Осмица Чаши + Десетка Пентакли",
    "reading_combination": ["eight_cups", "ten_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Десетка Пентакли – семейно наследство и богатство. Оставяте семейното наследство, за да тръгнете по свой път. Носете мъдростта на рода, не тежестта му.",
    "reading_description": "Оставяш семейното наследство, за да тръгнеш по свой път.",
    "reading_advice": "Носи мъдростта на рода, не тежестта му. Тръгваш, за да създадеш свое наследство."
  },
  {
    "reading_id": "eight_cups_page_pentacles",
    "reading_name": "Осмица Чаши + Паж Пентакли",
    "reading_cards": "Осмица Чаши + Паж Пентакли",
    "reading_combination": ["eight_cups", "page_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Паж Пентакли – нова възможност и учене. Тръгвате към нова възможност. Нови начала, нови умения. Пътят ви води към учене и растеж.",
    "reading_description": "Тръгваш към нова възможност. Нови начала, нови умения.",
    "reading_advice": "Хвани възможността. Тя носи учене и растеж. Пътят те води към нещо ново."
  },
  {
    "reading_id": "eight_cups_knight_pentacles",
    "reading_name": "Осмица Чаши + Рицар Пентакли",
    "reading_cards": "Осмица Чаши + Рицар Пентакли",
    "reading_combination": ["eight_cups", "knight_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Рицар Пентакли – бавен и сигурен напредък. Тръгвате бавно, но сигурно. Не бързайте – пътят е дълъг, но ще стигнете. Бавното и сигурно води до целта.",
    "reading_description": "Тръгваш бавно, но сигурно. Не бързай – ще стигнеш.",
    "reading_advice": "Не бързай. Бавното и сигурно води до целта. Наслаждавай се на пътя."
  },
  {
    "reading_id": "eight_cups_queen_pentacles",
    "reading_name": "Осмица Чаши + Царица Пентакли",
    "reading_cards": "Осмица Чаши + Царица Пентакли",
    "reading_combination": ["eight_cups", "queen_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Царица Пентакли – грижа и дом. Оставяте дома, но носите грижата със себе си. Където и да отидете, ще създадете дом. Грижете се за себе си на пътя.",
    "reading_description": "Оставяш дома, но носиш грижата със себе си.",
    "reading_advice": "Грижи се за себе си на пътя. Където и да отидеш, ще създадеш дом. Носи топлината със себе си."
  },
  {
    "reading_id": "eight_cups_king_pentacles",
    "reading_name": "Осмица Чаши + Цар Пентакли",
    "reading_cards": "Осмица Чаши + Цар Пентакли",
    "reading_combination": ["eight_cups", "king_pentacles"],
    "reading_meaning": "Осмица Чаши носи тръгване и оставяне, а Цар Пентакли – стабилност и успех. Тръгвате от стабилност, за да намерите нов успех. Оставяте сигурността, но носите увереността. Бъдете царят на своя път.",
    "reading_description": "Тръгваш от стабилност, за да намериш нов успех.",
    "reading_advice": "Бъди царят на своя път. Носи увереността със себе си. Стабилността ти ще те следва."
  },
    {
    "reading_id": "nine_cups_two_wands",
    "reading_name": "Деветка Чаши + Двойка Жезли",
    "reading_cards": "Деветка Чаши + Двойка Жезли",
    "reading_combination": ["nine_cups", "two_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Двойка Жезли – избор и планиране. Постигнали сте това, което искате, но предстои нов избор. Радвайте се на успеха, но не спирайте да планирате бъдещето.",
    "reading_description": "Постигнал си това, което искаш, но предстои нов избор.",
    "reading_advice": "Радвай се на успеха, но не спирай да планираш. Най-доброто тепърва идва."
  },
  {
    "reading_id": "nine_cups_three_wands",
    "reading_name": "Деветка Чаши + Тройка Жезли",
    "reading_cards": "Деветка Чаши + Тройка Жезли",
    "reading_combination": ["nine_cups", "three_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Тройка Жезли – очакване и разширяване. Постигнали сте успех и сега гледате към нови хоризонти. Чакате следващата стъпка с увереност.",
    "reading_description": "Постигнал си успех и гледаш към нови хоризонти.",
    "reading_advice": "Гледай напред с надежда. Ти си изградил основа – сега можеш да разширяваш."
  },
  {
    "reading_id": "nine_cups_four_wands",
    "reading_name": "Деветка Чаши + Четворка Жезли",
    "reading_cards": "Деветка Чаши + Четворка Жезли",
    "reading_combination": ["nine_cups", "four_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Четворка Жезли – празник и стабилност. Празнувате сбъдването на мечта със семейството и приятелите. Споделена радост, която умножава щастието.",
    "reading_description": "Празнуваш сбъдването на мечта със семейството и приятелите.",
    "reading_advice": "Сподели радостта. Щастието е по-голямо, когато е споделено. Празнувай с пълно сърце."
  },
  {
    "reading_id": "nine_cups_five_wands",
    "reading_name": "Деветка Чаши + Петица Жезли",
    "reading_cards": "Деветка Чаши + Петица Жезли",
    "reading_combination": ["nine_cups", "five_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Петица Жезли – конфликт и съперничество. Успехът ви предизвиква завист и конкуренция. Не се поддавайте – знаете колко струвате.",
    "reading_description": "Успехът ти предизвиква завист и конкуренция.",
    "reading_advice": "Не позволявай на завистниците да помрачат успеха ти. Ти си изградил това сам."
  },
  {
    "reading_id": "nine_cups_six_wands",
    "reading_name": "Деветка Чаши + Шестица Жезли",
    "reading_cards": "Деветка Чаши + Шестица Жезли",
    "reading_combination": ["nine_cups", "six_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Шестица Жезли – победа и признание. Успехът ви получава заслужено признание. Гордейте се – заслужили сте всяка минута.",
    "reading_description": "Успехът ти получава заслужено признание.",
    "reading_advice": "Наслади се на признанието. Ти го заслужи. Но не спирай да вървиш напред."
  },
  {
    "reading_id": "nine_cups_seven_wands",
    "reading_name": "Деветка Чаши + Седмица Жезли",
    "reading_cards": "Деветка Чаши + Седмица Жезли",
    "reading_combination": ["nine_cups", "seven_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Седмица Жезли – защита на позицията. Трябва да защитавате постигнатото от хора, които искат да ви го отнемат. Дръжте се – заслужили сте го.",
    "reading_description": "Трябва да защитаваш постигнатото от хора, които искат да ти го отнемат.",
    "reading_advice": "Дръж позицията си. Това, което си постигнал, си заслужава защита."
  },
  {
    "reading_id": "nine_cups_eight_wands",
    "reading_name": "Деветка Чаши + Осмица Жезли",
    "reading_cards": "Деветка Чаши + Осмица Жезли",
    "reading_combination": ["nine_cups", "eight_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Осмица Жезли – бързина и движение. Успехът идва бързо и неочаквано. Бъдете готови да го посрещнете.",
    "reading_description": "Успехът идва бързо и неочаквано. Бъди готов.",
    "reading_advice": "Приеми успеха с благодарност и смирение. Наслади се на скоростта."
  },
  {
    "reading_id": "nine_cups_nine_wands",
    "reading_name": "Деветка Чаши + Деветка Жезли",
    "reading_cards": "Деветка Чаши + Деветка Жезли",
    "reading_combination": ["nine_cups", "nine_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Деветка Жезли – устойчивост и изтощение. Постигнали сте успех, но цената беше висока. Чувствате се изтощени, но удовлетворени.",
    "reading_description": "Постигнал си успех, но цената беше висока. Изтощен, но удовлетворен.",
    "reading_advice": "Почини си. Заслужил си този успех. Наслади се на удовлетворението, но не забравяй да се грижиш за себе си."
  },
  {
    "reading_id": "nine_cups_ten_wands",
    "reading_name": "Деветка Чаши + Десетка Жезли",
    "reading_cards": "Деветка Чаши + Десетка Жезли",
    "reading_combination": ["nine_cups", "ten_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Десетка Жезли – претоварване и бреме. Успели сте, но носите тежестта на отговорностите. Освободете се от ненужното бреме.",
    "reading_description": "Успя, но носиш тежестта на отговорностите.",
    "reading_advice": "Потърси помощ. Успехът не трябва да те заробва. Сподели бремето."
  },
  {
    "reading_id": "nine_cups_page_wands",
    "reading_name": "Деветка Чаши + Паж Жезли",
    "reading_cards": "Деветка Чаши + Паж Жезли",
    "reading_combination": ["nine_cups", "page_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Паж Жезли – новини и ентусиазъм. Получавате вълнуваща новина, свързана с успеха ви. Ентусиазъм и нови възможности.",
    "reading_description": "Вълнуваща новина, свързана с успеха ти, идва.",
    "reading_advice": "Отвори се за новините. Те носят още повече радост и вдъхновение."
  },
  {
    "reading_id": "nine_cups_knight_wands",
    "reading_name": "Деветка Чаши + Рицар Жезли",
    "reading_cards": "Деветка Чаши + Рицар Жезли",
    "reading_combination": ["nine_cups", "knight_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Рицар Жезли – импулсивност и бързина. Успехът ви кара да действате импулсивно. Насладете се, но не вземайте прибързани решения.",
    "reading_description": "Успехът те кара да действаш импулсивно.",
    "reading_advice": "Наслаждавай се на успеха, но не позволявай на егото да те заслепи. Бъди мъдър."
  },
  {
    "reading_id": "nine_cups_queen_wands",
    "reading_name": "Деветка Чаши + Царица Жезли",
    "reading_cards": "Деветка Чаши + Царица Жезли",
    "reading_combination": ["nine_cups", "queen_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Царица Жезли – увереност и харизма. Вие сте пример за успех. Вашата увереност вдъхновява другите.",
    "reading_description": "Ти си пример за успех. Увереността ти вдъхновява.",
    "reading_advice": "Бъди себе си – топло и уверено. Твоята светлина води другите."
  },
  {
    "reading_id": "nine_cups_king_wands",
    "reading_name": "Деветка Чаши + Цар Жезли",
    "reading_cards": "Деветка Чаши + Цар Жезли",
    "reading_combination": ["nine_cups", "king_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Цар Жезли – лидерство и визия. Вие сте лидер, който е постигнал успех. Вашата визия вдъхновява другите да ви следват.",
    "reading_description": "Ти си лидер, който е постигнал успех. Визията ти вдъхновява.",
    "reading_advice": "Води с пример. Твоят успех е доказателство, че мечтите се сбъдват."
  },
  {
    "reading_id": "nine_cups_ace_wands",
    "reading_name": "Деветка Чаши + Асо Жезли",
    "reading_cards": "Деветка Чаши + Асо Жезли",
    "reading_combination": ["nine_cups", "ace_wands"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Асо Жезли – ново начало и вдъхновение. След успеха идва нова искра. Нов проект или страст се появява. Готови ли сте?",
    "reading_description": "След успеха идва нова искра. Нов проект или страст се появява.",
    "reading_advice": "Хвани новата искра. Успехът не е край – той е начало на нещо ново."
  },
  {
    "reading_id": "nine_cups_ace_cups",
    "reading_name": "Деветка Чаши + Асо Чаши",
    "reading_cards": "Деветка Чаши + Асо Чаши",
    "reading_combination": ["nine_cups", "ace_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Асо Чаши – нови чувства и любов. Нова любов идва след сбъдната мечта. Сърцето ви е пълно и готово да сподели.",
    "reading_description": "Нова любов идва след сбъдната мечта. Сърцето ти е пълно.",
    "reading_advice": "Отвори сърцето си. Любовта идва, когато си готов да я приемеш."
  },
  {
    "reading_id": "nine_cups_two_cups",
    "reading_name": "Деветка Чаши + Двойка Чаши",
    "reading_cards": "Деветка Чаши + Двойка Чаши",
    "reading_combination": ["nine_cups", "two_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Двойка Чаши – любов и връзка. Сбъдването на мечта ви води към нова любовна връзка или задълбочава съществуващата. Щастие и любов заедно.",
    "reading_description": "Сбъдването на мечта води към нова любовна връзка.",
    "reading_advice": "Сподели щастието с любимия. Любовта и успехът вървят ръка за ръка."
  },
  {
    "reading_id": "nine_cups_three_cups",
    "reading_name": "Деветка Чаши + Тройка Чаши",
    "reading_cards": "Деветка Чаши + Тройка Чаши",
    "reading_combination": ["nine_cups", "three_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Тройка Чаши – празник и радост. Празнувате сбъдването на мечта с приятели. Споделена радост, която умножава щастието.",
    "reading_description": "Празнуваш сбъдването на мечта с приятели.",
    "reading_advice": "Сподели радостта си. Тя става по-голяма, когато я споделяш с тези, които обичаш."
  },
  {
    "reading_id": "nine_cups_four_cups",
    "reading_name": "Деветка Чаши + Четворка Чаши",
    "reading_cards": "Деветка Чаши + Четворка Чаши",
    "reading_combination": ["nine_cups", "four_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Четворка Чаши – апатия и неудовлетворение. Имате всичко, за което сте мечтали, но не сте щастливи. Потърсете какво наистина ви липсва.",
    "reading_description": "Имаш всичко, за което си мечтал, но не си щастлив.",
    "reading_advice": "Щастието не е в притежанията. Потърси го вътре в себе си."
  },
  {
    "reading_id": "nine_cups_five_cups",
    "reading_name": "Деветка Чаши + Петица Чаши",
    "reading_cards": "Деветка Чаши + Петица Чаши",
    "reading_combination": ["nine_cups", "five_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Петица Чаши – загуба и тъга. Успех, но с цената на загуба. Позволете си да скърбите, но не забравяйте какво имате.",
    "reading_description": "Успех, но с цената на загуба. Скърби, но не забравяй какво имаш.",
    "reading_advice": "Понякога успехът идва със загуба. Позволи си да чувстваш и двете."
  },
  {
    "reading_id": "nine_cups_six_cups",
    "reading_name": "Деветка Чаши + Шестица Чаши",
    "reading_cards": "Деветка Чаши + Шестица Чаши",
    "reading_combination": ["nine_cups", "six_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Шестица Чаши – спомени и носталгия. Успехът ви напомня за корените ви. Носталгия и благодарност към миналото.",
    "reading_description": "Успехът ти напомня за корените ти. Носталгия и благодарност.",
    "reading_advice": "Благодари на миналото, което те доведе тук. Но гледай напред."
  },
  {
    "reading_id": "nine_cups_seven_cups",
    "reading_name": "Деветка Чаши + Седмица Чаши",
    "reading_cards": "Деветка Чаши + Седмица Чаши",
    "reading_combination": ["nine_cups", "seven_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Седмица Чаши – илюзии и фантазии. Мислите, че сте успели, но може да е илюзия. Проверете реалността.",
    "reading_description": "Мислиш, че си успял, но може да е илюзия. Провери реалността.",
    "reading_advice": "Не се залъгвай. Истинският успех е реален. Свали розовите очила."
  },
  {
    "reading_id": "nine_cups_eight_cups",
    "reading_name": "Деветка Чаши + Осмица Чаши",
    "reading_cards": "Деветка Чаши + Осмица Чаши",
    "reading_combination": ["nine_cups", "eight_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Осмица Чаши – тръгване и оставяне. Решавате да оставите успеха зад гърба си и да тръгнете към нещо ново. Смела стъпка за истински щастливия.",
    "reading_description": "Решаваш да оставиш успеха и да тръгнеш към нещо ново.",
    "reading_advice": "Тръгни смело. Истинското щастие е да можеш да оставиш дори успеха, когато е време."
  },
 
  {
    "reading_id": "nine_cups_ten_cups",
    "reading_name": "Деветка Чаши + Десетка Чаши",
    "reading_cards": "Деветка Чаши + Десетка Чаши",
    "reading_combination": ["nine_cups", "ten_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Десетка Чаши – семейно щастие. Успехът ви носи радост на цялото семейство. Споделена хармония и любов.",
    "reading_description": "Успехът ти носи радост на цялото семейство.",
    "reading_advice": "Сподели успеха със семейството си. Те са част от твоята история."
  },
  {
    "reading_id": "nine_cups_page_cups",
    "reading_name": "Деветка Чаши + Паж Чаши",
    "reading_cards": "Деветка Чаши + Паж Чаши",
    "reading_combination": ["nine_cups", "page_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Паж Чаши – емоционално послание. Получавате нежно послание, което докосва сърцето ви. Някой ви признава чувствата си.",
    "reading_description": "Нежно послание идва, което докосва сърцето ти.",
    "reading_advice": "Отвори сърцето си за посланието. То носи нещо ценно."
  },
  {
    "reading_id": "nine_cups_knight_cups",
    "reading_name": "Деветка Чаши + Рицар Чаши",
    "reading_cards": "Деветка Чаши + Рицар Чаши",
    "reading_combination": ["nine_cups", "knight_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Рицар Чаши – романтика и ухажване. Романтичен жест от някой, който цени вашето щастие. Любов и радост заедно.",
    "reading_description": "Романтичен жест от някой, който цени щастието ти.",
    "reading_advice": "Позволи на любовта да влезе. Някой те обича точно такава, каквато си."
  },
  {
    "reading_id": "nine_cups_queen_cups",
    "reading_name": "Деветка Чаши + Царица Чаши",
    "reading_cards": "Деветка Чаши + Царица Чаши",
    "reading_combination": ["nine_cups", "queen_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Царица Чаши – интуиция и емпатия. Успехът ви идва, защото сте слушали сърцето си. Интуицията ви води правилно.",
    "reading_description": "Успехът ти идва, защото си слушал сърцето си.",
    "reading_advice": "Довери се на интуицията си. Тя знае пътя към истинския успех."
  },
  {
    "reading_id": "nine_cups_king_cups",
    "reading_name": "Деветка Чаши + Цар Чаши",
    "reading_cards": "Деветка Чаши + Цар Чаши",
    "reading_combination": ["nine_cups", "king_cups"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Цар Чаши – емоционална зрялост и баланс. Постигате успех с мъдрост и емоционален баланс. Зряла победа.",
    "reading_description": "Постигаш успех с мъдрост и емоционален баланс.",
    "reading_advice": "Наслади се на успеха с мъдростта, която си придобил. Ти заслужи този момент."
  },
  {
    "reading_id": "nine_cups_two_swords",
    "reading_name": "Деветка Чаши + Двойка Мечове",
    "reading_cards": "Деветка Чаши + Двойка Мечове",
    "reading_combination": ["nine_cups", "two_swords"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Двойка Мечове – нерешителност и съмнение. Успели сте, но се съмнявате дали заслужавате. Свали превръзката – заслужили сте го.",
    "reading_description": "Успя, но се съмняваш дали заслужаваш.",
    "reading_advice": "Свали превръзката. Заслужил си успеха. Позволи си да се радваш без съмнение."
  },
   
  {
    "reading_id": "love_fast",
    "reading_name": "Любов от пръв поглед",
    "reading_cards": "8 Жезли + Асо Чаши",
    "reading_combination": ["eight_wands", "ace_cups"],
    "reading_meaning": "Бърза любов",
    "reading_description": "Всичко се случва светкавично. Страст, която пламва веднага.",
    "reading_advice": "Наслаждавай се, но не изгаряй прекалено бързо."
  },
  {
    "reading_id": "love_slow",
    "reading_name": "Бавно изграждане",
    "reading_cards": "8 Пентакли + 2 Чаши",
    "reading_combination": ["eight_pentacles", "two_cups"],
    "reading_meaning": "Бавен и стабилен растеж",
    "reading_description": "Връзка, която се гради бавно, но стабилно. Търпение.",
    "reading_advice": "Няма нужда да бързаш. Истинското идва с времето."
  },
  {
    "reading_id": "nine_cups_three_swords",
    "reading_name": "Деветка Чаши + Тройка Мечове",
    "reading_cards": "Деветка Чаши + Тройка Мечове",
    "reading_combination": ["nine_cups", "three_swords"],
    "reading_meaning": "Деветка Чаши носи сбъднато желание и удовлетворение, а Тройка Мечове – болка и разбито сърце. Успех, но с цената на разбито сърце. Смесени чувства – радост и болка заедно.",
    "reading_description": "Успех, но с цената на разбито сърце. Радост и болка заедно.",
    "reading_advice": "Позволи си да чувстваш и радостта, и болката. Те могат да съществуват едновременно."
  }


 
];
   
